// showMessage('Запис успішно збережено', 'success', 100000);

// Перевіряємо, чи підтримує браузер Service Workers
if ("serviceWorker" in navigator) {
  const SW_VERSION = "v69";
  window.addEventListener("load", () => {
    // Реєструємо Service Worker
    navigator.serviceWorker
      .register(`/src/js/sw.js?${SW_VERSION}`, { updateViaCache: "none" })
      .then((registration) => {
        registration.update().catch(() => { });
        // Перевірка оновлень при поверненні у вкладку
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") {
            registration.update().catch(() => { });
          }
        });
        console.log(
          "ServiceWorker успішно зареєстрований:",
          registration.scope,
        );
      })
      .catch((error) => {
        console.log("Помилка реєстрації ServiceWorker:", error);
      });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Перевіряємо авторизацію перед ініціалізацією
  checkAuthAndInit();

  // Ініціалізація розумних підказок
  initSmartTooltips();

  // Ініціалізація Drag & Drop для всіх таблиць
  initGlobalTableDragAndDrop();
});

// Інвалідуємо кеш статистики після успішних змін у ключових API.
(() => {
  const nativeFetch = window.fetch.bind(window);
  const statsAffectingApiPattern = /\/api\/(tasks|projects|goals|finances|egds|youtube|training)\.php(?:\?|$)/i;

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    try {
      const input = args[0];
      const init = args[1] || {};
      const rawMethod =
        (init && init.method) ||
        (typeof Request !== "undefined" && input instanceof Request ? input.method : "GET");
      const method = String(rawMethod || "GET").toUpperCase();

      let url = "";
      if (typeof input === "string") {
        url = input;
      } else if (typeof URL !== "undefined" && input instanceof URL) {
        url = input.toString();
      } else if (typeof Request !== "undefined" && input instanceof Request) {
        url = input.url || "";
      }

      if (response.ok && method !== "GET" && statsAffectingApiPattern.test(url)) {
        window.dispatchEvent(new CustomEvent("bb:data-mutated"));
      }
    } catch (_) {
      // silent
    }
    return response;
  };
})();

/**
 * Ініціалізація контекстного меню для рядків таблиці (три крапки)
 */
function initContextMenus() {
  // Створюємо елемент меню, якщо його ще немає
  let menu = document.getElementById('row-context-menu');
  if (!menu) {
    menu = document.createElement('div');
    menu.id = 'row-context-menu';
    menu.className = 'row-context-menu';
    menu.style.display = 'none';
    document.body.appendChild(menu);
  }

  // Обробник завантаження аватарки
  const avatarInput = document.getElementById('avatar-upload-input');
  if (avatarInput) {
    avatarInput.addEventListener('change', async function () {
      if (this.files && this.files[0]) {
        const formData = new FormData();
        formData.append('avatar', this.files[0]);

        try {
          const res = await fetch('api/upload-avatar.php', {
            method: 'POST',
            body: formData
          });
          const data = await res.json();
          if (data.success) {
            showMessage(data.message, 'success');
            loadProfile(); // Оновлюємо аватарку всюди
          } else {
            showMessage(data.message || 'Помилка завантаження', 'error');
          }
        } catch (e) {
          console.error(e);
          showMessage('Помилка мережі при завантаженні', 'error');
        }
      }
    });
  }

  function positionContextMenu(btnEl) {
    const rect = btnEl.getBoundingClientRect();
    const menuRect = menu.getBoundingClientRect();
    const viewportPadding = 8;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;

    let left = rect.right - menuRect.width + scrollX;
    const minLeft = viewportPadding + scrollX;
    const maxLeft = scrollX + window.innerWidth - menuRect.width - viewportPadding;
    left = Math.max(minLeft, Math.min(left, maxLeft));

    let top = rect.bottom + 5 + scrollY;
    const maxTop = scrollY + window.innerHeight - menuRect.height - viewportPadding;
    if (top > maxTop) {
      top = rect.top - menuRect.height - 5 + scrollY;
    }
    const minTop = viewportPadding + scrollY;
    top = Math.max(minTop, top);

    menu.style.left = `${left}px`;
    menu.style.top = `${top}px`;
  }

  // Обробка кліку на кнопку "три крапки"
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.row-more-btn');

    if (btn) {
      e.stopPropagation();
      const id = btn.dataset.id;
      const type = btn.dataset.type;
      const isDeleted = btn.dataset.isDeleted === 'true';
      const activeTabRoot = document.querySelector(".tab-panel.active");
      const activeSubPanel = activeTabRoot?.querySelector(".sub-tab-panel.active");
      const isTasksArchiveView =
        type === "task" && activeSubPanel?.id === "tasks-archive-content";

      // Формуємо вміст меню
      if (type === "user") {
        const canEdit = btn.dataset.canEdit !== "0";
        const canDelete = btn.dataset.canDelete !== "0";
        menu.innerHTML = `
          ${canEdit ? `<div class="menu-item" data-action="edit" data-id="${id}" data-type="${type}"><i class="ri-edit-line"></i> Редагувати</div>` : ""}
          ${canDelete ? `<div class="menu-item danger" data-action="delete" data-id="${id}" data-type="${type}"><i class="ri-delete-bin-line"></i> Видалити</div>` : ""}
        `;
      } else if (type === "egds-product" || type === "egds-order") {
        menu.innerHTML = `
          <div class="menu-item" data-action="edit" data-id="${id}" data-type="${type}">
            <i class="ri-edit-line"></i> Редагувати
          </div>
          <div class="menu-item danger" data-action="delete" data-id="${id}" data-type="${type}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        `;
      } else if (type === "training-session") {
        const exercise = btn.dataset.exercise || "";
        menu.innerHTML = `
          <div class="menu-item danger" data-action="delete" data-id="${id}" data-type="${type}" data-exercise="${exercise}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        `;
      } else if (isTasksArchiveView) {
        menu.innerHTML = isDeleted ? `
          <div class="menu-item" data-action="restore" data-id="${id}" data-type="${type}">
            <i class="ri-refresh-line"></i> Відновити
          </div>
          <div class="menu-item danger" data-action="delete-permanent" data-id="${id}" data-type="${type}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        ` : `
          <div class="menu-item" data-action="edit" data-id="${id}" data-type="${type}">
            <i class="ri-edit-line"></i> Редагувати
          </div>
          <div class="menu-item danger" data-action="delete-permanent" data-id="${id}" data-type="${type}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        `;
      } else {
        menu.innerHTML = isDeleted ? `
          <div class="menu-item" data-action="restore" data-id="${id}" data-type="${type}">
            <i class="ri-refresh-line"></i> Відновити
          </div>
          <div class="menu-item danger" data-action="delete-permanent" data-id="${id}" data-type="${type}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        ` : `
          <div class="menu-item" data-action="edit" data-id="${id}" data-type="${type}">
            <i class="ri-edit-line"></i> Редагувати
          </div>
          <div class="menu-item danger" data-action="delete" data-id="${id}" data-type="${type}">
            <i class="ri-delete-bin-line"></i> Видалити
          </div>
        `;
      }

      // Позиціонування меню
      menu.style.display = 'block';
      positionContextMenu(btn);

      // Додаємо клас active для анімації
      setTimeout(() => menu.classList.add('active'), 10);
    } else {
      // Закриваємо меню при кліку в будь-якому іншому місці
      closeContextMenu();
    }
  });

  // Закриття при скролі
  window.addEventListener('scroll', closeContextMenu, { passive: true });

  // Обробка вибору пункту меню
  menu.addEventListener('click', function (e) {
    const item = e.target.closest('.menu-item');
    if (!item) return;

    const action = item.dataset.action;
    const id = item.dataset.id;
    const type = item.dataset.type;
    const exercise = item.dataset.exercise || "";

    // Викликаємо відповідні функції залежно від дії та типу
    if (action === 'edit') {
      if (type === 'task') {
        const taskId = Number(id);
        if (!taskId) return;
        fetch(`api/tasks.php?id=${taskId}`)
          .then((r) => r.json())
          .then((res) => {
            if (res && res.success && res.data && typeof showEditTaskPanel === 'function') {
              showEditTaskPanel(res.data);
            } else {
              showMessage("Помилка завантаження завдання", "error");
            }
          })
          .catch(() => showMessage("Помилка завантаження завдання", "error"));
      } else if (type === 'bank') {
        const bankId = Number(id);
        const tr = document.querySelector(`#bank-table-tbody tr[data-id="${bankId}"]`);
        if (typeof showEditBankPanel === 'function' && tr) {
          showEditBankPanel({
            id: bankId,
            name: tr.querySelector(".col-name")?.textContent?.trim() || "",
            balance:
              tr
                .querySelector(".col-balance")
                ?.textContent?.trim()
                .replace(/\s/g, "")
                .replace(",", ".") || "0",
            currency: tr.querySelector(".col-currency")?.textContent?.trim() || "UAH",
            description: tr.querySelector(".col-description")?.textContent?.trim() || "",
          });
        } else {
          showMessage("Не вдалося відкрити редагування рахунку", "error");
        }
      } else if (type === 'income') {
        const incomeId = Number(id);
        const tr = document.querySelector(`#incomes-table-tbody tr[data-id="${incomeId}"]`);
        if (typeof showEditIncomePanel === 'function' && tr) {
          showEditIncomePanel({
            id: incomeId,
            source: tr.querySelector(".col-name")?.textContent?.trim() || "",
            amount:
              tr
                .querySelector(".col-amount")
                ?.textContent?.trim()
                .replace(/\s/g, "")
                .replace(",", ".") || "0",
            currency: tr.querySelector(".col-currency")?.textContent?.trim() || "UAH",
            category: tr.querySelector(".col-category")?.textContent?.trim() || "",
            description: tr.dataset.description || "",
          });
        } else {
          showMessage("Не вдалося відкрити редагування доходу", "error");
        }
      } else if (type === 'expense') {
        const expenseId = Number(id);
        const tr = document.querySelector(`#expenses-table-tbody tr[data-id="${expenseId}"]`);
        if (typeof showEditExpensePanel === 'function' && tr) {
          showEditExpensePanel({
            id: expenseId,
            date: tr.querySelector(".col-date")?.textContent?.trim() || "",
            expense_type: tr.querySelector(".col-category")?.textContent?.trim() || "",
            store: tr.querySelector(".col-name")?.textContent?.trim() || "",
            amount:
              tr
                .querySelector(".col-amount")
                ?.textContent?.trim()
                .replace(/\s/g, "")
                .replace(",", ".") || "0",
            currency: tr.querySelector(".col-currency")?.textContent?.trim() || "UAH",
            description: tr.dataset.description || "",
          });
        } else {
          showMessage("Не вдалося відкрити редагування витрати", "error");
        }
      } else if (type === 'user') {
        if (typeof showEditUserPanel === 'function') showEditUserPanel(id);
      } else if (type === 'project') {
        if (typeof openProjectEditById === 'function') openProjectEditById(id);
      } else if (type === 'goal') {
        if (typeof openGoalEditById === 'function') openGoalEditById(id);
      } else if (type === "egds-product") {
        showEgdsEditDialog(id, "products");
      } else if (type === "egds-order") {
        showEgdsEditDialog(id, "orders");
      }
    } else if (action === 'delete') {
      if (type === 'task') {
        const taskId = Number(id);
        if (!taskId) return;
        showConfirm("Ви дійсно хочете видалити це завдання?", () => {
          fetch("api/tasks.php", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: taskId }),
          })
            .then((r) => r.json())
            .then((res) => {
              if (res && res.success) {
                loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
                showMessage("Завдання видалено", "success");
              } else {
                showMessage(res?.error || "Не вдалося видалити завдання", "error");
              }
            })
            .catch(() => showMessage("Не вдалося видалити завдання", "error"));
        });
      } else if (type === 'bank') {
        if (typeof deleteBank === 'function') deleteBank(id);
      } else if (type === 'income') {
        if (typeof deleteIncome === 'function') deleteIncome(id);
      } else if (type === 'expense') {
        if (typeof deleteExpense === 'function') deleteExpense(id);
      } else if (type === 'user') {
        if (typeof deleteUser === 'function') deleteUser(id);
      } else if (type === 'project') {
        if (typeof deleteProject === 'function') deleteProject(id);
      } else if (type === 'goal') {
        if (typeof deleteGoal === "function") deleteGoal(id);
      } else if (type === 'egds-product') {
        deleteEgdsItem(id, "products");
      } else if (type === 'egds-order') {
        deleteEgdsItem(id, "orders");
      } else if (type === "training-session") {
        if (typeof deleteTrainingSession === "function") {
          deleteTrainingSession(id, exercise);
        }
      }
    } else if (action === 'restore') {
      if (type === 'task') {
        const taskId = Number(id);
        if (!taskId) return;
        fetch("api/tasks.php", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: taskId, restore: true }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res && res.success) {
              loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
              showMessage("Завдання відновлено", "success");
            } else {
              showMessage(res?.error || "Не вдалося відновити завдання", "error");
            }
          })
          .catch(() => showMessage("Не вдалося відновити завдання", "error"));
      }
    } else if (action === 'delete-permanent') {
      if (type === 'task') {
        const taskId = Number(id);
        if (!taskId) return;
        showConfirm("Видалити завдання назавжди?", () => {
          fetch("api/tasks.php", {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: taskId, permanent: true }),
          })
            .then((r) => r.json())
            .then((res) => {
              if (res && res.success) {
                loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
                showMessage("Завдання видалено назавжди", "success");
              } else {
                showMessage(res?.error || "Не вдалося видалити завдання назавжди", "error");
              }
            })
            .catch(() => showMessage("Не вдалося видалити завдання назавжди", "error"));
        });
      }
    }

    closeContextMenu();
  });

  function closeContextMenu() {
    menu.classList.remove('active');
    setTimeout(() => {
      if (!menu.classList.contains('active')) {
        menu.style.display = 'none';
      }
    }, 200);
  }
}

/**
 * Ініціалізація розумних підказок (Smart Tooltips)
 * Динамічно коригує позицію підказки, щоб вона не виходила за межі екрана.
 */
function initSmartTooltips() {
  let tooltipEl = document.getElementById('smart-tooltip');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.id = 'smart-tooltip';
    tooltipEl.className = 'smart-tooltip';
    tooltipEl.innerHTML = '<span class="smart-tooltip-text"></span><div class="smart-tooltip-arrow"></div>';
    document.body.appendChild(tooltipEl);
  }

  const tooltipText = tooltipEl.querySelector('.smart-tooltip-text');

  document.addEventListener('mouseover', function (e) {
    const target = e.target.closest('[data-tooltip]');
    if (!target) return;

    const text = target.getAttribute('data-tooltip');
    if (!text) return;

    let pos = target.getAttribute('data-tooltip-pos') || 'top';
    tooltipText.textContent = text;
    tooltipEl.setAttribute('data-pos', pos);

    // Показуємо елемент для розрахунку розмірів
    tooltipEl.classList.add('is-visible');

    const targetRect = target.getBoundingClientRect();
    const tooltipRect = tooltipEl.getBoundingClientRect();

    let top, left;
    const margin = 8;

    // Розрахунок базової позиції
    const calculatePos = (currentPos) => {
      switch (currentPos) {
        case 'top':
          top = targetRect.top - tooltipRect.height - margin;
          left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'bottom':
          top = targetRect.bottom + margin;
          left = targetRect.left + (targetRect.width / 2) - (tooltipRect.width / 2);
          break;
        case 'left':
          top = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
          left = targetRect.left - tooltipRect.width - margin;
          break;
        case 'right':
          top = targetRect.top + (targetRect.height / 2) - (tooltipRect.height / 2);
          left = targetRect.right + margin;
          break;
      }
    };

    calculatePos(pos);

    // Розумна корекція, якщо виходить за межі екрана
    const padding = 10;

    // Перевірка горизонтальних меж
    if (left < padding) {
      if (pos === 'left') { pos = 'right'; calculatePos(pos); }
      else left = padding;
    } else if (left + tooltipRect.width > window.innerWidth - padding) {
      if (pos === 'right') { pos = 'left'; calculatePos(pos); }
      else left = window.innerWidth - tooltipRect.width - padding;
    }

    // Перевірка вертикальних меж
    if (top < padding) {
      if (pos === 'top') { pos = 'bottom'; calculatePos(pos); }
      else top = padding;
    } else if (top + tooltipRect.height > window.innerHeight - padding) {
      if (pos === 'bottom') { pos = 'top'; calculatePos(pos); }
      else top = window.innerHeight - tooltipRect.height - padding;
    }

    tooltipEl.setAttribute('data-pos', pos);
    tooltipEl.style.top = `${top}px`;
    tooltipEl.style.left = `${left}px`;
    tooltipEl.style.transform = 'translate(0, 0)';
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('[data-tooltip]')) {
      tooltipEl.classList.remove('is-visible');
    }
  });

  // Приховуємо при скролі або зміні розміру для безпеки
  window.addEventListener('scroll', () => tooltipEl.classList.remove('is-visible'), { passive: true });
  window.addEventListener('resize', () => tooltipEl.classList.remove('is-visible'), { passive: true });
}



let tabButtons, tabPanels;
let subTabButtons, subTabPanels;

// Глобальні змінні для сортування
let currentSortField = "date";
let currentSortOrder = "ASC";
let isLoading = false; // Флаг для відстеження завантаження
let tasksSmartSortEnabled = false;
let lastActiveTaskId = 0;

// Глобальні змінні для пошуку
let searchTimeout;
let currentSearchQuery = "";
let searchListenerInit = false;

// Глобальна змінна для відстеження активних таймерів
let activeTimers = new Map();
let timerUpdateInterval = null;
let timerSyncInterval = null;

// Функція ініціалізації таб-панелі
function initTabPanel() {
  // Отримуємо всі кнопки табів та панелей контенту
  // Підтримуємо і старі .tab-button, і нові .sidebar-item
  tabButtons = document.querySelectorAll(
    ".tab-button, .sidebar-item[data-tab]",
  );
  tabPanels = document.querySelectorAll(".tab-panel");

  // Ініціалізуємо sidebar
  initSidebar();

  // Ініціалізуємо підвкладки
  initSubTabs();

  // Ініціалізуємо view tabs
  initViewTabs();

  // Ініціалізуємо чекбокси
  initCheckBoxes();

  // Ініціалізуємо обробники для додавання проектів
  initProjectActions();
  initTaskBulkActions();
  initTaskBulkMenu();
  initTaskKeyboardShortcuts();
  initTasksSmartSortToggle();
  initAdaptiveSubTabMenus();

  // Ініціалізуємо сортування
  initSorting();

  // Ініціалізуємо пошук
  initSearch();

  // Ініціалізуємо кастомні селекти
  initCustomSelects();
  initPrettyFieldSelects();

  // Ініціалізуємо обробники полів ліміту часу
  initTimeLimitInputs();
  initPrettyNumberInputs();

  // Маска і валідація для полів дати/часу
  initDateTimeInputs();
  initTaskDatePickerButtons();
  syncTaskPeriodByDate();

  // Ініціалізуємо Kanban-дошку
  initKanban();

  // Уніфікована динамічна ширина і ресайз для всіх таблиць (окрім tasks, де окрема логіка)
  initUniversalDataTableLayout();

  // Функція для завантаження табу з URL
  function loadTabFromURL() {
    const url = new URL(window.location);
    const tabId = url.searchParams.get("tab");
    const subTabId = url.searchParams.get("sub-tab");

    if (tabId) {
      switchTab(tabId);

      // Якщо є підвкладка в URL, перемикаємо на неї
      if (
        subTabId &&
        (tabId === "projects" || tabId === "tasks")
      ) {
        switchSubTab(subTabId);
      } else if (!subTabId) {
        // Якщо немає підвкладки, встановлюємо дефолт для відповідного табу
        if (tabId === "projects") {
          switchSubTab("projects-active");
          updateURLWithSubTab("projects-active");
        } else if (tabId === "tasks") {
          switchSubTab("tasks-list");
          updateURLWithSubTab("tasks-list");
        }
      }
    } else {
      // Якщо URL не містить табу, показуємо dashboard за замовчуванням
      switchTab("dashboard");
    }

    // Завантажуємо пошук з URL
    loadSearchFromURL();
  }

  // Додаємо обробники подій до кнопок
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const tabId = this.getAttribute("data-tab");
      switchTab(tabId);
    });
  });

  // Додаємо підтримку клавіатури (Tab + Enter/Space)
  tabButtons.forEach((button) => {
    button.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const tabId = this.getAttribute("data-tab");
        switchTab(tabId);
      }
    });
  });

  // Ініціалізуємо контекстні меню для рядків
  initContextMenus();
  initCustomModalCloseButtons();

  // Реєструємо обробники для всіх таблиць завдань
  const taskTbodyIds = [
    "tasks-table-tbody",
    "tasks-archive-table-tbody",
    "tasks-all-table-tbody",
    "active-tasks-table-tbody",
    "today-tasks-table-tbody",
    "no-date-tasks-table-tbody",
  ];
  taskTbodyIds.forEach((id) => {
    const el = document.getElementById(id);
    if (el) attachTaskTbodyHandlers(el);
  });

  // Ініціалізація - завантажуємо таб з URL або перший за замовчуванням
  loadTabFromURL();
  // Після того як ми застосували активні таби — показуємо контейнер (уникаємо бліку)
  const tc = document.querySelector(".tab-container");
  if (tc) tc.style.visibility = "visible";
}

function initCustomModalCloseButtons() {
  document.querySelectorAll(".custom-modal .custom-modal-content").forEach((content) => {
    if (content.querySelector(".custom-modal-close")) return;
    const modal = content.closest(".custom-modal");
    if (!modal) return;

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "custom-modal-close";
    closeBtn.setAttribute("aria-label", "Закрити");
    closeBtn.innerHTML = '<i class="ri-close-line"></i>';

    closeBtn.addEventListener("click", () => {
      modal.classList.remove("active");
    });

    content.appendChild(closeBtn);
  });
}

// Функція ініціалізації sidebar
function initSidebar() {
  const sidebar = document.querySelector(".sidebar");
  const sidebarToggle = document.querySelector(".sidebar-toggle");

  if (sidebarToggle && sidebar) {
    sidebarToggle.addEventListener("click", function () {
      sidebar.classList.toggle("collapsed");
      // Зберігаємо стан в localStorage
      localStorage.setItem(
        "sidebarCollapsed",
        sidebar.classList.contains("collapsed"),
      );
    });

    // Відновлюємо стан з localStorage
    if (localStorage.getItem("sidebarCollapsed") === "true") {
      sidebar.classList.add("collapsed");
    }
  }
}

// Функція ініціалізації view tabs (для перемикання між Board/List)
function initViewTabs() {
  const viewTabs = document.querySelectorAll(".view-tab");

  viewTabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const view = this.getAttribute("data-view");
      switchTasksView(view);
    });
  });
}

// Перемикання між Board та List view для tasks
function switchTasksView(view) {
  // Прибираємо active з усіх view tabs
  document
    .querySelectorAll(".view-tab")
    .forEach((t) => t.classList.remove("active"));

  // Додаємо active до обраного
  const activeTab = document.querySelector(`.view-tab[data-view="${view}"]`);
  if (activeTab) activeTab.classList.add("active");

  // Перемикаємо панелі
  if (view === "board") {
    document.getElementById("tasks-board-content")?.classList.add("active");
    document.getElementById("tasks-list-content")?.classList.remove("active");
    renderKanbanBoard();
  } else if (view === "list") {
    document.getElementById("tasks-board-content")?.classList.remove("active");
    document.getElementById("tasks-list-content")?.classList.add("active");
    loadTasks();
  }
}

// Функція для ініціалізації підвкладок
function initSubTabs() {
  subTabButtons = document.querySelectorAll(".sub-tab-button");
  subTabPanels = document.querySelectorAll(".sub-tab-panel");

  subTabButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      // Find the closest button element, regardless of whether icon or text was clicked
      const btn = e.target.closest('.sub-tab-button');
      if (btn) {
        const subTabId = btn.getAttribute("data-sub-tab");
        if (subTabId) switchSubTab(subTabId);
      }
    });
  });

  // Додаємо підтримку клавіатури для підвкладок
  subTabButtons.forEach((button) => {
    button.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        const btn = e.target.closest('.sub-tab-button');
        if (btn) {
          const subTabId = btn.getAttribute("data-sub-tab");
          if (subTabId) switchSubTab(subTabId);
        }
      }
    });
  });
}

// Функція перевірки авторизації та ініціалізації
async function checkAuthAndInit() {
  try {
    const response = await fetch(`api/check-session.php?_=${Date.now()}`);
    const data = await response.json();

    if (data.success) {
      document.body.classList.remove("auth-pending");
      // Ініціалізуємо всі компоненти
      initTabPanel();
      initEdgeTableScrollbars();
      await Promise.all([loadProjects(), loadProfile()]);
      refreshEdgeTableScrollbars();
      // застосувати фільтр вкладок за дозволами користувача
      try {
        applyTabAccessFromSettings();
      } catch (e) {
        console.warn("applyTabAccessFromSettings error", e);
      }
    } else {
      window.location.href = "login.html";
    }
  } catch (error) {
    console.error("Помилка перевірки авторизації: ", error);
    // При помилці також перенаправляємо на login
    window.location.href = "login.html";
  }
}

function applyTabAccessFromSettings() {
  // 1) Якщо поточний користувач — super_admin за своєю роллю, не обмежуємо
  fetch("api/profile.php")
    .then((r) => r.json())
    .then((profile) => {
      if (
        profile &&
        profile.success &&
        String((profile.data || {}).role || "").toLowerCase() === "super_admin"
      ) {
        window.currentUserId = Number((profile.data || {}).id || 0);
        window.currentUserRole = "super_admin";
        // Super_admin має повні права, додаємо клас ініціалізації
        document.body.classList.add("tabs-initialized");
        return; // повні права
      }
      if (profile && profile.success) {
        window.currentUserId = Number((profile.data || {}).id || 0);
        window.currentUserRole = String(
          (profile.data || {}).role || "user",
        ).toLowerCase();
      }
      // 2) Інакше читаємо дозволені вкладки зі своїх налаштувань
      return fetch("api/settings.php")
        .then((r) => r.json())
        .then((res) => {
          if (!res || !res.success || !Array.isArray(res.data)) {
            // Якщо немає налаштувань, показуємо всі вкладки
            document.body.classList.add("tabs-initialized");
            return;
          }
          const item = res.data.find(
            (it) => String(it.name || "").toLowerCase() === "allowed_tabs",
          );
          const allowed = parseAllowedTabs(item ? item.value : "");

          // Для звичайного user приховуємо security.
          // admin і super_admin повинні бачити вкладку.
          const currentRole = String(
            window.currentUserRole || "user",
          ).toLowerCase();
          if (currentRole === "user") {
            const securityBtn = document.querySelector(
              '.sidebar-item[data-tab="security"]',
            );
            const securityPanel = document.getElementById("security");
            if (securityBtn) securityBtn.style.display = "none";
            if (securityPanel) securityPanel.style.display = "none";
          }

          if (allowed.size === 0) {
            // пустий — доступ до всіх, додаємо клас ініціалізації
            document.body.classList.add("tabs-initialized");
            return;
          }
          document.querySelectorAll(".sidebar-item").forEach((btn) => {
            const tabId = btn.getAttribute("data-tab") || "";
            // profile та settings завжди доступні всім
            if (["profile", "settings"].includes(tabId)) return;
            // security доступна тільки якщо є в allowed або якщо користувач admin/super_admin
            if (tabId === "security") {
              if (!allowed.has("security") && currentRole !== "admin") {
                const panel = document.getElementById(tabId);
                btn.style.display = "none";
                if (panel) panel.style.display = "none";
              }
              return;
            }
            // Для всіх інших вкладок
            if (!allowed.has(tabId)) {
              const panel = document.getElementById(tabId);
              btn.style.display = "none";
              if (panel) panel.style.display = "none";
            }
          });
          // Додаємо клас після обробки всіх вкладок
          document.body.classList.add("tabs-initialized");
        });
    })
    .catch(() => {
      // При помилці показуємо всі вкладки
      document.body.classList.add("tabs-initialized");
    });
}

// Функція для перемикання вкладок
function switchTab(tabId) {
  // Отримуємо актуальний список усіх кнопок та панелей
  const allButtons = document.querySelectorAll(".tab-button, .sidebar-item[data-tab]");
  const allPanels = document.querySelectorAll(".tab-panel");

  // Прибираємо активний клас з усіх кнопок та панелей
  allButtons.forEach((button) => {
    button.classList.remove("active");
  });

  allPanels.forEach((panel) => {
    panel.classList.remove("active");
  });

  const activeButton = document.querySelector(`[data-tab="${tabId}"]`);
  const activePanel = document.getElementById(tabId);

  if (activeButton && activePanel) {
    activeButton.classList.add("active");
    activePanel.classList.add("active");
    activePanel.style.removeProperty("display");
    activeButton.style.removeProperty("display");
    activePanel.classList.remove("tab-panel-fade-in");
    void activePanel.offsetWidth; // trigger reflow
    activePanel.classList.add("tab-panel-fade-in");
    updateURL(tabId); // Оновлюємо URL
    document.body.classList.toggle("dashboard-active", tabId === "dashboard");
    document.body.classList.toggle("egds-active", tabId === "egds");
    document.body.classList.toggle("tasks-active", tabId === "tasks");
    document.body.classList.toggle("finances-active", tabId === "finances");
    document.body.classList.toggle("youtube-active", tabId === "youtube");
    document.body.classList.toggle("training-active", tabId === "training");
    document.body.classList.toggle("security-active", tabId === "security");
    document.body.classList.toggle("profile-active", tabId === "profile");
    document.body.classList.toggle("statistics-active", tabId === "statistics");
    document.body.classList.toggle("settings-active", tabId === "settings");
    document.body.classList.toggle("projects-active", tabId === "projects");
    document.body.classList.toggle("goals-active", tabId === "goals");
    document.body.classList.toggle("notes-active", tabId === "notes");
    document.body.classList.toggle("habits-active", tabId === "habits");
    document.body.classList.toggle("pomodoro-active", tabId === "pomodoro");
    document.body.classList.toggle("photo-reports-active", tabId === "photo-reports");
    syncUnifiedHeaderLayout(tabId);
    updateTasksSmartSortButtonState();
    refreshAdaptiveSubTabMenus();
    requestAnimationFrame(() => {
      if (activePanel) {
        activePanel.querySelectorAll("table.data-table").forEach((t) => applyUniversalTableColumnSizing(t));
      }
    });

    // Оновлюємо заголовок сторінки
    const pageTitle = document.getElementById("page-title");
    const titles = {
      dashboard: "Сьогодні",
      tasks: "Завдання",
      projects: "Проекти",
      finances: "Фінанси",
      training: "Тренування",
      youtube: "YouTube",
      profile: "Профіль",
      security: "Безпека",
      settings: "Налаштування",
      statistics: "Статистика",
      egds: "eGDS",
      goals: "Цілі",
      "photo-reports": "Фотозвіти",
      notes: "База знань",
      habits: "Звички",
      pomodoro: "Помодоро",
    };
    const icons = {
      dashboard: "ri-calendar-event-line",
      tasks: "ri-checkbox-circle-line",
      projects: "ri-folder-3-line",
      finances: "ri-wallet-3-line",
      training: "ri-run-line",
      youtube: "ri-youtube-line",
      profile: "ri-user-line",
      security: "ri-shield-keyhole-line",
      settings: "ri-settings-4-line",
      statistics: "ri-bar-chart-2-line",
      egds: "ri-shopping-bag-3-line",
      goals: "ri-focus-3-line",
      "photo-reports": "ri-gallery-line",
      notes: "ri-book-read-line",
      habits: "ri-calendar-check-line",
      pomodoro: "ri-timer-line",
    };
    if (pageTitle && titles[tabId]) {
      const iconClass = icons[tabId] || "ri-file-text-line";
      pageTitle.innerHTML = `<i class="${iconClass} sub-tab-icon"></i><span>${titles[tabId]}</span>`;
    }

    // Завантажуємо відповідні дані для вкладки
    if (tabId === "projects") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");

      if (subTabId === "projects-active") {
        switchSubTab("projects-active");
      } else {
        switchSubTab("projects-active");
        updateURLWithSubTab("projects-active");
      }
      loadProjects();
    } else if (tabId === "tasks") {
      // При відкритті вкладки tasks — поважаємо sub-tab з URL, або дефолт
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set([
        "tasks-list",
        "tasks-archive",
        "tasks-all",
        "active-tasks",
        "today-tasks",
        "tasks-calendar",
        "no-date-tasks",
      ]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("tasks-list");
        updateURLWithSubTab("tasks-list");
      }
    } else if (tabId === "profile") {
      loadProfile();
    } else if (tabId === "security") {
      const secPanel = document.getElementById("users-list-content");
      if (secPanel) secPanel.classList.add("active");
      loadUsers();
    } else if (tabId === "settings") {
      activateSettingsMainPanel();
      ensureSettingsTableStructure();
      requestAnimationFrame(() => loadSettings(""));
      // PWA/mobile safeguard against delayed layout/cached shell race
      setTimeout(() => {
        if (document.body.classList.contains("settings-active")) {
          activateSettingsMainPanel();
          const tbody = document.getElementById("settings-table-tbody");
          if (!tbody || !tbody.children.length) loadSettings("");
        }
      }, 550);
    } else if (tabId === "finances") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["bank", "incomes", "expenses"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("bank");
        updateURLWithSubTab("bank");
      }
      // Завантажуємо дані підвкладки
      if (subTabId === "incomes") {
        loadIncomes();
      } else if (subTabId === "expenses") {
        loadExpenses();
      } else {
        loadBank();
      }
    } else if (tabId === "youtube") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      if (subTabId === "fancy-music") {
        switchSubTab("fancy-music");
      } else {
        switchSubTab("fancy-music");
        updateURLWithSubTab("fancy-music");
      }
    } else if (tabId === "training") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set([
        "running",
        "pullups",
        "pushups",
        "training-history",
      ]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("running");
        updateURLWithSubTab("running");
      }
    } else if (tabId === "egds") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["egds-products", "egds-orders"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("egds-products");
        updateURLWithSubTab("egds-products");
      }
    } else if (tabId === "goals") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["goals-current"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("goals-current");
        updateURLWithSubTab("goals-current");
      }
    } else if (tabId === "statistics") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["stats-general", "stats-training", "stats-egds", "stats-youtube"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("stats-general");
        updateURLWithSubTab("stats-general");
      }
      loadStatisticsDashboard();
    } else if (tabId === "dashboard") {
      loadDashboard();
    } else if (tabId === "photo-reports") {
      loadPhotoReportsTab();
    } else if (tabId === "notes") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["notes-list"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("notes-list");
        updateURLWithSubTab("notes-list");
      }
      if (typeof window.loadNotes === "function") window.loadNotes();
    } else if (tabId === "pomodoro") {
      const url = new URL(window.location);
      const subTabId = url.searchParams.get("sub-tab");
      const allowed = new Set(["pomodoro-timer", "pomodoro-stats"]);
      if (subTabId && allowed.has(subTabId)) {
        switchSubTab(subTabId);
      } else {
        switchSubTab("pomodoro-timer");
        updateURLWithSubTab("pomodoro-timer");
      }
      if (typeof window.loadPomodoroStats === "function") window.loadPomodoroStats();
    }

    refreshEdgeTableScrollbars();
  }
}

function syncUnifiedHeaderLayout(tabId) {
  const pageHeader = document.querySelector(".page-header");
  const pageHeaderRight = document.querySelector(".page-header-right");
  if (!pageHeader || !pageHeaderRight) return;

  if (
    tabId === "dashboard" ||
    tabId === "photo-reports" ||
    tabId === "egds" ||
    tabId === "tasks" ||
    tabId === "finances" ||
    tabId === "youtube" ||
    tabId === "projects" ||
    tabId === "goals" ||
    tabId === "training" ||
    tabId === "security" ||
    tabId === "profile" ||
    tabId === "statistics" ||
    tabId === "settings" ||
    tabId === "notes" ||
    tabId === "habits" ||
    tabId === "pomodoro"
  ) {
    const panelHeader = document.querySelector(`#${tabId} .tab-panel-header`);
    const panelRight = document.querySelector(`#${tabId} .tab-header-right`);
    if (!panelHeader) return;

    if (panelRight && pageHeaderRight.parentElement !== panelRight) {
      panelRight.insertBefore(pageHeaderRight, panelRight.firstChild || null);
    } else if (!panelRight && pageHeaderRight.parentElement !== panelHeader) {
      panelHeader.appendChild(pageHeaderRight);
    }
  } else {
    if (pageHeaderRight.parentElement !== pageHeader) {
      pageHeader.appendChild(pageHeaderRight);
    }
  }
}

const EDGE_TABLE_SCROLL_SELECTOR = ".data-table-container, .tab-panel-table";

function updateEdgeTableScrollbar(container) {
  if (!container) return;

  const bar = container.__edgeBar || null;
  const thumb = bar?.querySelector(".table-edge-thumb");
  if (!bar || !thumb) return;
  const barWidth = 1;
  const dpr = window.devicePixelRatio || 1;
  const snapToDevicePixel = (value) => Math.round(value * dpr) / dpr;
  const host = bar.parentElement;
  if (!host) return;

  const thead = container.querySelector("thead");
  const theadHeight = thead ? Math.round(thead.getBoundingClientRect().height) : 48;
  const topGap = Math.max(1, theadHeight + 1);
  const bottomGap = 9;
  const trackTop = container.offsetTop + topGap;
  const trackHeight = container.clientHeight - topGap - bottomGap;
  const containerRect = container.getBoundingClientRect();
  const hostRect = host.getBoundingClientRect();
  const cs = window.getComputedStyle(container);
  const borderRightWidth = parseFloat(cs.borderRightWidth || "1") || 1;
  const borderCenterX = containerRect.right - hostRect.left - borderRightWidth / 2;
  const maxScrollTop = container.scrollHeight - container.clientHeight;

  if (trackHeight <= 0) {
    bar.classList.add("is-hidden");
    return;
  }

  bar.style.left = `${snapToDevicePixel(borderCenterX - 0.5)}px`;
  bar.style.top = `${trackTop}px`;
  bar.style.height = `${trackHeight}px`;

  if (maxScrollTop <= 1) {
    bar.classList.add("is-hidden");
    return;
  }

  bar.classList.remove("is-hidden");
  const ratio = container.clientHeight / container.scrollHeight;
  const thumbHeight = Math.max(24, Math.round(trackHeight * ratio));
  const boundedThumbHeight = Math.min(trackHeight, thumbHeight);
  const maxThumbTop = Math.max(0, trackHeight - boundedThumbHeight);
  const thumbTop =
    maxScrollTop > 0
      ? Math.round((container.scrollTop / maxScrollTop) * maxThumbTop)
      : 0;

  thumb.style.height = `${boundedThumbHeight}px`;
  thumb.style.transform = `translateY(${thumbTop}px)`;
}

function updateBottomTableScrollbar(container) {
  if (!container) return;

  const bar = container.__bottomBar || null;
  const thumb = bar?.querySelector(".table-bottom-thumb");
  if (!bar || !thumb) return;
  const barHeight = 12;
  const dpr = window.devicePixelRatio || 1;
  const snapToDevicePixel = (value) => Math.round(value * dpr) / dpr;

  const sideInset = 12;
  const trackLeft = container.offsetLeft + sideInset;
  const trackWidth = container.clientWidth - sideInset * 2;
  const host = bar.parentElement;
  if (!host) return;
  const containerRect = container.getBoundingClientRect();
  const hostRect = host.getBoundingClientRect();
  const cs = window.getComputedStyle(container);
  const borderBottomWidth = parseFloat(cs.borderBottomWidth || "1") || 1;
  const borderCenterY =
    containerRect.bottom - hostRect.top - borderBottomWidth / 2;
  const maxScrollLeft = container.scrollWidth - container.clientWidth;

  if (trackWidth <= 0 || maxScrollLeft <= 1) {
    bar.classList.add("is-hidden");
    return;
  }

  bar.style.left = `${trackLeft}px`;
  bar.style.top = `${snapToDevicePixel(borderCenterY - barHeight / 2 - 0.5)}px`;
  bar.style.width = `${trackWidth}px`;
  bar.classList.remove("is-hidden");

  const ratio = container.clientWidth / container.scrollWidth;
  const thumbWidth = Math.max(24, Math.round(trackWidth * ratio));
  const boundedThumbWidth = Math.min(trackWidth, thumbWidth);
  const maxThumbLeft = Math.max(0, trackWidth - boundedThumbWidth);
  const thumbLeft =
    maxScrollLeft > 0
      ? Math.round((container.scrollLeft / maxScrollLeft) * maxThumbLeft)
      : 0;

  thumb.style.width = `${boundedThumbWidth}px`;
  thumb.style.transform = `translateX(${thumbLeft}px) translateY(calc(-50% + 0.5px))`;
}

function ensureEdgeTableScrollbar(container) {
  if (!container || container.dataset.edgeScrollbarInit === "1") {
    updateEdgeTableScrollbar(container);
    updateBottomTableScrollbar(container);
    return;
  }

  const host = container.parentElement;
  if (!host) return;
  if (getComputedStyle(host).position === "static") {
    host.style.position = "relative";
  }
  host.classList.add("edge-scrollbar-host");

  let bar = host.querySelector(":scope > .table-edge-scrollbar");
  if (!bar) {
    bar = document.createElement("div");
    bar.className = "table-edge-scrollbar is-hidden";
    bar.innerHTML = '<div class="table-edge-thumb"></div>';
    host.appendChild(bar);
  }
  container.__edgeBar = bar;

  let bottomBar = host.querySelector(":scope > .table-bottom-scrollbar");
  if (!bottomBar) {
    bottomBar = document.createElement("div");
    bottomBar.className = "table-bottom-scrollbar is-hidden";
    bottomBar.innerHTML = '<div class="table-bottom-thumb"></div>';
    host.appendChild(bottomBar);
  }
  container.__bottomBar = bottomBar;

  container.addEventListener(
    "scroll",
    () => {
      updateEdgeTableScrollbar(container);
      updateBottomTableScrollbar(container);
    },
    { passive: true },
  );

  const observer = new MutationObserver(() => {
    requestAnimationFrame(() => {
      updateEdgeTableScrollbar(container);
      updateBottomTableScrollbar(container);
    });
  });
  observer.observe(container, { childList: true, subtree: true });

  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(() => {
      updateEdgeTableScrollbar(container);
      updateBottomTableScrollbar(container);
    });
    resizeObserver.observe(container);
    const thead = container.querySelector("thead");
    if (thead) resizeObserver.observe(thead);
    container.__edgeResizeObserver = resizeObserver;
  }

  function scrollFromPointer(clientY, dragOffset = 0) {
    const rect = bar.getBoundingClientRect();
    const thumbHeight = edgeThumb?.offsetHeight || 0;
    const maxThumbTop = Math.max(1, rect.height - thumbHeight);
    const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
    const rawTop = clientY - rect.top - dragOffset;
    const thumbTop = Math.min(Math.max(0, rawTop), maxThumbTop);
    container.scrollTop = (thumbTop / maxThumbTop) * maxScrollTop;
  }

  const edgeThumb = bar.querySelector(".table-edge-thumb");
  let isDragging = false;
  let activeDragOffset = 0;

  const onMove = (moveEvent) => {
    if (!isDragging) return;
    moveEvent.preventDefault();
    scrollFromPointer(moveEvent.clientY, activeDragOffset);
  };

  const onUp = () => {
    if (!isDragging) return;
    isDragging = false;
    bar.classList.remove("is-dragging");
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", onMove);
    document.removeEventListener("mouseup", onUp);
    window.removeEventListener("mouseup", onUp);
    window.removeEventListener("blur", onUp);
    updateEdgeTableScrollbar(container);
  };

  const startDrag = (startY, dragOffset) => {
    isDragging = true;
    bar.classList.add("is-dragging");
    activeDragOffset = dragOffset;
    document.body.style.userSelect = "none";
    scrollFromPointer(startY, activeDragOffset);
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("blur", onUp);
  };

  if (edgeThumb) {
    edgeThumb.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      const thumbRect = edgeThumb.getBoundingClientRect();
      startDrag(e.clientY, e.clientY - thumbRect.top);
    });
  }

  bar.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    const thumbHeight = edgeThumb ? edgeThumb.offsetHeight : 0;
    startDrag(e.clientY, thumbHeight / 2);
  });

  function scrollFromPointerX(clientX, dragOffset = 0) {
    const rect = bottomBar.getBoundingClientRect();
    const thumbWidth = bottomThumb?.offsetWidth || 0;
    const maxThumbLeft = Math.max(1, rect.width - thumbWidth);
    const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
    const rawLeft = clientX - rect.left - dragOffset;
    const thumbLeft = Math.min(Math.max(0, rawLeft), maxThumbLeft);
    container.scrollLeft = (thumbLeft / maxThumbLeft) * maxScrollLeft;
  }

  const bottomThumb = bottomBar.querySelector(".table-bottom-thumb");
  let isDraggingX = false;
  let activeDragOffsetX = 0;

  const onMoveX = (moveEvent) => {
    if (!isDraggingX) return;
    moveEvent.preventDefault();
    scrollFromPointerX(moveEvent.clientX, activeDragOffsetX);
  };

  const onUpX = () => {
    if (!isDraggingX) return;
    isDraggingX = false;
    bottomBar.classList.remove("is-dragging");
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", onMoveX);
    document.removeEventListener("mouseup", onUpX);
    window.removeEventListener("mouseup", onUpX);
    window.removeEventListener("blur", onUpX);
    updateBottomTableScrollbar(container);
  };

  const startDragX = (startX, dragOffsetX) => {
    isDraggingX = true;
    bottomBar.classList.add("is-dragging");
    activeDragOffsetX = dragOffsetX;
    document.body.style.userSelect = "none";
    scrollFromPointerX(startX, activeDragOffsetX);
    document.addEventListener("mousemove", onMoveX);
    document.addEventListener("mouseup", onUpX);
    window.addEventListener("mouseup", onUpX);
    window.addEventListener("blur", onUpX);
  };

  if (bottomThumb) {
    bottomThumb.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      const thumbRect = bottomThumb.getBoundingClientRect();
      startDragX(e.clientX, e.clientX - thumbRect.left);
    });
  }

  bottomBar.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    e.preventDefault();
    const thumbWidth = bottomThumb ? bottomThumb.offsetWidth : 0;
    startDragX(e.clientX, thumbWidth / 2);
  });

  container.__edgeMutationObserver = observer;
  container.dataset.edgeScrollbarInit = "1";
  updateEdgeTableScrollbar(container);
  updateBottomTableScrollbar(container);
}

function refreshEdgeTableScrollbars() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.querySelectorAll(EDGE_TABLE_SCROLL_SELECTOR).forEach((container) => {
        ensureEdgeTableScrollbar(container);
        updateEdgeTableScrollbar(container);
        updateBottomTableScrollbar(container);
      });
    });
  });
}

function initEdgeTableScrollbars() {
  if (window.__edgeTableScrollbarsInitialized) return;
  window.__edgeTableScrollbarsInitialized = true;
  refreshEdgeTableScrollbars();
  window.addEventListener("resize", refreshEdgeTableScrollbars, { passive: true });
}

// Функція для перемикання підвкладок
function switchSubTab(subTabId) {
  // Додаємо активний клас для обраної підкнопки та підвкладки
  const activeSubButton =
    document.querySelector(`.tab-panel.active [data-sub-tab="${subTabId}"]`) ||
    document.querySelector(`[data-sub-tab="${subTabId}"]`);
  const activeSubPanel = document.getElementById(`${subTabId}-content`);

  const ownerTab =
    activeSubPanel?.closest(".tab-panel") ||
    activeSubButton?.closest(".tab-panel") ||
    document.querySelector(".tab-panel.active");
  if (ownerTab) {
    ownerTab.querySelectorAll(".sub-tab-button").forEach((button) => {
      button.classList.remove("active");
    });
    ownerTab.querySelectorAll(".sub-tab-panel").forEach((panel) => {
      panel.classList.remove("active");
    });
  }

  if (activeSubButton && activeSubPanel) {
    activeSubButton.classList.add("active");
    activeSubPanel.classList.add("active");
    activeSubPanel.classList.remove("sub-tab-panel-fade-in");
    void activeSubPanel.offsetWidth; // trigger reflow
    activeSubPanel.classList.add("sub-tab-panel-fade-in");

    // Оновлюємо URL з підвкладкою
    updateURLWithSubTab(subTabId);
  }

  updateTasksSmartSortButtonState();
  refreshAdaptiveSubTabMenus();
  requestAnimationFrame(() => {
    const activeSub = document.querySelector(".sub-tab-panel.active");
    if (activeSub) {
      activeSub.querySelectorAll("table.data-table").forEach((t) => applyUniversalTableColumnSizing(t));
    }
  });

  // Завантажуємо відповідні дані для підвкладки
  if (subTabId === "projects-active") {
    loadProjects();
  } else if (
    subTabId === "tasks-list" ||
    subTabId === "tasks-archive" ||
    subTabId === "tasks-all" ||
    subTabId === "active-tasks" ||
    subTabId === "today-tasks" ||
    subTabId === "tasks-calendar" ||
    subTabId === "no-date-tasks"
  ) {
    loadTasks();
  } else if (subTabId === "bank") {
    loadBank();
  } else if (subTabId === "incomes") {
    loadIncomes();
  } else if (subTabId === "expenses") {
    loadExpenses();
  } else if (
    subTabId === "running" ||
    subTabId === "pullups" ||
    subTabId === "pushups" ||
    subTabId === "training-history"
  ) {
    initTrainingSubTab(subTabId);
  } else if (subTabId === "egds-products" || subTabId === "egds-orders") {
    cancelEgdsForms();
    loadEgds();
  } else if (subTabId === "goals-current") {
    cancelGoalDialogs();
    loadGoals();
  } else if (subTabId === "fancy-music") {
    loadYoutube();
  }

  refreshEdgeTableScrollbars();
}

// Функція для оновлення URL з підвкладкою
function updateURLWithSubTab(subTabId) {
  const url = new URL(window.location);
  const currentTab = url.searchParams.get("tab");

  // Додаємо підвкладку тільки якщо ми на табі з підвкладками
  if (
    currentTab === "projects" ||
    currentTab === "tasks" ||
    currentTab === "finances" ||
    currentTab === "youtube" ||
    currentTab === "egds" ||
    currentTab === "goals"
  ) {
    url.searchParams.set("sub-tab", subTabId);
    window.history.replaceState({}, "", url);
  }
}

// Функція для оновлення URL
function updateURL(tabId) {
  const url = new URL(window.location);
  url.searchParams.set("tab", tabId);
  url.searchParams.delete("sub-tab");
  window.history.pushState({}, "", url);
}

function isTypingContext(target) {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = String(target.tagName || "").toLowerCase();
  if (tag === "input" || tag === "textarea" || tag === "select") return true;
  return Boolean(
    target.closest("input, textarea, select, [contenteditable='true']"),
  );
}

function getActiveTasksPanel() {
  return document.querySelector("#tasks .sub-tab-panel.active");
}

function getPreferredTaskRow() {
  const panel = getActiveTasksPanel();
  if (!panel) return null;
  const tbody = panel.querySelector("tbody");
  if (!tbody) return null;

  const selected = tbody.querySelector("tr .row-checkbox:checked");
  if (selected) {
    const selectedRow = selected.closest("tr");
    if (selectedRow) return selectedRow;
  }

  if (lastActiveTaskId) {
    const remembered = tbody.querySelector(`tr[data-id="${lastActiveTaskId}"]`);
    if (remembered) return remembered;
  }

  return tbody.querySelector("tr[data-id]");
}

function setActiveTaskRow(row) {
  const panel = getActiveTasksPanel();
  if (!panel) return;
  panel.querySelectorAll("tr.task-row-active").forEach((tr) => {
    tr.classList.remove("task-row-active");
  });
  if (!row) return;
  row.classList.add("task-row-active");
  const id = Number(row.dataset.id || 0);
  if (id) lastActiveTaskId = id;
}

function parseTaskDueAt(rawValue) {
  const raw = String(rawValue || "").trim();
  if (!raw) return { date: null, hasTime: false };
  const match = raw.match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})(?:\s([0-1][0-9]|2[0-3]):([0-5][0-9]))?$/,
  );
  if (!match) return { date: null, hasTime: false };
  const day = Number(match[1]);
  const month = Number(match[2]) - 1;
  const year = Number(match[3]);
  const hour = match[4] != null ? Number(match[4]) : 0;
  const minute = match[5] != null ? Number(match[5]) : 0;
  return {
    date: new Date(year, month, day, hour, minute, 0, 0),
    hasTime: match[4] != null,
  };
}

function applyTasksSmartSortPreset(items) {
  const now = new Date();
  const todayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    0,
    0,
    0,
    0,
  );
  const tomorrowStart = new Date(todayStart);
  tomorrowStart.setDate(tomorrowStart.getDate() + 1);

  const groupByPriority = (task) => {
    const parsed = parseTaskDueAt(task?.due_at || task?.due_date || task?.date);
    if (!parsed.date) return 2;
    const dueDate = parsed.date;
    const isToday = dueDate >= todayStart && dueDate < tomorrowStart;
    const isOverdue = parsed.hasTime ? dueDate < now : dueDate < todayStart;
    if (isOverdue) return 0;
    if (isToday) return 1;
    return 2;
  };

  const toTimestamp = (task) => {
    const parsed = parseTaskDueAt(task?.due_at || task?.due_date || task?.date);
    return parsed.date ? parsed.date.getTime() : Number.POSITIVE_INFINITY;
  };

  return [...items].sort((a, b) => {
    const groupDiff = groupByPriority(a) - groupByPriority(b);
    if (groupDiff !== 0) return groupDiff;
    const dateDiff = toTimestamp(a) - toTimestamp(b);
    if (dateDiff !== 0) return dateDiff;
    return Number(b?.id || 0) - Number(a?.id || 0);
  });
}

function updateTasksSmartSortButtonState() {
  const btn = document.getElementById("tasks-smart-sort-toggle");
  if (!btn) return;
  btn.classList.toggle("active", tasksSmartSortEnabled);
  btn.setAttribute("aria-pressed", tasksSmartSortEnabled ? "true" : "false");
}

function initTasksSmartSortToggle() {
  const btn = document.getElementById("tasks-smart-sort-toggle");
  if (!btn || btn.__smartSortInit) return;
  btn.addEventListener("click", () => {
    tasksSmartSortEnabled = !tasksSmartSortEnabled;
    updateTasksSmartSortButtonState();
    loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
  });
  btn.__smartSortInit = true;
  updateTasksSmartSortButtonState();
}

function getAdaptiveSubTabLimit() {
  const w = window.innerWidth || 0;
  if (w <= 1100) return 2;
  if (w <= 1440) return 3;
  if (w <= 1800) return 4;
  return 5;
}

function closeAllAdaptiveSubTabMenus(exceptWrap = null) {
  document.querySelectorAll(".sub-tabs-more.is-open").forEach((wrap) => {
    if (exceptWrap && wrap === exceptWrap) return;
    wrap.classList.remove("is-open");
    const toggle = wrap.querySelector(".sub-tabs-more-toggle");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  });
}

function ensureAdaptiveSubTabMoreWrap(header) {
  let wrap = header.querySelector(":scope > .sub-tabs-more");
  if (!wrap) {
    wrap = document.createElement("div");
    wrap.className = "sub-tabs-more";
    wrap.innerHTML = `
      <button class="sub-tabs-more-toggle" type="button" aria-haspopup="true" aria-expanded="false">
        <i class="ri-more-line sub-tab-icon"></i>
        <span>Ще</span>
      </button>
      <div class="sub-tabs-more-menu"></div>
    `;
    header.appendChild(wrap);
  }
  return wrap;
}

function refreshAdaptiveSubTabMenuForHeader(header) {
  if (!header) return;
  const wrap = ensureAdaptiveSubTabMoreWrap(header);
  const toggle = wrap.querySelector(".sub-tabs-more-toggle");
  const menu = wrap.querySelector(".sub-tabs-more-menu");
  if (!toggle || !menu) return;

  // Restore buttons back into header before recalculating.
  Array.from(menu.querySelectorAll(":scope > .sub-tab-button[data-sub-tab]")).forEach((btn) => {
    header.insertBefore(btn, wrap);
  });

  const directButtons = Array.from(header.children).filter(
    (el) =>
      el instanceof HTMLElement &&
      el.classList.contains("sub-tab-button") &&
      el.hasAttribute("data-sub-tab"),
  );
  if (directButtons.length === 0) {
    wrap.remove();
    return;
  }

  const right = header.querySelector(":scope > .tab-header-right");
  const headerStyle = window.getComputedStyle(header);
  const gapRaw = headerStyle.columnGap || headerStyle.gap || "0";
  const gap = Number.parseFloat(gapRaw) || 0;
  const headerWidth = header.getBoundingClientRect().width || 0;
  const rightWidth = right ? right.getBoundingClientRect().width : 0;
  const availableLeftWidth = Math.max(0, headerWidth - rightWidth - gap);

  const label = toggle.querySelector("span");
  const measureLeftWidth = (visibleButtons, hiddenCount) => {
    let total = visibleButtons.reduce((sum, btn) => sum + (btn.getBoundingClientRect().width || 0), 0);
    let itemCount = visibleButtons.length;
    if (hiddenCount > 0) {
      if (label) label.textContent = `Ще (${hiddenCount})`;
      total += wrap.getBoundingClientRect().width || 0;
      itemCount += 1;
    } else if (label) {
      label.textContent = "Ще";
    }
    if (itemCount > 1) total += gap * (itemCount - 1);
    return total;
  };

  let visibleCount = directButtons.length;
  while (visibleCount > 1) {
    const hiddenCount = directButtons.length - visibleCount;
    const needed = measureLeftWidth(directButtons.slice(0, visibleCount), hiddenCount);
    if (needed <= availableLeftWidth) break;
    visibleCount -= 1;
  }

  const hidden = directButtons.slice(visibleCount);
  if (hidden.length === 0) {
    wrap.remove();
    return;
  }

  const visible = directButtons.slice(0, visibleCount);
  const afterVisible = visible[visible.length - 1]?.nextSibling || null;
  header.insertBefore(wrap, afterVisible);
  hidden.forEach((btn) => menu.appendChild(btn));

  if (label) label.textContent = `Ще (${hidden.length})`;
  const hasHiddenActive = hidden.some((btn) => btn.classList.contains("active"));
  toggle.classList.toggle("active", hasHiddenActive);
  toggle.setAttribute("aria-expanded", wrap.classList.contains("is-open") ? "true" : "false");
}

function refreshAdaptiveSubTabMenus() {
  document.querySelectorAll(".tab-panel .tab-panel-header").forEach((header) => {
    refreshAdaptiveSubTabMenuForHeader(header);
  });
}

function initAdaptiveSubTabMenus() {
  if (window.__adaptiveSubTabsInitialized) {
    refreshAdaptiveSubTabMenus();
    return;
  }
  window.__adaptiveSubTabsInitialized = true;

  document.addEventListener("click", (e) => {
    const toggle = e.target.closest(".sub-tabs-more-toggle");
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      const wrap = toggle.closest(".sub-tabs-more");
      if (!wrap) return;
      const willOpen = !wrap.classList.contains("is-open");
      closeAllAdaptiveSubTabMenus(wrap);
      wrap.classList.toggle("is-open", willOpen);
      toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
      return;
    }

    const subTabBtnInMenu = e.target.closest(".sub-tabs-more-menu .sub-tab-button");
    if (subTabBtnInMenu) {
      closeAllAdaptiveSubTabMenus();
      return;
    }

    if (!e.target.closest(".sub-tabs-more")) {
      closeAllAdaptiveSubTabMenus();
    }
  });

  let resizeRaf = 0;
  window.addEventListener(
    "resize",
    () => {
      cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => {
        closeAllAdaptiveSubTabMenus();
        refreshAdaptiveSubTabMenus();
      });
    },
    { passive: true },
  );

  refreshAdaptiveSubTabMenus();
}

function getSelectedTaskIds() {
  const panel = getActiveTasksPanel();
  if (!panel) return [];
  const tbody = panel.querySelector("tbody");
  if (!tbody) return [];
  return Array.from(tbody.querySelectorAll(".row-checkbox:checked"))
    .map((cb) => Number(cb.closest("tr")?.dataset.id || 0))
    .filter(Boolean);
}

async function openTaskForEdit(taskId) {
  if (!taskId) return;
  try {
    const response = await fetch(`api/tasks.php?id=${Number(taskId)}`);
    const data = await response.json();
    if (data?.success && data.data) {
      showEditTaskPanel(data.data);
    } else {
      showMessage("Помилка завантаження завдання", "error");
    }
  } catch (_) {
    showMessage("Помилка завантаження завдання", "error");
  }
}

function deleteTaskById(taskId, row) {
  if (!taskId) return;
  const isArchiveView = getActiveTasksPanel()?.id === "tasks-archive-content";
  showConfirm("Ви дійсно хочете видалити це завдання?", () => {
    fetch("api/tasks.php", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(isArchiveView ? { id: taskId, permanent: true } : { id: taskId }),
    })
      .then((r) => r.json())
      .then((res) => {
        if (res?.success) {
          if (row) row.remove();
          updateSelectedCount();
          updateSelectAllCheckBox();
          showMessage(
            isArchiveView ? "Завдання видалено назавжди" : "Завдання видалено",
            "success",
          );
          if (!row) {
            loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
          }
        } else {
          showMessage(res?.error || "Не вдалося видалити завдання", "error");
        }
      })
      .catch(() => showMessage("Не вдалося видалити завдання", "error"));
  });
}

async function bulkUpdateTasks(ids, payload, successMessage) {
  if (!ids.length) {
    showMessage("Нічого не вибрано", "error");
    return;
  }
  const results = await Promise.all(
    ids.map(async (id) => {
      try {
        const response = await fetch("api/tasks.php", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, ...payload }),
        });
        const data = await response.json();
        return Boolean(data?.success);
      } catch (_) {
        return false;
      }
    }),
  );
  const ok = results.filter(Boolean).length;
  const fail = results.length - ok;
  if (ok > 0) {
    showMessage(
      fail > 0
        ? `${successMessage} (${ok} успішно, ${fail} з помилкою)`
        : successMessage,
      fail > 0 ? "error" : "success",
    );
    await loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
  } else {
    showMessage("Масове оновлення не виконано", "error");
  }
}

async function runTaskBulkAction(action) {
  const ids = getSelectedTaskIds();
  if (!ids.length) {
    showMessage("Нічого не вибрано", "error");
    return;
  }

  if (action === "archive") {
    showConfirm(`Архівувати ${ids.length} завдань?`, async () => {
      await bulkUpdateTasks(ids, { done: true }, "Завдання архівовано");
    });
    return;
  }

  if (action === "category") {
    const value = prompt("Нова категорія (порожньо = очистити):", "");
    if (value === null) return;
    const category = value.trim() || null;
    await bulkUpdateTasks(ids, { category }, "Категорію оновлено");
    return;
  }

  if (action === "period") {
    const value = prompt(
      "Новий період:\n09:00-12:00 | 12:00-15:00 | 15:00-18:00 | 18:00-21:00\nпорожньо = очистити",
      "",
    );
    if (value === null) return;
    const period = value.trim();
    const allowed = new Set(["09:00-12:00", "12:00-15:00", "15:00-18:00", "18:00-21:00"]);
    if (period && !allowed.has(period)) {
      showMessage("Невірний формат періоду", "error");
      return;
    }
    await bulkUpdateTasks(ids, { day_period: period || null }, "Період оновлено");
    return;
  }

  if (action === "date") {
    const value = prompt(
      "Нова дата: ДД.ММ.РРРР або ДД.ММ.РРРР ГГ:ХХ\nпорожньо = без дати",
      "",
    );
    if (value === null) return;
    const dateValue = value.trim();
    const valid =
      dateValue === "" ||
      /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})(\s([0-1][0-9]|2[0-3]):([0-5][0-9]))?$/.test(
        dateValue,
      );
    if (!valid) {
      showMessage("Невірний формат дати", "error");
      return;
    }
    await bulkUpdateTasks(ids, { due_date: dateValue }, "Дату оновлено");
    return;
  }

  if (action === "limit") {
    const value = prompt("Новий ліміт (хв), порожньо = без ліміту:", "");
    if (value === null) return;
    const normalized = value.trim();
    if (normalized !== "" && !/^\d+$/.test(normalized)) {
      showMessage("Ліміт має бути числом", "error");
      return;
    }
    await bulkUpdateTasks(
      ids,
      { time_limit_minutes: normalized === "" ? "" : Number(normalized) },
      "Ліміт оновлено",
    );
  }
}

function initTaskBulkActions() {
  document.querySelectorAll("#tasks [data-task-bulk]").forEach((btn) => {
    if (btn.__taskBulkInit) return;
    btn.addEventListener("click", () => {
      const action = btn.getAttribute("data-task-bulk") || "";
      runTaskBulkAction(action);
      closeTaskBulkMenus();
    });
    btn.__taskBulkInit = true;
  });
}

function closeTaskBulkMenus() {
  document.querySelectorAll(".task-bulk-more.is-open").forEach((wrap) => {
    wrap.classList.remove("is-open");
  });
}

function initTaskBulkMenu() {
  document.querySelectorAll("#tasks .task-bulk-more").forEach((wrap) => {
    if (wrap.__bulkMenuInit) return;
    const toggle = wrap.querySelector(".task-bulk-more-toggle");
    if (!toggle) return;
    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = wrap.classList.contains("is-open");
      closeTaskBulkMenus();
      if (!isOpen) wrap.classList.add("is-open");
    });
    wrap.__bulkMenuInit = true;
  });

  if (!window.__taskBulkMenuDocInit) {
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".task-bulk-more")) {
        closeTaskBulkMenus();
      }
    });
    window.__taskBulkMenuDocInit = true;
  }
}

function initTaskKeyboardShortcuts() {
  if (window.__taskShortcutsInit) return;
  window.__taskShortcutsInit = true;

  document.addEventListener("keydown", (e) => {
    if (isTypingContext(e.target)) return;
    if (document.querySelector(".legacy-modal.active, .custom-modal.active")) return;

    const activeTab = document
      .querySelector(".sidebar-item.active")
      ?.getAttribute("data-tab");
    const key = String(e.key || "").toLowerCase();

    // Створення нового елемента (клавіша N) - працює на всіх вкладках, де є кнопка "Додати"
    if (key === "n" || e.code === "KeyN" || key === "т") {
      e.preventDefault();
      const activePanel = document.querySelector(".tab-panel.active");
      if (activePanel) {
        const activeSubPanel = activePanel.querySelector(".sub-tab-panel.active");
        const addBtn = (activeSubPanel || activePanel).querySelector(".add-data-table-item");
        if (addBtn) {
          addBtn.click();
          return;
        }
      }
      // Фолбек для вкладки завдань
      if (activeTab === "tasks") {
        showAddTaskPanel();
      }
      return;
    }

    // Швидкий пошук (клавіша F / а) - фокусується на полі пошуку
    if (key === "f" || e.code === "KeyF" || key === "а") {
      const searchInput = document.getElementById("page-search-input");
      if (searchInput) {
        e.preventDefault();
        searchInput.focus();
        searchInput.select();
        return;
      }
    }

    // Решта гарячих клавіш працюють виключно на вкладці завдань (tasks)
    if (activeTab !== "tasks") return;

    // Редагування завдання (клавіша E)
    if (key === "e" || e.code === "KeyE" || key === "у") {
      e.preventDefault();
      const row = getPreferredTaskRow();
      const id = Number(row?.dataset.id || 0);
      if (!id) {
        showMessage("Оберіть завдання для редагування", "error");
        return;
      }
      openTaskForEdit(id);
      return;
    }

    // Позначення виконаним (клавіша Space)
    if (key === " " || e.code === "Space") {
      e.preventDefault();
      const row = getPreferredTaskRow();
      const doneBox = row?.querySelector(".task-done");
      if (!doneBox) {
        showMessage("Немає доступного чекбокса в поточному рядку", "error");
        return;
      }
      doneBox.click();
      return;
    }

    // Видалення завдання (клавіша Delete)
    if (e.key === "Delete") {
      e.preventDefault();
      const selectedIds = getSelectedTaskIds();
      if (selectedIds.length > 0) {
        const bulkDelete = document.querySelector(
          "#tasks .data-table-bulk-actions .delete-data-table-item",
        );
        bulkDelete?.click();
        return;
      }
      const row = getPreferredTaskRow();
      const id = Number(row?.dataset.id || 0);
      if (!id) return;
      deleteTaskById(id, row);
    }
  });
}

// Функція для завантаження проектів з сортуванням
async function loadProjects(
  sortBy = currentSortField,
  sortOrder = currentSortOrder,
  searchQuery = "",
) {
  try {
    const params = new URLSearchParams({
      sort_by: sortBy,
      sort_order: sortOrder,
    });

    if (searchQuery) {
      params.append("search", searchQuery);
    }

    const response = await fetch(`api/projects.php?${params}`, { cache: "no-store" });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data.success) {
      displayProjects(data.data || []);
    } else {
      showMessage(data.message || "Помилка завантаження проектів", "error");
    }
  } catch (error) {
    console.error("Помилка завантаження списку проектів: ", error);
    showMessage("Помилка завантаження списку проектів", "error");
  } finally {
    isLoading = false;
  }
}

// Функція очищення пошуку
function clearSearch() {
  const searchInput = document.getElementById("search-input");
  if (searchInput) {
    searchInput.value = "";
    performSearch("");
  }
}

function renderEmptyTableState(tbody, message) {
  if (!tbody) return;
  const table = tbody.closest("table");
  const colspan = Math.max(1, table?.querySelectorAll("thead th").length || 1);
  tbody.innerHTML = `<tr><td colspan="${colspan}" style="text-align:center;color:rgba(255,255,255,0.5);">${escapeHtml(message || "Немає записів")}</td></tr>`;
}

function getEmptyMessageByPanelId(panelId) {
  const messages = {
    "tasks-list-content": "Немає активних завдань",
    "tasks-archive-content": "Немає завдань в архіві",
    "active-tasks-content": "Немає активних таймерів",
    "today-tasks-content": "Немає завдань на сьогодні",
    "no-date-tasks-content": "Немає завдань без дати",
    "projects-active-content": "Немає активних проектів",
    "egds-products-content": "Немає товарів",
    "egds-orders-content": "Немає замовлень",
    "goals-current-content": "Немає поточних цілей",
    "users-list-content": "Немає користувачів",
    "accounts-content": "Немає рахунків",
    "income-content": "Немає доходів",
    "expenses-content": "Немає витрат",
  };
  return messages[panelId] || "Немає записів";
}

function ensurePanelEmptyState(panel) {
  if (!panel) return;
  const tbody = panel.querySelector("tbody");
  if (!tbody) return;
  const hasDataRows = tbody.querySelectorAll("tr[data-id]").length > 0;
  if (!hasDataRows) {
    renderEmptyTableState(tbody, getEmptyMessageByPanelId(panel.id));
  }
}

// Функція для завантаження історії проектів
async function loadProjectsHistory() {
  try {
    const response = await fetch("api/projects-history.php");
    const data = await response.json();

    if (data.success) {
      displayProjectsHistory(data.projects);
    } else {
      console.error("Помилка завантаження історії: ", data.message);
    }
  } catch (error) {
    console.error("Помилка завантаження історії: ", error);
  }
}

function sanitizeClassName(str) {
  return String(str || "").toLowerCase().replace(/[^a-z0-9_-]/g, "-");
}

// Функція відображення проектів в таблиці
function displayProjects(projects) {
  const tbody = document.getElementById("projects-active-table-tbody") || document.getElementById("projects-table-tbody");
  if (!tbody) return;
  tbody.innerHTML = "";

  if (!projects || !projects.length) {
    renderEmptyTableState(tbody, "Немає активних проектів");
    return;
  }

  projects.forEach((project) => {
    const row = document.createElement("tr");
    row.dataset.id = String(project.id);
    row.innerHTML = `
      <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
      <td class="col-name">${escapeHtml(project.name || "")}</td>
      <td class="col-status"><span class="status-badge ${sanitizeClassName(project.status || "active")}">${escapeHtml(project.status || "—")}</span></td>
      <td class="col-date">${escapeHtml(project.created_at || "—")}</td>
      <td class="col-actions">
        <button class="row-more-btn" data-id="${project.id}" data-type="project">
          <i class="ri-more-2-fill"></i>
        </button>
      </td>
    `;
    tbody.appendChild(row);
  });
  resetCheckboxStates();
  const table = tbody.closest("table");
  if (table) applyUniversalTableColumnSizing(table);
}

async function openProjectEditById(id) {
  const projectId = Number(id);
  if (!projectId) return;
  try {
    const response = await fetch(`api/projects.php?id=${projectId}`, { cache: "no-store" });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    if (!data.success || !data.data) throw new Error(data.error || "Проект не знайдено");
    showEditProjectPanel(data.data);
  } catch (error) {
    showMessage("Помилка завантаження проекту", "error");
  }
}

function deleteProject(id) {
  const projectId = Number(id);
  if (!projectId) return;

  showConfirm("Видалити проект?", async () => {
    try {
      const response = await fetch("api/projects.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: projectId }),
      });
      const data = await response.json();
      if (!data.success) {
        showMessage(data.error || "Помилка видалення проекту", "error");
        return;
      }
      await loadProjects(currentSortField, currentSortOrder, currentSearchQuery);
      showMessage("Проект видалено", "success");
    } catch (error) {
      showMessage("Помилка видалення проекту", "error");
    }
  });
}

// Функція відображення історії проектів в таблиці
function displayProjectsHistory(projects) {
  const tbody = document.getElementById("history-table-tbody");

  if (!tbody) return;

  tbody.innerHTML = "";
  if (!projects.length) {
    renderEmptyTableState(tbody, "Немає записів в історії проектів");
    return;
  }

  projects.forEach((project) => {
    const row = document.createElement("tr");
    row.innerHTML = `
        <td class="col-checkbox">
            <input type="checkbox" class="row-checkbox" data-id="${project.number}">
        </td>
        <td class="col-id">${escapeHtml(String(project.number ?? ""))}</td>
        <td class="col-name">${escapeHtml(project.name || "")}</td>
        <td class="col-status">${escapeHtml(project.status || "")}</td>
        <td class="col-date">${escapeHtml(project.created_at || "")}</td>
    `;
    tbody.appendChild(row);
  });
}

const dataTbody = document.getElementById("data-table-tbody");
if (dataTbody && !dataTbody.__rowActionsInit) {
  dataTbody.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : null;
    if (btn.dataset.action === "edit") {
      btn.classList.toggle("active");
      // зчитуємо дані рядка для попереднього заповнення
      if (tr && id) {
        const project = {
          id,
          name: tr.querySelector(".col-name")?.textContent?.trim() || "",
          status:
            tr.querySelector(".col-status")?.textContent?.trim() || "Активний",
          created_at:
            tr.querySelector(".col-date")?.childNodes[0]?.textContent?.trim() ||
            "",
        };
        showEditProjectPanel(project);
      } else {
        showEditProjectPanel();
      }
    } else if (btn.dataset.action === "delete") {
      if (!id) return;
      showConfirm("Видалити запис?", () => {
        fetch("api/projects.php", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res && res.success) {
              tr?.remove();
              const panel = tr ? tr.closest(".sub-tab-panel") : null;
              ensurePanelEmptyState(panel);
              updateSelectedCount();
              updateSelectAllCheckBox();
              renumberTableRows();
              showMessage("Запис видалено", "success");
            } else {
              showMessage(res?.error || "Не вдалося видалити елемент", "error");
            }
          })
          .catch(() => showMessage("Не вдалося видалити елемент", "error"));
      });
    }
  });
  dataTbody.__rowActionsInit = true;
}

// Дії в таблицях задач (активні та історія)
// Функція для показу кастомного вікна підтвердження
function showConfirm(message, onConfirm) {
  const modal = document.getElementById("custom-confirm");
  const messageEl = document.getElementById("custom-confirm-message");
  const yesBtn = document.getElementById("custom-confirm-yes");
  const noBtn = document.getElementById("custom-confirm-no");

  if (!modal || !messageEl || !yesBtn || !noBtn) return;

  messageEl.textContent = message;
  modal.classList.add("active");

  const cleanup = () => {
    modal.classList.remove("active");
    yesBtn.onclick = null;
    noBtn.onclick = null;
  };

  yesBtn.onclick = () => {
    onConfirm();
    cleanup();
  };

  noBtn.onclick = () => {
    cleanup();
  };

  // Закриття при кліку поза вікном
  modal.onclick = (e) => {
    if (e.target === modal) cleanup();
  };
}

function openLegacyModal(panel) {
  if (!panel) return;
  panel.classList.add("active");
  panel.style.display = "";
}

function closeLegacyModal(panel) {
  if (!panel) return;
  panel.classList.remove("active");
  panel.style.display = "none";
}

function resetModalFormState(panel) {
  if (!panel) return;

  Object.keys(panel.dataset || {}).forEach((key) => {
    delete panel.dataset[key];
  });

  panel.querySelectorAll("input, textarea, select").forEach((field) => {
    if (field.tagName === "SELECT") {
      const options = Array.from(field.options || []);
      const defaultOption = options.find((opt) => opt.defaultSelected) || options[0];
      field.value = defaultOption ? defaultOption.value : "";
      return;
    }

    if (field.type === "checkbox" || field.type === "radio") {
      field.checked = !!field.defaultChecked;
      return;
    }

    field.value = field.defaultValue != null ? field.defaultValue : "";
  });

  panel.querySelectorAll(".custom-select").forEach((cs) => {
    const hidden = cs.querySelector('input[type="hidden"]');
    const toggle = cs.querySelector(".custom-select-toggle");
    const options = Array.from(cs.querySelectorAll(".custom-select-option"));
    if (!options.length) return;

    const currentValue = hidden
      ? hidden.value
      : cs.querySelector(".custom-select-option.is-selected")?.dataset.value || "";
    const selected =
      options.find(
        (opt) => (opt.dataset.value || opt.textContent.trim()) === currentValue,
      ) || options[0];
    const selectedValue = selected.dataset.value || selected.textContent.trim();

    options.forEach((opt) => opt.classList.remove("is-selected"));
    selected.classList.add("is-selected");
    if (hidden) hidden.value = selectedValue;
    if (toggle) toggle.textContent = selected.textContent.trim();
    cs.classList.remove("is-open");
  });

  panel.querySelectorAll(".field-select-wrap").forEach((wrap) => {
    wrap.classList.remove("is-open");
  });
  refreshPrettyFieldSelects(panel);
}

function closeActiveLegacyModalByContext(panel) {
  if (!panel) return;
  if (panel.classList.contains("add-user-panel")) return cancelUserPanel();
  if (panel.classList.contains("edit-user-panel")) return cancelEditUserPanel();
  if (panel.classList.contains("edit-profile-panel")) return cancelEditProfile();
  if (panel.classList.contains("add-bank-panel")) return cancelBankPanel();
  if (panel.classList.contains("edit-bank-panel")) return cancelEditBankPanel();
  if (panel.classList.contains("add-income-panel")) return cancelIncomePanel();
  if (panel.classList.contains("edit-income-panel"))
    return cancelEditIncomePanel();
  if (panel.classList.contains("add-expense-panel")) return cancelExpensePanel();
  if (panel.classList.contains("edit-expense-panel"))
    return cancelEditExpensePanel();
  closeLegacyModal(panel);
}

document.addEventListener("click", (e) => {
  const panel = e.target.closest(".legacy-modal.active");
  if (!panel || e.target !== panel) return;
  closeActiveLegacyModalByContext(panel);
});

document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
  const activePanels = document.querySelectorAll(".legacy-modal.active");
  if (!activePanels.length) return;
  closeActiveLegacyModalByContext(activePanels[activePanels.length - 1]);
});

function attachTaskTbodyHandlers(tbody) {
  if (!tbody || tbody.__rowActionsInit) return;
  tbody.addEventListener("click", function (e) {
    const clickedRow = e.target.closest("tr[data-id]");
    if (clickedRow) setActiveTaskRow(clickedRow);

    // toggle done by clicking on checkbox
    const doneBox = e.target.closest(".task-done");
    if (doneBox) {
      const tr = doneBox.closest("tr");
      const id = tr ? Number(tr.dataset.id) : 0;
      if (id) {
        // Скасовуємо попередній таймер видалення, якщо він є
        if (tr.dataset.removeTimeout) {
          clearTimeout(Number(tr.dataset.removeTimeout));
          delete tr.dataset.removeTimeout;
        }

        // Скидаємо класи анімації для коректного перезапуску
        tr.classList.remove("row-done-transition", "row-undo-transition");
        void tr.offsetWidth; // force reflow

        const nowDone = doneBox.checked;
        tr.classList.add(
          nowDone ? "row-done-transition" : "row-undo-transition",
        );

        fetch("api/tasks.php", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, done: nowDone }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (!res || !res.success) {
              showMessage(res?.error || "Не вдалося оновити статус", "error");
              doneBox.checked = !doneBox.checked; // відкотити
              tr.classList.remove("row-done-transition", "row-undo-transition");
              return;
            }
            const currentSub = document.querySelector(
              "#tasks .sub-tab-panel.active",
            );
            if (!currentSub) return;

            // Перевіряємо, чи потрібно видаляти рядок з поточного списку
            const isTasksList = currentSub.id === "tasks-list-content"; // Активні
            const isArchiveList = currentSub.id === "tasks-archive-content"; // Архів

            let shouldRemove = false;
            if (isTasksList && nowDone) shouldRemove = true; // Був активний, став виконаний -> видалити
            if (isArchiveList && !nowDone) shouldRemove = true; // Був в архіві, став активний -> видалити

            if (shouldRemove) {
              const delayMs = nowDone ? 1200 : 600;
              const timeoutId = setTimeout(() => {
                tr.remove();
                updateSelectedCount();
                updateSelectAllCheckBox();
                loadTasks(
                  currentSortField,
                  currentSortOrder,
                  currentSearchQuery,
                );
              }, delayMs);
              tr.dataset.removeTimeout = String(timeoutId);
            } else {
              // Якщо не видаляємо, то просто прибираємо клас анімації згодом
              setTimeout(() => {
                tr.classList.remove(
                  "row-done-transition",
                  "row-undo-transition",
                );
              }, 1200);
            }
          })
          .catch(() => {
            showMessage("Не вдалося оновити статус", "error");
            doneBox.checked = !doneBox.checked;
            tr.classList.remove("row-done-transition", "row-undo-transition");
          });
      }
      return; // Завершуємо, бо це був чекбокс
    }

    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : null;

    if (btn.dataset.action === "edit") {
      if (!id) return;
      openTaskForEdit(id);
    } else if (btn.dataset.action === "delete") {
      if (!id) return;
      deleteTaskById(id, tr);
    } else if (btn.dataset.action === "restore") {
      if (!id) return;
      fetch("api/tasks.php", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, restore: true }),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res && res.success) {
            tr?.remove();
            updateSelectedCount();
            updateSelectAllCheckBox();
            showMessage("Завдання відновлено", "success");
          } else {
            showMessage(res?.error || "Не вдалося відновити завдання", "error");
          }
        })
        .catch(() => showMessage("Не вдалося відновити завдання", "error"));
    } else if (btn.dataset.action === "start-timer") {
      if (!id) return;
      handleTimer(id, "start_timer", tr);
    } else if (btn.dataset.action === "pause-timer") {
      if (!id) return;
      handleTimer(id, "pause_timer", tr);
    } else if (btn.dataset.action === "stop-timer") {
      if (!id) return;
      handleTimer(id, "stop_timer", tr);
    } else if (btn.dataset.action === "reset-timer") {
      if (!id) return;
      showConfirm("Скинути таймер для цього завдання?", () => {
        handleTimer(id, "reset_timer", tr);
      });
    }
  });
  tbody.__rowActionsInit = true;
}

attachTaskTbodyHandlers(document.getElementById("tasks-table-tbody"));
attachTaskTbodyHandlers(document.getElementById("tasks-archive-table-tbody"));
attachTaskTbodyHandlers(document.getElementById("tasks-all-table-tbody"));
attachTaskTbodyHandlers(document.getElementById("active-tasks-table-tbody"));
attachTaskTbodyHandlers(document.getElementById("today-tasks-table-tbody"));
attachTaskTbodyHandlers(document.getElementById("no-date-tasks-table-tbody"));

// Уникаємо миготіння: завантаження даних керується у switchSubTab.
// Тут лише перевішуємо обробники після перемикання.
document.addEventListener("click", function (e) {
  const subBtn = e.target.closest(".sub-tab-button");
  if (!subBtn) return;
  const tab = subBtn.closest("#tasks");
  if (!tab) return;
  setTimeout(() => {
    attachTaskTbodyHandlers(document.getElementById("tasks-table-tbody"));
    attachTaskTbodyHandlers(
      document.getElementById("tasks-archive-table-tbody"),
    );
    attachTaskTbodyHandlers(document.getElementById("tasks-all-table-tbody"));
    attachTaskTbodyHandlers(
      document.getElementById("active-tasks-table-tbody"),
    );
    attachTaskTbodyHandlers(document.getElementById("today-tasks-table-tbody"));
    attachTaskTbodyHandlers(
      document.getElementById("no-date-tasks-table-tbody"),
    );
  }, 0);
});

// Перенумерація колонки № після змін у таблиці
function renumberTableRows() {
  const activeTabRoot = document.querySelector(".tab-panel.active");
  const activePanel = activeTabRoot
    ? activeTabRoot.querySelector(".sub-tab-panel.active")
    : null;
  // спеціальний випадок для security
  const panel = activePanel || document.getElementById("users-list-content");
  if (!panel) return;
  const tbody = panel.querySelector("tbody");
  if (!tbody) return;
  let i = 1;
  tbody.querySelectorAll("tr").forEach((tr) => {
    const numCell = tr.querySelector(".col-id");
    if (numCell) {
      numCell.textContent = i++;
    }
  });
}

// Функція для ініціалізації чекбоксів
function initCheckBoxes() {
  // Видаляємо всі попередні обробники для уникнення дублювання
  if (window.checkboxHandlersInitialized) return;
  window.checkboxHandlersInitialized = true;

  // Делегація подій для чекбоксу "вибрати всі" в заголовку
  document.addEventListener("change", function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    // Обробник для select-all-checkbox
    if (target.classList.contains("select-all-checkbox")) {
      const table = target.closest("table");
      if (!table) return;
      const tbody = table.querySelector("tbody");
      if (!tbody) return;

      // Встановлюємо статус всіх row-checkbox у поточній таблиці
      tbody.querySelectorAll(".row-checkbox").forEach((cb) => {
        cb.checked = target.checked;
      });

      updateSelectedCount();
      updateSelectAllCheckBox();
    }

    // Обробник для done-all-checkbox (масове позначення "Готово" для tasks)
    else if (target.classList.contains("done-all-checkbox")) {
      const table = target.closest("table");
      if (!table) return;
      const tbody = table.querySelector("tbody");
      if (!tbody) return;

      tbody.querySelectorAll(".task-done").forEach((cb) => {
        cb.checked = target.checked;
      });
    }

    // Обробник для row-checkbox (окремі рядки)
    else if (target.classList.contains("row-checkbox")) {
      updateSelectedCount();
      updateSelectAllCheckBox();
    }
  });
}

// Функція для ресету стану чекбоксів після завантаження даних
function resetCheckboxStates() {
  // Знаходимо всі select-all-checkbox та скидаємо їх стан
  document.querySelectorAll(".select-all-checkbox").forEach((checkbox) => {
    checkbox.checked = false;
    checkbox.indeterminate = false;
  });

  // Оновлюємо лічильник
  updateSelectedCount();
}

// Функція оновлення ліччильника обраних елементів
function updateSelectedCount() {
  const activeTabRoot = document.querySelector(".tab-panel.active");
  if (!activeTabRoot) return;
  let activePanel = activeTabRoot.querySelector(".sub-tab-panel.active");
  if (!activePanel && activeTabRoot.id === "security") {
    activePanel = document.getElementById("users-list-content");
  }
  if (!activePanel) return;

  const tableBody = activePanel.querySelector("tbody");
  if (!tableBody) return;

  const checkedCheckBoxes = tableBody.querySelectorAll(".row-checkbox:checked");
  const count = checkedCheckBoxes.length;

  // Працюємо тільки в межах активного табу (projects/tasks)
  const tabRoot = activeTabRoot;
  if (!tabRoot) return;

  const badgeContainer = tabRoot.querySelector(".selected-data-table-item");
  const badge = tabRoot.querySelector(".selected-data-table-item-badge");
  if (badge) badge.textContent = String(count);
  if (badgeContainer) badgeContainer.style.display = count > 0 ? "flex" : "none";
  tabRoot.classList.toggle("bulk-selection-active", count > 0);

  const bulkActions = tabRoot.querySelector(".data-table-bulk-actions");
  // Показуємо масові дії, якщо вибрано хоча б 1 рядок
  if (bulkActions) bulkActions.style.display = count > 0 ? "flex" : "none";
  if (count === 0) closeTaskBulkMenus();
  refreshAdaptiveSubTabMenus();
}

// Функція оновлення стану "вибрано всі" чекбокса
function updateSelectAllCheckBox() {
  const activeTabRoot = document.querySelector(".tab-panel.active");
  if (!activeTabRoot) return;
  let activePanel = activeTabRoot.querySelector(".sub-tab-panel.active");
  if (!activePanel && activeTabRoot.id === "security") {
    activePanel = document.getElementById("users-list-content");
  }
  if (!activePanel) return;

  const tableBody = activePanel.querySelector("tbody");
  if (!tableBody) return;

  const allCheckBoxes = tableBody.querySelectorAll(".row-checkbox");
  const checkedCheckBoxes = tableBody.querySelectorAll(".row-checkbox:checked");

  // select-all знаходиться в поточній таблиці (у шапці thead)
  const selectAllCheckBox = activePanel.querySelector(
    "thead .select-all-checkbox",
  );
  if (selectAllCheckBox) {
    selectAllCheckBox.checked =
      allCheckBoxes.length > 0 &&
      allCheckBoxes.length === checkedCheckBoxes.length;
    selectAllCheckBox.indeterminate =
      checkedCheckBoxes.length > 0 &&
      checkedCheckBoxes.length < allCheckBoxes.length;
  }
}

// Функція ініціалізації дій з проектами
function initProjectActions() {
  // Обробники для всіх кнопок додавання у видимих вкладках
  const addButtons = document.querySelectorAll(".add-data-table-item");
  addButtons.forEach((btn) => {
    if (btn.__addInit) return;
    btn.addEventListener("click", function () {
      const currentTab = document
        .querySelector(".sidebar-item.active")
        ?.getAttribute("data-tab");
      if (currentTab === "tasks") showAddTaskPanel();
      else if (currentTab === "security") showAddUserPanel();
      else if (currentTab === "egds") showEgdsAddDialog();
      else if (currentTab === "goals") showAddGoalDialog();
      else if (currentTab === "projects") showAddProjectPanel();
    });
    btn.__addInit = true;
  });

  // Edit buttons are handled per-row, no global editButton needed.
  if (false) {
    editButton.addEventListener("click", function () {
      this.classList.toggle("active");
      showEditProjectPanel();
    });
    editButton.__editInit = true;
  }

  // Масове видалення (кнопка в sub-tab-header) — для кожної панелі окремо
  const bulkDeleteBtns = document.querySelectorAll(
    ".data-table-bulk-actions .delete-data-table-item",
  );
  bulkDeleteBtns.forEach((bulkDeleteBtn) => {
    if (bulkDeleteBtn && !bulkDeleteBtn.__bulkInit) {
      bulkDeleteBtn.addEventListener("click", async function () {
        // Обмежуємо пошук активною вкладкою, щоб не брати "active" з прихованих табів
        const activeTabRoot = document.querySelector(".tab-panel.active");
        if (!activeTabRoot) return;
        let activePanel = activeTabRoot.querySelector(".sub-tab-panel.active");
        if (!activePanel && activeTabRoot.id === "security") {
          activePanel = document.getElementById("users-list-content");
        }
        if (!activePanel) return;
        const tableBody = activePanel.querySelector("tbody");
        if (!tableBody) return;
        // Фільтруємо виділення згідно прав: адміністратор не може масово видаляти інших адміністраторів або супер-адміністраторів
        const actorRole = String(
          window.currentUserRole || "user",
        ).toLowerCase();
        const actorId = Number(window.currentUserId || 0);
        const checked = Array.from(
          tableBody.querySelectorAll(".row-checkbox:checked"),
        ).filter((cb) => {
          if (activeTabRoot.id !== "security") return true;
          const tr = cb.closest("tr");
          const id = tr && tr.dataset.id ? Number(tr.dataset.id) : 0;
          const roleCell = tr ? tr.querySelectorAll(".col-status")[1] : null;
          const vis = roleCell
            ? (roleCell.textContent || "").trim().toLowerCase()
            : "";
          const back = {
            адміністратор: "admin",
            "супер-адміністратор": "super_admin",
            користувач: "user",
          };
          const targetRole = back[vis] || vis || "user";
          if (actorRole === "super_admin") {
            return !(targetRole === "super_admin" && id !== actorId);
          }
          if (actorRole === "admin") {
            return targetRole === "user" || id === actorId;
          }
          return false;
        });
        if (checked.length === 0) {
          showMessage("Нічого не вибрано");
          return;
        }
        showConfirm(`Видалити ${checked.length} запис(и)?`, async () => {
          // Отримуємо id з рядків
          const ids = checked
            .map((cb) => cb.closest("tr"))
            .filter((tr) => tr && tr.dataset.id)
            .map((tr) => Number(tr.dataset.id));
          if (ids.length === 0) {
            showMessage("Не знайдено id для видалення", "error");
            return;
          }

          try {
            const currentTab = document
              .querySelector(".sidebar-item.active")
              ?.getAttribute("data-tab");
            let url = "api/projects.php";
            if (currentTab === "tasks") url = "api/tasks.php";
            if (currentTab === "security") url = "api/users.php";
            if (currentTab === "egds") url = "api/egds.php";
            if (currentTab === "goals") url = "api/goals.php";
            const financesType =
              currentTab === "finances"
                ? activePanel.id === "incomes-content"
                  ? "incomes"
                  : activePanel.id === "expenses-content"
                    ? "expenses"
                    : "bank"
                : "";
            if (currentTab === "finances") url = `api/finances.php?type=${financesType}`;
            const egdsType =
              currentTab === "egds" && activePanel.id === "egds-orders-content"
                ? "orders"
                : "products";
            const isTasksArchive =
              currentTab === "tasks" && activePanel.id === "tasks-archive-content";
            await Promise.all(
              ids.map((id) =>
                fetch(url, {
                  method: "DELETE",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(
                    currentTab === "egds"
                      ? { id, type: egdsType }
                      : currentTab === "finances"
                        ? { id }
                      : currentTab === "tasks" && isTasksArchive
                        ? { id, permanent: true }
                        : { id },
                  ),
                }).then((r) => r.json()),
              ),
            );

            ids.forEach((id) => {
              const tr = tableBody.querySelector(`tr[data-id="${id}"]`);
              if (tr) tr.remove();
            });

            updateSelectedCount();
            updateSelectAllCheckBox();
            renumberTableRows();
            ensurePanelEmptyState(activePanel);
            const n = ids.length;
            showMessage(
              isTasksArchive
                ? `${n} запис${n % 10 === 1 && n % 100 !== 11 ? "" : "ів"} видалено назавжди`
                : `${n} запис${n % 10 === 1 && n % 100 !== 11 ? "" : "ів"} видалено`,
              "success",
            );
          } catch (e) {
            showMessage("Помилка масового видалення", "error");
          }
        });
      });
      bulkDeleteBtn.__bulkInit = true;
    }
  });

  // Обробники для всіх кнопок фільтрів
  const filterButtons = document.querySelectorAll(".filter-button");
  filterButtons.forEach((filterButton) => {
    if (filterButton.__filterInit) return;
    filterButton.addEventListener("click", function () {
      this.classList.toggle("active");
      // TODO: відкривати/закривати панель фільтрів
    });
    filterButton.__filterInit = true;
  });
}

// Функція показу панелі додавання проекту
function showAddProjectPanel() {
  const modal = document.getElementById("add-project-modal");
  if (!modal) return;

  const editModal = document.getElementById("edit-project-modal");
  if (editModal) editModal.classList.remove("active");

  resetModalFormState(modal);
  initPrettyFieldSelects(modal);
  refreshPrettyFieldSelects(modal);

  modal.classList.add("active");
  modal.onclick = (e) => {
    if (e.target === modal) cancelProjectPanel();
  };
}

// Функція приховування панелі (викликається через onclick)
function cancelProjectPanel() {
  const modal = document.getElementById("add-project-modal");
  if (modal) modal.classList.remove("active");
}

// Показ панелі редагування
function showEditProjectPanel(project) {
  const modal = document.getElementById("edit-project-modal");
  if (!modal) return;

  const addModal = document.getElementById("add-project-modal");
  if (addModal) addModal.classList.remove("active");

  modal.classList.add("active");

  // якщо прийшов об'єкт проекту — підставляємо значення
  if (project) {
    const name = modal.querySelector("#edit-project-modal-name");
    const statusInput = modal.querySelector("#edit-project-modal-status");
    const date = modal.querySelector("#edit-project-modal-date");
    if (name) name.value = project.name || "";
    if (statusInput)
      statusInput.value =
        project.status === "Завершений" || project.status === "В розробці"
          ? project.status
          : "Активний";
    if (date) date.value = project.created_at || "";
    modal.dataset.id = String(project.id || "");
  }

  initDateTimeInputs(modal);
  requestAnimationFrame(() => refreshDateGhostHints(modal));
  modal.onclick = (e) => {
    if (e.target === modal) cancelEditProjectPanel();
  };
}

function cancelEditProjectPanel() {
  const modal = document.getElementById("edit-project-modal");
  if (modal) modal.classList.remove("active");
}

async function updateProject() {
  const modal = document.getElementById("edit-project-modal");
  if (!modal) return;
  const id = Number(modal.dataset.id || 0);
  const nameInput = document.getElementById("edit-project-modal-name");
  const statusSelect = document.getElementById("edit-project-modal-status");
  const dateInput = document.getElementById("edit-project-modal-date");
  if (!id) {
    showMessage("Невірні дані для збереження", "error");
    return;
  }
  if (!nameInput || !nameInput.value.trim()) {
    showMessage("Не введено назву", "error");
    return;
  }
  if (!statusSelect || !String(statusSelect.value || "").trim()) {
    showMessage("Не вибрано статус", "error");
    return;
  }
  if (!dateInput || !dateInput.value.trim()) {
    showMessage("Не введено дату", "error");
    return;
  }
  try {
    // фінальна перевірка формату дати перед відправкою
    let createdAt = dateInput && dateInput.value ? dateInput.value : undefined;
    if (
      createdAt &&
      !/^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(
        createdAt,
      )
    ) {
      showMessage(
        "Невірний формат дати. Використовуйте ДД.ММ.РРРР ГГ:ХХ",
        "error",
      );
      return;
    }
    const response = await fetch("api/projects.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        name: nameInput.value.trim(),
        status:
          statusSelect && statusSelect.value ? statusSelect.value : "Активний",
        created_at: createdAt,
      }),
    });
    const data = await response.json();
    if (data.success) {
      cancelEditProjectPanel();
      await loadProjects();
      showMessage("Запис оновлено", "success");
    } else {
      showMessage(data.error || "Помилка оновлення запису", "error");
    }
  } catch (e) {
    showMessage("Помилка збереження запису", "error");
  }
}

// Функція для збереження проекту (викликається через onclick)
async function saveProject() {
  const nameInput = document.getElementById("project-modal-name");
  const statusSelect = document.getElementById("project-modal-status");
  if (!nameInput || !nameInput.value.trim()) {
    showMessage("Не введено назву", "error");
    return;
  }
  if (!statusSelect || !String(statusSelect.value || "").trim()) {
    showMessage("Не вибрано статус", "error");
    return;
  }

  try {
    const response = await fetch("api/projects.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: nameInput.value.trim(),
        status:
          statusSelect && statusSelect.value ? statusSelect.value : "Активний",
      }),
    });

    const data = await response.json();

    if (data.success) {
      // Приховуємо панель
      cancelProjectPanel();
      // Перезавантажуємо список проектів
      await loadProjects();
      showMessage("Запис створено", "success");
    } else {
      showMessage(data.error || "Помилка створення запису", "error");
    }
  } catch (error) {
    console.error("Помилка збереження проекту: ", error);
    showMessage("Помилка збереження запису", "error");
  }
}

// Функція для оновлення іконок сортування
function updateSortIcons(sortBy, sortOrder) {
  const activeTab = document.querySelector(".sidebar-item.active")?.getAttribute("data-tab");
  const tabRoot = activeTab ? document.querySelector(`#${activeTab}`) : null;
  const scope =
    tabRoot?.querySelector(".sub-tab-panel.active") ||
    tabRoot ||
    document;
  if (!scope) return;

  // Скидаємо іконки тільки в активній вкладці
  scope.querySelectorAll(".data-table th.sortable").forEach((th) => {
    th.classList.remove("sort-asc", "sort-desc");
  });

  // Встановлюємо активну іконку тільки в активній вкладці
  const activeTh = scope.querySelector(
    `.data-table th[data-sort="${sortBy}"]`,
  );
  if (activeTh) {
    activeTh.classList.add(sortOrder === "ASC" ? "sort-asc" : "sort-desc");
  }
}

// Функція ініціалізації сортування
function initSorting() {
  document.querySelectorAll(".data-table th.sortable").forEach((th) => {
    th.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Запобігаємо швидким клікам
      if (isLoading) {
        return;
      }

      const sortField = this.getAttribute("data-sort");

      // Визначаємо новий порядок сортування
      let newSortOrder = "ASC";
      if (currentSortField === sortField) {
        newSortOrder = currentSortOrder === "ASC" ? "DESC" : "ASC";
      }

      // Оновлюємо глобальні змінні
      currentSortField = sortField;
      currentSortOrder = newSortOrder;

      // Оновлюємо візуальні індикатори
      updateSortIcons(sortField, newSortOrder);

      // Завантажуємо дані з новим сортуванням для активного табу
      const activeTab = document
        .querySelector(".sidebar-item.active")
        ?.getAttribute("data-tab");
      if (activeTab === "tasks") {
        loadTasks(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "security") {
        loadUsers(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "egds") {
        loadEgds(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "goals") {
        loadGoals(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "finances") {
        const sub = document.querySelector("#finances .sub-tab-panel.active")?.id;
        if (sub === "bank-content") loadBank(sortField, newSortOrder, currentSearchQuery);
        else if (sub === "incomes-content") loadIncomes(sortField, newSortOrder, currentSearchQuery);
        else if (sub === "expenses-content") loadExpenses(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "youtube") {
        loadYoutube(sortField, newSortOrder, currentSearchQuery);
      } else if (activeTab === "training") {
        loadTrainingHistory(currentHistoryFilter);
      } else {
        loadProjects(sortField, newSortOrder, currentSearchQuery);
      }
    });
  });
}

// Функція ініціалізації пошуку
function initSearch() {
  const searchInput = document.getElementById("page-search-input");
  const clearBtn = document.getElementById("page-search-clear");

  if (searchInput) {
    searchInput.addEventListener("input", function () {
      const query = this.value.trim();
      if (clearBtn) clearBtn.style.display = query ? "flex" : "none";
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, 400);
    });

    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        clearTimeout(searchTimeout);
        performSearch(this.value.trim());
      }
    });
  }

  if (clearBtn) {
    clearBtn.onclick = () => {
      if (searchInput) {
        searchInput.value = "";
        clearBtn.style.display = "none";
        performSearch("");
      }
    };
  }

  // Clickable task tags handler
  document.addEventListener("click", function (e) {
    const tagEl = e.target.closest(".task-tag");
    if (!tagEl) return;
    let tagText = tagEl.textContent.trim();
    if (!tagText) return;
    if (!tagText.startsWith("#")) tagText = "#" + tagText;
    const sInput = document.getElementById("page-search-input");
    const cBtn = document.getElementById("page-search-clear");
    if (sInput) {
      sInput.value = tagText;
      if (cBtn) cBtn.style.display = "flex";
      const tasksTabBtn = document.querySelector('[data-tab="tasks"]');
      if (tasksTabBtn && !tasksTabBtn.classList.contains("active")) {
        tasksTabBtn.click();
      }
      performSearch(tagText);
    }
  });

  initStandaloneTimer();
}

let standaloneTimerInterval = null;
let standaloneTimerSeconds = 0;
let standaloneTimerRunning = false;
let standaloneTimerMode = "stopwatch";
let standaloneCountdownTargetSeconds = 25 * 60;
let standaloneLaps = [];

function initStandaloneTimer() {
  const display = document.getElementById("standalone-timer-display");
  const startBtn = document.getElementById("standalone-timer-start");
  const pauseBtn = document.getElementById("standalone-timer-pause");
  const resetBtn = document.getElementById("standalone-timer-reset");
  const lapBtn = document.getElementById("standalone-timer-lap");
  const btnStopwatch = document.getElementById("timer-mode-stopwatch");
  const btnCountdown = document.getElementById("timer-mode-countdown");
  const countdownPresets = document.getElementById("countdown-presets");
  const lapsContainer = document.getElementById("timer-laps-container");
  const lapsList = document.getElementById("timer-laps-list");

  // Custom countdown elements
  const customGroup = document.getElementById("custom-timer-input-group");
  const customToggleBtn = document.getElementById("custom-timer-toggle-btn");
  const customApplyBtn = document.getElementById("custom-timer-apply");
  const hrsInput = document.getElementById("custom-timer-hrs");
  const minsInput = document.getElementById("custom-timer-mins");
  const secsInput = document.getElementById("custom-timer-secs");

  if (!display || !startBtn || !pauseBtn || !resetBtn) return;

  function formatTime(totalSecs) {
    const s = Math.max(0, totalSecs);
    const hrs = String(Math.floor(s / 3600)).padStart(2, "0");
    const mins = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const secs = String(s % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }

  function updateDisplay() {
    display.textContent = formatTime(standaloneTimerSeconds);
  }

  function syncInputsFromSeconds(totalSecs) {
    if (!hrsInput || !minsInput || !secsInput) return;
    const h = Math.floor(totalSecs / 3600);
    const m = Math.floor((totalSecs % 3600) / 60);
    const s = totalSecs % 60;
    hrsInput.value = String(h).padStart(2, "0");
    minsInput.value = String(m).padStart(2, "0");
    secsInput.value = String(s).padStart(2, "0");
  }

  function updateControlButtons() {
    const isInitial = standaloneTimerMode === "stopwatch"
      ? standaloneTimerSeconds === 0
      : standaloneTimerSeconds === standaloneCountdownTargetSeconds;

    if (standaloneTimerRunning) {
      startBtn.style.display = "none";
      pauseBtn.style.display = "inline-flex";
      if (lapBtn) {
        lapBtn.style.display = standaloneTimerMode === "stopwatch" ? "inline-flex" : "none";
      }
      resetBtn.style.display = "none";
    } else {
      startBtn.style.display = "inline-flex";
      if (isInitial) {
        startBtn.innerHTML = '<i class="ri-play-fill"></i> Старт';
        resetBtn.style.display = "none";
      } else {
        startBtn.innerHTML = '<i class="ri-play-fill"></i> Продовжити';
        resetBtn.style.display = "inline-flex";
      }
      pauseBtn.style.display = "none";
      if (lapBtn) lapBtn.style.display = "none";
    }
  }

  function applyCustomTime() {
    if (!hrsInput || !minsInput || !secsInput) return;
    let h = Math.max(0, parseInt(hrsInput.value, 10) || 0);
    let m = Math.max(0, parseInt(minsInput.value, 10) || 0);
    let s = Math.max(0, parseInt(secsInput.value, 10) || 0);

    if (s >= 60) {
      m += Math.floor(s / 60);
      s = s % 60;
    }
    if (m >= 60) {
      h += Math.floor(m / 60);
      m = m % 60;
    }

    const totalSecs = h * 3600 + m * 60 + s;
    if (totalSecs <= 0) return;

    standaloneCountdownTargetSeconds = totalSecs;
    if (standaloneTimerMode === "countdown") {
      stopTimer();
      standaloneTimerSeconds = standaloneCountdownTargetSeconds;
      updateDisplay();
      updateControlButtons();
    }
    syncInputsFromSeconds(totalSecs);
  }

  function renderLaps() {
    if (!lapsList || !lapsContainer) return;
    if (standaloneLaps.length === 0) {
      lapsContainer.style.display = "none";
      lapsList.innerHTML = "";
      return;
    }
    lapsContainer.style.display = "block";
    lapsList.innerHTML = standaloneLaps
      .map(
        (lapTime, idx) =>
          `<div class="timer-lap-item"><span>Коло ${idx + 1}</span><span>${lapTime}</span></div>`,
      )
      .reverse()
      .join("");
  }

  function stopTimer() {
    standaloneTimerRunning = false;
    if (standaloneTimerInterval) clearInterval(standaloneTimerInterval);
    standaloneTimerInterval = null;
    updateControlButtons();
  }

  // Display click handler for quick edit in countdown mode
  display.addEventListener("click", () => {
    if (standaloneTimerMode === "countdown" && !standaloneTimerRunning) {
      if (customGroup) {
        const isHidden = customGroup.style.display === "none";
        customGroup.style.display = isHidden ? "flex" : "none";
        if (isHidden) {
          syncInputsFromSeconds(standaloneCountdownTargetSeconds);
          if (minsInput) minsInput.focus();
        }
      }
    }
  });

  // Mode switching
  if (btnStopwatch) {
    btnStopwatch.addEventListener("click", () => {
      if (standaloneTimerMode === "stopwatch") return;
      stopTimer();
      standaloneTimerMode = "stopwatch";
      btnStopwatch.classList.add("active");
      if (btnCountdown) btnCountdown.classList.remove("active");
      if (countdownPresets) countdownPresets.style.display = "none";
      if (customGroup) customGroup.style.display = "none";
      display.classList.remove("clickable");
      display.removeAttribute("title");
      standaloneTimerSeconds = 0;
      updateDisplay();
      renderLaps();
      updateControlButtons();
    });
  }

  if (btnCountdown) {
    btnCountdown.addEventListener("click", () => {
      if (standaloneTimerMode === "countdown") return;
      stopTimer();
      standaloneTimerMode = "countdown";
      btnCountdown.classList.add("active");
      if (btnStopwatch) btnStopwatch.classList.remove("active");
      if (countdownPresets) countdownPresets.style.display = "flex";
      display.classList.add("clickable");
      display.setAttribute("title", "Клацніть, щоб змінити час");
      standaloneTimerSeconds = standaloneCountdownTargetSeconds;
      syncInputsFromSeconds(standaloneCountdownTargetSeconds);
      updateDisplay();
      if (lapsContainer) lapsContainer.style.display = "none";
      updateControlButtons();
    });
  }

  // Preset buttons
  if (countdownPresets) {
    countdownPresets.querySelectorAll(".preset-time-btn:not(.custom-preset-btn)").forEach((btn) => {
      btn.addEventListener("click", () => {
        countdownPresets.querySelectorAll(".preset-time-btn").forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        if (customGroup) customGroup.style.display = "none";
        const mins = Number(btn.dataset.mins || 25);
        standaloneCountdownTargetSeconds = mins * 60;
        syncInputsFromSeconds(standaloneCountdownTargetSeconds);
        if (standaloneTimerMode === "countdown") {
          stopTimer();
          standaloneTimerSeconds = standaloneCountdownTargetSeconds;
          updateDisplay();
          updateControlButtons();
        }
      });
    });
  }

  // Custom toggle button
  if (customToggleBtn) {
    customToggleBtn.addEventListener("click", () => {
      if (customGroup) {
        const isHidden = customGroup.style.display === "none";
        customGroup.style.display = isHidden ? "flex" : "none";
        if (isHidden) {
          syncInputsFromSeconds(standaloneCountdownTargetSeconds);
          if (minsInput) minsInput.focus();
        }
        if (countdownPresets) {
          countdownPresets.querySelectorAll(".preset-time-btn").forEach((b) => b.classList.remove("active"));
        }
        customToggleBtn.classList.add("active");
      }
    });
  }

  // Custom apply & input listeners
  if (customApplyBtn) {
    customApplyBtn.addEventListener("click", () => {
      applyCustomTime();
      if (customGroup) customGroup.style.display = "none";
    });
  }

  [hrsInput, minsInput, secsInput].forEach((inp) => {
    if (!inp) return;
    inp.addEventListener("change", () => {
      applyCustomTime();
    });
    inp.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        applyCustomTime();
        if (customGroup) customGroup.style.display = "none";
      }
    });
  });

  startBtn.addEventListener("click", () => {
    if (standaloneTimerRunning) return;
    if (customGroup) customGroup.style.display = "none";
    standaloneTimerRunning = true;
    updateControlButtons();

    standaloneTimerInterval = setInterval(() => {
      if (standaloneTimerMode === "stopwatch") {
        standaloneTimerSeconds++;
        updateDisplay();
      } else {
        if (standaloneTimerSeconds > 0) {
          standaloneTimerSeconds--;
          updateDisplay();
        } else {
          stopTimer();
          showMessage("Час таймера вичерпано!", "success");
        }
      }
    }, 1000);
  });

  pauseBtn.addEventListener("click", () => {
    stopTimer();
  });

  resetBtn.addEventListener("click", () => {
    stopTimer();
    if (customGroup) customGroup.style.display = "none";
    standaloneTimerSeconds = standaloneTimerMode === "countdown" ? standaloneCountdownTargetSeconds : 0;
    standaloneLaps = [];
    renderLaps();
    updateDisplay();
    updateControlButtons();
  });

  if (lapBtn) {
    lapBtn.addEventListener("click", () => {
      if (!standaloneTimerRunning || standaloneTimerMode !== "stopwatch") return;
      standaloneLaps.push(formatTime(standaloneTimerSeconds));
      renderLaps();
    });
  }

  // Initial UI control update
  updateControlButtons();
}

// Кастомні select-и
function initCustomSelects(scope) {
  const root = scope || document;
  const selects = root.querySelectorAll(".custom-select");
  selects.forEach((cs) => {
    if (cs.__inited) return;
    const toggle = cs.querySelector(".custom-select-toggle");
    const menu = cs.querySelector(".custom-select-menu");
    const hidden = cs.querySelector('input[type="hidden"]');
    if (!toggle || !menu || !hidden) return;

    function closeAll(ev) {
      if (ev && cs.contains(ev.target)) return;
      cs.classList.remove("is-open");
    }

    toggle.addEventListener("click", (e) => {
      e.stopPropagation();
      cs.classList.toggle("is-open");
    });
    menu.addEventListener("click", (e) => {
      const opt = e.target.closest(".custom-select-option");
      if (!opt) return;
      const value = opt.dataset.value || opt.textContent.trim();
      hidden.value = value;
      toggle.textContent = opt.textContent.trim();
      menu
        .querySelectorAll(".custom-select-option")
        .forEach((o) => o.classList.remove("is-selected"));
      opt.classList.add("is-selected");
      cs.classList.remove("is-open");

      // Показуємо/приховуємо поле автозавершення для ліміту часу
      if (hidden.id === "task-limit" || hidden.id === "edit-task-limit") {
        const autoCompleteGroup =
          hidden.id === "task-limit"
            ? document.getElementById("task-auto-complete-group")
            : document.getElementById("edit-task-auto-complete-group");

        if (autoCompleteGroup) {
          // Показуємо поле тільки якщо встановлений ліміт часу (не "Немає" і не порожнє)
          const hasLimit = value && value !== "" && value !== "Немає";
          autoCompleteGroup.style.display = hasLimit ? "block" : "none";
        }
      }
    });
    document.addEventListener("click", closeAll);
    cs.__inited = true;
  });
}

function renderPrettyFieldSelect(select) {
  const wrap = select.closest(".field-select-wrap");
  if (!wrap) return;
  const trigger = wrap.querySelector(".field-select-trigger");
  const menu = wrap.querySelector(".field-select-menu");
  if (!trigger || !menu) return;
  const selectedOption = select.options[select.selectedIndex];
  trigger.textContent = selectedOption ? selectedOption.textContent.trim() : "";
  menu.querySelectorAll(".field-select-option").forEach((optBtn) => {
    const isSelected = optBtn.dataset.value === select.value;
    optBtn.classList.toggle("is-selected", isSelected);
  });
}

function closePrettyFieldSelects(exceptWrap = null) {
  document.querySelectorAll(".field-select-wrap.is-open").forEach((wrap) => {
    if (exceptWrap && wrap === exceptWrap) return;
    wrap.classList.remove("is-open");
  });
}

function initPrettyFieldSelects(scope) {
  const root = scope || document;
  const selects = root.querySelectorAll(".field-select-wrap > select.field-select");
  selects.forEach((select) => {
    if (select.__prettyInit) return;
    const wrap = select.closest(".field-select-wrap");
    if (!wrap) return;

    const trigger = document.createElement("button");
    trigger.type = "button";
    trigger.className = "field-select-trigger";
    trigger.setAttribute("aria-haspopup", "listbox");
    trigger.setAttribute("aria-expanded", "false");

    const menu = document.createElement("div");
    menu.className = "field-select-menu";
    menu.setAttribute("role", "listbox");

    Array.from(select.options).forEach((opt) => {
      const optBtn = document.createElement("button");
      optBtn.type = "button";
      optBtn.className = "field-select-option";
      optBtn.textContent = opt.textContent.trim();
      optBtn.dataset.value = opt.value;
      if (opt.disabled) optBtn.disabled = true;
      optBtn.addEventListener("click", () => {
        if (optBtn.disabled) return;
        select.value = optBtn.dataset.value || "";
        select.dispatchEvent(new Event("input", { bubbles: true }));
        select.dispatchEvent(new Event("change", { bubbles: true }));
        wrap.classList.remove("is-open");
        trigger.setAttribute("aria-expanded", "false");
        renderPrettyFieldSelect(select);
      });
      menu.appendChild(optBtn);
    });

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const willOpen = !wrap.classList.contains("is-open");
      closePrettyFieldSelects(wrap);
      wrap.classList.toggle("is-open", willOpen);
      trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });

    select.addEventListener("change", () => renderPrettyFieldSelect(select));
    wrap.appendChild(trigger);
    wrap.appendChild(menu);
    renderPrettyFieldSelect(select);
    select.__prettyInit = true;
  });

  if (!document.__prettyFieldSelectDocInit) {
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".field-select-wrap")) closePrettyFieldSelects();
    });
    document.__prettyFieldSelectDocInit = true;
  }
}

function refreshPrettyFieldSelects(scope) {
  const root = scope || document;
  root.querySelectorAll(".field-select-wrap > select.field-select").forEach((select) => {
    renderPrettyFieldSelect(select);
  });
}

function setAutoCompleteGroupVisibility(groupEl, checkboxEl, isVisible) {
  if (!groupEl) return;
  groupEl.style.setProperty("display", isVisible ? "flex" : "none", "important");
  if (!isVisible && checkboxEl) checkboxEl.checked = false;
}

// Ініціалізація полів ліміту часу
function initTimeLimitInputs(scope) {
  const root = scope || document;
  const limitInputs = root.querySelectorAll("#task-limit, #edit-task-limit");

  limitInputs.forEach((input) => {
    if (input.__limitInit) return;

    const inputId = input.id;
    const autoCompleteGroup =
      inputId === "task-limit"
        ? document.getElementById("task-auto-complete-group")
        : document.getElementById("edit-task-auto-complete-group");
    const autoCompleteCheckbox =
      inputId === "task-limit"
        ? document.getElementById("task-auto-complete")
        : document.getElementById("edit-task-auto-complete");

    function updateAutoCompleteVisibility() {
      const value = parseInt(input.value, 10) || 0;
      setAutoCompleteGroupVisibility(
        autoCompleteGroup,
        autoCompleteCheckbox,
        value > 0,
      );
    }

    // Обробники подій
    input.addEventListener("input", updateAutoCompleteVisibility);
    input.addEventListener("change", updateAutoCompleteVisibility);

    // Початкова перевірка
    updateAutoCompleteVisibility();

    input.__limitInit = true;
  });
}

function initPrettyNumberInputs(scope) {
  const root = scope || document;
  root.querySelectorAll(".field-number-btn").forEach((btn) => {
    if (btn.__prettyNumberInit) return;
    const targetId = btn.dataset.stepTarget;
    const direction = btn.dataset.stepDir;
    const input = targetId ? root.querySelector(`#${targetId}`) : null;
    if (!input) return;

    btn.addEventListener("click", () => {
      const current = parseInt(input.value, 10) || 0;
      const next = direction === "up" ? current + 1 : current - 1;
      input.value = String(Math.max(0, next));
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    btn.__prettyNumberInit = true;
  });
}

// Маска та валідація для ДД.ММ.РРРР ГГ:ХХ
function initDateTimeInputs(scope) {
  const root = scope || document;
  const inputs = root.querySelectorAll("input.date-time-input");
  inputs.forEach((inp) => {
    if (inp.__inited) return;
    const MASK = "ДД.ММ.РРРР ГГ:ХХ";
    const noGhostHint = inp.dataset.noGhost === "1";
    // Створюємо "примарну" підказку, що зменшується
    const parent = inp.parentElement;
    if (parent && !noGhostHint) {
      parent.style.position = parent.style.position || "relative";
      let ghost = parent.querySelector(".date-ghost-hint");
      if (!ghost) {
        ghost = document.createElement("span");
        ghost.className = "date-ghost-hint";
        parent.appendChild(ghost);
      }
      function measure(text) {
        const cs = window.getComputedStyle(inp);
        const canvas = measureCanvasRef();
        const ctx = canvas.getContext("2d");
        ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
        return ctx.measureText(text).width;
      }
      function updateGhost() {
        const val = inp.value || "";
        const rest = MASK.slice(val.length);
        ghost.textContent = rest;
        const cs = window.getComputedStyle(inp);
        const padLeft = parseFloat(cs.paddingLeft || "0");
        const left = inp.offsetLeft + padLeft + measure(val);
        const top = inp.offsetTop;
        ghost.style.left = left + "px";
        ghost.style.top = top + "px";
        ghost.style.height = inp.offsetHeight + "px";
        ghost.style.lineHeight = inp.offsetHeight + "px";
        ghost.style.transform = "none";
        ghost.style.fontSize = cs.fontSize;
        ghost.style.fontFamily = cs.fontFamily;
        ghost.style.fontWeight = cs.fontWeight;
        ghost.style.pointerEvents = "none";
        // показ/приховування: показуємо тільки, якщо є що підказувати
        ghost.style.display = rest.length > 0 ? "block" : "none";
      }
      inp.addEventListener("focus", () => {
        if (!inp.dataset._phSaved) {
          inp.dataset._phSaved = inp.placeholder || "";
        }
        inp.placeholder = "";
        // показуємо лише якщо є незаповнена частина маски
        const val = inp.value || "";
        ghost.style.display =
          MASK.slice(val.length).length > 0 ? "block" : "none";
        updateGhost();
      });
      inp.addEventListener("blur", () => {
        ghost.style.display = inp.value ? "none" : "block";
        if (!inp.value && inp.dataset._phSaved !== undefined)
          inp.placeholder = inp.dataset._phSaved;
        updateGhost();
      });
      // ініціалізація стану
      ghost.style.display = "block";
      updateGhost();
    } else if (parent && noGhostHint) {
      const oldGhost = parent.querySelector(".date-ghost-hint");
      if (oldGhost) oldGhost.remove();
    }
    inp.addEventListener("input", () => {
      // лишаємо лише цифри
      let v = inp.value.replace(/[^0-9]/g, "").slice(0, 12); // DDMMYYYYHHmm
      let out = "";
      if (v.length >= 1) out = v.slice(0, 1);
      if (v.length >= 2) out = v.slice(0, 2);
      if (v.length >= 3) out = v.slice(0, 2) + "." + v.slice(2, 3);
      if (v.length >= 4) out = v.slice(0, 2) + "." + v.slice(2, 4);
      if (v.length >= 5)
        out = v.slice(0, 2) + "." + v.slice(2, 4) + "." + v.slice(4, 5);
      if (v.length >= 6)
        out = v.slice(0, 2) + "." + v.slice(2, 4) + "." + v.slice(4, 6);
      if (v.length >= 7)
        out = v.slice(0, 2) + "." + v.slice(2, 4) + "." + v.slice(4, 7);
      if (v.length >= 8)
        out = v.slice(0, 2) + "." + v.slice(2, 4) + "." + v.slice(4, 8);
      if (v.length >= 9)
        out =
          v.slice(0, 2) +
          "." +
          v.slice(2, 4) +
          "." +
          v.slice(4, 8) +
          " " +
          v.slice(8, 9);
      if (v.length >= 10)
        out =
          v.slice(0, 2) +
          "." +
          v.slice(2, 4) +
          "." +
          v.slice(4, 8) +
          " " +
          v.slice(8, 10);
      if (v.length >= 11)
        out =
          v.slice(0, 2) +
          "." +
          v.slice(2, 4) +
          "." +
          v.slice(4, 8) +
          " " +
          v.slice(8, 10) +
          ":" +
          v.slice(10, 11);
      if (v.length >= 12)
        out =
          v.slice(0, 2) +
          "." +
          v.slice(2, 4) +
          "." +
          v.slice(4, 8) +
          " " +
          v.slice(8, 10) +
          ":" +
          v.slice(10, 12);
      inp.value = out;
      // оновлюємо "примарну" підказку
      const ghost =
        inp.parentElement &&
        inp.parentElement.querySelector(".date-ghost-hint");
      if (ghost) {
        const cs = window.getComputedStyle(inp);
        const canvas = measureCanvasRef();
        const ctx = canvas.getContext("2d");
        ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
        const width = ctx.measureText(out).width;
        const padLeft = parseFloat(cs.paddingLeft || "0");
        ghost.textContent = MASK.slice(out.length);
        ghost.style.left = inp.offsetLeft + padLeft + width + "px";
        ghost.style.top = inp.offsetTop + "px";
        ghost.style.height = inp.offsetHeight + "px";
        ghost.style.lineHeight = inp.offsetHeight + "px";
        ghost.style.display =
          MASK.slice(out.length).length > 0 ? "block" : "none";
      }
    });

    inp.addEventListener("blur", () => {
      const re =
        /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/;
      const val = inp.value.trim();
      if (val && !re.test(val)) {
        showMessage(
          "Невірний формат дати. Використовуйте ДД.ММ.РРРР ГГ:ХХ",
          "error",
        );
        inp.focus();
      }
    });
    inp.__inited = true;
  });
}

function inferPeriodFromDateValue(dateValue, timeValue = "") {
  let hour = null;
  const dateTimeMatch = String(dateValue || "").match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(19|20)\d\d\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
  );
  if (dateTimeMatch) {
    hour = Number(dateTimeMatch[4]);
  } else {
    const timeMatch = String(timeValue || "").trim().match(
      /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
    );
    if (!timeMatch) return null;
    hour = Number(timeMatch[1]);
  }
  if (hour >= 9 && hour < 12) return "09:00-12:00";
  if (hour >= 12 && hour < 15) return "12:00-15:00";
  if (hour >= 15 && hour < 18) return "15:00-18:00";
  if (hour >= 18 && hour < 21) return "18:00-21:00";
  return "OUT_OF_PERIOD";
}

function syncTaskPeriodByDate(scope) {
  const root = scope || document;
  const pairs = [
    { dateId: "task-date", timeId: "task-time", periodId: "task-period" },
    { dateId: "edit-task-date", timeId: "edit-task-time", periodId: "edit-task-period" },
  ];
  pairs.forEach(({ dateId, timeId, periodId }) => {
    const dateInput = root.querySelector(`#${dateId}`);
    const timeInput = root.querySelector(`#${timeId}`);
    const periodSelect = root.querySelector(`#${periodId}`);
    if (!dateInput || !periodSelect || dateInput.__periodSyncInit) return;

    const apply = () => {
      const inferred = inferPeriodFromDateValue(dateInput.value, timeInput?.value || "");
      if (!inferred) return;
      const optionExists = Array.from(periodSelect.options).some(
        (opt) => opt.value === inferred,
      );
      if (optionExists && periodSelect.value !== inferred) {
        periodSelect.value = inferred;
        periodSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }
    };

    apply();
    dateInput.addEventListener("input", apply);
    dateInput.addEventListener("change", apply);
    dateInput.addEventListener("blur", apply);
    if (timeInput) {
      timeInput.addEventListener("input", apply);
      timeInput.addEventListener("change", apply);
      timeInput.addEventListener("blur", apply);
    }
    dateInput.__periodSyncInit = true;
  });
}

function initTaskDateTimeSplitInputs(scope) {
  const root = scope || document;
  const formatDateDigitsMask = (digits) => {
    const v = String(digits || "").replace(/[^0-9]/g, "").slice(0, 8);
    let out = "";
    if (v.length >= 1) out = v.slice(0, 1);
    if (v.length >= 2) out = v.slice(0, 2);
    if (v.length >= 3) out = `${v.slice(0, 2)}.${v.slice(2, 3)}`;
    if (v.length >= 4) out = `${v.slice(0, 2)}.${v.slice(2, 4)}`;
    if (v.length >= 5) out = `${v.slice(0, 2)}.${v.slice(2, 4)}.${v.slice(4, 5)}`;
    if (v.length >= 6) out = `${v.slice(0, 2)}.${v.slice(2, 4)}.${v.slice(4, 6)}`;
    if (v.length >= 7) out = `${v.slice(0, 2)}.${v.slice(2, 4)}.${v.slice(4, 7)}`;
    if (v.length >= 8) out = `${v.slice(0, 2)}.${v.slice(2, 4)}.${v.slice(4, 8)}`;
    return out;
  };
  const getCaretByDigitsCount = (formatted, digitsBeforeCaret) => {
    if (digitsBeforeCaret <= 0) return 0;
    let seen = 0;
    for (let i = 0; i < formatted.length; i += 1) {
      if (/[0-9]/.test(formatted[i])) seen += 1;
      if (seen >= digitsBeforeCaret) return i + 1;
    }
    return formatted.length;
  };

  root.querySelectorAll("input.task-date-input").forEach((inp) => {
    if (inp.__taskDateInit) return;
    inp.addEventListener("input", () => {
      const current = inp.value || "";
      const rawCaret = Number.isFinite(inp.selectionStart) ? inp.selectionStart : current.length;
      const digitsBeforeCaret = current
        .slice(0, rawCaret)
        .replace(/[^0-9]/g, "")
        .length;
      const out = formatDateDigitsMask(current);
      inp.value = out;
      if (document.activeElement === inp) {
        const nextCaret = getCaretByDigitsCount(out, digitsBeforeCaret);
        inp.setSelectionRange(nextCaret, nextCaret);
      }
    });
    inp.addEventListener("blur", () => {
      const val = String(inp.value || "").trim();
      if (!val) return;
      const re = /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})$/;
      const m = val.match(re);
      if (!m) {
        showMessage("Невірний формат дати. Використовуйте ДД.ММ.РРРР", "error");
        inp.focus();
        return;
      }
      const day = Number(m[1]);
      const month = Number(m[2]);
      const year = Number(m[3]);
      const d = new Date(year, month - 1, day);
      if (
        d.getFullYear() !== year ||
        d.getMonth() !== month - 1 ||
        d.getDate() !== day
      ) {
        showMessage("Невірна дата", "error");
        inp.focus();
      }
    });
    inp.__taskDateInit = true;
  });

  root.querySelectorAll("input.task-time-input").forEach((inp) => {
    if (inp.__taskTimeInit) return;
    inp.addEventListener("input", () => {
      const v = inp.value.replace(/[^0-9]/g, "").slice(0, 4);
      let out = "";
      if (v.length >= 1) out = v.slice(0, 1);
      if (v.length >= 2) out = v.slice(0, 2);
      if (v.length >= 3) out = `${v.slice(0, 2)}:${v.slice(2, 3)}`;
      if (v.length >= 4) out = `${v.slice(0, 2)}:${v.slice(2, 4)}`;
      inp.value = out;
    });
    inp.addEventListener("blur", () => {
      const val = String(inp.value || "").trim();
      if (!val) return;
      if (!/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(val)) {
        showMessage("Невірний формат часу. Використовуйте ГГ:ХХ", "error");
        inp.focus();
      }
    });
    inp.__taskTimeInit = true;
  });
}

function parseTaskDateMask(value) {
  const match = String(value || "")
    .trim()
    .match(/^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})$/);
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
}

function formatTaskDateMask(dateObj) {
  return `${String(dateObj.getDate()).padStart(2, "0")}.${String(
    dateObj.getMonth() + 1,
  ).padStart(2, "0")}.${dateObj.getFullYear()}`;
}

function setTaskDateInputValue(targetDateInput, dateObj) {
  targetDateInput.value = formatTaskDateMask(dateObj);
  targetDateInput.dispatchEvent(new Event("input", { bubbles: true }));
  targetDateInput.dispatchEvent(new Event("change", { bubbles: true }));
}

function getTodayFormattedString() {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

function buildTaskDueDateForPayload(dateInput, timeInput) {
  let dateValue = String(dateInput?.value || "").trim();
  const timeValue = String(timeInput?.value || "").trim();
  if (!dateValue) {
    dateValue = getTodayFormattedString();
  }
  const dateMatch = dateValue.match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})$/,
  );
  if (!dateMatch) {
    return {
      ok: false,
      message: "Невірний формат дати. Використовуйте ДД.ММ.РРРР",
    };
  }
  const day = Number(dateMatch[1]);
  const month = Number(dateMatch[2]);
  const year = Number(dateMatch[3]);
  const testDate = new Date(year, month - 1, day);
  if (
    testDate.getFullYear() !== year ||
    testDate.getMonth() !== month - 1 ||
    testDate.getDate() !== day
  ) {
    return { ok: false, message: "Невірна дата" };
  }
  if (!timeValue) return { ok: true, value: dateValue };
  if (!/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(timeValue)) {
    return {
      ok: false,
      message: "Невірний формат часу. Використовуйте ГГ:ХХ",
    };
  }
  return { ok: true, value: `${dateValue} ${timeValue}` };
}

function formatLocalDateTimeToMask(localValue) {
  // input format: YYYY-MM-DDTHH:mm
  const m = String(localValue || "").match(
    /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/,
  );
  if (!m) return "";
  const [, y, mm, dd, hh, min] = m;
  return `${dd}.${mm}.${y} ${hh}:${min}`;
}

function parseMaskToLocalDateTime(maskValue) {
  const m = String(maskValue || "").match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
  );
  if (!m) return "";
  const [, dd, mm, y, hh, min] = m;
  return `${y}-${mm}-${dd}T${hh}:${min}`;
}

const DTP_MONTHS = [
  "Січень",
  "Лютий",
  "Березень",
  "Квітень",
  "Травень",
  "Червень",
  "Липень",
  "Серпень",
  "Вересень",
  "Жовтень",
  "Листопад",
  "Грудень",
];
const DTP_WEEKDAYS = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"];
let dateTimePopoverState = null;

function getDateTimePopoverEl() {
  let el = document.getElementById("datetime-popover");
  if (el) return el;
  el = document.createElement("div");
  el.id = "datetime-popover";
  el.className = "datetime-popover";
  el.hidden = true;
  el.innerHTML = `
    <div class="dtp-header">
      <button type="button" class="dtp-nav-btn" data-dtp-nav="prev"><i class="ri-arrow-left-s-line"></i></button>
      <div class="dtp-month-label"></div>
      <button type="button" class="dtp-nav-btn" data-dtp-nav="next"><i class="ri-arrow-right-s-line"></i></button>
    </div>
    <div class="dtp-weekdays"></div>
    <div class="dtp-grid"></div>
    <div class="dtp-time-label">Час</div>
    <div class="dtp-time">
      <input type="number" class="dtp-time-input" id="dtp-hour" min="0" max="23" placeholder="ГГ">
      <span class="dtp-time-sep">:</span>
      <input type="number" class="dtp-time-input" id="dtp-minute" min="0" max="59" placeholder="ХХ">
    </div>
    <div class="dtp-actions">
      <div class="dtp-actions-left">
        <button type="button" class="dtp-btn" data-dtp-action="today">Сьогодні</button>
        <button type="button" class="dtp-btn" data-dtp-action="now">Зараз</button>
        <button type="button" class="dtp-btn ghost" data-dtp-action="clear-time">Без часу</button>
      </div>
      <div>
        <button type="button" class="dtp-btn" data-dtp-action="cancel">Скасувати</button>
        <button type="button" class="dtp-btn apply" data-dtp-action="apply">Застосувати</button>
      </div>
    </div>
  `;
  document.body.appendChild(el);

  const weekdays = el.querySelector(".dtp-weekdays");
  weekdays.innerHTML = DTP_WEEKDAYS.map((d) => `<div class="dtp-weekday">${d}</div>`).join("");

  el.addEventListener("click", (e) => {
    const nav = e.target.closest("[data-dtp-nav]");
    if (nav && dateTimePopoverState) {
      dateTimePopoverState.viewMonth += nav.dataset.dtpNav === "prev" ? -1 : 1;
      if (dateTimePopoverState.viewMonth < 0) {
        dateTimePopoverState.viewMonth = 11;
        dateTimePopoverState.viewYear -= 1;
      }
      if (dateTimePopoverState.viewMonth > 11) {
        dateTimePopoverState.viewMonth = 0;
        dateTimePopoverState.viewYear += 1;
      }
      renderDateTimePopover();
      return;
    }

    const dayBtn = e.target.closest(".dtp-day");
    if (dayBtn && dateTimePopoverState) {
      dateTimePopoverState.selectedYear = Number(dayBtn.dataset.year);
      dateTimePopoverState.selectedMonth = Number(dayBtn.dataset.month);
      dateTimePopoverState.selectedDay = Number(dayBtn.dataset.day);
      dateTimePopoverState.viewYear = dateTimePopoverState.selectedYear;
      dateTimePopoverState.viewMonth = dateTimePopoverState.selectedMonth;
      renderDateTimePopover();
      return;
    }

    const actionBtn = e.target.closest("[data-dtp-action]");
    if (!actionBtn || !dateTimePopoverState) return;
    const action = actionBtn.dataset.dtpAction;
    if (action === "cancel") {
      closeDateTimePopover();
      return;
    }
    if (action === "today") {
      const now = new Date();
      dateTimePopoverState.selectedYear = now.getFullYear();
      dateTimePopoverState.selectedMonth = now.getMonth();
      dateTimePopoverState.selectedDay = now.getDate();
      dateTimePopoverState.viewYear = now.getFullYear();
      dateTimePopoverState.viewMonth = now.getMonth();
      renderDateTimePopover();
      return;
    }
    if (action === "now") {
      const now = new Date();
      dateTimePopoverState.selectedYear = now.getFullYear();
      dateTimePopoverState.selectedMonth = now.getMonth();
      dateTimePopoverState.selectedDay = now.getDate();
      dateTimePopoverState.viewYear = now.getFullYear();
      dateTimePopoverState.viewMonth = now.getMonth();
      dateTimePopoverState.hour = now.getHours();
      dateTimePopoverState.minute = now.getMinutes();
      dateTimePopoverState.hasTime = true;
      renderDateTimePopover();
      return;
    }
    if (action === "clear-time") {
      dateTimePopoverState.hasTime = false;
      dateTimePopoverState.hour = 0;
      dateTimePopoverState.minute = 0;
      renderDateTimePopover();
      return;
    }
    if (action === "apply") {
      applyDateTimePopoverValue();
    }
  });

  document.addEventListener("mousedown", (e) => {
    if (!dateTimePopoverState || el.hidden) return;
    const clickedInsidePopover = el.contains(e.target);
    const clickedAnchor =
      dateTimePopoverState.anchor && dateTimePopoverState.anchor.contains(e.target);
    if (!clickedInsidePopover && !clickedAnchor) closeDateTimePopover();
  });

  document.addEventListener("keydown", (e) => {
    if (!dateTimePopoverState || el.hidden) return;
    if (e.key === "Escape") closeDateTimePopover();
  });

  window.addEventListener("resize", () => {
    if (!el.hidden) positionDateTimePopover();
  });
  window.addEventListener(
    "scroll",
    () => {
      if (!el.hidden) positionDateTimePopover();
    },
    { passive: true },
  );

  return el;
}

function normalizeTimePart(value, max) {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  return Math.max(0, Math.min(max, Math.trunc(num)));
}

function parseMaskToDateParts(maskValue) {
  const dateTimeMatch = String(maskValue || "").match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
  );
  if (dateTimeMatch) {
    return {
      day: Number(dateTimeMatch[1]),
      month: Number(dateTimeMatch[2]) - 1,
      year: Number(dateTimeMatch[3]),
      hour: Number(dateTimeMatch[4]),
      minute: Number(dateTimeMatch[5]),
      hasTime: true,
    };
  }
  const dateOnlyMatch = String(maskValue || "").match(
    /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})$/,
  );
  if (!dateOnlyMatch) return null;
  return {
    day: Number(dateOnlyMatch[1]),
    month: Number(dateOnlyMatch[2]) - 1,
    year: Number(dateOnlyMatch[3]),
    hour: 0,
    minute: 0,
    hasTime: false,
  };
}

function parseTimeToParts(timeValue) {
  const m = String(timeValue || "").trim().match(
    /^([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
  );
  if (!m) return null;
  return { hour: Number(m[1]), minute: Number(m[2]) };
}

function formatDatePartsToDateMask(parts) {
  const dd = String(parts.day).padStart(2, "0");
  const mm = String(parts.month + 1).padStart(2, "0");
  const yyyy = String(parts.year);
  return `${dd}.${mm}.${yyyy}`;
}

function formatTimePartsToMask(parts) {
  const hh = String(parts.hour).padStart(2, "0");
  const min = String(parts.minute).padStart(2, "0");
  return `${hh}:${min}`;
}

function formatDatePartsToMask(parts) {
  const dd = String(parts.day).padStart(2, "0");
  const mm = String(parts.month + 1).padStart(2, "0");
  const yyyy = String(parts.year);
  const hh = String(parts.hour).padStart(2, "0");
  const min = String(parts.minute).padStart(2, "0");
  return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
}

function positionDateTimePopover() {
  const popover = getDateTimePopoverEl();
  if (!dateTimePopoverState?.anchor || popover.hidden) return;
  const rect = dateTimePopoverState.anchor.getBoundingClientRect();
  const width = 300;
  const margin = 8;
  let left = rect.left + rect.width - width;
  let top = rect.bottom + 8;
  if (left < margin) left = margin;
  if (left + width > window.innerWidth - margin) left = window.innerWidth - width - margin;
  if (top + popover.offsetHeight > window.innerHeight - margin) {
    top = rect.top - popover.offsetHeight - 8;
  }
  if (top < margin) top = margin;
  popover.style.left = `${left}px`;
  popover.style.top = `${top}px`;
}

function renderDateTimePopover() {
  const popover = getDateTimePopoverEl();
  if (!dateTimePopoverState) return;
  const label = popover.querySelector(".dtp-month-label");
  const grid = popover.querySelector(".dtp-grid");
  const hourInput = popover.querySelector("#dtp-hour");
  const minuteInput = popover.querySelector("#dtp-minute");
  const timeLabel = popover.querySelector(".dtp-time-label");
  const clearTimeBtn = popover.querySelector('[data-dtp-action="clear-time"]');
  if (!label || !grid || !hourInput || !minuteInput || !timeLabel || !clearTimeBtn) return;

  label.textContent = `${DTP_MONTHS[dateTimePopoverState.viewMonth]} ${dateTimePopoverState.viewYear}`;
  const isSplitMode = dateTimePopoverState.mode === "split";
  timeLabel.textContent = isSplitMode ? "Час (необов'язково)" : "Час";
  clearTimeBtn.style.display = isSplitMode ? "inline-flex" : "none";
  hourInput.value = dateTimePopoverState.hasTime
    ? String(dateTimePopoverState.hour).padStart(2, "0")
    : "";
  minuteInput.value = dateTimePopoverState.hasTime
    ? String(dateTimePopoverState.minute).padStart(2, "0")
    : "";

  const firstDay = new Date(dateTimePopoverState.viewYear, dateTimePopoverState.viewMonth, 1);
  const startOffset = (firstDay.getDay() + 6) % 7;
  const daysInMonth = new Date(dateTimePopoverState.viewYear, dateTimePopoverState.viewMonth + 1, 0).getDate();
  const prevMonthDays = new Date(dateTimePopoverState.viewYear, dateTimePopoverState.viewMonth, 0).getDate();

  const cells = [];
  for (let i = 0; i < 42; i += 1) {
    let day;
    let month = dateTimePopoverState.viewMonth;
    let year = dateTimePopoverState.viewYear;
    let outside = false;
    if (i < startOffset) {
      day = prevMonthDays - startOffset + i + 1;
      month -= 1;
      outside = true;
      if (month < 0) {
        month = 11;
        year -= 1;
      }
    } else if (i >= startOffset + daysInMonth) {
      day = i - startOffset - daysInMonth + 1;
      month += 1;
      outside = true;
      if (month > 11) {
        month = 0;
        year += 1;
      }
    } else {
      day = i - startOffset + 1;
    }

    const isSelected =
      day === dateTimePopoverState.selectedDay &&
      month === dateTimePopoverState.selectedMonth &&
      year === dateTimePopoverState.selectedYear;
    cells.push(`
      <button type="button" class="dtp-day${outside ? " is-outside" : ""}${isSelected ? " is-selected" : ""}" data-day="${day}" data-month="${month}" data-year="${year}">
        ${day}
      </button>
    `);
  }
  grid.innerHTML = cells.join("");
  positionDateTimePopover();
}

function openDateTimePopover(inputEl, anchorEl, timeInputEl = null) {
  const popover = getDateTimePopoverEl();
  const now = new Date();
  const isSplitMode = !!timeInputEl;
  let init;
  if (isSplitMode) {
    const parsedDate = parseMaskToDateParts(inputEl.value);
    const parsedTime = parseTimeToParts(timeInputEl.value);
    init = parsedDate || {
      day: now.getDate(),
      month: now.getMonth(),
      year: now.getFullYear(),
      hour: now.getHours(),
      minute: now.getMinutes(),
      hasTime: false,
    };
    if (parsedTime) {
      init.hour = parsedTime.hour;
      init.minute = parsedTime.minute;
      init.hasTime = true;
    }
  } else {
    const parsed = parseMaskToDateParts(inputEl.value);
    init = parsed || {
      day: now.getDate(),
      month: now.getMonth(),
      year: now.getFullYear(),
      hour: now.getHours(),
      minute: now.getMinutes(),
      hasTime: true,
    };
  }
  dateTimePopoverState = {
    input: inputEl,
    timeInput: timeInputEl,
    anchor: anchorEl,
    mode: isSplitMode ? "split" : "combined",
    selectedDay: init.day,
    selectedMonth: init.month,
    selectedYear: init.year,
    viewMonth: init.month,
    viewYear: init.year,
    hour: init.hour,
    minute: init.minute,
    hasTime: isSplitMode ? !!init.hasTime : true,
  };

  const hourInput = popover.querySelector("#dtp-hour");
  const minuteInput = popover.querySelector("#dtp-minute");
  if (hourInput && !hourInput.__dtpBound) {
    hourInput.addEventListener("input", () => {
      if (!dateTimePopoverState) return;
      const hourValue = String(hourInput.value || "").trim();
      const minuteValue = String(minuteInput?.value || "").trim();
      if (!hourValue && !minuteValue) {
        dateTimePopoverState.hasTime = false;
        return;
      }
      dateTimePopoverState.hasTime = true;
      dateTimePopoverState.hour = normalizeTimePart(hourValue, 23);
    });
    hourInput.__dtpBound = true;
  }
  if (minuteInput && !minuteInput.__dtpBound) {
    minuteInput.addEventListener("input", () => {
      if (!dateTimePopoverState) return;
      const hourValue = String(hourInput?.value || "").trim();
      const minuteValue = String(minuteInput.value || "").trim();
      if (!hourValue && !minuteValue) {
        dateTimePopoverState.hasTime = false;
        return;
      }
      dateTimePopoverState.hasTime = true;
      dateTimePopoverState.minute = normalizeTimePart(minuteValue, 59);
    });
    minuteInput.__dtpBound = true;
  }

  popover.hidden = false;
  renderDateTimePopover();
}

function closeDateTimePopover() {
  const popover = getDateTimePopoverEl();
  popover.hidden = true;
  dateTimePopoverState = null;
}

function applyDateTimePopoverValue() {
  if (!dateTimePopoverState?.input) return;
  const parts = {
    day: dateTimePopoverState.selectedDay,
    month: dateTimePopoverState.selectedMonth,
    year: dateTimePopoverState.selectedYear,
    hour: normalizeTimePart(dateTimePopoverState.hour, 23),
    minute: normalizeTimePart(dateTimePopoverState.minute, 59),
  };
  if (dateTimePopoverState.mode === "split") {
    dateTimePopoverState.input.value = formatDatePartsToDateMask(parts);
    if (dateTimePopoverState.timeInput) {
      dateTimePopoverState.timeInput.value = dateTimePopoverState.hasTime
        ? formatTimePartsToMask(parts)
        : "";
      dateTimePopoverState.timeInput.dispatchEvent(
        new Event("input", { bubbles: true }),
      );
      dateTimePopoverState.timeInput.dispatchEvent(
        new Event("change", { bubbles: true }),
      );
    }
  } else {
    const value = formatDatePartsToMask(parts);
    dateTimePopoverState.input.value = value;
  }
  dateTimePopoverState.input.dispatchEvent(new Event("input", { bubbles: true }));
  dateTimePopoverState.input.dispatchEvent(new Event("change", { bubbles: true }));
  closeDateTimePopover();
}

function initTaskDatePickerButtons(scope) {
  const root = scope || document;
  root.querySelectorAll(".date-picker-trigger").forEach((btn) => {
    if (btn.__pickerInit) return;
    const targetId = btn.getAttribute("data-target-input");
    const visibleInput = targetId ? root.querySelector(`#${targetId}`) : null;
    const targetTimeId = btn.getAttribute("data-target-time-input");
    const timeInput = targetTimeId ? root.querySelector(`#${targetTimeId}`) : null;
    if (!visibleInput) return;

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openDateTimePopover(visibleInput, btn, timeInput);
    });

    btn.__pickerInit = true;
  });

  root.querySelectorAll(".date-today-trigger").forEach((btn) => {
    if (btn.__todayInit) return;
    const targetDateId = btn.getAttribute("data-target-date-input");
    const targetDateInput = targetDateId ? root.querySelector(`#${targetDateId}`) : null;
    if (!targetDateInput) return;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      setTaskDateInputValue(targetDateInput, new Date());
      targetDateInput.focus();
    });
    btn.__todayInit = true;
  });

  root.querySelectorAll(".date-shift-trigger").forEach((btn) => {
    if (btn.__dateShiftInit) return;
    const targetDateId = btn.getAttribute("data-target-date-input");
    const targetDateInput = targetDateId ? root.querySelector(`#${targetDateId}`) : null;
    const shiftDays = Number(btn.getAttribute("data-shift-days") || 0);
    if (!targetDateInput || !Number.isFinite(shiftDays) || !shiftDays) return;
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const baseDate = parseTaskDateMask(targetDateInput.value) || new Date();
      const nextDate = new Date(
        baseDate.getFullYear(),
        baseDate.getMonth(),
        baseDate.getDate() + shiftDays,
      );
      setTaskDateInputValue(targetDateInput, nextDate);
      targetDateInput.focus();
    });
    btn.__dateShiftInit = true;
  });
}

// спільний canvas для вимірювань
function measureCanvasRef() {
  if (!measureCanvasRef._c)
    measureCanvasRef._c = document.createElement("canvas");
  return measureCanvasRef._c;
}

// Оновити позиції "примарних" підказок у видимій панелі
function refreshDateGhostHints(scope) {
  const root = scope || document;
  const MASK = "ДД.ММ.РРРР ГГ:ХХ";
  root.querySelectorAll("input.date-time-input").forEach((inp) => {
    const parent = inp.parentElement;
    const ghost = parent && parent.querySelector(".date-ghost-hint");
    if (!ghost) return;
    const val = inp.value || "";
    const cs = window.getComputedStyle(inp);
    const canvas = measureCanvasRef();
    const ctx = canvas.getContext("2d");
    ctx.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    const width = ctx.measureText(val).width;
    const padLeft = parseFloat(cs.paddingLeft || "0");
    ghost.textContent = MASK.slice(val.length);
    ghost.style.left = inp.offsetLeft + padLeft + width + "px";
    ghost.style.top = inp.offsetTop + "px";
    ghost.style.height = inp.offsetHeight + "px";
    ghost.style.lineHeight = inp.offsetHeight + "px";
    ghost.style.display = MASK.slice(val.length).length > 0 ? "block" : "none";
  });
}

// Функція виконання пошуку
async function performSearch(query) {
  currentSearchQuery = query;
  const activePanel = document.querySelector(".tab-panel.active");
  const tabId = activePanel ? activePanel.id : "tasks";

  try {
    if (tabId === "tasks") {
      await loadTasks(currentSortField, currentSortOrder, query);
    } else if (tabId === "finances") {
      const sub = activePanel.querySelector(".sub-tab-panel.active")?.id;
      if (sub === "bank-content") await loadBank("id", "DESC", query);
      else if (sub === "incomes-content") await loadIncomes("id", "DESC", query);
      else if (sub === "expenses-content") await loadExpenses("id", "DESC", query);
    } else if (tabId === "projects") {
      await loadProjects(currentSortField, currentSortOrder, query);
    } else if (tabId === "security") {
      await loadUsers(currentSortField, currentSortOrder, query);
    } else if (tabId === "egds") {
      await loadEgds(currentSortField, currentSortOrder, query);
    } else if (tabId === "goals") {
      await loadGoals(currentSortField, currentSortOrder, query);
    } else if (tabId === "youtube") {
      await loadYoutube(currentSortField, currentSortOrder, query);
    }
    updateURLWithSearch(query);
    updateSearchResultsCount(query);
  } catch (e) { console.error("Search error:", e); }
}

function updateSearchResultsCount(query) {
  const el = document.getElementById("search-results-count");
  if (!el) return;
  if (!query) {
    el.classList.remove("visible", "no-results");
    el.textContent = "";
    return;
  }
  const activePanel = document.querySelector(".tab-panel.active");
  if (!activePanel) return;

  let count = 0;
  const activeSub = activePanel.querySelector(".sub-tab-panel.active") || activePanel;
  const tbody = activeSub.querySelector("tbody");
  const gridCards = activeSub.querySelectorAll(".goal-card, .dash-project-card");
  
  if (gridCards.length > 0) {
    count = gridCards.length;
  } else if (tbody) {
    const rows = tbody.querySelectorAll("tr[data-id]");
    count = rows.length;
  }

  el.classList.add("visible");
  if (count > 0) {
    el.classList.remove("no-results");
    el.textContent = `Знайдено: ${count}`;
  } else {
    el.classList.add("no-results");
    el.textContent = "Нічого не знайдено";
  }
}

// ===== Settings =====
async function loadSettings(searchQuery = "") {
  const fallbackRows = [
    { id: null, name: "Версія", label: "Версія", value: "3.2", updated_at: null },
  ];
  activateSettingsMainPanel();
  ensureSettingsTableStructure();
  try {
    const params = new URLSearchParams();
    if (searchQuery) params.append("search", searchQuery);
    const res = await fetch(`api/settings.php?${params}`);
    if (!res.ok) throw new Error("HTTP error " + res.status);
    const data = await res.json();
    if (!data.success) {
      displaySettings(fallbackRows);
      return;
    }
    const rows = Array.isArray(data.data) && data.data.length ? data.data : fallbackRows;
    displaySettings(rows);
  } catch (e) {
    console.error("Помилка завантаження налаштувань: ", e);
    displaySettings(fallbackRows);
  }
}

function activateSettingsMainPanel() {
  const panel = document.getElementById("settings");
  if (!panel) return;
  const mainPanel = panel.querySelector("#settings-main-content");
  if (!mainPanel) return;
  panel.querySelectorAll(".sub-tab-panel").forEach((subPanel) => {
    subPanel.classList.remove("active");
  });
  mainPanel.classList.add("active");
}

function ensureSettingsTableStructure() {
  let tbody = document.getElementById("settings-table-tbody");
  if (tbody) return tbody;

  const panel = document.getElementById("settings");
  if (!panel) return null;

  let content = panel.querySelector(".sub-tab-content");
  if (!content) {
    content = document.createElement("div");
    content.className = "sub-tab-content";
    panel.appendChild(content);
  }

  let sub = panel.querySelector("#settings-main-content");
  if (!sub) {
    sub = document.createElement("div");
    sub.className = "sub-tab-panel active";
    sub.id = "settings-main-content";
    content.appendChild(sub);
  } else {
    sub.classList.add("active");
  }

  let wrap = sub.querySelector(".tab-panel-table");
  if (!wrap) {
    wrap = document.createElement("div");
    wrap.className = "tab-panel-table";
    sub.appendChild(wrap);
  }

  let table = wrap.querySelector("table.data-table");
  if (!table) {
    table = document.createElement("table");
    table.className = "data-table";
    table.innerHTML = `
      <thead>
        <tr>
          <th class="col-name">Параметр</th>
          <th class="col-value">Значення</th>
          <th class="col-date">Оновлено</th>
        </tr>
      </thead>
      <tbody id="settings-table-tbody"></tbody>
    `;
    wrap.appendChild(table);
  } else if (!table.querySelector("tbody#settings-table-tbody")) {
    const newBody = document.createElement("tbody");
    newBody.id = "settings-table-tbody";
    table.appendChild(newBody);
  }

  refreshEdgeTableScrollbars();
  return document.getElementById("settings-table-tbody");
}

// ===== YouTube =====
const YOUTUBE_DEFAULT_CHANNEL_URL = "https://www.youtube.com/@fmua/videos";
let youtubeControlsInitialized = false;

function initYoutubeControls() {
  if (youtubeControlsInitialized) return;
  youtubeControlsInitialized = true;

  const syncBtn = document.getElementById("youtube-sync-btn");
  if (!syncBtn) return;

  syncBtn.addEventListener("click", async () => {
    const icon = syncBtn.querySelector("i");
    const text = syncBtn.querySelector("span");
    const originalText = text ? text.textContent : "";
    syncBtn.disabled = true;
    if (icon) icon.className = "ri-loader-4-line bb-spin";
    if (text) text.textContent = "Синхронізація...";

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 120000);
      const res = await fetch("api/youtube.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: controller.signal,
        body: JSON.stringify({
          action: "sync",
          channel_url: YOUTUBE_DEFAULT_CHANNEL_URL,
          max_items: 1000,
        }),
      });
      clearTimeout(timeoutId);
      const raw = await res.text();
      let data = null;
      try {
        data = JSON.parse(raw);
      } catch (_) {
        throw new Error("Сервер повернув не JSON (ймовірно таймаут). Спробуй ще раз.");
      }
      if (!res.ok || !data.success) {
        throw new Error(data.error || "Помилка синхронізації");
      }

      await loadYoutube();
      const info = data.data || {};
      showMessage(
        `YouTube синхронізовано: +${Number(info.inserted || 0)}, оновлено ${Number(info.updated || 0)}, видалено ${Number(info.deleted || 0)}, уточнено ${Number(info.enriched || 0)}`,
        "success",
      );
    } catch (e) {
      const message =
        e?.name === "AbortError"
          ? "Синхронізація триває занадто довго. Спробуй ще раз."
          : (e.message || "Помилка синхронізації YouTube");
      showMessage(message, "error");
    } finally {
      syncBtn.disabled = false;
      if (icon) icon.className = "ri-refresh-line";
      if (text) text.textContent = originalText || "Синхронізувати";
    }
  });
}

async function loadYoutube(
  sortBy = currentSortField || "id",
  sortOrder = currentSortOrder || "DESC",
  searchQuery = currentSearchQuery || "",
) {
  initYoutubeControls();
  try {
    const params = new URLSearchParams({
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    const res = await fetch(`api/youtube.php?${params}`, { cache: "no-store" });
    if (res.status === 401) {
      window.location.href = "login.html";
      return;
    }
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.success) {
      if (data.error === "Користувач не авторизований") {
        window.location.href = "login.html";
        return;
      }
      throw new Error(data.error || "HTTP error " + res.status);
    }
    displayYoutube(data.data || []);
  } catch (e) {
    console.error("Помилка завантаження YouTube:", e);
    showMessage(e.message || "Помилка завантаження YouTube", "error");
  }
}

function displayYoutube(items) {
  const tbody = document.getElementById("fancy-music-table-tbody");
  if (!tbody) return;

  if (!items || !items.length) {
    tbody.innerHTML =
      '<tr><td colspan="5" style="text-align:center;color:rgba(255,255,255,0.5);padding:24px;">Немає треків або плейлистів</td></tr>';
    return;
  }

  let html = "";
  items.forEach((item) => {
    const isTrack = item.video_type === "single_track";
    const badgeHtml = isTrack
      ? `<span class="fancy-music-badge track"><i class="ri-music-2-line"></i> Трек</span>`
      : `<span class="fancy-music-badge playlist"><i class="ri-playlist-2-line"></i> Плейлист</span>`;

    const ytUrl = item.youtube_id ? `https://www.youtube.com/watch?v=${encodeURIComponent(item.youtube_id)}` : "#";

    html += `
      <tr data-id="${item.id}">
        <td class="col-drag-handle" title="Перетягнути рядок"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="drag-handle-svg"><circle cx="2" cy="2" r="1" fill="currentColor"/><circle cx="6" cy="2" r="1" fill="currentColor"/><circle cx="2" cy="6" r="1" fill="currentColor"/><circle cx="6" cy="6" r="1" fill="currentColor"/><circle cx="2" cy="10" r="1" fill="currentColor"/><circle cx="6" cy="10" r="1" fill="currentColor"/></svg></td>
        <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
        <td class="col-name" style="font-weight: 500;">
          <a href="${ytUrl}" target="_blank" style="color: inherit; text-decoration: none;" title="Відкрити на YouTube">
            ${escapeHtml(item.title || "")}
          </a>
        </td>
        <td class="col-type">${badgeHtml}</td>
        <td class="col-date">${escapeHtml(item.published_at || "—")}</td>
        <td class="col-actions">
          <a href="${ytUrl}" target="_blank" class="row-more-btn" title="Слухати на YouTube" style="display:inline-flex; align-items:center; justify-content:center; text-decoration:none;">
            <i class="ri-youtube-fill" style="color: #ef4444; font-size: 18px;"></i>
          </a>
        </td>
      </tr>
    `;
  });
  tbody.innerHTML = html;
  resetCheckboxStates();
}

// ===== eGDS =====
async function loadEgds(
  sortBy = currentSortField || "id",
  sortOrder = currentSortOrder || "DESC",
  searchQuery = currentSearchQuery || "",
) {
  try {
    const activePanel = document.querySelector("#egds .sub-tab-panel.active");
    const type = activePanel?.id === "egds-orders-content" ? "orders" : "products";
    const params = new URLSearchParams({
      type,
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    const res = await fetch(`api/egds.php?${params}`, { cache: "no-store" });
    if (!res.ok) throw new Error("HTTP error " + res.status);
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка eGDS");

    if (type === "products") displayEgdsProducts(data.data || []);
    else displayEgdsOrders(data.data || []);
  } catch (e) {
    console.error("Помилка завантаження eGDS:", e);
    showMessage("Помилка завантаження eGDS", "error");
  }
}

function displayEgdsProducts(items) {
  const tbody = document.getElementById("egds-products-tbody");
  if (!tbody) return;

  if (!items.length) {
    tbody.innerHTML =
      '<tr><td colspan="7" style="text-align:center;color:rgba(255,255,255,0.5);">Немає товарів</td></tr>';
    return;
  }

  let html = "";
  items.forEach((p) => {
    const safeName = decodeMojibakeText(p.name || "");
    const safeCategory = decodeMojibakeText(p.category || "—");
    html += `
      <tr data-id="${p.id}">
        <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
        <td class="col-name">${escapeHtml(safeName)}</td>
        <td class="col-category">${escapeHtml(safeCategory)}</td>
        <td class="col-price">${Number(p.price || 0).toLocaleString("uk-UA")} ₴</td>
        <td class="col-quantity">${Number(p.stock_quantity || 0)}</td>
        <td class="col-date">${escapeHtml(p.updated_at || "—")}</td>
        <td class="col-actions">
          <button class="row-more-btn" data-id="${p.id}" data-type="egds-product">
            <i class="ri-more-2-fill"></i>
          </button>
        </td>
      </tr>
    `;
  });
  tbody.innerHTML = html;
  resetCheckboxStates();
}

function displayEgdsOrders(items) {
  const tbody = document.getElementById("egds-orders-tbody");
  if (!tbody) return;

  if (!items.length) {
    tbody.innerHTML =
      '<tr><td colspan="7" style="text-align:center;color:rgba(255,255,255,0.5);">Немає замовлень</td></tr>';
    return;
  }

  const statusMap = {
    new: "Нове",
    processing: "В обробці",
    shipped: "Відправлено",
    delivered: "Доставлено",
    cancelled: "Скасовано",
  };

  let html = "";
  items.forEach((o) => {
    const safeCustomerName = decodeMojibakeText(o.customer_name || "—");
    html += `
      <tr data-id="${o.id}">
        <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
        <td class="col-name">${escapeHtml(o.order_number || "")}</td>
        <td class="col-name">${escapeHtml(safeCustomerName)}</td>
        <td class="col-price">${Number(o.total_amount || 0).toLocaleString("uk-UA")} ₴</td>
        <td class="col-category">${escapeHtml(statusMap[o.status] || o.status || "—")}</td>
        <td class="col-date">${escapeHtml(o.created_at || "—")}</td>
        <td class="col-actions">
          <button class="row-more-btn" data-id="${o.id}" data-type="egds-order">
            <i class="ri-more-2-fill"></i>
          </button>
        </td>
      </tr>
    `;
  });
  tbody.innerHTML = html;
  resetCheckboxStates();
}

async function deleteEgdsItem(id, type) {
  const itemTypeLabel = type === "orders" ? "замовлення" : "товар";
  showConfirm(`Видалити ${itemTypeLabel}?`, async () => {
    try {
      const res = await fetch("api/egds.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: Number(id), type }),
      });
      const data = await res.json();
      if (!data.success) {
        showMessage(data.error || "Помилка видалення", "error");
        return;
      }
      await loadEgds();
      showMessage(
        itemTypeLabel === "замовлення" ? "Замовлення видалено" : "Товар видалено",
        "success",
      );
    } catch (e) {
      showMessage("Помилка видалення", "error");
    }
  });
}

function cancelEgdsForms() {
  const p = document.getElementById("egds-product-form-panel");
  const o = document.getElementById("egds-order-form-panel");
  if (p) p.classList.remove("active");
  if (o) o.classList.remove("active");
}

async function fillEgdsCustomersSelect(selectedId = null) {
  const select = document.getElementById("egds-order-customer-id");
  if (!select) return;
  const res = await fetch("api/egds.php?type=customers", { cache: "no-store" });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Не вдалося завантажити клієнтів");
  const rows = data.data || [];
  select.innerHTML = rows
    .map((c) => {
      const safeFullName = decodeMojibakeText(c.full_name || `Клієнт #${c.id}`);
      return `<option value="${c.id}">${escapeHtml(safeFullName)}</option>`;
    })
    .join("");
  if (selectedId) select.value = String(selectedId);
}

async function showEgdsAddDialog() {
  const activePanel = document.querySelector("#egds .sub-tab-panel.active");
  const type = activePanel?.id === "egds-orders-content" ? "orders" : "products";
  cancelEgdsForms();
  if (type === "products") {
    const panel = document.getElementById("egds-product-form-panel");
    const title = document.getElementById("egds-product-form-title");
    const id = document.getElementById("egds-product-id");
    const name = document.getElementById("egds-product-name");
    const category = document.getElementById("egds-product-category");
    const price = document.getElementById("egds-product-price");
    const stock = document.getElementById("egds-product-stock");
    if (!panel || !title || !id || !name || !category || !price || !stock) return;
    resetModalFormState(panel);
    title.textContent = "Новий товар";
    id.value = "";
    initPrettyNumberInputs(panel);
    panel.classList.add("active");
    panel.onclick = (e) => {
      if (e.target === panel) cancelEgdsForms();
    };
    return;
  }

  try {
    await fillEgdsCustomersSelect();
    const panel = document.getElementById("egds-order-form-panel");
    const title = document.getElementById("egds-order-form-title");
    const id = document.getElementById("egds-order-id");
    const number = document.getElementById("egds-order-number");
    const total = document.getElementById("egds-order-total");
    const status = document.getElementById("egds-order-status");
    if (!panel || !title || !id || !number || !total || !status) return;
    resetModalFormState(panel);
    title.textContent = "Нове замовлення";
    id.value = "";
    number.value = `ORD-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`;
    initPrettyFieldSelects(panel);
    initPrettyNumberInputs(panel);
    refreshPrettyFieldSelects(panel);
    panel.classList.add("active");
    panel.onclick = (e) => {
      if (e.target === panel) cancelEgdsForms();
    };
  } catch (e) {
    showMessage(e.message || "Помилка завантаження клієнтів", "error");
  }
}

async function showEgdsEditDialog(id, type) {
  try {
    const res = await fetch(`api/egds.php?type=${type}&id=${Number(id)}`, {
      cache: "no-store",
    });
    const data = await res.json();
    if (!data.success || !data.data) throw new Error(data.error || "Запис не знайдено");
    const item = data.data;

    if (type === "products") {
      cancelEgdsForms();
      const panel = document.getElementById("egds-product-form-panel");
      const title = document.getElementById("egds-product-form-title");
      const idInput = document.getElementById("egds-product-id");
      const name = document.getElementById("egds-product-name");
      const category = document.getElementById("egds-product-category");
      const price = document.getElementById("egds-product-price");
      const stock = document.getElementById("egds-product-stock");
      if (!panel || !title || !idInput || !name || !category || !price || !stock) return;
      title.textContent = "Редагування товару";
      idInput.value = String(item.id);
      name.value = decodeMojibakeText(item.name || "");
      category.value = decodeMojibakeText(item.category || "");
      price.value = String(item.price ?? 0);
      stock.value = String(item.stock_quantity ?? 0);
      initPrettyNumberInputs(panel);
      panel.classList.add("active");
      panel.onclick = (e) => {
        if (e.target === panel) cancelEgdsForms();
      };
      return;
    }

    cancelEgdsForms();
    await fillEgdsCustomersSelect(item.customer_id || null);
    const panel = document.getElementById("egds-order-form-panel");
    const title = document.getElementById("egds-order-form-title");
    const idInput = document.getElementById("egds-order-id");
    const number = document.getElementById("egds-order-number");
    const total = document.getElementById("egds-order-total");
    const status = document.getElementById("egds-order-status");
    if (!panel || !title || !idInput || !number || !total || !status) return;
    title.textContent = "Редагування замовлення";
    idInput.value = String(item.id);
    number.value = item.order_number || "";
    total.value = String(item.total_amount ?? 0);
    status.value = item.status || "new";
    initPrettyFieldSelects(panel);
    initPrettyNumberInputs(panel);
    refreshPrettyFieldSelects(panel);
    panel.classList.add("active");
    panel.onclick = (e) => {
      if (e.target === panel) cancelEgdsForms();
    };
  } catch (e) {
    showMessage(e.message || "Помилка редагування", "error");
  }
}

async function saveEgdsProduct() {
  const id = Number(document.getElementById("egds-product-id")?.value || 0);
  const name = (document.getElementById("egds-product-name")?.value || "").trim();
  const category = (document.getElementById("egds-product-category")?.value || "").trim();
  const price = (document.getElementById("egds-product-price")?.value || "").trim();
  const stock = (document.getElementById("egds-product-stock")?.value || "").trim();
  if (!name) {
    showMessage("Назва товару обов'язкова", "error");
    return;
  }
  try {
    const method = id ? "PUT" : "POST";
    const payload = {
      type: "products",
      name,
      category,
      price: price || 0,
      stock_quantity: stock || 0,
      ...(id ? { id } : {}),
    };
    const res = await fetch("api/egds.php", {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка збереження");
    cancelEgdsForms();
    await loadEgds();
    showMessage(id ? "Товар оновлено" : "Товар додано", "success");
  } catch (e) {
    showMessage(e.message || "Помилка збереження", "error");
  }
}

async function saveEgdsOrder() {
  const id = Number(document.getElementById("egds-order-id")?.value || 0);
  const orderNumber = (document.getElementById("egds-order-number")?.value || "").trim();
  const customerId = Number(document.getElementById("egds-order-customer-id")?.value || 0);
  const total = (document.getElementById("egds-order-total")?.value || "").trim();
  const status = (document.getElementById("egds-order-status")?.value || "new").trim();
  if (!orderNumber || !customerId) {
    showMessage("Номер замовлення та клієнт обов'язкові", "error");
    return;
  }
  try {
    const method = id ? "PUT" : "POST";
    const payload = {
      type: "orders",
      order_number: orderNumber,
      total_amount: total || 0,
      status,
      ...(id ? { id } : { customer_id: customerId }),
    };
    const res = await fetch("api/egds.php", {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка збереження");
    cancelEgdsForms();
    await loadEgds();
    showMessage(id ? "Замовлення оновлено" : "Замовлення додано", "success");
  } catch (e) {
    showMessage(e.message || "Помилка збереження", "error");
  }
}

// ===== Goals =====
function normalizeGoalDate(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const m = raw.match(
    /^([0-2]\d|3[0-1])\.(0\d|1[0-2])\.(19|20)\d{2}\s([0-1]\d|2[0-3]):([0-5]\d)$/,
  );
  return m ? raw : "";
}

function clampGoalProgress(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, Math.round(n)));
}

function getGoalProgressColor(pct) {
  const p = Math.min(100, Math.max(0, Number(pct) || 0));
  const stops = [
    { p: 0,   r: 249, g: 115, b: 22  }, // #f97316
    { p: 35,  r: 245, g: 158, b: 11  }, // #f59e0b
    { p: 60,  r: 234, g: 179, b: 8   }, // #eab308
    { p: 85,  r: 16,  g: 185, b: 129 }, // #10b981
    { p: 100, r: 52,  g: 211, b: 153 }  // #34d399
  ];

  if (p <= stops[0].p) return `rgb(${stops[0].r}, ${stops[0].g}, ${stops[0].b})`;
  if (p >= stops[stops.length - 1].p) {
    const s = stops[stops.length - 1];
    return `rgb(${s.r}, ${s.g}, ${s.b})`;
  }

  for (let i = 0; i < stops.length - 1; i++) {
    const s1 = stops[i];
    const s2 = stops[i + 1];
    if (p >= s1.p && p <= s2.p) {
      const ratio = (p - s1.p) / (s2.p - s1.p);
      const r = Math.round(s1.r + ratio * (s2.r - s1.r));
      const g = Math.round(s1.g + ratio * (s2.g - s1.g));
      const b = Math.round(s1.b + ratio * (s2.b - s1.b));
      return `rgb(${r}, ${g}, ${b})`;
    }
  }

  return '#f59e0b';
}

let currentGoalsView = "grid";
let cachedGoalsData = [];

function cancelGoalDialogs() {
  const addModal = document.getElementById("add-goal-modal");
  const editModal = document.getElementById("edit-goal-modal");
  const depositModal = document.getElementById("deposit-goal-modal");
  if (addModal) addModal.classList.remove("active");
  if (editModal) editModal.classList.remove("active");
  if (depositModal) depositModal.classList.remove("active");
}

function cancelAddGoalDialog() {
  const addModal = document.getElementById("add-goal-modal");
  if (addModal) addModal.classList.remove("active");
}

function cancelEditGoalDialog() {
  const editModal = document.getElementById("edit-goal-modal");
  if (editModal) editModal.classList.remove("active");
}

function cancelDepositGoalDialog() {
  const depositModal = document.getElementById("deposit-goal-modal");
  if (depositModal) depositModal.classList.remove("active");
}

function showAddGoalDialog() {
  cancelGoalDialogs();
  const modal = document.getElementById("add-goal-modal");
  if (!modal) return;
  resetModalFormState(modal);

  const goalType = document.getElementById("goal-type");
  const finBlock = document.getElementById("goal-financial-fields");
  const progWrap = document.getElementById("goal-progress-wrap");
  if (goalType) goalType.value = "general";
  if (finBlock) finBlock.style.display = "none";
  if (progWrap) progWrap.style.display = "block";

  const targetAmt = document.getElementById("goal-target-amount");
  const currentAmt = document.getElementById("goal-current-amount");
  const imgUrl = document.getElementById("goal-image-url");
  if (targetAmt) targetAmt.value = "";
  if (currentAmt) currentAmt.value = "";
  if (imgUrl) imgUrl.value = "";

  initPrettyFieldSelects(modal);
  initPrettyNumberInputs(modal);
  initDateTimeInputs(modal);
  refreshPrettyFieldSelects(modal);
  requestAnimationFrame(() => refreshDateGhostHints(modal));

  modal.classList.add("active");
  modal.onclick = (e) => {
    if (e.target === modal) cancelAddGoalDialog();
  };
}

async function openGoalEditById(id) {
  try {
    const res = await fetch(`api/goals.php?id=${Number(id)}`, { cache: "no-store" });
    const data = await res.json();
    if (!data.success || !data.data) throw new Error(data.error || "Ціль не знайдено");
    const item = data.data;

    cancelGoalDialogs();
    const modal = document.getElementById("edit-goal-modal");
    if (!modal) return;
    const idInput = document.getElementById("edit-goal-id");
    const title = document.getElementById("edit-goal-title");
    const category = document.getElementById("edit-goal-category");
    const status = document.getElementById("edit-goal-status");
    const targetDate = document.getElementById("edit-goal-target-date");
    const progress = document.getElementById("edit-goal-progress");
    const desc = document.getElementById("edit-goal-description");

    const goalType = document.getElementById("edit-goal-type");
    const targetAmt = document.getElementById("edit-goal-target-amount");
    const currentAmt = document.getElementById("edit-goal-current-amount");
    const currency = document.getElementById("edit-goal-currency");
    const imgUrl = document.getElementById("edit-goal-image-url");
    const finBlock = document.getElementById("edit-goal-financial-fields");
    const progWrap = document.getElementById("edit-goal-progress-wrap");

    if (idInput) idInput.value = String(item.id || "");
    if (title) title.value = item.title || "";
    if (category) category.value = item.category || "Покупки";
    if (status) status.value = item.status || "Планується";
    if (targetDate) targetDate.value = item.target_at || "";
    if (progress) progress.value = String(clampGoalProgress(item.progress_percent));
    if (desc) desc.value = item.description || "";

    const gType = item.goal_type || (Number(item.target_amount) > 0 ? "financial" : "general");
    if (goalType) goalType.value = gType;
    if (targetAmt) targetAmt.value = item.target_amount != null && Number(item.target_amount) > 0 ? item.target_amount : "";
    if (currentAmt) currentAmt.value = item.current_amount != null && Number(item.current_amount) > 0 ? item.current_amount : "";
    if (currency) currency.value = item.currency || "грн";
    if (imgUrl) imgUrl.value = item.image_url || "";
    if (finBlock) finBlock.style.display = gType === "financial" ? "block" : "none";
    if (progWrap) progWrap.style.display = gType === "financial" ? "none" : "block";

    initPrettyFieldSelects(modal);
    initPrettyNumberInputs(modal);
    refreshPrettyFieldSelects(modal);

    modal.classList.add("active");
    modal.onclick = (e) => {
      if (e.target === modal) cancelEditGoalDialog();
    };
  } catch (e) {
    showMessage(e.message || "Помилка завантаження цілі", "error");
  }
}

async function saveGoal() {
  const title = (document.getElementById("goal-title")?.value || "").trim();
  const category = (document.getElementById("goal-category")?.value || "").trim();
  const status = (document.getElementById("goal-status")?.value || "").trim();
  const targetAt = normalizeGoalDate(document.getElementById("goal-target-date")?.value || "");
  const progress = clampGoalProgress(document.getElementById("goal-progress")?.value || 0);
  const description = (document.getElementById("goal-description")?.value || "").trim();

  const goalType = (document.getElementById("goal-type")?.value || "general").trim();
  const targetAmount = parseFloat(document.getElementById("goal-target-amount")?.value || 0);
  const currentAmount = parseFloat(document.getElementById("goal-current-amount")?.value || 0);
  const currency = (document.getElementById("goal-currency")?.value || "грн").trim();
  const imageUrl = (document.getElementById("goal-image-url")?.value || "").trim();

  if (!title) {
    showMessage("Назва цілі обов'язкова", "error");
    return;
  }

  try {
    const res = await fetch("api/goals.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        title,
        category,
        status,
        target_at: targetAt,
        progress_percent: progress,
        description,
        goal_type: goalType,
        target_amount: targetAmount,
        current_amount: currentAmount,
        currency,
        image_url: imageUrl,
      }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка збереження");
    cancelAddGoalDialog();
    await loadGoals();
    showMessage("Ціль додано", "success");
  } catch (e) {
    showMessage(e.message || "Помилка збереження", "error");
  }
}

async function updateGoal() {
  const id = Number(document.getElementById("edit-goal-id")?.value || 0);
  const title = (document.getElementById("edit-goal-title")?.value || "").trim();
  const category = (document.getElementById("edit-goal-category")?.value || "").trim();
  const status = (document.getElementById("edit-goal-status")?.value || "").trim();
  const targetAt = normalizeGoalDate(document.getElementById("edit-goal-target-date")?.value || "");
  const progress = clampGoalProgress(document.getElementById("edit-goal-progress")?.value || 0);
  const description = (document.getElementById("edit-goal-description")?.value || "").trim();

  const goalType = (document.getElementById("edit-goal-type")?.value || "general").trim();
  const targetAmount = parseFloat(document.getElementById("edit-goal-target-amount")?.value || 0);
  const currentAmount = parseFloat(document.getElementById("edit-goal-current-amount")?.value || 0);
  const currency = (document.getElementById("edit-goal-currency")?.value || "грн").trim();
  const imageUrl = (document.getElementById("edit-goal-image-url")?.value || "").trim();

  if (!id) {
    showMessage("Некоректний id цілі", "error");
    return;
  }
  if (!title) {
    showMessage("Назва цілі обов'язкова", "error");
    return;
  }

  try {
    const res = await fetch("api/goals.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        title,
        category,
        status,
        target_at: targetAt,
        progress_percent: progress,
        description,
        goal_type: goalType,
        target_amount: targetAmount,
        current_amount: currentAmount,
        currency,
        image_url: imageUrl,
      }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка оновлення");
    cancelEditGoalDialog();
    await loadGoals();
    showMessage("Ціль оновлено", "success");
  } catch (e) {
    showMessage(e.message || "Помилка оновлення", "error");
  }
}

function openDepositGoalModal(goalId) {
  const goal = cachedGoalsData.find((item) => Number(item.id) === Number(goalId));
  if (!goal) return;

  const modal = document.getElementById("deposit-goal-modal");
  if (!modal) return;

  const idInput = document.getElementById("deposit-goal-id");
  const nameEl = document.getElementById("deposit-goal-name");
  const infoEl = document.getElementById("deposit-goal-info");
  const amtInput = document.getElementById("deposit-amount-input");

  if (idInput) idInput.value = String(goal.id);
  if (nameEl) nameEl.textContent = goal.title || "";

  const currAmt = Number(goal.current_amount || 0).toLocaleString("uk-UA");
  const targAmt = Number(goal.target_amount || 0).toLocaleString("uk-UA");
  const currSym = goal.currency || "грн";
  if (infoEl) infoEl.textContent = `Наразі накопичено: ${currAmt} ${currSym} з ${targAmt} ${currSym}`;
  if (amtInput) amtInput.value = "";

  modal.classList.add("active");
  requestAnimationFrame(() => amtInput?.focus());
}

async function saveDepositGoal() {
  const id = Number(document.getElementById("deposit-goal-id")?.value || 0);
  const deposit = parseFloat(document.getElementById("deposit-amount-input")?.value || 0);

  if (!id) {
    showMessage("Некоректний ідентифікатор цілі", "error");
    return;
  }
  if (isNaN(deposit) || deposit <= 0) {
    showMessage("Введіть суму поповнення більшу за 0", "error");
    return;
  }

  try {
    const res = await fetch("api/goals.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, deposit_amount: deposit }),
    });
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка поповнення");
    cancelDepositGoalDialog();
    await loadGoals();
    showMessage(`Ціль успішно поповнено на +${deposit.toLocaleString("uk-UA")}`, "success");
  } catch (e) {
    showMessage(e.message || "Помилка поповнення цілі", "error");
  }
}

async function deleteGoal(id) {
  const goalId = Number(id);
  if (!goalId) return;
  showConfirm("Видалити ціль?", async () => {
    try {
      const res = await fetch("api/goals.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: goalId }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || "Помилка видалення");
      await loadGoals();
      showMessage("Ціль видалено", "success");
    } catch (e) {
      showMessage(e.message || "Помилка видалення", "error");
    }
  });
}

async function loadGoals(
  sortBy = currentSortField || "target_at",
  sortOrder = currentSortOrder || "ASC",
  searchQuery = currentSearchQuery || "",
) {
  try {
    const grid = document.getElementById("goals-cards-grid");
    const tbody = document.getElementById("goals-table-tbody");
    if (grid && currentGoalsView === "grid") {
      grid.innerHTML = Array(6).fill('<div class="skeleton skeleton-card"></div>').join('');
    } else if (tbody && currentGoalsView === "table") {
      tbody.innerHTML = Array(5).fill('<tr><td colspan="7"><div class="skeleton skeleton-row"></div></td></tr>').join('');
    }

    const params = new URLSearchParams({
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);
    const res = await fetch(`api/goals.php?${params}`, { cache: "no-store" });
    if (!res.ok) throw new Error("HTTP error " + res.status);
    const data = await res.json();
    if (!data.success) throw new Error(data.error || "Помилка завантаження цілей");
    displayGoals(data.data || []);
  } catch (e) {
    console.error("Помилка завантаження цілей:", e);
    showMessage("Помилка завантаження цілей", "error");
  }
}

function displayGoals(items) {
  cachedGoalsData = Array.isArray(items) ? items : [];
  renderGoalsCurrentView();
}

function renderGoalsCurrentView() {
  const gridContainer = document.getElementById("goals-cards-grid");
  const tableContainer = document.getElementById("goals-table-container");
  const tbody = document.getElementById("goals-table-tbody");

  if (!gridContainer || !tableContainer || !tbody) return;

  if (currentGoalsView === "grid") {
    gridContainer.style.display = "grid";
    tableContainer.style.display = "none";
    renderGoalsGridCards(cachedGoalsData, gridContainer);
  } else {
    gridContainer.style.display = "none";
    tableContainer.style.display = "block";
    renderGoalsTableRows(cachedGoalsData, tbody);
  }
}

function getGoalMotivationText(progress, status) {
  if (status === 'Досягнуто' || progress >= 100) return 'Ціль досягнуто! 🎉';
  if (progress >= 75) return 'Майже у мети! 🔥';
  if (progress >= 50) return 'Більше половини шляху! 🚀';
  if (progress >= 25) return 'Впевнений рух вперед! ⚡';
  if (progress > 0) return 'Старт покладено! 💪';
  return 'Готовий до старту 🎯';
}

function getGoalCategoryTheme(category) {
  const c = String(category || "").toLowerCase();
  if (c.includes("медіа") || c.includes("youtube") || c.includes("відео")) return { theme: "theme-media", icon: "ri-youtube-line" };
  if (c.includes("покупки") || c.includes("шопінг")) return { theme: "theme-shopping", icon: "ri-shopping-bag-3-line" };
  if (c.includes("фінанси") || c.includes("гроші") || c.includes("банк")) return { theme: "theme-finance", icon: "ri-wallet-3-line" };
  if (c.includes("робота") || c.includes("проєкт") || c.includes("бізнес")) return { theme: "theme-work", icon: "ri-rocket-line" };
  if (c.includes("навчання") || c.includes("освіта")) return { theme: "theme-learning", icon: "ri-book-open-line" };
  if (c.includes("здоров") || c.includes("спорт") || c.includes("фітнес")) return { theme: "theme-health", icon: "ri-heart-pulse-line" };
  if (c.includes("особисте") || c.includes("життя")) return { theme: "theme-personal", icon: "ri-compass-3-line" };
  return { theme: "theme-default", icon: "ri-focus-3-line" };
}

function renderGoalsGridCards(items, container) {
  if (!items || !items.length) {
    container.innerHTML = `<div class="empty-table-state" style="grid-column: 1/-1;"><i class="ri-focus-3-line"></i><p>Немає поточних цілей</p></div>`;
    return;
  }

  let html = "";
  items.forEach((g) => {
    const isFinancial = g.goal_type === "financial" || Number(g.target_amount) > 0;
    const progress = clampGoalProgress(g.progress_percent);
    const targetAmt = Number(g.target_amount || 0);
    const currentAmt = Number(g.current_amount || 0);
    const currSymbol = g.currency || "грн";
    const statusClass = `status-${String(g.status || "").toLowerCase().replace(/\s+/g, "-")}`;
    const imgUrl = g.image_url ? escapeHtml(g.image_url) : "";
    const catTheme = getGoalCategoryTheme(g.category);
    const motivationText = getGoalMotivationText(progress, g.status);

    let thumbHtml = "";
    if (imgUrl) {
      thumbHtml = `<img src="${imgUrl}" alt="${escapeHtml(g.title || '')}" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';">
                   <div class="goal-card-thumb-gradient ${catTheme.theme}" style="display:none;">
                     <div class="goal-card-grid-bg"></div>
                     <div class="goal-card-icon-wrapper"><i class="${catTheme.icon}"></i></div>
                   </div>`;
    } else {
      thumbHtml = `<div class="goal-card-thumb-gradient ${catTheme.theme}">
                     <div class="goal-card-grid-bg"></div>
                     <div class="goal-card-icon-wrapper"><i class="${catTheme.icon}"></i></div>
                   </div>`;
    }

    let financialBlockHtml = "";
    if (isFinancial) {
      const formattedCurrent = currentAmt.toLocaleString("uk-UA");
      const formattedTarget = targetAmt > 0 ? targetAmt.toLocaleString("uk-UA") : "—";
      financialBlockHtml = `
        <div class="goal-financial-summary">
          <div class="goal-amounts-row">
            <div>
              <span class="goal-current-amount">${formattedCurrent} ${currSymbol}</span>
            </div>
            <div class="goal-target-amount">з ${formattedTarget} ${currSymbol}</div>
          </div>
          <div class="goal-progress-wrap">
            <div class="goal-progress-bar-bg">
              <div class="goal-progress-bar-fill" style="width: ${progress}%;"></div>
            </div>
            <div class="goal-progress-meta">
              <span>${motivationText}</span>
              <span style="color: ${getGoalProgressColor(progress)}; font-weight: 700;">${progress}%</span>
            </div>
          </div>
        </div>
      `;
    } else {
      financialBlockHtml = `
        <div class="goal-progress-wrap">
          <div class="goal-progress-bar-bg">
            <div class="goal-progress-bar-fill" style="width: ${progress}%;"></div>
          </div>
          <div class="goal-progress-meta">
            <span>${motivationText}</span>
            <span style="color: ${getGoalProgressColor(progress)}; font-weight: 700;">${progress}%</span>
          </div>
        </div>
      `;
    }

    html += `
      <div class="goal-card" data-id="${g.id}">
        <input type="checkbox" class="goal-card-checkbox" title="Виділити">
        <div class="goal-card-thumb">
          ${thumbHtml}
          <div class="goal-card-badge">${escapeHtml(g.category || "Загальне")}</div>
          <div class="goal-card-status-badge ${statusClass}"><span class="status-dot"></span>${escapeHtml(g.status || "Планується")}</div>
        </div>
        <div class="goal-card-body">
          <h4 class="goal-card-title">${escapeHtml(g.title || "")}</h4>
          ${g.description ? `<p class="goal-card-desc">${escapeHtml(g.description)}</p>` : ""}
          ${financialBlockHtml}
          <div class="goal-card-footer">
            <div class="goal-card-deadline">
              <i class="ri-calendar-event-line"></i> ${escapeHtml(g.target_at || "Без дедлайну")}
            </div>
            <div class="goal-card-actions">
              ${isFinancial ? `<button class="btn-deposit-goal" onclick="openDepositGoalModal(${g.id})"><i class="ri-add-line"></i> Поповнити</button>` : ""}
              <button class="row-more-btn" data-id="${g.id}" data-type="goal" aria-label="Опції">
                <i class="ri-more-2-fill"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  initGoalsCardSelection(container);
}

// Ініціалізація виділення карток цілей
function initGoalsCardSelection(container) {
  if (!container) return;
  container.querySelectorAll(".goal-card-checkbox").forEach((cb) => {
    cb.addEventListener("change", () => {
      const card = cb.closest(".goal-card");
      if (card) card.classList.toggle("is-selected", cb.checked);
      updateGoalsCardSelectedCount();
    });
    // Не дозволяємо кліку по чекбоксу відкривати картку
    cb.addEventListener("click", (e) => e.stopPropagation());
  });
}

// Оновлення лічильника виділених карток
function updateGoalsCardSelectedCount() {
  const tabRoot = document.getElementById("goals");
  if (!tabRoot) return;
  const grid = document.getElementById("goals-cards-grid");
  const checked = grid ? Array.from(grid.querySelectorAll(".goal-card-checkbox:checked")) : [];
  const count = checked.length;

  const badgeContainer = tabRoot.querySelector(".selected-data-table-item");
  const badge = tabRoot.querySelector(".selected-data-table-item-badge");
  if (badge) badge.textContent = String(count);
  if (badgeContainer) badgeContainer.style.display = count > 0 ? "flex" : "none";
  tabRoot.classList.toggle("bulk-selection-active", count > 0);

  const bulkActions = tabRoot.querySelector(".data-table-bulk-actions");
  if (bulkActions) bulkActions.style.display = count > 0 ? "flex" : "none";

  // Синхронізуємо кнопку "Виділити всі"
  const selectAllBtn = document.getElementById("goals-select-all-btn");
  const total = grid ? grid.querySelectorAll(".goal-card-checkbox").length : 0;
  if (selectAllBtn) selectAllBtn.classList.toggle("active", count > 0 && count === total);
}

// Ініціалізація кнопки "Виділити всі" для карток цілей
function initGoalsBulkSelectBtn() {
  const btn = document.getElementById("goals-select-all-btn");
  if (!btn || btn.__goalsSelectInit) return;
  btn.__goalsSelectInit = true;

  btn.addEventListener("click", () => {
    const grid = document.getElementById("goals-cards-grid");
    if (!grid) return;
    const allCbs = Array.from(grid.querySelectorAll(".goal-card-checkbox"));
    const allChecked = allCbs.every((cb) => cb.checked);
    allCbs.forEach((cb) => {
      cb.checked = !allChecked;
      const card = cb.closest(".goal-card");
      if (card) card.classList.toggle("is-selected", cb.checked);
    });
    grid.classList.toggle("selection-mode", !allChecked);
    updateGoalsCardSelectedCount();
  });

  // Bulk delete для карток цілей
  const tabRoot = document.getElementById("goals");
  if (!tabRoot) return;
  const deleteBtns = tabRoot.querySelectorAll(".data-table-bulk-actions .delete-data-table-item");
  deleteBtns.forEach((deleteBtn) => {
    if (deleteBtn.__goalsBulkDeleteInit) return;
    deleteBtn.__goalsBulkDeleteInit = true;
    deleteBtn.addEventListener("click", async () => {
      // Якщо активний режим карток — видаляємо виділені картки
      if (document.getElementById("goals-cards-grid")?.style.display !== "none") {
        const grid = document.getElementById("goals-cards-grid");
        if (!grid) return;
        const checked = Array.from(grid.querySelectorAll(".goal-card-checkbox:checked"));
        if (checked.length === 0) { showMessage("Нічого не вибрано"); return; }
        const ids = checked.map((cb) => Number(cb.closest(".goal-card")?.dataset.id)).filter(Boolean);
        showConfirm(`Видалити ${ids.length} ціл${ids.length === 1 ? "ь" : "і"}?`, async () => {
          try {
            await Promise.all(ids.map((id) =>
              fetch("api/goals.php", {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
              }).then((r) => r.json())
            ));
            await loadGoals();
            showMessage(`${ids.length} ціл${ids.length === 1 ? "ь" : "і"} видалено`, "success");
            updateGoalsCardSelectedCount();
          } catch (e) {
            showMessage(e.message || "Помилка видалення", "error");
          }
        });
      }
    });
  });
}

function renderGoalsTableRows(items, tbody) {
  if (!items || !items.length) {
    renderEmptyTableState(tbody, "Немає поточних цілей");
    return;
  }

  let html = "";
  items.forEach((goal) => {
    const progress = clampGoalProgress(goal.progress_percent);
    html += `
      <tr data-id="${goal.id}">
        <td class="col-drag-handle" title="Перетягнути рядок"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="drag-handle-svg"><circle cx="2" cy="2" r="1" fill="currentColor"/><circle cx="6" cy="2" r="1" fill="currentColor"/><circle cx="2" cy="6" r="1" fill="currentColor"/><circle cx="6" cy="6" r="1" fill="currentColor"/><circle cx="2" cy="10" r="1" fill="currentColor"/><circle cx="6" cy="10" r="1" fill="currentColor"/></svg></td>
        <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
        <td class="col-name">${escapeHtml(goal.title || "")}</td>
        <td class="col-category">${escapeHtml(goal.category || "—")}</td>
        <td class="col-status">${escapeHtml(goal.status || "—")}</td>
        <td class="col-limit" style="color: ${getGoalProgressColor(progress)}; font-weight: 700;">${progress}%</td>
        <td class="col-date">${escapeHtml(goal.target_at || "—")}</td>
        <td class="col-actions">
          <button class="row-more-btn" data-id="${goal.id}" data-type="goal">
            <i class="ri-more-2-fill"></i>
          </button>
        </td>
      </tr>
    `;
  });
  tbody.innerHTML = html;
  resetCheckboxStates();
}

function initGoalsEvents() {
  // Ініціалізуємо кнопку "Виділити всі" для карток
  initGoalsBulkSelectBtn();

  document.addEventListener("click", function (e) {
    const presetBtn = e.target.closest(".preset-img-btn");
    if (presetBtn) {
      e.preventDefault();
      const targetId = presetBtn.dataset.targetInput;
      const url = presetBtn.dataset.url;
      if (targetId && url) {
        const input = document.getElementById(targetId);
        if (input) input.value = url;
      }
    }

    const viewBtn = e.target.closest(".goals-view-btn");
    if (viewBtn) {
      e.preventDefault();
      const view = viewBtn.dataset.view;
      if (view && (view === "grid" || view === "table")) {
        currentGoalsView = view;
        const allBtns = document.querySelectorAll(".goals-view-btn");
        allBtns.forEach((b) => b.classList.toggle("active", b.dataset.view === view));
        renderGoalsCurrentView();
        // Показуємо кнопку "Виділити всі" тільки в режимі карток
        const selectAllBtn = document.getElementById("goals-select-all-btn");
        if (selectAllBtn) selectAllBtn.style.display = view === "grid" ? "" : "none";
        // Знімаємо виділення при перемиканні виду
        if (view === "table") {
          const grid = document.getElementById("goals-cards-grid");
          if (grid) {
            grid.querySelectorAll(".goal-card-checkbox").forEach((cb) => { cb.checked = false; });
            grid.querySelectorAll(".goal-card").forEach((c) => c.classList.remove("is-selected"));
            grid.classList.remove("selection-mode");
          }
          updateGoalsCardSelectedCount();
        } else if (view === "grid") {
          const tableContainer = document.getElementById("goals-table-container");
          if (tableContainer) {
            tableContainer.querySelectorAll(".row-checkbox").forEach((cb) => { cb.checked = false; });
            const selectAll = tableContainer.querySelector(".select-all-checkbox");
            if (selectAll) selectAll.checked = false;
          }
          updateSelectedCount();
        }
      }
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target && (e.target.id === "goal-type" || e.target.id === "edit-goal-type")) {
      const isAdd = e.target.id === "goal-type";
      const val = e.target.value;
      const finBlock = document.getElementById(isAdd ? "goal-financial-fields" : "edit-goal-financial-fields");
      const progWrap = document.getElementById(isAdd ? "goal-progress-wrap" : "edit-goal-progress-wrap");
      if (finBlock) finBlock.style.display = val === "financial" ? "block" : "none";
      if (progWrap) progWrap.style.display = val === "financial" ? "none" : "block";
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGoalsEvents);
} else {
  initGoalsEvents();
}


function displaySettings(items) {
  const tbody = ensureSettingsTableStructure();
  if (!tbody) return;
  tbody.innerHTML = "";
  if (!items.length) {
    renderEmptyTableState(tbody, "Немає налаштувань");
    return;
  }
  items.forEach((s) => {
    const isReadonly = !s.id || String(s.name || "").toLowerCase() === "версія";
    const tr = document.createElement("tr");
    tr.dataset.id = String(s.id || "");
    tr.dataset.name = s.name;
    const updatedAt = s.updated_at ? escapeHtml(String(s.updated_at)) : "—";
    const safeValue = escapeAttr(s.value || "");
    tr.innerHTML = `
            <td class="col-name">${escapeHtml(s.label || s.name || "")}</td>
            <td class="col-value">
                ${isReadonly
        ? `<span class="setting-value-static">${escapeHtml(String(s.value || ""))}</span>`
        : `<input type="text" class="setting-input" value="${safeValue}">`}
            </td>
            <td class="col-date">${updatedAt}</td>`;
    tbody.appendChild(tr);

    const input = tr.querySelector(".setting-input");
    if (isReadonly || !input) {
      return;
    }
    const commit = async () => {
      const newVal = input.value.trim();
      if (newVal !== s.value) {
        try {
          await saveSetting(s.name, newVal, s.id);
          showMessage("Збережено", "success");
          s.value = newVal;
        } catch (err) {
          showMessage(err.message, "error");
          input.value = s.value;
        }
      }
    };
    input.addEventListener("keydown", (ev) => {
      if (ev.key === "Enter") {
        ev.preventDefault();
        commit();
      }
    });
    input.addEventListener("blur", commit);
  });
  tbody.__settingsInit = true;
}

async function saveSetting(name, value, id) {
  const payload = id ? { id, value } : { name, value };
  const method = id ? "PUT" : "POST";
  const res = await fetch("api/settings.php", {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Помилка збереження");
  // Перезавантажимо список, щоб оновити id для нових записів
  await loadSettings(currentSearchQuery);
}

// Утиліта для екранування HTML
function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

// ===== Tasks =====
async function loadTasks(sortBy = "date", sortOrder = "ASC", searchQuery = "", extraParams = {}) {
  try {
    // Оновлюємо глобальні змінні сортування
    currentSortField = sortBy;
    currentSortOrder = sortOrder;

    const params = new URLSearchParams({
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    // Додаткові параметри (фільтр статусу)
    for (const [key, val] of Object.entries(extraParams)) {
      params.append(key, val);
    }

    // Показуємо skeleton loader у поточній активній таблиці завдань
    const activeSub = document.querySelector("#tasks .sub-tab-panel.active");
    if (activeSub && activeSub.id !== "tasks-calendar-content") {
      const tbody = activeSub.querySelector("tbody");
      if (tbody) {
        tbody.innerHTML = Array(5).fill('<tr><td colspan="8"><div class="skeleton skeleton-row"></div></td></tr>').join('');
      }
    }

    const hasExtraFilter = Object.keys(extraParams).length > 0;
    if (activeSub && !hasExtraFilter) {
      const id = activeSub.id;
      if (id === "tasks-list-content") params.append("done", "0");
      if (id === "tasks-archive-content") params.append("archive", "1");
      if (id === "tasks-all-content") {
        // No filter for All tasks
      }
      if (id === "active-tasks-content") {
        params.append("has_timer", "1");
        params.append("done", "0");
      }
      if (id === "today-tasks-content") params.append("date", "today_overdue");
      if (id === "no-date-tasks-content") params.append("no_date", "1");
      // календар: фільтруємо за місяцем, читаємо з URL (?month=YYYY-MM), або поточний
      if (id === "tasks-calendar-content") {
        const url = new URL(window.location);
        const month =
          url.searchParams.get("month") || new Date().toISOString().slice(0, 7);
        params.append("month", month);
      }
    }
    const res = await fetch(`api/tasks.php?${params}`, {
      cache: "no-store",
      headers: {
        "Cache-Control": "no-cache, no-store, must-revalidate",
        "Pragma": "no-cache",
        "Expires": "0"
      }
    });
    if (!res.ok) throw new Error("HTTP error " + res.status);
    const data = await res.json();
    if (data.success) {
      let taskItems = data.data || [];
      const activeSub2 = document.querySelector("#tasks .sub-tab-panel.active");
      const smartSortAllowed =
        activeSub2 &&
        activeSub2.id !== "tasks-archive-content" &&
        activeSub2.id !== "tasks-calendar-content";
      if (tasksSmartSortEnabled && smartSortAllowed) {
        taskItems = applyTasksSmartSortPreset(taskItems);
      }
      if (activeSub2 && activeSub2.id === "tasks-calendar-content") {
        const url = new URL(window.location);
        const month =
          url.searchParams.get("month") || new Date().toISOString().slice(0, 7);
        const [y, m] = month.split("-").map(Number);
        const monthLabel = new Date(y, m - 1, 1).toLocaleDateString("uk-UA", {
          year: "numeric",
          month: "long",
        });
        const label = document.getElementById("calendar-month-label");
        if (label) label.textContent = monthLabel;
        displayTasksCalendar(taskItems);
      } else {
        displayTasks(taskItems);
      }
    }
  } catch (e) {
    console.error("Помилка завантаження задач: ", e);
    showMessage("Помилка завантаження задач", "error");
  }
}

const TASK_COLUMN_MIN_WIDTHS = [34, 34, 34, 86, 160, 80, 110, 80, 120, 40];
const TASK_COLUMN_DEFAULT_WIDTHS = [34, 34, 34, 86, 260, 100, 130, 90, 135, 40];
const TASK_COLUMN_MAX_WIDTHS = [34, 34, 34, 104, 800, 160, 240, 140, 160, 40];
const taskMeasureCanvas = document.createElement("canvas");

function formatTaskPeriodLabel(value) {
  const period = String(value || "").trim();
  if (!period || period === "Немає") return "";
  if (period === "09:00-12:00") return '<span class="task-period-tag"><i class="ri-haze-line"></i> Ранок</span>';
  if (period === "12:00-15:00") return '<span class="task-period-tag"><i class="ri-sun-line"></i> День</span>';
  if (period === "15:00-18:00") return '<span class="task-period-tag"><i class="ri-sun-cloudy-line"></i> Вечір</span>';
  if (period === "18:00-21:00") return '<span class="task-period-tag"><i class="ri-moon-line"></i> Пізній вечір</span>';
  if (period === "OUT_OF_PERIOD") return '<span class="task-period-tag"><i class="ri-error-warning-line"></i> Поза</span>';
  return period;
}

function formatTaskDateLabel(dateStr) {
  if (!dateStr) return "";
  const str = String(dateStr).trim();
  if (!str || str === "—") return "";
  const m = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    return `${m[3]}.${m[2]}.${m[1]}`;
  }
  const m2 = str.match(/^(\d{2})\.(\d{2})\.(\d{4})/);
  if (m2) {
    return `${m2[1]}.${m2[2]}.${m2[3]}`;
  }
  return str;
}

function formatTaskCategoryLabel(value) {
  const category = String(value || "").trim();
  if (!category || category === "Немає") return "";
  return `<span class="category-pill" data-cat="${category}">${category}</span>`;
}

function formatTaskRepeatLabel(type, days) {
  const repeatType = String(type || "").trim();
  if (!repeatType || repeatType === "none") return "";
  if (repeatType === "daily")
    return '<span class="task-repeat-tag" title="Повторення: Кожен день"><i class="ri-repeat-line"></i></span>';
  if (repeatType === "weekdays")
    return '<span class="task-repeat-tag" title="Повторення: Пн-Пт"><i class="ri-repeat-line"></i></span>';
  if (repeatType === "custom") {
    const dayNames = { 1: "Пн", 2: "Вт", 3: "Ср", 4: "Чт", 5: "Пт", 6: "Сб", 7: "Нд" };
    const list = String(days || "")
      .split(",")
      .map((d) => dayNames[d.trim()])
      .filter(Boolean);
    const text = list.length ? list.join(", ") : "Дні тижня";
    return `<span class="task-repeat-tag" title="Повторення по днях: ${text}"><i class="ri-repeat-line"></i></span>`;
  }
  return "";
}

function getSelectedRepeatDays(containerId) {
  const container = document.getElementById(containerId);
  if (!container) return "";
  const activeBtns = container.querySelectorAll(".repeat-day-btn.active");
  const days = Array.from(activeBtns)
    .map((btn) => btn.dataset.day)
    .filter(Boolean);
  return days.join(",");
}

function setSelectedRepeatDays(containerId, daysString) {
  const container = document.getElementById(containerId);
  if (!container) return;
  const activeList = String(daysString || "")
    .split(",")
    .map((d) => d.trim());
  const btns = container.querySelectorAll(".repeat-day-btn");
  btns.forEach((btn) => {
    if (activeList.includes(btn.dataset.day)) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });
}

function initTaskRecurrenceEvents() {
  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "task-repeat-type") {
      const wrap = document.getElementById("task-repeat-days-wrap");
      if (wrap) wrap.style.display = e.target.value === "custom" ? "block" : "none";
    }
    if (e.target && e.target.id === "edit-task-repeat-type") {
      const wrap = document.getElementById("edit-task-repeat-days-wrap");
      if (wrap) wrap.style.display = e.target.value === "custom" ? "block" : "none";
    }
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".repeat-day-btn");
    if (btn) {
      e.preventDefault();
      btn.classList.toggle("active");
    }
  });

  // Автоматичне очищення лідируючих табуляцій/пробілів при вставці в назву завдання
  document.addEventListener("paste", function (e) {
    if (
      e.target &&
      (e.target.id === "task-title" || e.target.id === "edit-task-title")
    ) {
      const text = (e.clipboardData || window.clipboardData)?.getData("text");
      if (text) {
        e.preventDefault();
        const cleaned = text.replace(/^[\s\t]+|[\s\t]+$/g, "");
        const input = e.target;
        const start = input.selectionStart || 0;
        const end = input.selectionEnd || 0;
        const val = input.value;
        input.value = val.substring(0, start) + cleaned + val.substring(end);
        input.setSelectionRange(
          start + cleaned.length,
          start + cleaned.length,
        );
        input.dispatchEvent(new Event("input"));
      }
    }
  });
}

// Запускаємо слухачі повторень завдань при старті
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTaskRecurrenceEvents);
} else {
  initTaskRecurrenceEvents();
}


function measureTaskTextWidth(text) {
  const ctx = taskMeasureCanvas.getContext("2d");
  if (!ctx) return 0;
  ctx.font = "500 13px Montserrat, sans-serif";
  return ctx.measureText(String(text || "")).width;
}

function clampWidth(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function ensureTaskColGroup(table, count) {
  let colgroup = table.querySelector("colgroup.task-colgroup");
  if (!colgroup) {
    colgroup = document.createElement("colgroup");
    colgroup.className = "task-colgroup";
    table.insertBefore(colgroup, table.firstChild);
  }
  while (colgroup.children.length < count) {
    colgroup.appendChild(document.createElement("col"));
  }
  while (colgroup.children.length > count) {
    colgroup.removeChild(colgroup.lastChild);
  }
  return colgroup;
}

function computeTaskColumnWidths(items, headers) {
  const widths = TASK_COLUMN_DEFAULT_WIDTHS.slice();
  if (!Array.isArray(items) || !items.length) return widths;
  const sampleItems = items.length > 120 ? items.slice(0, 120) : items;

  const headerTexts = headers.map((th) =>
    String(th?.textContent || "").replace(/\s+/g, " ").trim(),
  );

  let maxTitle = measureTaskTextWidth(headerTexts[4] || "Завдання");
  let maxCategory = measureTaskTextWidth(headerTexts[5] || "Категорія");
  let maxPeriod = measureTaskTextWidth(headerTexts[6] || "Період");
  let maxLimit = measureTaskTextWidth(headerTexts[7] || "Обмеження");
  let maxDate = measureTaskTextWidth(headerTexts[8] || "Дата");

  sampleItems.forEach((t) => {
    maxTitle = Math.max(maxTitle, measureTaskTextWidth(t.task || t.title || ""));
    maxCategory = Math.max(
      maxCategory,
      measureTaskTextWidth(formatTaskCategoryLabel(t.category)),
    );
    const periodStr = (formatTaskPeriodLabel(t.day_period) + " " + formatTaskRepeatLabel(t.repeat_type, t.repeat_days)).replace(/<[^>]*>/g, '').trim();
    maxPeriod = Math.max(
      maxPeriod,
      measureTaskTextWidth(periodStr),
    );
    maxLimit = Math.max(
      maxLimit,
      measureTaskTextWidth(
        t.time_limit_minutes ? `${Number(t.time_limit_minutes)} хв` : "Немає",
      ),
    );
    maxDate = Math.max(
      maxDate,
      measureTaskTextWidth(t.date || t.due_date || t.due_at || ""),
    );
  });

  widths[4] = clampWidth(Math.ceil(maxTitle) + 30, 220, 760);
  widths[5] = clampWidth(Math.ceil(maxCategory) + 10, 80, 140);
  widths[6] = clampWidth(Math.ceil(maxPeriod) + 35, 110, 320);
  widths[7] = clampWidth(Math.ceil(maxLimit) + 10, 80, 130);
  widths[8] = clampWidth(Math.ceil(maxDate) + 10, 110, 150);
  return widths;
}

function applyTaskTableColumnSizing(table, items) {
  if (!table || !table.closest("#tasks")) return;
  const headers = Array.from(table.querySelectorAll("thead th"));
  if (!headers.length) return;
  const colgroup = ensureTaskColGroup(table, headers.length);

  const host =
    table.closest(".data-table-container") ||
    table.closest(".tab-panel-table") ||
    table.parentElement;

  const mainContent = document.querySelector(".main-content");
  const hostWidth = host?.clientWidth || (mainContent?.clientWidth ? mainContent.clientWidth - 40 : 900);

  const baseWidths = computeTaskColumnWidths(items || [], headers);
  const finalWidths = baseWidths.map((base, idx) => {
    const hardMin = TASK_COLUMN_MIN_WIDTHS[idx] || 28;
    const hardMax = TASK_COLUMN_MAX_WIDTHS[idx] || 9999;
    const defaultMin = Math.max(hardMin, TASK_COLUMN_DEFAULT_WIDTHS[idx] || hardMin);
    return clampWidth(base, defaultMin, hardMax);
  });

  const nameColIdx = 4;
  const usedOtherCols = finalWidths.reduce((sum, w, i) => (i === nameColIdx ? sum : sum + w), 0);
  const availableForName = Math.max(160, hostWidth - usedOtherCols - 16);
  finalWidths[nameColIdx] = availableForName;

  finalWidths.forEach((width, idx) => {
    const px = `${Math.round(width)}px`;
    if (colgroup.children[idx]) {
      colgroup.children[idx].style.width = px;
    }
  });

  const headerCells = Array.from(table.querySelectorAll("thead th"));
  finalWidths.forEach((width, idx) => {
    const px = `${Math.round(width)}px`;
    const th = headerCells[idx];
    if (th) {
      th.style.setProperty("width", px);
      th.style.setProperty("min-width", idx === nameColIdx ? "140px" : px);
      th.style.removeProperty("max-width");
    }
  });

  table.style.minWidth = "100%";
  table.style.width = "100%";
  table.style.tableLayout = "fixed";
}

const universalTableMeasureCanvas = document.createElement("canvas");
let universalTableResizeBound = false;
let universalTableDiscoveryObserverBound = false;

function ensureUniversalColGroup(table, count) {
  let colgroup = table.querySelector("colgroup.data-colgroup");
  if (!colgroup) {
    colgroup = document.createElement("colgroup");
    colgroup.className = "data-colgroup";
    table.insertBefore(colgroup, table.firstChild);
  }
  while (colgroup.children.length < count) {
    colgroup.appendChild(document.createElement("col"));
  }
  while (colgroup.children.length > count) {
    colgroup.removeChild(colgroup.lastChild);
  }
  return colgroup;
}

function measureUniversalText(text, isHeader = false) {
  const ctx = universalTableMeasureCanvas.getContext("2d");
  if (!ctx) return 0;
  ctx.font = isHeader
    ? "500 11px Montserrat, sans-serif"
    : "500 13px Montserrat, sans-serif";
  return ctx.measureText(String(text || "")).width;
}

function getUniversalColumnBounds(th, idx) {
  const cls = th.className || "";
  if (cls.includes("col-drag-handle")) {
    return { min: 34, max: 34, base: 34 };
  }
  if (cls.includes("col-checkbox") || cls.includes("col-func")) {
    return { min: 34, max: 34, base: 34 };
  }
  if (cls.includes("col-timer")) {
    return { min: 104, max: 116, base: 104 };
  }
  if (cls.includes("col-actions")) {
    return { min: 56, max: 56, base: 56 };
  }
  if (cls.includes("col-timer")) {
    return { min: 72, max: 120, base: 72 };
  }
  if (cls.includes("col-date")) {
    return { min: 120, max: 260, base: 130 };
  }
  if (cls.includes("col-limit")) {
    return { min: 110, max: 220, base: 120 };
  }
  if (cls.includes("col-name")) {
    return { min: 120, max: 2400, base: 300 };
  }
  if (cls.includes("col-category")) {
    return { min: 120, max: 320, base: 150 };
  }
  if (cls.includes("col-status")) {
    return { min: 120, max: 260, base: 140 };
  }
  if (cls.includes("col-currency")) {
    return { min: 90, max: 160, base: 96 };
  }
  if (cls.includes("col-amount") || cls.includes("col-price") || cls.includes("col-balance")) {
    return { min: 110, max: 220, base: 120 };
  }
  if (cls.includes("col-period")) {
    return { min: 120, max: 320, base: 140 };
  }
  if (cls.includes("col-value")) {
    return { min: 160, max: 520, base: 240 };
  }
  return { min: 110, max: 460, base: idx === 0 ? 120 : 140 };
}

function computeUniversalColumnWidths(table) {
  const headers = Array.from(table.querySelectorAll("thead th"));
  const rows = Array.from(table.querySelectorAll("tbody tr")).slice(0, 24);
  return headers.map((th, idx) => {
    const bounds = getUniversalColumnBounds(th, idx);
    let maxText = measureUniversalText(
      String(th.textContent || "").replace(/\s+/g, " ").trim(),
      true,
    );
    rows.forEach((tr) => {
      const td = tr.children[idx];
      if (!td) return;
      const text = String(td.textContent || "").replace(/\s+/g, " ").trim();
      if (!text) return;
      maxText = Math.max(maxText, measureUniversalText(text, false));
    });
    const contentBased = Math.ceil(maxText) + 26;
    return clampWidth(contentBased || bounds.base, bounds.min, bounds.max);
  });
}

function applyUniversalTableColumnSizing(table) {
  if (!table) return;
  table.style.minWidth = "100%";
  table.style.width = "100%";
  table.style.tableLayout = "fixed";
}

function initUniversalDataTableLayout(scope) {
  const root = scope || document;
  root.querySelectorAll("table.data-table").forEach((table) => {
    if (table.closest("#tasks")) return;
    applyUniversalTableColumnSizing(table);
    if (!table.__universalObserverInit) {
      const tbody = table.querySelector("tbody");
      if (tbody) {
        const observer = new MutationObserver(() => {
          applyUniversalTableColumnSizing(table);
        });
        observer.observe(tbody, {
          childList: true,
          subtree: true,
          characterData: true,
        });
        table.__universalObserver = observer;
      }
      table.__universalObserverInit = true;
    }
  });

  if (!universalTableResizeBound) {
    let rafId = 0;
    window.addEventListener("resize", () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        document.querySelectorAll("table.data-table").forEach((table) => {
          applyUniversalTableColumnSizing(table);
        });
      });
    });
    universalTableResizeBound = true;
  }

  if (!universalTableDiscoveryObserverBound) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches?.("table.data-table")) {
            applyUniversalTableColumnSizing(node);
            return;
          }
          node.querySelectorAll?.("table.data-table").forEach((table) => {
            applyUniversalTableColumnSizing(table);
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    universalTableDiscoveryObserverBound = true;
  }
}

function displayTasks(items) {
  // Обираємо tbody в межах активної підвкладки tasks
  const activeSub = document.querySelector("#tasks .sub-tab-panel.active");
  if (!activeSub) return;
  const tbody = activeSub.querySelector("tbody");
  if (!tbody) return;
  const table = activeSub.querySelector("table.data-table");
  tbody.innerHTML = "";
  if (!items.length) {
    const emptyMessages = {
      "tasks-list-content": "Немає активних завдань",
      "tasks-archive-content": "Немає завдань в архіві",
      "tasks-all-content": "Немає завдань",
      "active-tasks-content": "Немає активних таймерів",
      "today-tasks-content": "Немає завдань на сьогодні",
      "no-date-tasks-content": "Немає завдань без дати",
    };
    renderEmptyTableState(
      tbody,
      emptyMessages[activeSub.id] || "Немає завдань",
    );
    applyTaskTableColumnSizing(table, []);
    resetCheckboxStates();
    return;
  }

  // Видаляємо з активних таймерів тільки ті завдання, яких немає в новому списку
  const currentTaskIds = new Set(items.map((t) => t.id.toString()));
  const activeTaskIds = Array.from(activeTimers.keys());

  activeTaskIds.forEach((taskId) => {
    if (!currentTaskIds.has(taskId)) {
      activeTimers.delete(taskId);
    }
  });

  // Зупиняємо оновлення тільки якщо не залишилось активних таймерів
  if (activeTimers.size === 0) {
    stopTimerUpdates();
  }

  items.forEach((t) => {
    const tr = document.createElement("tr");
    tr.dataset.id = String(t.id);
    if (Number(t.id) === Number(lastActiveTaskId)) {
      tr.classList.add("task-row-active");
    }
    const isDeletedView = Number(t.is_deleted || 0) === 1;
    const isDone = Number(t.done || 0) === 1;

    // Таймер: визначаємо стан
    const hasTimer =
      t.timer_started_at !== null &&
      t.timer_started_at !== undefined &&
      t.timer_started_at !== "";
    const elapsedSeconds = Number(t.timer_elapsed_seconds || 0);
    const timeLimitMinutes = Number(t.time_limit_minutes || 0);
    const autoComplete = Boolean(t.auto_complete);
    const timerText = formatTimer(
      elapsedSeconds,
      hasTimer,
      t.id,
      t.timer_started_timestamp,
      timeLimitMinutes,
      autoComplete,
    );

    // Кнопки таймера - показуємо якщо є обмеження часу АБО якщо таймер вже запущений/має elapsed time
    let timerButtons = "";
    const hasTimerActivity = hasTimer || elapsedSeconds > 0;
    if (
      !isDone &&
      !isDeletedView &&
      (timeLimitMinutes > 0 || hasTimerActivity)
    ) {
      // Перевіряємо чи таймер завершився (досяг ліміту але не активний)
      const isTimerFinished =
        timeLimitMinutes > 0 &&
        elapsedSeconds >= timeLimitMinutes * 60 &&
        !hasTimer;

      if (hasTimer) {
        timerButtons = `
                    <div class="task-timer-controls">
                        <button class="timer-button pause-timer" data-action="pause-timer" data-tooltip="Призупинити таймер">
                            <i class="ri-pause-fill"></i>
                        </button>
                        <button class="timer-button stop-timer" data-action="stop-timer" data-tooltip="Зупинити таймер">
                            <i class="ri-stop-fill"></i>
                        </button>
                    </div>`;
      } else if (isTimerFinished) {
        // Таймер завершився - показуємо тільки кнопку перезапуску
        timerButtons = `
                    <div class="task-timer-controls">
                        <button class="timer-button reset-timer" data-action="reset-timer" data-tooltip="Перезапустити таймер">
                            <i class="ri-refresh-line"></i>
                        </button>
                    </div>`;
      } else {
        // Звичайний стан - таймер не запущений
        let resetBtn = "";
        if (elapsedSeconds > 0) {
          resetBtn = `
                        <button class="timer-button reset-timer" data-action="reset-timer" data-tooltip="Скинути таймер">
                            <i class="ri-refresh-line"></i>
                        </button>`;
        }

        timerButtons = `
                    <div class="task-timer-controls">
                        <button class="timer-button start-timer" data-action="start-timer" data-tooltip="Запустити таймер">
                            <i class="ri-play-fill"></i>
                        </button>
                        ${resetBtn}
                    </div>`;
      }
    }

    const descriptionText =
      typeof t.description === "string" ? t.description.trim() : "";
    const tagsList =
      typeof t.tags === "string"
        ? t.tags
            .split(/[ ,]+/)
            .filter(Boolean)
            .map((tag) => tag.trim())
            .filter(Boolean)
        : [];
    const hasMetaContent = descriptionText.length > 0 || tagsList.length > 0;
    if (hasMetaContent) {
      tr.classList.add("task-row-has-meta");
    }

    const isAllyNote = String(t.source || "").toLowerCase() === "allynote" || tagsList.some(tag => tag.toLowerCase().includes("allynote"));
    const allyNoteBadge = isAllyNote ? `<span class="badge-allynote" title="Синхронізовано з AllyNote"><i class="ri-booklet-line"></i> AllyNote</span>` : "";

    tr.innerHTML = `
            <td class="col-drag-handle" title="Перетягнути рядок"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="drag-handle-svg"><circle cx="2" cy="2" r="1" fill="currentColor"/><circle cx="6" cy="2" r="1" fill="currentColor"/><circle cx="2" cy="6" r="1" fill="currentColor"/><circle cx="6" cy="6" r="1" fill="currentColor"/><circle cx="2" cy="10" r="1" fill="currentColor"/><circle cx="6" cy="10" r="1" fill="currentColor"/></svg></td>
            <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
            <td class="col-checkbox"><input type="checkbox" class="task-done" ${t.done ? "checked" : ""}></td>
            <td class="col-timer">
                <div class="timer-cell-content">
                    ${timerText}
                    ${timerButtons || ""}
                </div>
            </td>
            <td class="col-name"><div class="task-title">${escapeHtml(t.task || t.title || "")} ${allyNoteBadge}</div>${descriptionText ? `<div class="task-desc">${escapeHtml(descriptionText)}</div>` : ""}${tagsList.length ? `<div class="task-tags">${tagsList.map(tag => `<span class="task-tag">${escapeHtml(tag.startsWith('#') ? tag : '#' + tag)}</span>`).join('')}</div>` : ""}</td>
            <td class="col-category">${formatTaskCategoryLabel(t.category)}</td>
            <td class="col-period">${formatTaskPeriodLabel(t.day_period)}${formatTaskRepeatLabel(t.repeat_type, t.repeat_days)}</td>
            <td class="col-limit">${t.time_limit_minutes ? Number(t.time_limit_minutes) + " хв" : ""}</td>
            <td class="col-date">${escapeHtml(t.date || t.due_date || t.due_at || "") || ""}</td>
            <td class="col-actions">
                <button class="row-more-btn" data-id="${t.id}" data-type="${t.item_type || 'task'}" data-is-deleted="${isDeletedView}">
                    <i class="ri-more-2-fill"></i>
                </button>
            </td>
        `;
    tbody.appendChild(tr);
  });
  applyTaskTableColumnSizing(table, items);
  if (!tbody.querySelector("tr.task-row-active")) {
    const firstRow = tbody.querySelector("tr[data-id]");
    if (firstRow) setActiveTaskRow(firstRow);
  }
  // Скидаємо стан чекбоксів після завантаження нових даних
  resetCheckboxStates();
}

// Функція форматування часу таймера
function formatTimer(
  elapsedSeconds,
  isRunning,
  taskId,
  startedTimestamp,
  timeLimitMinutes,
  autoComplete = false,
) {
  // Показуємо таймер тільки якщо:
  // 1. Таймер активний (isRunning = true), АБО
  // 2. Є ліміт часу (timeLimitMinutes > 0) і є накопичений час (elapsedSeconds > 0)
  if (!isRunning && (timeLimitMinutes === 0 || elapsedSeconds === 0)) {
    return "";
  }

  // Для активних таймерів зберігаємо інформацію для реального часу
  if (isRunning && startedTimestamp && taskId) {
    const taskIdStr = taskId.toString();
    const existingTimer = activeTimers.get(taskIdStr);

    if (!existingTimer) {
      // Створюємо новий таймер тільки якщо його ще немає
      const startTime = Number(startedTimestamp) * 1000;
      const serverTime = Date.now();
      activeTimers.set(taskIdStr, {
        startTime,
        baseElapsed: elapsedSeconds,
        lastSync: serverTime,
        timeLimitMinutes: timeLimitMinutes || 0,
        autoComplete: autoComplete,
      });
      startTimerUpdates();
    } else {
      // Якщо таймер уже існує, оновлюємо тільки необхідні дані
      existingTimer.timeLimitMinutes = timeLimitMinutes || 0;
      existingTimer.autoComplete = autoComplete;
    }
  } else if (!isRunning && taskId) {
    activeTimers.delete(taskId.toString());
    if (activeTimers.size === 0) {
      stopTimerUpdates();
    }
  }

  // Визначаємо який час показувати
  let displaySeconds = elapsedSeconds;
  let isCountdown = false;
  let isOvertime = false;

  // Якщо таймер активний і є в activeTimers, використовуємо реальний час
  if (isRunning && taskId) {
    const taskIdStr = taskId.toString();
    const timerData = activeTimers.get(taskIdStr);
    if (timerData) {
      const now = Date.now();
      const currentElapsed =
        timerData.baseElapsed + Math.floor((now - timerData.startTime) / 1000);
      displaySeconds = currentElapsed;
    }
  }

  if (timeLimitMinutes > 0) {
    const limitSeconds = timeLimitMinutes * 60;
    if (displaySeconds <= limitSeconds) {
      // Зворотний відлік до закінчення ліміту
      const countdownSeconds = limitSeconds - displaySeconds;
      isCountdown = true;

      // Перевіряємо чи таймер закінчився (досяг 0)
      if (countdownSeconds <= 0 && isRunning && taskId) {
        const taskIdStr = taskId.toString();
        const timerData = activeTimers.get(taskIdStr);
        // Таймер завершився - перевіряємо чи потрібно автозавершення
        if (timerData && timerData.autoComplete) {
          markTaskAsCompleted(taskId);
          return ""; // Повертаємо пустий рядок, завдання переміщується
        } else {
          // Просто зупиняємо таймер без автозавершення
          if (timerData) {
            activeTimers.delete(taskIdStr);
          }
          displaySeconds = 0; // Показуємо 00:00
        }
      } else {
        displaySeconds = countdownSeconds;
      }
    } else {
      // Без автозавершення не показуємо "+" після ліміту, фіксуємо 00:00.
      if (!autoComplete) {
        displaySeconds = 0;
        isCountdown = true;
      } else {
        // Перевищення ліміту - показуємо час перевищення
        displaySeconds = displaySeconds - limitSeconds;
        isOvertime = true;
      }
    }
  }

  const hours = Math.floor(displaySeconds / 3600);
  const minutes = Math.floor((displaySeconds % 3600) / 60);
  const seconds = displaySeconds % 60;

  let timeStr = "";
  if (hours > 0) {
    timeStr = `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  } else {
    timeStr = `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }

  // Префікс залежно від типу відліку
  let prefix = "";
  let cssClass = "task-timer";

  if (isCountdown) {
    prefix = '';
    cssClass += " countdown";
  } else if (isOvertime) {
    prefix = '+';
    cssClass += " overtime";
  }

  // Якщо таймер активний, додаємо клас анімації пульсу або блимання на весь бейдж
  if (isRunning) {
    cssClass += " active-timer-badge";
  }

  return `<span class="${cssClass}" data-task-id="${taskId}">${prefix}${timeStr}</span>`;
}

// Функція оновлення активних таймерів в реальному часі
function updateActiveTimers() {
  const now = Date.now();

  const timersToDelete = [];

  activeTimers.forEach((timerData, taskId) => {
    const elapsed =
      timerData.baseElapsed + Math.floor((now - timerData.startTime) / 1000);
    const timerElements = document.querySelectorAll(
      `.task-timer[data-task-id="${taskId}"]`,
    );

    const timeLimitMinutes = timerData.timeLimitMinutes || 0;

    // Визначаємо який час показувати
    let displaySeconds = elapsed;
    let prefix = "";
    let shouldStop = false;
    let shouldComplete = false;

    if (timeLimitMinutes > 0) {
      const limitSeconds = timeLimitMinutes * 60;
      if (elapsed >= limitSeconds) {
        // Досягли/перевищили ліміт: або автозавершуємо, або зупиняємо рівно на 00:00.
        if (timerData.autoComplete) {
          shouldComplete = true;
        } else {
          shouldStop = true;
          displaySeconds = 0;
          prefix = '';
        }
      } else {
        // Зворотний відлік до закінчення ліміту
        displaySeconds = limitSeconds - elapsed;
        prefix = '';
      }
    }

    // Обробляємо завершення або зупинку
    if (shouldComplete) {
      markTaskAsCompleted(taskId);
      return;
    }

    if (shouldStop) {
      timersToDelete.push(taskId);

      // Зупиняємо таймер на сервері
      fetch("api/tasks.php", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: taskId, stop_timer: true }),
      })
        .then(() => {
          // Після успішної зупинки на сервері перезавантажуємо завдання
          loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
        })
        .catch((error) => {
          console.warn("Помилка зупинки таймера на сервері:", error);
        });

      timerElements.forEach((timerElement) => {
        timerElement.innerHTML = '00:00';
        timerElement.classList.remove('active-timer-badge');
      });
      return;
    }

    // Оновлюємо відображення для всіх елементів
    const hours = Math.floor(displaySeconds / 3600);
    const minutes = Math.floor((displaySeconds % 3600) / 60);
    const seconds = displaySeconds % 60;

    let timeStr = "";
    if (hours > 0) {
      timeStr = `${hours}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    } else {
      timeStr = `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }

    timerElements.forEach((timerElement) => {
      timerElement.innerHTML = `${prefix}${timeStr}`;
    });

    // Update Progress Bar if exists
    const progressBar = document.getElementById(`progress-bar-${taskId}`);
    if (progressBar && timeLimitMinutes > 0) {
      const limitSeconds = timeLimitMinutes * 60;
      // В режимі відліку elapsed вже враховано для displaySeconds, 
      // але для прогресу краще брати чистий elapsed від старту
      const percent = Math.min(100, (elapsed / limitSeconds) * 100);
      progressBar.style.width = `${percent}%`;

      if (percent > 90) {
        progressBar.classList.add("danger");
        progressBar.classList.remove("warning");
      } else if (percent > 70) {
        progressBar.classList.add("warning");
        progressBar.classList.remove("danger");
      } else {
        progressBar.classList.remove("warning", "danger");
      }
    }
  });

  // Видаляємо зупинені таймери після ітерації
  timersToDelete.forEach((taskId) => {
    activeTimers.delete(taskId);
  });
}

// Функція автоматичного позначення завдання як виконаного при завершенні таймера
async function markTaskAsCompleted(taskId) {
  try {
    // Видаляємо таймер з активних
    activeTimers.delete(taskId);

    // Знаходимо рядок завдання
    const taskRow = document.querySelector(`tr[data-id="${taskId}"]`);
    if (!taskRow) return;

    // Знаходимо чекбокс done
    const doneCheckbox = taskRow.querySelector(".task-done");
    if (!doneCheckbox) return;

    // Додаємо анімацію переходу
    taskRow.classList.add("row-done-transition");

    // Оновлюємо чекбокс
    doneCheckbox.checked = true;

    // Спочатку зупиняємо таймер на сервері
    await fetch("api/tasks.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: taskId, stop_timer: true }),
    });

    // Потім позначаємо завдання як виконане
    const response = await fetch("api/tasks.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: taskId, done: true }),
    });

    const result = await response.json();

    if (result && result.success) {
      // Показуємо повідомлення про автоматичне завершення
      showMessage(
        "🎉 Завдання автоматично завершено! Таймер закінчився.",
        "success",
      );

      // Затримка для анімації, потім перезавантажуємо завдання
      setTimeout(async () => {
        await loadTasks();

        // Якщо користувач зараз на tasks-list, автоматично переключаємо на tasks-archive
        const currentSubTab = document.querySelector(
          "#tasks .sub-tab-panel.active",
        );
        if (currentSubTab && currentSubTab.id === "tasks-list-content") {
          switchSubTab("tasks-archive");
          updateURLWithSubTab("tasks-archive");
        }
      }, 800); // Час анімації
    } else {
      // При помилці відкочуємо зміни
      doneCheckbox.checked = false;
      taskRow.classList.remove("row-done-transition");
      showMessage(
        result?.error || "Помилка автоматичного завершення завдання",
        "error",
      );
    }
  } catch (error) {
    console.error("Помилка автоматичного завершення:", error);
    showMessage("Помилка автоматичного завершення завдання", "error");
  }
}

// Запуск оновлень таймерів
function startTimerUpdates() {
  if (!timerUpdateInterval) {
    timerUpdateInterval = setInterval(updateActiveTimers, 1000);
  }
  if (!timerSyncInterval) {
    // Додаткова синхронізація з сервером кожні 30 секунд для забезпечення точності між пристроями
    timerSyncInterval = setInterval(syncWithServer, 30000);
  }
}

// Синхронізація з сервером для багатопристрійного доступу
async function syncWithServer() {
  if (activeTimers.size === 0) return;

  try {
    // Синхронізуємо тільки активні таймери без повного перезавантаження
    const taskIds = Array.from(activeTimers.keys());

    for (const taskId of taskIds) {
      const response = await fetch(`api/tasks.php?id=${taskId}`);
      const data = await response.json();

      if (data.success && data.data) {
        const task = data.data;
        const timerData = activeTimers.get(taskId);

        if (timerData && task.timer_started_at) {
          // Оновлюємо базовий час з сервера
          const serverElapsed = Number(task.timer_elapsed_seconds || 0);
          const serverStartTime = Number(task.timer_started_timestamp) * 1000;

          // Оновлюємо дані таймера
          timerData.baseElapsed = serverElapsed;
          timerData.startTime = serverStartTime;
          timerData.lastSync = Date.now();
        } else if (!task.timer_started_at) {
          // Таймер був зупинений на сервері - видаляємо з активних
          activeTimers.delete(taskId);
        }
      }
    }

    // Якщо не залишилось активних таймерів, зупиняємо оновлення
    if (activeTimers.size === 0) {
      stopTimerUpdates();
    }
  } catch (error) {
    console.warn("Помилка синхронізації з сервером:", error);
  }
}

// Зупинка оновлень таймерів
function stopTimerUpdates() {
  if (timerUpdateInterval) {
    clearInterval(timerUpdateInterval);
    timerUpdateInterval = null;
  }
  if (timerSyncInterval) {
    clearInterval(timerSyncInterval);
    timerSyncInterval = null;
  }
}

// Синхронізація при поверненні фокуса на вкладку (для багатопристрійного доступу)
document.addEventListener("visibilitychange", function () {
  if (!document.hidden && activeTimers.size > 0) {
    // Коли користувач повертається на вкладку, синхронізуємо з сервером
    syncWithServer();
  }
});

// Функція обробки дій таймера
async function handleTimer(taskId, action, tr) {
  try {
    const payload = { id: taskId };
    payload[action] = true;

    const response = await fetch("api/tasks.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (data.success) {
      // Перезавантажуємо завдання, щоб оновити інтерфейс
      await loadTasks(currentSortField, currentSortOrder, currentSearchQuery);

      let message = "";
      switch (action) {
        case "start_timer":
          message = "Таймер запущено";
          break;
        case "pause_timer":
          message = "Таймер призупинено";
          break;
        case "stop_timer":
          message = "Таймер зупинено";
          break;
        case "reset_timer":
          message = "Таймер скинуто";
          break;
      }
      showMessage(message, "success");
    } else {
      showMessage(data.error || "Помилка роботи з таймером", "error");
    }
  } catch (error) {
    console.error("Помилка таймера:", error);
    showMessage("Помилка роботи з таймером", "error");
  }
}

function displayTasksCalendar(items) {
  const grid = document.getElementById("tasks-calendar");
  if (!grid) return;
  grid.innerHTML = "";

  // Навігація по місяцях
  const toolbar = grid.previousElementSibling?.classList?.contains(
    "calendar-toolbar",
  )
    ? grid.previousElementSibling
    : null;
  if (toolbar && !toolbar.__navInit) {
    toolbar.addEventListener("click", (e) => {
      const btn = e.target.closest(".cal-nav");
      if (!btn) return;
      const url = new URL(window.location);
      const current =
        url.searchParams.get("month") || new Date().toISOString().slice(0, 7);
      const [y, m] = current.split("-").map(Number);
      const d = new Date(y, m - 1, 1);
      if (btn.dataset.cal === "prev") d.setMonth(d.getMonth() - 1);
      if (btn.dataset.cal === "next") d.setMonth(d.getMonth() + 1);
      const nextMonth =
        String(d.getFullYear()) +
        "-" +
        String(d.getMonth() + 1).padStart(2, "0");
      url.searchParams.set("month", nextMonth);
      window.history.replaceState({}, "", url);
      loadTasks(currentSortField, currentSortOrder, currentSearchQuery);
    });
    toolbar.__navInit = true;
  }

  // Обчислюємо вибраний місяць і будуємо порожні дні
  const url = new URL(window.location);
  const monthStr =
    url.searchParams.get("month") || new Date().toISOString().slice(0, 7);
  const [yy, mm] = monthStr.split("-").map(Number);
  const firstDay = new Date(yy, (mm || 1) - 1, 1);
  const lastDay = new Date(yy, mm || 1, 0).getDate();

  // Назви місяців українською
  const monthNames = [
    "Січень",
    "Лютий",
    "Березень",
    "Квітень",
    "Травень",
    "Червень",
    "Липень",
    "Серпень",
    "Вересень",
    "Жовтень",
    "Листопад",
    "Грудень",
  ];

  // Назви днів тижня українською
  const weekdayNames = ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

  // Оновлюємо лейбл місяця
  const monthLabel = document.getElementById("calendar-month-label");
  if (monthLabel) {
    monthLabel.textContent = `${monthNames[(mm || 1) - 1]} ${yy} р.`;
  }

  // Групуємо задачі по ключу YYYY-MM-DD
  const byDate = new Map();
  items.forEach((t) => {
    const raw = t.due_at || t.due_date || "";
    if (!raw) return;
    const [d, m, y] = raw.split(" ")[0].split(".");
    if (!d || !m || !y) return;
    const key = `${y}-${m}-${d}`;
    if (!byDate.has(key)) byDate.set(key, []);
    byDate.get(key).push(t);
  });

  // Визначаємо сьогоднішню дату
  const today = new Date();
  const todayKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  // Рендеримо всі дні місяця (навіть без задач)
  for (let day = 1; day <= lastDay; day++) {
    const dateKey = `${yy}-${String(mm).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const dayDate = new Date(yy, mm - 1, day);
    const dayTasks = byDate.get(dateKey) || [];
    const isToday = dateKey === todayKey;
    const hasTasks = dayTasks.length > 0;

    const card = document.createElement("div");
    card.className = "tasks-calendar-day";
    if (isToday) card.classList.add("is-today");
    if (hasTasks) card.classList.add("has-tasks");

    // Заголовок дня
    const header = document.createElement("div");
    header.className = "tasks-calendar-day-header";

    // Номер дня
    const dayNumber = document.createElement("div");
    dayNumber.className = "tasks-calendar-day-number";
    dayNumber.textContent = String(day);

    // Назва дня тижня
    const dayName = document.createElement("div");
    dayName.className = "tasks-calendar-day-name";
    dayName.textContent = weekdayNames[dayDate.getDay()];

    header.appendChild(dayNumber);
    header.appendChild(dayName);

    // Якщо є завдання, додаємо бейдж з кількістю
    if (hasTasks) {
      const taskCount = document.createElement("span");
      taskCount.className = "tasks-calendar-task-count";
      taskCount.textContent = dayTasks.length;
      header.style.flexDirection = "row";
      header.style.alignItems = "center";
      header.style.justifyContent = "space-between";

      const leftPart = document.createElement("div");
      leftPart.appendChild(dayNumber);
      leftPart.appendChild(dayName);
      leftPart.style.display = "flex";
      leftPart.style.flexDirection = "column";
      leftPart.style.gap = "2px";

      header.innerHTML = "";
      header.appendChild(leftPart);
      header.appendChild(taskCount);
    }

    card.appendChild(header);

    // Список завдань
    if (hasTasks) {
      const list = document.createElement("ul");
      list.className = "tasks-calendar-day-list";
      dayTasks.forEach((t) => {
        const li = document.createElement("li");
        li.textContent = (t.title || t.task || "").slice(0, 50);
        li.title = t.title || t.task || "";
        list.appendChild(li);
      });
      card.appendChild(list);
    } else {
      // Порожній стан
      const emptyState = document.createElement("div");
      emptyState.className = "tasks-calendar-day-empty";
      emptyState.textContent = "Немає завдань";
      card.appendChild(emptyState);
    }

    grid.appendChild(card);
  }
}

// Показ панелі додавання завдання
function showAddTaskPanel() {
  const modal = document.getElementById("add-task-modal");
  if (!modal) return;
  resetModalFormState(modal);
  modal.classList.add("active");
  const autoCompleteCheckbox = modal.querySelector("#task-auto-complete");
  const autoCompleteGroup = modal.querySelector("#task-auto-complete-group");
  if (autoCompleteCheckbox) autoCompleteCheckbox.checked = false;
  const taskDateInput = modal.querySelector("#task-date");
  if (taskDateInput) {
    taskDateInput.value = getTodayFormattedString();
  }

  const repeatType = modal.querySelector("#task-repeat-type");
  const repeatWrap = modal.querySelector("#task-repeat-days-wrap");
  if (repeatType) repeatType.value = "none";
  if (repeatWrap) repeatWrap.style.display = "none";
  setSelectedRepeatDays("task-repeat-days-picker", "");

  initPrettyFieldSelects(modal);
  initPrettyNumberInputs(modal);
  initTimeLimitInputs(modal);
  initTaskDateTimeSplitInputs(modal);
  initTaskDatePickerButtons(modal);
  syncTaskPeriodByDate(modal);
  refreshPrettyFieldSelects(modal);
  requestAnimationFrame(() => refreshDateGhostHints(modal));
}
function cancelTaskPanel() {
  const modal = document.getElementById("add-task-modal");
  if (modal) modal.classList.remove("active");
}

function showEditTaskPanel(task) {
  // Закриваємо панель додавання якщо відкрита
  const addModal = document.getElementById("add-task-modal");
  if (addModal) addModal.classList.remove("active");

  const modal = document.getElementById("edit-task-modal");
  if (!modal) return;

  modal.classList.add("active");
  initPrettyFieldSelects(modal);
  initPrettyNumberInputs(modal);

  if (task) {
    modal.dataset.id = String(task.id || "");
    const title = modal.querySelector("#edit-task-title");
    const date = modal.querySelector("#edit-task-date");
    const time = modal.querySelector("#edit-task-time");
    const desc = modal.querySelector("#edit-task-desc");
    const tags = modal.querySelector("#edit-task-tags");
    const category = modal.querySelector("#edit-task-category");
    const period = modal.querySelector("#edit-task-period");
    const limit = modal.querySelector("#edit-task-limit");
    if (title) title.value = task.title || task.task || "";
    const rawDue = String(task.due_at || task.due_date || task.date || "").trim();
    const dueDateTimeMatch = rawDue.match(
      /^([0-2][0-9]|3[0-1])\.(0[1-9]|1[0-2])\.(\d{4})\s([0-1][0-9]|2[0-3]):([0-5][0-9])$/,
    );
    if (dueDateTimeMatch) {
      if (date)
        date.value = `${dueDateTimeMatch[1]}.${dueDateTimeMatch[2]}.${dueDateTimeMatch[3]}`;
      if (time) time.value = `${dueDateTimeMatch[4]}:${dueDateTimeMatch[5]}`;
    } else {
      if (date) date.value = rawDue;
      if (time) time.value = "";
    }
    if (desc) desc.value = task.description || "";
    if (tags) tags.value = task.tags || "";
    if (category) {
      const categoryValue = String(task.category || "");
      const hasOption = Array.from(category.options).some(
        (opt) => opt.value === categoryValue,
      );
      category.value = hasOption ? categoryValue : "";
    }
    if (period) {
      const periodValue = String(task.day_period || "");
      const hasOption = Array.from(period.options).some(
        (opt) => opt.value === periodValue,
      );
      period.value = hasOption ? periodValue : "";
    }
    if (limit)
      limit.value =
        task.time_limit_minutes != null ? String(task.time_limit_minutes) : "";

    const repeatType = modal.querySelector("#edit-task-repeat-type");
    const repeatDaysWrap = modal.querySelector("#edit-task-repeat-days-wrap");
    if (repeatType) {
      const rVal = String(task.repeat_type || "none");
      repeatType.value = rVal;
      if (repeatDaysWrap) {
        repeatDaysWrap.style.display = rVal === "custom" ? "block" : "none";
      }
      setSelectedRepeatDays("edit-task-repeat-days-picker", task.repeat_days || "");
    }

    // Автозавершення
    const autoComplete = modal.querySelector("#edit-task-auto-complete");
    const autoCompleteGroup = modal.querySelector(
      "#edit-task-auto-complete-group",
    );
    if (autoComplete && autoCompleteGroup) {
      const hasTimeLimit =
        task.time_limit_minutes && task.time_limit_minutes > 0;
      autoComplete.checked = !!task.auto_complete && !!hasTimeLimit;
      setAutoCompleteGroupVisibility(
        autoCompleteGroup,
        autoComplete,
        !!hasTimeLimit,
      );
    }

    // Ініціалізуємо поля дати
    initTimeLimitInputs(modal);
    initTaskDateTimeSplitInputs(modal);
    initTaskDatePickerButtons(modal);
    syncTaskPeriodByDate(modal);
    refreshPrettyFieldSelects(modal);
    requestAnimationFrame(() => refreshDateGhostHints(modal));
  }
}
function cancelEditTaskPanel() {
  const modal = document.getElementById("edit-task-modal");
  if (modal) modal.classList.remove("active");
}

async function saveTask() {
  const TASK_TITLE_MAX = 100;
  const title = document.getElementById("task-title");
  const date = document.getElementById("task-date");
  const time = document.getElementById("task-time");
  const desc = document.getElementById("task-desc");
  const tags = document.getElementById("task-tags");
  const category = document.getElementById("task-category");
  const period = document.getElementById("task-period");
  const limit = document.getElementById("task-limit");
  if (!title || !title.value.trim()) {
    showMessage("Не введено завдання", "error");
    return;
  }
  if (title.value.trim().length > TASK_TITLE_MAX) {
    showMessage(`Назва завдання не може перевищувати ${TASK_TITLE_MAX} символів`, "error");
    return;
  }
  try {
    const dueBuild = buildTaskDueDateForPayload(date, time);
    if (!dueBuild.ok) {
      showMessage(dueBuild.message, "error");
      return;
    }
    const payload = { title: title.value.trim() };
    if (dueBuild.value) payload.due_date = dueBuild.value;
    if (desc && desc.value.trim()) payload.description = desc.value.trim();
    if (tags && tags.value.trim()) payload.tags = tags.value.trim();
    if (category) payload.category = category.value || null;
    if (period) payload.day_period = period.value || null;
    if (limit) payload.time_limit_minutes = limit.value || "";

    const repeatTypeEl = document.getElementById("task-repeat-type");
    const rType = repeatTypeEl ? repeatTypeEl.value : "none";
    payload.repeat_type = rType;
    if (rType === "custom") {
      payload.repeat_days = getSelectedRepeatDays("task-repeat-days-picker");
    } else {
      payload.repeat_days = null;
    }

    // Автозавершення - передаємо тільки якщо є ліміт часу
    const autoComplete = document.getElementById("task-auto-complete");
    const limitValue = parseInt(limit?.value) || 0;
    if (autoComplete && limitValue > 0) {
      payload.auto_complete = autoComplete.checked;
    }

    const res = await fetch("api/tasks.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data.success) {
      cancelTaskPanel();
      showMessage("Завдання створено", "success");
      loadTasks().catch((e) => {
        console.error("Помилка фонової перезагрузки задач:", e);
      });
    } else {
      showMessage(data.error || "Помилка створення завдання", "error");
    }
  } catch {
    showMessage("Помилка створення завдання", "error");
  }
}

async function updateTask() {
  const TASK_TITLE_MAX = 100;
  const modal = document.getElementById("edit-task-modal");
  if (!modal) return;
  const id = Number(modal.dataset.id || 0);
  const title = document.getElementById("edit-task-title");
  const date = document.getElementById("edit-task-date");
  const time = document.getElementById("edit-task-time");
  const desc = document.getElementById("edit-task-desc");
  const tags = document.getElementById("edit-task-tags");
  const category = document.getElementById("edit-task-category");
  const period = document.getElementById("edit-task-period");
  const limit = document.getElementById("edit-task-limit");
  if (!id) {
    showMessage("Невірні дані", "error");
    return;
  }
  if (!title || !title.value.trim()) {
    showMessage("Не введено завдання", "error");
    return;
  }
  if (title.value.trim().length > TASK_TITLE_MAX) {
    showMessage(`Назва завдання не може перевищувати ${TASK_TITLE_MAX} символів`, "error");
    return;
  }
  try {
    const dueBuild = buildTaskDueDateForPayload(date, time);
    if (!dueBuild.ok) {
      showMessage(dueBuild.message, "error");
      return;
    }
    const body = {
      id,
      title: title.value.trim(),
      due_date: dueBuild.value,
    };
    if (desc) body.description = desc.value.trim();
    if (tags) body.tags = tags.value.trim();
    if (category) body.category = category.value || null;
    if (period) body.day_period = period.value || null;
    if (limit) body.time_limit_minutes = limit.value || "";

    const repeatTypeEl = document.getElementById("edit-task-repeat-type");
    const rType = repeatTypeEl ? repeatTypeEl.value : "none";
    body.repeat_type = rType;
    if (rType === "custom") {
      body.repeat_days = getSelectedRepeatDays("edit-task-repeat-days-picker");
    } else {
      body.repeat_days = null;
    }

    // Автозавершення - передаємо тільки якщо є ліміт часу
    const autoComplete = document.getElementById("edit-task-auto-complete");
    const limitValue = parseInt(limit?.value) || 0;
    if (autoComplete && limitValue > 0) {
      body.auto_complete = autoComplete.checked;
    }

    const res = await fetch("api/tasks.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (data.success) {
      cancelEditTaskPanel();
      showMessage("Завдання оновлено", "success");
      loadTasks().catch((e) => {
        console.error("Помилка фонової перезагрузки задач:", e);
      });
    } else {
      showMessage(data.error || "Помилка оновлення завдання", "error");
    }
  } catch {
    showMessage("Помилка оновлення завдання", "error");
  }
}

// Функція оновлення URL з параметром пошуку
function updateURLWithSearch(query) {
  const url = new URL(window.location);

  if (query) {
    url.searchParams.set("search", query);
  } else {
    url.searchParams.delete("search");
  }

  // Зберігаємо поточний таб та підвкладку
  const activeTab = document.querySelector(".sidebar-item.active");
  const activeSubTab = document.querySelector(".sub-tab-panel.active");

  if (activeTab) {
    url.searchParams.set("tab", activeTab.getAttribute("data-tab"));
  }

  if (activeSubTab) {
    const sub = activeSubTab.id.replace("-content", "");
    url.searchParams.set("sub-tab", sub);
  }

  window.history.replaceState({}, "", url);
}

const DEFAULT_AVATAR = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'%3E%3Crect width='64' height='64' rx='32' fill='%231e293b'/%3E%3Cpath d='M32 34c4.97 0 9-4.03 9-9s-4.03-9-9-9-9 4.03-9 9 4.03 9 9 9zm0 5c-6.08 0-18 3.06-18 9.15V52h36v-3.85c0-6.09-11.92-9.15-18-9.15z' fill='%2394a3b8'/%3E%3C/svg%3E";
(window as any).DEFAULT_AVATAR = DEFAULT_AVATAR;

// ===== Profile =====
async function loadProfile() {
  try {
    const res = await fetch(`api/profile.php?_=${Date.now()}`, {
      cache: "no-store",
    });
    const data = await res.json();
    if (!data || !data.success) return;
    const user = data.data || {};
    const roleLabel = mapRoleUA(user.role);
    const displayName = user.nickname || user.username || "Користувач";

    // Оновлюємо основний профіль
    setText("#profile-nickname", displayName);
    setText("#profile-username", user.username || "—");
    setText("#profile-role", roleLabel || "—");
    setText("#profile-created", user.created_at || "—");

    const avatarSrc = user.avatar_url
      ? `${user.avatar_url}${user.avatar_url.includes("?") ? "&" : "?"}v=${Date.now()}`
      : DEFAULT_AVATAR;

    // Оновлюємо аватарку в профілі
    const profileAvatarImg = document.getElementById("profile-avatar-img") as HTMLImageElement | null;
    if (profileAvatarImg) {
      profileAvatarImg.src = avatarSrc;
      profileAvatarImg.onerror = () => { profileAvatarImg.src = DEFAULT_AVATAR; };
    }

    // Оновлюємо дані в сайдбарі
    const sidebarUser = document.getElementById("sidebar-username");
    const sidebarRole = document.getElementById("sidebar-role");
    const sidebarAvatarImg = document.getElementById("sidebar-avatar-img") as HTMLImageElement | null;

    if (sidebarUser) sidebarUser.textContent = displayName;
    if (sidebarRole) sidebarRole.textContent = user.username === 'admin' ? 'Адміністратор' : (roleLabel || "SyncFlow");
    if (sidebarAvatarImg) {
      sidebarAvatarImg.src = avatarSrc;
      sidebarAvatarImg.onerror = () => { sidebarAvatarImg.src = DEFAULT_AVATAR; };
    }

    const sidebarProfileBox = document.getElementById("sidebar-profile-box");
    if (sidebarProfileBox && !sidebarProfileBox.dataset.bound) {
      sidebarProfileBox.dataset.bound = "true";
      sidebarProfileBox.style.cursor = "pointer";
      sidebarProfileBox.addEventListener("click", () => switchTab("profile"));
    }
  } catch (e) {
    console.error("Помилка завантаження профілю: ", e);
  }
}

function setText(sel, text) {
  const el = document.querySelector(sel);
  if (el) el.textContent = String(text);
}

function mapRoleUA(role) {
  const map = {
    admin: "Адміністратор",
    super_admin: "Супер-адміністратор",
    user: "Користувач",
  };
  return map[String(role || "").toLowerCase()] || role || "";
}

// ===== Users (Security) =====
async function loadUsers(
  sortBy = "username",
  sortOrder = "ASC",
  searchQuery = "",
) {
  try {
    // синхронізуємо глобальні змінні сортування для єдиного UX
    currentSortField = sortBy;
    currentSortOrder = sortOrder;
    const params = new URLSearchParams({
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);
    // гарантуємо, що знаємо поточного користувача (id/role) до рендера
    await ensureCurrentUser();
    const res = await fetch(`api/users.php?${params}`);
    if (!res.ok) throw new Error("HTTP error " + res.status);
    const data = await res.json();
    if (data.success) {
      displayUsers(data.data || []);
      updateSortIcons(sortBy, sortOrder);
    }
  } catch (e) {
    console.error("Помилка завантаження користувачів: ", e);
    showMessage("Помилка завантаження користувачів", "error");
  }
}

// Гарантує наявність window.currentUserId / window.currentUserRole
async function ensureCurrentUser() {
  if (window.currentUserId && window.currentUserRole) return;
  try {
    const r = await fetch("api/profile.php");
    const p = await r.json();
    if (p && p.success && p.data) {
      window.currentUserId = Number(p.data.id || 0);
      window.currentUserRole = String(p.data.role || "user").toLowerCase();
    }
  } catch { }
}

function displayUsers(items) {
  const tbody = document.getElementById("users-table-tbody");
  if (!tbody) return;
  tbody.innerHTML = "";
  if (!items.length) {
    renderEmptyTableState(tbody, "Немає користувачів");
    resetCheckboxStates();
    return;
  }
  items.forEach((u) => {
    const tr = document.createElement("tr");
    tr.dataset.id = String(u.id);
    if (u.allowed_tabs)
      tr.dataset.allowedTabs =
        typeof u.allowed_tabs === "string"
          ? u.allowed_tabs
          : JSON.stringify(u.allowed_tabs);
    const isMe = Number(u.id) === Number(window.currentUserId || 0);
    const nameTdClass = isMe ? "col-name current-user" : "col-name";
    const actorRole = String(window.currentUserRole || "user").toLowerCase();
    const actorId = Number(window.currentUserId || 0);
    const targetRole = String(u.role || "user").toLowerCase();
    let canEdit = false,
      canDelete = false;
    if (actorRole === "super_admin") {
      canEdit = true;
      // супер-адмін не може видаляти іншого супер-адміністратора
      canDelete = !(targetRole === "super_admin" && Number(u.id) !== actorId);
    } else if (actorRole === "admin") {
      const isSelf = Number(u.id) === actorId;
      // адмін може редагувати/видаляти лише user або себе
      canEdit = targetRole === "user" || isSelf;
      canDelete = targetRole === "user" || isSelf;
    } else {
      canEdit = false;
      canDelete = false;
    }
    const rowActions =
      canEdit || canDelete
        ? `<button class="row-more-btn" data-id="${u.id}" data-type="user" data-can-edit="${canEdit ? "1" : "0"}" data-can-delete="${canDelete ? "1" : "0"}"><i class="ri-more-2-fill"></i></button>`
        : "";
    tr.innerHTML = `
            <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
            <td class="${nameTdClass}">${escapeHtml(u.username || "")}</td>
            <td class="col-status">${escapeHtml(u.password || "********")}</td>
            <td class="col-status">${escapeHtml(mapRoleUA(u.role))}</td>
            <td class="col-date">${escapeHtml(u.created_at || "")}</td>
            <td class="col-actions">${rowActions}</td>`;
    tbody.appendChild(tr);
  });
  attachUsersTbodyHandlers();
  // Скидаємо стан чекбоксів після завантаження нових даних
  resetCheckboxStates();
}

// Рендер чекліста вкладок у панелі користувача
function renderTabAccessChecklist(scope, allowedTabsStr) {
  const panel = scope || document;
  let holder = panel.querySelector("#user-tab-access");
  if (!holder) {
    holder = document.createElement("div");
    holder.id = "user-tab-access";
    holder.className = "user-tab-access";
    const group = document.createElement("div");
    group.className = "form-group full-width user-tab-access-group";
    const label = document.createElement("label");
    label.className = "field-label";
    label.textContent = "Доступні вкладки";
    group.appendChild(label);
    group.appendChild(holder);
    const container = panel.querySelector(
      ".add-edit-project-panel-content, .modal-form-grid",
    );
    if (container) container.appendChild(group);
  } else {
    holder.innerHTML = "";
  }
  const allowed = parseAllowedTabs(allowedTabsStr);
  // Логіка видимості панелі:
  // - Не показувати, якщо редагуємо самого себе
  // - Показувати лише якщо поточний користувач: admin або super_admin
  // - Для super_admin: можна редагувати admin/user, але не super_admin
  const groupWrapper = holder.parentElement;
  const isSecurityTab =
    !!panel.closest("#security") ||
    panel.classList.contains("add-user-panel") ||
    panel.classList.contains("edit-user-panel");
  let targetId = 0;
  const containerPanel = panel.closest(".edit-user-panel, .add-user-panel");
  if (containerPanel && containerPanel.classList.contains("edit-user-panel")) {
    targetId = Number(containerPanel.dataset.id || 0);
  }
  const currentId = Number(window.currentUserId || 0);
  const currentRole = String(window.currentUserRole || "user").toLowerCase();
  if (groupWrapper && isSecurityTab) {
    // тільки супер-адмін може керувати доступами вкладок, і не для себе/супер-адміна
    const roleInput = panel.querySelector("#edit-user-role, #user-role");
    const targetRole = roleInput
      ? String(roleInput.value || "").toLowerCase()
      : "user";
    const canSee = currentRole === "super_admin" && currentId !== targetId;
    if (!canSee || targetRole === "super_admin") {
      groupWrapper.style.display = "none";
      holder.innerHTML = "";
      return;
    }
    groupWrapper.style.display = "";
  }
  const tabs = Array.from(document.querySelectorAll(".sidebar-item"))
    .map((btn) => ({
      id: btn.getAttribute("data-tab"),
      text:
        btn.querySelector(".tab-icon")?.getAttribute("alt") ||
        btn.getAttribute("data-tab"),
    }))
    .filter((t) => t.id && !["profile", "settings"].includes(t.id));
  tabs.forEach((t) => {
    const id = t.id;
    const label = document.createElement("label");
    label.className = "user-tab-access-item";
    const cb = document.createElement("input");
    cb.type = "checkbox";
    cb.value = id;
    cb.checked = allowed.size === 0 ? true : allowed.has(id); // якщо список порожній — доступ до всіх
    label.appendChild(cb);
    const span = document.createElement("span");
    span.textContent = t.text;
    label.appendChild(span);
    holder.appendChild(label);
  });
}

function parseAllowedTabs(str) {
  try {
    if (!str) return new Set();
    const arr = JSON.parse(str);
    if (Array.isArray(arr)) return new Set(arr);
    return new Set(
      String(str)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    );
  } catch {
    return new Set();
  }
}

function collectTabAccessFromPanel(panel) {
  if (!panel) return null;
  const holder = panel.querySelector("#user-tab-access");
  if (!holder) return null;
  const checked = Array.from(
    holder.querySelectorAll('input[type="checkbox"]:checked'),
  ).map((cb) => cb.value);
  return checked;
}

function showAddUserPanel() {
  const panel = document.getElementById("add-user-modal");
  const addBtn = document.querySelector("#security .add-data-table-item");
  if (!panel) return;
  const isOpen = panel.classList.contains("active");
  if (isOpen) panel.classList.remove("active");
  else panel.classList.add("active");
  if (addBtn) addBtn.classList.toggle("active");
  if (!isOpen) {
    resetAddUserForm();
    initPrettyFieldSelects(panel);
    refreshPrettyFieldSelects(panel);
    // ініціалізувати список вкладок для нового користувача (порожній)
    renderTabAccessChecklist(panel, "");
  }
  panel.onclick = (e) => {
    if (e.target === panel) cancelUserPanel();
  };
  const closeBtn = panel.querySelector(".custom-modal-close");
  if (closeBtn) closeBtn.onclick = () => cancelUserPanel();
}
function cancelUserPanel() {
  const panel = document.getElementById("add-user-modal");
  if (panel) panel.classList.remove("active");
  const addBtn = document.querySelector("#security .add-data-table-item");
  if (addBtn) addBtn.classList.remove("active");
  resetAddUserForm();
}

function showEditUserPanel(user) {
  const panel = document.getElementById("edit-user-modal");
  if (!panel) return;
  const addPanel = document.getElementById("add-user-modal");
  if (addPanel) addPanel.classList.remove("active");
  panel.classList.add("active");
  const normalizedUser =
    user && typeof user === "object"
      ? user
      : { id: user, username: "", role: "user", allowed_tabs: "" };
  if (normalizedUser) {
    panel.dataset.id = String(normalizedUser.id || "");
    const u = panel.querySelector("#edit-user-username");
    const r = panel.querySelector("#edit-user-role");
    if (u) u.value = normalizedUser.username || "";
    if (r) r.value = normalizedUser.role || "user";
    // Права доступу: список вкладок
    renderTabAccessChecklist(panel, normalizedUser.allowed_tabs || "");
  }
  // Зберігаємо allowed_tabs як data для подальшого збереження
  panel.dataset.allowedTabs =
    typeof normalizedUser.allowed_tabs === "string"
      ? normalizedUser.allowed_tabs
      : Array.isArray(normalizedUser.allowed_tabs)
        ? JSON.stringify(normalizedUser.allowed_tabs)
        : "";
  panel.onclick = (e) => {
    if (e.target === panel) cancelEditUserPanel();
  };
  const closeBtn = panel.querySelector(".custom-modal-close");
  if (closeBtn) closeBtn.onclick = () => cancelEditUserPanel();
}
function cancelEditUserPanel() {
  const panel = document.getElementById("edit-user-modal");
  if (panel) panel.classList.remove("active");
}

async function saveUser() {
  const username = document.getElementById("user-username");
  const password = document.getElementById("user-password");
  const role = document.getElementById("user-role");
  if (!username || !username.value.trim()) {
    showMessage("Не введено логін", "error");
    return;
  }
  if (!password || !password.value.trim()) {
    showMessage("Не введено пароль", "error");
    return;
  }
  try {
    const allowed = collectTabAccessFromPanel(
      document.getElementById("add-user-modal"),
    );
    const payload = {
      username: username.value.trim(),
      password: password.value.trim(),
      role: role && role.value ? role.value : "user",
    };
    if (allowed) payload.allowed_tabs = allowed;
    const res = await fetch("api/users.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data.success) {
      // Скидаємо поля форми, щоб при наступному відкритті вони були порожні
      resetAddUserForm();
      cancelUserPanel();
      await loadUsers();
      showMessage("Користувача створено", "success");
    } else {
      showMessage(data.error || "Помилка створення", "error");
    }
  } catch {
    showMessage("Помилка створення", "error");
  }
}

// Скидання полів форми додавання користувача до значень за замовчуванням
function resetAddUserForm() {
  const panel = document.getElementById("add-user-modal");
  if (!panel) return;
  resetModalFormState(panel);
  // Очистити чекліст доступів, якщо існує
  const checklist = panel.querySelector("#user-tab-access");
  if (checklist) checklist.innerHTML = "";
}

async function updateUser() {
  const panel = document.getElementById("edit-user-modal");
  if (!panel) return;
  const id = Number(panel.dataset.id || 0);
  const username = document.getElementById("edit-user-username");
  const password = document.getElementById("edit-user-password");
  const role = document.getElementById("edit-user-role");
  if (!id) {
    showMessage("Невірні дані", "error");
    return;
  }
  if (!username || !username.value.trim()) {
    showMessage("Не введено логін", "error");
    return;
  }
  try {
    const allowed = collectTabAccessFromPanel(
      document.getElementById("edit-user-modal"),
    );
    const body = {
      id,
      username: username.value.trim(),
      role: role && role.value ? role.value : "user",
    };
    if (allowed) body.allowed_tabs = allowed;
    if (password && password.value.trim())
      body.password = password.value.trim();
    const res = await fetch("api/users.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (data.success) {
      cancelEditUserPanel();
      await loadUsers();
      showMessage("Користувача оновлено", "success");
    } else {
      showMessage(data.error || "Помилка оновлення", "error");
    }
  } catch {
    showMessage("Помилка оновлення", "error");
  }
}

async function deleteUser(id) {
  const userId = Number(id);
  if (!userId) return;
  showConfirm("Видалити користувача?", async () => {
    try {
      const res = await fetch("api/users.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: userId }),
      });
      const data = await res.json();
      if (data.success) {
        await loadUsers(currentSortField, currentSortOrder, currentSearchQuery);
        showMessage("Користувача видалено", "success");
      } else {
        showMessage(data.error || "Не вдалося видалити", "error");
      }
    } catch {
      showMessage("Не вдалося видалити", "error");
    }
  });
}

function attachUsersTbodyHandlers() {
  const tbody = document.getElementById("users-table-tbody");
  if (!tbody || tbody.__rowActionsInit) return;
  tbody.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : 0;
    if (btn.dataset.action === "edit") {
      if (!id) return;
      const user = {
        id,
        username: tr.querySelector(".col-name")?.textContent?.trim() || "",
        role: (
          tr.querySelectorAll(".col-status")[1]?.textContent?.trim() || ""
        ).toLowerCase(),
        allowed_tabs: tr.dataset.allowedTabs || "",
      };
      const back = {
        адміністратор: "admin",
        "супер-адміністратор": "super_admin",
        користувач: "user",
      };
      const vis = (
        tr.querySelectorAll(".col-status")[1]?.textContent?.trim() || ""
      ).toLowerCase();
      if (back[vis]) user.role = back[vis];
      showEditUserPanel(user);
    } else if (btn.dataset.action === "delete") {
      if (!id) return;
      showConfirm("Видалити користувача?", () => {
        fetch("api/users.php", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res && res.success) {
              tr?.remove();
              updateSelectedCount();
              updateSelectAllCheckBox();
              showMessage("Користувача видалено", "success");
            } else {
              showMessage(res?.error || "Не вдалося видалити", "error");
            }
          })
          .catch(() => showMessage("Не вдалося видалити", "error"));
      });
    }
  });
  tbody.__rowActionsInit = true;
}

// Функція завантаження пошуку з URL
function loadSearchFromURL() {
  const url = new URL(window.location);
  const searchQuery = url.searchParams.get("search");

  if (searchQuery) {
    currentSearchQuery = searchQuery;
    // Заповнюємо інпут у активному контейнері пошуку
    const activePanel = document.querySelector(".tab-panel.active");
    const activeSearch = activePanel
      ? activePanel.querySelector(".search-container")
      : document.querySelector(".search-container");
    const searchInput = activeSearch
      ? activeSearch.querySelector('input[type="text"], input.search-input')
      : null;
    if (searchInput) {
      searchInput.value = searchQuery;
    }
  }
}

// Функція показу форми редагування профілю
function showEditProfile() {
  const panel = document.querySelector(".edit-profile-panel");
  if (!panel) return;

  // Заповнюємо поточні дані
  const currentNickname = document.getElementById("profile-nickname")?.textContent;
  const currentUsername = document.getElementById("profile-username")?.textContent;

  const nicknameInput = document.getElementById("edit-profile-nickname");
  const usernameInput = document.getElementById("edit-profile-username");

  if (nicknameInput && currentNickname && currentNickname !== "—") {
    nicknameInput.value = currentNickname;
  }
  if (usernameInput && currentUsername && currentUsername !== "—") {
    usernameInput.value = currentUsername;
  }

  // Очищуємо поля паролів
  document.getElementById("edit-profile-password").value = "";
  document.getElementById("edit-profile-confirm-password").value = "";

  openLegacyModal(panel);
}

// Функція закриття форми редагування профілю
function cancelEditProfile() {
  const panel = document.querySelector(".edit-profile-panel");
  if (panel) closeLegacyModal(panel);
}

// Функція оновлення профілю
async function updateProfile() {
  const nickname = document.getElementById("edit-profile-nickname")?.value?.trim();
  const username = document.getElementById("edit-profile-username")?.value?.trim();
  const password = document.getElementById("edit-profile-password")?.value;
  const confirmPassword = document.getElementById(
    "edit-profile-confirm-password",
  )?.value;

  if (!username) {
    showMessage("Логін не може бути порожнім", "error");
    return;
  }

  if (password && password !== confirmPassword) {
    showMessage("Паролі не співпадають", "error");
    return;
  }

  if (password && password.length < 6) {
    showMessage("Пароль повинен містити мінімум 6 символів", "error");
    return;
  }

  try {
    const payload = { username, nickname };
    if (password) {
      payload.password = password;
    }

    const response = await fetch("api/profile.php", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.success) {
      cancelEditProfile();
      showMessage("Профіль успішно оновлено", "success");
      // Перезавантажуємо профіль для оновлення всіх UI елементів
      await loadProfile();
    } else {
      showMessage(data.error || "Помилка оновлення профілю", "error");
    }
  } catch (error) {
    console.error("Помилка оновлення профілю:", error);
    showMessage("Помилка оновлення профілю", "error");
  }
}

// Функція виходу з системи
async function handleLogout() {
  try {
    const response = await fetch("api/logout.php", { method: "POST" });
    const data = await response.json();

    if (data.success) {
      // Очищаємо localStorage
      localStorage.removeItem("currentEnvironment");
      localStorage.removeItem("currentDbType");
      localStorage.removeItem("currentUser");

      // Перенаправляємо на сторінку входу
      window.location.href = "login.html";
    } else {
      console.error("Помилка виходу: ", data.message);
    }
  } catch (error) {
    console.error("Помилка виходу: ", error);
    // Навіть при помилці перенаправляємо на login
    window.location.href = "login.html";
  }
}

// ===== Finances: Bank Accounts =====
async function loadBank(sortBy = "id", sortOrder = "DESC", searchQuery = "") {
  try {
    const params = new URLSearchParams({
      type: "bank",
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    const res = await fetch(`api/finances.php?${params}`);
    const data = await res.json();
    if (data.success) {
      displayBank(data.data || []);
    }
  } catch (e) {
    console.error("Помилка завантаження банківських рахунків:", e);
    showMessage("Помилка завантаження банківських рахунків", "error");
  }
}

function displayBank(items) {
  const tbody = document.getElementById("bank-table-tbody");
  if (!tbody) return;
  tbody.innerHTML = "";
  if (!items.length) {
    renderEmptyTableState(tbody, "Немає рахунків");
    resetCheckboxStates();
    return;
  }

  items.forEach((item, index) => {
    const safeName = decodeMojibakeText(item.name || "");
    const safeCurrency = decodeMojibakeText(item.currency || "UAH");
    const safeDescription = decodeMojibakeText(item.description || "");
    const tr = document.createElement("tr");
    tr.dataset.id = String(item.id);
    tr.innerHTML = `
            <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
            <td class="col-name">${escapeHtml(safeName)}</td>
            <td class="col-balance">${formatMoney(item.balance)}</td>
            <td class="col-currency">${escapeHtml(safeCurrency)}</td>
            <td class="col-description">${escapeHtml(safeDescription)}</td>
            <td class="col-actions">
                <button class="row-more-btn" data-id="${item.id}" data-type="bank">
                    <i class="ri-more-2-fill"></i>
                </button>
            </td>`;
    tbody.appendChild(tr);
  });

  attachBankTbodyHandlers();
  resetCheckboxStates();
}

function formatMoney(val) {
  const num = parseFloat(val) || 0;
  return num.toLocaleString("uk-UA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function decodeMojibakeText(value) {
  const text = String(value ?? "");
  if (!text) return "";
  // Typical broken UTF-8 markers displayed as latin1 symbols.
  if (!/[ÐÑÂÃ]/.test(text)) return text;
  try {
    const bytes = new Uint8Array(
      Array.from(text).map((ch) => ch.charCodeAt(0) & 0xff),
    );
    const decoded = new TextDecoder("utf-8", { fatal: true }).decode(bytes);
    if (/[А-Яа-яІіЇїЄєҐґ]/.test(decoded)) return decoded;
  } catch { }
  return text;
}

function attachBankTbodyHandlers() {
  const tbody = document.getElementById("bank-table-tbody");
  if (!tbody || tbody.__bankHandlersInit) return;

  tbody.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : null;
    if (!id) return;

    if (btn.dataset.action === "edit") {
      const item = {
        id,
        name: tr.querySelector(".col-name")?.textContent?.trim() || "",
        balance:
          tr
            .querySelector(".col-balance")
            ?.textContent?.trim()
            .split(" ")[0]
            .replace(/\s/g, "")
            .replace(",", ".") || "0",
        currency:
          tr.querySelector(".col-currency")?.textContent?.trim() || "UAH",
        description:
          tr.querySelector(".col-description")?.textContent?.trim() || "",
      };
      showEditBankPanel(item);
    } else if (btn.dataset.action === "delete") {
      showConfirm("Видалити рахунок?", () => {
        fetch("api/finances.php?type=bank", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.success) {
              loadBank();
              showMessage("Рахунок видалено", "success");
            } else {
              showMessage(data.error || "Помилка видалення", "error");
            }
          });
      });
    }
  });
  tbody.__bankHandlersInit = true;
}

function showAddBankPanel() {
  const panel = document.querySelector(".add-bank-panel");
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (!panel) return;
  const isOpen = panel.classList.contains("active");
  if (isOpen) closeLegacyModal(panel);
  else {
    resetModalFormState(panel);
    openLegacyModal(panel);
  }
  if (addBtn) addBtn.classList.toggle("active");
}

function cancelBankPanel() {
  const panel = document.querySelector(".add-bank-panel");
  if (panel) closeLegacyModal(panel);
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (addBtn) addBtn.classList.remove("active");
}

function showEditBankPanel(item) {
  const panel = document.querySelector(".edit-bank-panel");
  if (!panel) return;
  cancelBankPanel();
  openLegacyModal(panel);
  panel.dataset.id = String(item.id || "");
  const name = panel.querySelector("#edit-bank-name");
  const balance = panel.querySelector("#edit-bank-balance");
  const currency = panel.querySelector("#edit-bank-currency");
  const desc = panel.querySelector("#edit-bank-description");
  if (name) name.value = item.name || "";
  if (balance) balance.value = item.balance || "";
  if (currency) currency.value = item.currency || "UAH";
  if (desc) desc.value = item.description || "";
}

function cancelEditBankPanel() {
  const panel = document.querySelector(".edit-bank-panel");
  if (panel) closeLegacyModal(panel);
}

async function deleteBank(id) {
  const bankId = Number(id);
  if (!bankId) return;
  showConfirm("Видалити рахунок?", async () => {
    try {
      const res = await fetch("api/finances.php?type=bank", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: bankId }),
      });
      const data = await res.json();
      if (data.success) {
        await loadBank();
        showMessage("Рахунок видалено", "success");
      } else {
        showMessage(data.error || "Помилка видалення", "error");
      }
    } catch {
      showMessage("Помилка видалення", "error");
    }
  });
}

async function saveBank() {
  const name = document.getElementById("bank-name")?.value?.trim();
  const balance = document.getElementById("bank-balance")?.value || "0";
  const currency =
    document.getElementById("bank-currency")?.value?.trim() || "UAH";
  const description =
    document.getElementById("bank-description")?.value?.trim() || "";

  if (!name) {
    showMessage("Введіть назву рахунку", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=bank", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name,
        balance: parseFloat(balance),
        currency,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelBankPanel();
      loadBank();
      showMessage("Рахунок створено", "success");
      document.getElementById("bank-name").value = "";
      document.getElementById("bank-balance").value = "";
      document.getElementById("bank-description").value = "";
    } else {
      showMessage(data.error || "Помилка створення", "error");
    }
  } catch {
    showMessage("Помилка створення рахунку", "error");
  }
}

async function updateBank() {
  const panel = document.querySelector(".edit-bank-panel");
  if (!panel) return;
  const id = Number(panel.dataset.id || 0);
  const name = document.getElementById("edit-bank-name")?.value?.trim();
  const balance = document.getElementById("edit-bank-balance")?.value || "0";
  const currency =
    document.getElementById("edit-bank-currency")?.value?.trim() || "UAH";
  const description =
    document.getElementById("edit-bank-description")?.value?.trim() || "";

  if (!id) {
    showMessage("Невірний ID", "error");
    return;
  }
  if (!name) {
    showMessage("Введіть назву рахунку", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=bank", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        name,
        balance: parseFloat(balance),
        currency,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelEditBankPanel();
      loadBank();
      showMessage("Рахунок оновлено", "success");
    } else {
      showMessage(data.error || "Помилка оновлення", "error");
    }
  } catch {
    showMessage("Помилка оновлення рахунку", "error");
  }
}

// ===== Finances: Incomes =====
async function loadIncomes(
  sortBy = "id",
  sortOrder = "DESC",
  searchQuery = "",
) {
  try {
    const params = new URLSearchParams({
      type: "incomes",
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    const res = await fetch(`api/finances.php?${params}`);
    const data = await res.json();
    if (data.success) {
      displayIncomes(data.data || []);
    }
  } catch (e) {
    console.error("Помилка завантаження доходів:", e);
    showMessage("Помилка завантаження доходів", "error");
  }
}

function displayIncomes(items) {
  const tbody = document.getElementById("incomes-table-tbody");
  if (!tbody) return;
  tbody.innerHTML = "";
  if (!items.length) {
    renderEmptyTableState(tbody, "Немає доходів");
    resetCheckboxStates();
    return;
  }

  items.forEach((item) => {
    const safeSource = decodeMojibakeText(item.source || "");
    const safeCategory = decodeMojibakeText(item.category || "");
    const safeDescription = decodeMojibakeText(item.description || "");
    const tr = document.createElement("tr");
    tr.dataset.id = String(item.id);
    tr.dataset.description = safeDescription;
    tr.innerHTML = `
            <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
            <td class="col-name">${escapeHtml(safeSource)}</td>
            <td class="col-amount">${formatMoney(item.amount)}</td>
            <td class="col-currency">${escapeHtml(item.currency || "UAH")}</td>
            <td class="col-category">${escapeHtml(safeCategory)}</td>
            <td class="col-actions">
                <button class="row-more-btn" data-id="${item.id}" data-type="income">
                    <i class="ri-more-2-fill"></i>
                </button>
            </td>
`;
    tbody.appendChild(tr);
  });

  attachIncomesTbodyHandlers();
  resetCheckboxStates();
}

function attachIncomesTbodyHandlers() {
  const tbody = document.getElementById("incomes-table-tbody");
  if (!tbody || tbody.__incomesHandlersInit) return;

  tbody.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : null;
    if (!id) return;

    if (btn.dataset.action === "edit") {
      const item = {
        id,
        source: tr.querySelector(".col-name")?.textContent?.trim() || "",
        amount:
          tr
            .querySelector(".col-amount")
            ?.textContent?.trim()
            .split(" ")[0]
            .replace(/\s/g, "")
            .replace(",", ".") || "0",
        category: tr.querySelector(".col-category")?.textContent?.trim() || "",
        description: tr.dataset.description || "",
      };
      showEditIncomePanel(item);
    } else if (btn.dataset.action === "delete") {
      showConfirm("Видалити дохід?", () => {
        fetch("api/finances.php?type=incomes", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.success) {
              loadIncomes();
              showMessage("Дохід видалено", "success");
            } else {
              showMessage(data.error || "Помилка видалення", "error");
            }
          });
      });
    }
  });
  tbody.__incomesHandlersInit = true;
}

function showAddIncomePanel() {
  const panel = document.querySelector(".add-income-panel");
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (!panel) return;
  const isOpen = panel.classList.contains("active");
  if (isOpen) closeLegacyModal(panel);
  else {
    resetModalFormState(panel);
    openLegacyModal(panel);
  }
  if (addBtn) addBtn.classList.toggle("active");
  initDateTimeInputs(panel);
}

function cancelIncomePanel() {
  const panel = document.querySelector(".add-income-panel");
  if (panel) closeLegacyModal(panel);
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (addBtn) addBtn.classList.remove("active");
}

function showEditIncomePanel(item) {
  const panel = document.querySelector(".edit-income-panel");
  if (!panel) return;
  cancelIncomePanel();
  openLegacyModal(panel);
  panel.dataset.id = String(item.id || "");
  const source = panel.querySelector("#edit-income-source");
  const amount = panel.querySelector("#edit-income-amount");
  const currency = panel.querySelector("#edit-income-currency");
  const category = panel.querySelector("#edit-income-category");
  const desc = panel.querySelector("#edit-income-description");
  if (source) source.value = item.source || "";
  if (amount) amount.value = item.amount || "";
  if (currency) currency.value = item.currency || "UAH";
  if (category) category.value = item.category || "";
  if (desc) desc.value = item.description || "";
  initDateTimeInputs(panel);
}

function cancelEditIncomePanel() {
  const panel = document.querySelector(".edit-income-panel");
  if (panel) closeLegacyModal(panel);
}

async function deleteIncome(id) {
  const incomeId = Number(id);
  if (!incomeId) return;
  showConfirm("Видалити дохід?", async () => {
    try {
      const res = await fetch("api/finances.php?type=incomes", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: incomeId }),
      });
      const data = await res.json();
      if (data.success) {
        await loadIncomes();
        showMessage("Дохід видалено", "success");
      } else {
        showMessage(data.error || "Помилка видалення", "error");
      }
    } catch {
      showMessage("Помилка видалення", "error");
    }
  });
}

async function saveIncome() {
  const source = document.getElementById("income-source")?.value?.trim();
  const amount = document.getElementById("income-amount")?.value || "0";
  const currency =
    document.getElementById("income-currency")?.value?.trim() || "UAH";
  const category =
    document.getElementById("income-category")?.value?.trim() || "";
  const description =
    document.getElementById("income-description")?.value?.trim() || "";

  if (!source) {
    showMessage("Введіть джерело доходу", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=incomes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        source,
        amount: parseFloat(amount),
        currency,
        category,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelIncomePanel();
      loadIncomes();
      showMessage("Дохід створено", "success");
      document.getElementById("income-source").value = "";
      document.getElementById("income-amount").value = "";
      document.getElementById("income-category").value = "";
      document.getElementById("income-description").value = "";
    } else {
      showMessage(data.error || "Помилка створення", "error");
    }
  } catch {
    showMessage("Помилка створення доходу", "error");
  }
}

async function updateIncome() {
  const panel = document.querySelector(".edit-income-panel");
  if (!panel) return;
  const id = Number(panel.dataset.id || 0);
  const source = document.getElementById("edit-income-source")?.value?.trim();
  const amount = document.getElementById("edit-income-amount")?.value || "0";
  const currency =
    document.getElementById("edit-income-currency")?.value?.trim() || "UAH";
  const category =
    document.getElementById("edit-income-category")?.value?.trim() || "";
  const description =
    document.getElementById("edit-income-description")?.value?.trim() || "";

  if (!id) {
    showMessage("Невірний ID", "error");
    return;
  }
  if (!source) {
    showMessage("Введіть джерело доходу", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=incomes", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        source,
        amount: parseFloat(amount),
        currency,
        category,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelEditIncomePanel();
      loadIncomes();
      showMessage("Дохід оновлено", "success");
    } else {
      showMessage(data.error || "Помилка оновлення", "error");
    }
  } catch {
    showMessage("Помилка оновлення доходу", "error");
  }
}

// Обробник кнопки "Додати" для вкладки Finances
document.addEventListener("DOMContentLoaded", () => {
  const financesPanel = document.getElementById("finances");
  if (financesPanel) {
    const addBtn = financesPanel.querySelector(".add-data-table-item");
    if (addBtn) {
      addBtn.addEventListener("click", () => {
        const activeSub = financesPanel.querySelector(".sub-tab-panel.active");
        if (activeSub && activeSub.id === "incomes-content") {
          showAddIncomePanel();
        } else if (activeSub && activeSub.id === "expenses-content") {
          showAddExpensePanel();
        } else {
          showAddBankPanel();
        }
      });
    }
  }
});

// ===== Finances: Expenses =====
async function loadExpenses(
  sortBy = "date",
  sortOrder = "DESC",
  searchQuery = "",
) {
  try {
    const params = new URLSearchParams({
      type: "expenses",
      sort_by: sortBy,
      sort_order: sortOrder,
    });
    if (searchQuery) params.append("search", searchQuery);

    const res = await fetch(`api/finances.php?${params}`);
    const data = await res.json();
    if (data.success) {
      displayExpenses(data.data || []);
    }
  } catch (e) {
    console.error("Помилка завантаження витрат:", e);
    showMessage("Помилка завантаження витрат", "error");
  }
}

function updateBudgetWidget(items: any[]) {
  const spentEl = document.getElementById("budget-spent-amount");
  const percentEl = document.getElementById("budget-percentage-text");
  const barEl = document.getElementById("budget-progress-bar");
  if (!spentEl || !percentEl || !barEl) return;

  const currentMonthStr = new Date().toISOString().slice(0, 7); // YYYY-MM
  let totalMonthSpent = 0;
  items.forEach((item) => {
    if (item.date && String(item.date).startsWith(currentMonthStr)) {
      totalMonthSpent += parseFloat(item.amount || 0);
    }
  });

  const MONTHLY_LIMIT = 50000;
  const percentage = Math.min(100, Math.round((totalMonthSpent / MONTHLY_LIMIT) * 100));

  spentEl.textContent = `${totalMonthSpent.toLocaleString("uk-UA")} ₴`;
  percentEl.textContent = `${percentage}%`;
  barEl.style.width = `${percentage}%`;

  if (percentage > 90) {
    barEl.style.background = "#ef4444"; // Red
  } else if (percentage > 70) {
    barEl.style.background = "#f59e0b"; // Yellow
  } else {
    barEl.style.background = "#10b981"; // Green
  }
}

function displayExpenses(items) {
  updateBudgetWidget(items);
  const tbody = document.getElementById("expenses-table-tbody");
  if (!tbody) return;
  tbody.innerHTML = "";
  if (!items.length) {
    renderEmptyTableState(tbody, "Немає витрат");
    resetCheckboxStates();
    return;
  }

  items.forEach((item) => {
    const safeDate = decodeMojibakeText(item.date || "");
    const safeExpenseType = decodeMojibakeText(item.expense_type || "");
    const safeStore = decodeMojibakeText(item.store || "");
    const tr = document.createElement("tr");
    tr.dataset.id = String(item.id);
    tr.dataset.description = decodeMojibakeText(item.description || "");
    const safeStatusClass = sanitizeClassName(item.status || "active");
    const safeStatusLabel = escapeHtml(
      decodeMojibakeText(item.status || "Активний"),
    );
    tr.innerHTML = `
            <td class="col-checkbox"><input type="checkbox" class="row-checkbox"></td>
            <td class="col-date">${escapeHtml(safeDate)}</td>
            <td class="col-category">${escapeHtml(safeExpenseType)}</td>
            <td class="col-name">${escapeHtml(safeStore)}</td>
            <td class="col-amount">${formatMoney(item.amount)}</td>
            <td class="col-currency">${escapeHtml(item.currency || "UAH")}</td>
            <td class="col-actions">
                <button class="row-more-btn" data-id="${item.id}" data-type="expense">
                    <i class="ri-more-2-fill"></i>
                </button>
            </td>`;
    tbody.appendChild(tr);
  });

  attachExpensesTbodyHandlers();
  resetCheckboxStates();
}

function attachExpensesTbodyHandlers() {
  const tbody = document.getElementById("expenses-table-tbody");
  if (!tbody || tbody.__expensesHandlersInit) return;

  tbody.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-action]");
    if (!btn) return;
    const tr = btn.closest("tr");
    const id = tr ? Number(tr.dataset.id) : null;
    if (!id) return;

    if (btn.dataset.action === "edit") {
      const item = {
        id,
        date: tr.querySelector(".col-date")?.textContent?.trim() || "",
        expense_type:
          tr.querySelector(".col-category")?.textContent?.trim() || "",
        store: tr.querySelector(".col-name")?.textContent?.trim() || "",
        amount:
          tr
            .querySelector(".col-amount")
            ?.textContent?.trim()
            .split(" ")[0]
            .replace(/\s/g, "")
            .replace(",", ".") || "0",
        currency: tr.querySelector(".col-currency")?.textContent?.trim() || "UAH",
        description: tr.dataset.description || "",
      };
      showEditExpensePanel(item);
    } else if (btn.dataset.action === "delete") {
      showConfirm("Видалити витрату?", () => {
        fetch("api/finances.php?type=expenses", {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data.success) {
              loadExpenses();
              showMessage("Витрату видалено", "success");
            } else {
              showMessage(data.error || "Помилка видалення", "error");
            }
          });
      });
    }
  });
  tbody.__expensesHandlersInit = true;
}

function getCurrentDateTimeFormatted(): string {
  const now = new Date();
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(now.getDate())}.${pad(now.getMonth() + 1)}.${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}`;
}

function showAddExpensePanel() {
  const panel = document.querySelector(".add-expense-panel");
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (!panel) return;

  const isOpen = panel.classList.contains("active");
  if (isOpen) {
    closeLegacyModal(panel);
  } else {
    resetModalFormState(panel);
    openLegacyModal(panel);
    const dateInput = panel.querySelector("#expense-date") as HTMLInputElement | null;
    if (dateInput) {
      dateInput.value = getCurrentDateTimeFormatted();
    }
  }
  if (addBtn) addBtn.classList.toggle("active");
  initDateTimeInputs(panel);
  initCustomSelects(panel);
}

function cancelExpensePanel() {
  const panel = document.querySelector(".add-expense-panel");
  if (panel) closeLegacyModal(panel);
  const addBtn = document.querySelector("#finances .add-data-table-item");
  if (addBtn) addBtn.classList.remove("active");
}

function showEditExpensePanel(item) {
  const panel = document.querySelector(".edit-expense-panel");
  if (!panel) return;
  cancelExpensePanel();
  openLegacyModal(panel);
  panel.dataset.id = String(item.id || "");

  const date = panel.querySelector("#edit-expense-date");
  const expenseType = panel.querySelector("#edit-expense-type");
  const store = panel.querySelector("#edit-expense-store");
  const amount = panel.querySelector("#edit-expense-amount");
  const currency = panel.querySelector("#edit-expense-currency");
  const desc = panel.querySelector("#edit-expense-description");

  if (date) date.value = item.date || "";
  if (expenseType) expenseType.value = item.expense_type || "Магазин";
  if (store) store.value = item.store || "";
  if (amount) amount.value = item.amount || "";
  if (currency) currency.value = item.currency || "UAH";
  if (desc) desc.value = item.description || "";

  // Оновити кастомний селект
  const cs = panel.querySelector(
    '.custom-select[data-input-id="edit-expense-type"]',
  );
  if (cs) {
    const btn = cs.querySelector(".custom-select-toggle");
    cs.querySelectorAll(".custom-select-option").forEach((opt) => {
      const isSel =
        (opt.dataset.value || "") === (item.expense_type || "Магазин");
      opt.classList.toggle("is-selected", isSel);
      if (isSel && btn) btn.textContent = opt.textContent.trim();
    });
  }

  initDateTimeInputs(panel);
  initCustomSelects(panel);
}

function cancelEditExpensePanel() {
  const panel = document.querySelector(".edit-expense-panel");
  if (panel) closeLegacyModal(panel);
}

async function deleteExpense(id) {
  const expenseId = Number(id);
  if (!expenseId) return;
  showConfirm("Видалити витрату?", async () => {
    try {
      const res = await fetch("api/finances.php?type=expenses", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: expenseId }),
      });
      const data = await res.json();
      if (data.success) {
        await loadExpenses();
        showMessage("Витрату видалено", "success");
      } else {
        showMessage(data.error || "Помилка видалення", "error");
      }
    } catch {
      showMessage("Помилка видалення", "error");
    }
  });
}

async function saveExpense() {
  const date = document.getElementById("expense-date")?.value?.trim() || "";
  const expense_type =
    document.getElementById("expense-type")?.value?.trim() || "Магазин";
  const store = document.getElementById("expense-store")?.value?.trim() || "";
  const amount = document.getElementById("expense-amount")?.value || "0";
  const currency =
    document.getElementById("expense-currency")?.value?.trim() || "UAH";
  const description =
    document.getElementById("expense-description")?.value?.trim() || "";

  if (!expense_type) {
    showMessage("Оберіть тип витрати", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=expenses", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        date,
        expense_type,
        store,
        amount: parseFloat(amount),
        currency,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelExpensePanel();
      if (typeof loadExpenses === "function") loadExpenses();
      if (typeof loadDashboard === "function") loadDashboard();
      showMessage("Витрату створено", "success");
      document.getElementById("expense-date").value = "";
      document.getElementById("expense-store").value = "";
      document.getElementById("expense-amount").value = "";
      document.getElementById("expense-description").value = "";
    } else {
      showMessage(data.error || "Помилка створення", "error");
    }
  } catch {
    showMessage("Помилка створення витрати", "error");
  }
}

async function updateExpense() {
  const panel = document.querySelector(".edit-expense-panel");
  if (!panel) return;
  const id = Number(panel.dataset.id || 0);
  const date =
    document.getElementById("edit-expense-date")?.value?.trim() || "";
  const expense_type =
    document.getElementById("edit-expense-type")?.value?.trim() || "Магазин";
  const store =
    document.getElementById("edit-expense-store")?.value?.trim() || "";
  const amount = document.getElementById("edit-expense-amount")?.value || "0";
  const currency =
    document.getElementById("edit-expense-currency")?.value?.trim() || "UAH";
  const description =
    document.getElementById("edit-expense-description")?.value?.trim() || "";

  if (!id) {
    showMessage("Невірний ID", "error");
    return;
  }
  if (!expense_type) {
    showMessage("Оберіть тип витрати", "error");
    return;
  }

  try {
    const res = await fetch("api/finances.php?type=expenses", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id,
        date,
        expense_type,
        store,
        amount: parseFloat(amount),
        currency,
        description,
      }),
    });
    const data = await res.json();
    if (data.success) {
      cancelEditExpensePanel();
      loadExpenses();
      showMessage("Витрату оновлено", "success");
    } else {
      showMessage(data.error || "Помилка оновлення", "error");
    }
  } catch {
    showMessage("Помилка оновлення витрати", "error");
  }
}

// ===== СТАТИСТИКА =====

const statsState = {
  period: "30d",
  trainingProgressScale: "month",
  data: null,
  initialized: false,
  loading: false,
};

function isStatisticsTabActive() {
  const activeTab = document.querySelector(".sidebar-item.active");
  return activeTab?.getAttribute("data-tab") === "statistics";
}

function invalidateStatisticsCache() {
  statsState.data = null;
  if (isStatisticsTabActive() && !statsState.loading) {
    loadStatisticsDashboard(true);
  }
}

window.addEventListener("bb:data-mutated", invalidateStatisticsCache);

function parseStatsDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const normalized = String(value).trim().replace(" ", "T");
  const date = new Date(normalized);
  if (!Number.isNaN(date.getTime())) return date;
  return null;
}

function isDateInStatsPeriod(date, period) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return false;
  const now = new Date();
  const dayStartNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dayStartDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );
  const diffDays = Math.floor(
    (dayStartNow.getTime() - dayStartDate.getTime()) / 86400000,
  );

  if (period === "7d") return diffDays >= 0 && diffDays < 7;
  if (period === "30d") return diffDays >= 0 && diffDays < 30;
  if (period === "12m") return diffDays >= 0 && diffDays < 365;
  if (period === "year") return date.getFullYear() === now.getFullYear();
  return true;
}

function statsNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

function statsCurrency(v) {
  return `${formatMoney(v)} ₴`;
}

function statsBucketKey(date, period) {
  if (!(date instanceof Date)) return "";
  if (period === "7d" || period === "30d") {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  }
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

function statsBuildTimeline(period, minDate = null) {
  const now = new Date();
  const items = [];
  if (period === "7d" || period === "30d") {
    const days = period === "7d" ? 7 : 30;
    for (let i = days - 1; i >= 0; i -= 1) {
      const d = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() - i,
        0,
        0,
        0,
        0,
      );
      const key = statsBucketKey(d, period);
      const label = d.toLocaleDateString("uk-UA", {
        day: "2-digit",
        month: "2-digit",
      });
      items.push({ key, label });
    }
    return items;
  }

  if (period === "year") {
    for (let m = 0; m < 12; m += 1) {
      const d = new Date(now.getFullYear(), m, 1);
      items.push({
        key: statsBucketKey(d, period),
        label: d.toLocaleDateString("uk-UA", { month: "short" }),
      });
    }
    return items;
  }

  if (period === "all") {
    const start = minDate instanceof Date ? minDate : new Date(now.getFullYear(), now.getMonth() - 11, 1);
    let cursor = new Date(start.getFullYear(), start.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 1);
    while (cursor <= end) {
      items.push({
        key: statsBucketKey(cursor, period),
        label: cursor.toLocaleDateString("uk-UA", { month: "short", year: "2-digit" }),
      });
      cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
    }
    return items.slice(-36);
  }

  for (let i = 11; i >= 0; i -= 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    items.push({
      key: statsBucketKey(d, period),
      label: d.toLocaleDateString("uk-UA", { month: "short" }),
    });
  }
  return items;
}

function statsRenderLineChart(containerId, labels, datasets) {
  const host = document.getElementById(containerId);
  if (!host) return;
  if (!labels.length) {
    host.innerHTML = '<div class="stats-empty">Немає даних за обраний період</div>';
    return;
  }

  const width = 760;
  const height = 240;
  const padX = 18;
  const padY = 18;
  const maxValue = Math.max(
    1,
    ...datasets.flatMap((d) => d.values.map((v) => statsNumber(v))),
  );

  const xStep = labels.length > 1 ? (width - padX * 2) / (labels.length - 1) : 0;
  const scaleY = (height - padY * 2) / maxValue;

  const paths = datasets
    .map((dataset) => {
      const points = dataset.values.map((value, idx) => {
        const x = padX + xStep * idx;
        const y = height - padY - statsNumber(value) * scaleY;
        return `${x},${y}`;
      });
      return `<polyline fill="none" stroke="${dataset.color}" stroke-width="2.5" points="${points.join(" ")}"></polyline>`;
    })
    .join("");

  const legends = datasets
    .map(
      (d) =>
        `<span class="stats-legend-item"><i style="background:${d.color}"></i>${escapeHtml(d.name)}</span>`,
    )
    .join("");

  const labelsHtml = labels
    .map((label) => `<span>${escapeHtml(label)}</span>`)
    .join("");

  host.innerHTML = `
    <div class="stats-legend">${legends}</div>
    <svg class="stats-svg-line" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
      <line x1="${padX}" y1="${height - padY}" x2="${width - padX}" y2="${height - padY}" stroke="rgba(255,255,255,.18)" />
      <line x1="${padX}" y1="${padY}" x2="${padX}" y2="${height - padY}" stroke="rgba(255,255,255,.18)" />
      ${paths}
    </svg>
    <div class="stats-x-labels">${labelsHtml}</div>
  `;
}

function statsRenderBars(containerId, rows) {
  const host = document.getElementById(containerId);
  if (!host) return;
  if (!rows.length) {
    host.innerHTML = '<div class="stats-empty">Немає даних за обраний період</div>';
    return;
  }
  const maxVal = Math.max(1, ...rows.map((r) => statsNumber(r.value)));
  host.innerHTML = rows
    .map((row) => {
      const pct = Math.max(3, Math.round((statsNumber(row.value) / maxVal) * 100));
      return `
        <div class="stats-bar-row">
          <div class="stats-bar-head">
            <span>${escapeHtml(row.label)}</span>
            <strong>${escapeHtml(String(row.formatted ?? row.value))}</strong>
          </div>
          <div class="stats-bar-track"><div class="stats-bar-fill" style="width:${pct}%"></div></div>
        </div>
      `;
    })
    .join("");
}

function statsRenderDonut(containerId, rows) {
  const host = document.getElementById(containerId);
  if (!host) return;
  if (!rows.length) {
    host.innerHTML = '<div class="stats-empty">Немає даних за обраний період</div>';
    return;
  }
  const total = rows.reduce((sum, row) => sum + statsNumber(row.value), 0) || 1;
  const colors = ["#d7dde5", "#b8c3d1", "#8fa0b6", "#6f839c", "#5b6f87", "#e4e8ee"];

  let from = 0;
  const slices = rows
    .map((row, idx) => {
      const pct = (statsNumber(row.value) / total) * 100;
      const color = colors[idx % colors.length];
      const part = `${color} ${from}% ${from + pct}%`;
      from += pct;
      return part;
    })
    .join(", ");

  const legend = rows
    .map((row, idx) => {
      const pct = ((statsNumber(row.value) / total) * 100).toFixed(1);
      return `<div class="stats-donut-legend-item"><i style="background:${colors[idx % colors.length]}"></i><span>${escapeHtml(row.label)}</span><strong>${pct}%</strong></div>`;
    })
    .join("");

  host.innerHTML = `
    <div class="stats-donut-wrap">
      <div class="stats-donut" style="background: conic-gradient(${slices});"></div>
      <div class="stats-donut-center">${formatMoney(total)}</div>
    </div>
    <div class="stats-donut-legend">${legend}</div>
  `;
}

function statsRenderList(containerId, items, formatter) {
  const host = document.getElementById(containerId);
  if (!host) return;
  if (!items.length) {
    host.innerHTML = '<div class="stats-empty">Немає даних</div>';
    return;
  }
  host.innerHTML = items
    .map((item, idx) => formatter(item, idx))
    .join("");
}

function statsSetPeriodButtons(period) {
  document.querySelectorAll("#statistics .stats-period-btn").forEach((btn) => {
    btn.classList.toggle("active", btn.dataset.period === period);
  });
}

function statsSetTrainingProgressButtons(scale) {
  document
    .querySelectorAll("#statistics .stats-mini-btn")
    .forEach((btn) => btn.classList.toggle("active", btn.dataset.scale === scale));
}

function statsInitControls() {
  if (statsState.initialized) return;
  const switcher = document.getElementById("statistics-period-switch");
  if (switcher) {
    switcher.addEventListener("click", (event) => {
      const btn = event.target.closest(".stats-period-btn");
      if (!btn) return;
      const period = btn.dataset.period || "30d";
      if (period === statsState.period) return;
      statsState.period = period;
      statsSetPeriodButtons(period);
      if (statsState.data) {
        renderStatisticsDashboard(statsState.data, period);
      }
    });
  }

  const refreshBtn = document.getElementById("statistics-refresh-btn");
  if (refreshBtn) {
    refreshBtn.addEventListener("click", () => {
      loadStatisticsDashboard(true);
    });
  }

  const progressionSwitcher = document.getElementById(
    "stats-training-progression-switch",
  );
  if (progressionSwitcher) {
    progressionSwitcher.addEventListener("click", (event) => {
      const btn = event.target.closest(".stats-mini-btn");
      if (!btn) return;
      const scale = btn.dataset.scale === "year" ? "year" : "month";
      if (scale === statsState.trainingProgressScale) return;
      statsState.trainingProgressScale = scale;
      statsSetTrainingProgressButtons(scale);
      if (statsState.data) {
        renderStatisticsDashboard(statsState.data, statsState.period);
      }
    });
  }

  statsState.initialized = true;
  statsSetPeriodButtons(statsState.period);
  statsSetTrainingProgressButtons(statsState.trainingProgressScale);
}

function buildTrainingProgression(training) {
  const rows = (Array.isArray(training) ? training : []).filter(
    (s) => Number(s.is_completed) === 1,
  );
  const now = new Date();
  const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  if (statsState.trainingProgressScale === "month") {
    const daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    const timeline = [];
    const daily = Object.create(null);
    rows.forEach((s) => {
      const d = parseStatsDate(s.date);
      if (!d) return;
      if (d < monthStart || d.getMonth() !== now.getMonth() || d.getFullYear() !== now.getFullYear()) return;
      const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
      const score =
        Math.round(statsNumber(s.duration_seconds) / 60) + statsNumber(s.total_reps);
      daily[key] = (daily[key] || 0) + score;
    });

    let cumulative = 0;
    for (let day = 1; day <= daysInMonth; day += 1) {
      const d = new Date(now.getFullYear(), now.getMonth(), day);
      const key = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
      cumulative += daily[key] || 0;
      timeline.push({
        label: d.toLocaleDateString("uk-UA", { day: "2-digit", month: "2-digit" }),
        value: cumulative,
      });
    }
    return timeline;
  }

  const monthly = new Array(12).fill(0);
  rows.forEach((s) => {
    const d = parseStatsDate(s.date);
    if (!d || d.getFullYear() !== now.getFullYear()) return;
    const score =
      Math.round(statsNumber(s.duration_seconds) / 60) + statsNumber(s.total_reps);
    monthly[d.getMonth()] += score;
  });
  let cumulative = 0;
  return monthly.map((v, idx) => {
    cumulative += v;
    const d = new Date(now.getFullYear(), idx, 1);
    return {
      label: d.toLocaleDateString("uk-UA", { month: "short" }),
      value: cumulative,
    };
  });
}

async function loadStatisticsDashboard(forceRefresh = false) {
  statsInitControls();
  if (statsState.loading) return;
  if (statsState.data && !forceRefresh) renderStatisticsDashboard(statsState.data, statsState.period);

  statsState.loading = true;
  try {
    const res = await fetch("api/statistics.php", { cache: "no-store" });
    const payload = await res.json();
    if (!payload.success || !payload.data) {
      throw new Error(payload.error || "Помилка завантаження статистики");
    }
    statsState.data = payload.data;
    renderStatisticsDashboard(payload.data, statsState.period);
  } catch (e) {
    showMessage(e.message || "Помилка завантаження статистики", "error");
  } finally {
    statsState.loading = false;
  }
}

function renderStatisticsDashboard(data, period) {
  const tasks = Array.isArray(data.tasks) ? data.tasks : [];
  const incomes = Array.isArray(data.finances?.incomes) ? data.finances.incomes : [];
  const expenses = Array.isArray(data.finances?.expenses) ? data.finances.expenses : [];
  const orders = Array.isArray(data.orders) ? data.orders : [];
  const goals = Array.isArray(data.goals) ? data.goals : [];
  const training = Array.isArray(data.training) ? data.training : [];
  const products = Array.isArray(data.egds) ? data.egds : [];
  const projects = Array.isArray(data.projects) ? data.projects : [];
  const youtube = Array.isArray(data.youtube) ? data.youtube : [];

  const filteredIncomes = incomes.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.date), period),
  );
  const filteredExpenses = expenses.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.date), period),
  );
  const filteredOrders = orders.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.created_at), period),
  );
  const filteredTraining = training.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.date), period),
  );
  const filteredTasks = tasks.filter((x) => {
    const base = parseStatsDate(x.due_at || x.created_at);
    return isDateInStatsPeriod(base, period);
  });
  const filteredYoutube = youtube.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.published_at), period),
  );
  const filteredProjects = projects.filter((x) =>
    isDateInStatsPeriod(parseStatsDate(x.created_at), period),
  );

  const totalIncome = filteredIncomes.reduce((s, x) => s + statsNumber(x.amount), 0);
  const totalExpense = filteredExpenses.reduce((s, x) => s + statsNumber(x.amount), 0);
  const net = totalIncome - totalExpense;
  const doneTasks = filteredTasks.filter((x) => Number(x.done) === 1).length;
  const allTasks = filteredTasks.length;
  const trainingCount = filteredTraining.length;
  const salesTotal = filteredOrders
    .filter((x) => String(x.status || "").toLowerCase() !== "cancelled")
    .reduce((s, x) => s + statsNumber(x.total_amount), 0);

  const setText = (id, value) => {
    const el = document.getElementById(id);
    if (el) el.textContent = value;
  };
  setText("stats-kpi-incomes", statsCurrency(totalIncome));
  setText("stats-kpi-expenses", statsCurrency(totalExpense));
  setText("stats-kpi-net", `${net >= 0 ? "+" : ""}${statsCurrency(net)}`);
  setText("stats-kpi-tasks", `${doneTasks} / ${allTasks}`);
  setText("stats-kpi-training", String(trainingCount));
  setText("stats-kpi-sales", statsCurrency(salesTotal));

  const allDates = [
    ...filteredIncomes.map((x) => parseStatsDate(x.date)),
    ...filteredExpenses.map((x) => parseStatsDate(x.date)),
  ].filter(Boolean);
  const minDate =
    allDates.length > 0
      ? new Date(Math.min(...allDates.map((d) => d.getTime())))
      : null;

  const timeline = statsBuildTimeline(period, minDate);
  const incomeByBucket = Object.create(null);
  const expenseByBucket = Object.create(null);
  filteredIncomes.forEach((x) => {
    const date = parseStatsDate(x.date);
    if (!date) return;
    const key = statsBucketKey(date, period);
    incomeByBucket[key] = (incomeByBucket[key] || 0) + statsNumber(x.amount);
  });
  filteredExpenses.forEach((x) => {
    const date = parseStatsDate(x.date);
    if (!date) return;
    const key = statsBucketKey(date, period);
    expenseByBucket[key] = (expenseByBucket[key] || 0) + statsNumber(x.amount);
  });

  statsRenderLineChart(
    "stats-chart-cashflow",
    timeline.map((t) => t.label),
    [
      { name: "Доходи", color: "#bfc9d6", values: timeline.map((t) => incomeByBucket[t.key] || 0) },
      { name: "Витрати", color: "#7f90a6", values: timeline.map((t) => expenseByBucket[t.key] || 0) },
    ],
  );

  const expenseByType = Object.create(null);
  filteredExpenses.forEach((x) => {
    const key = String(x.expense_type || "Інше");
    expenseByType[key] = (expenseByType[key] || 0) + statsNumber(x.amount);
  });
  const topExpenseTypes = Object.entries(expenseByType)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 6)
    .map(([label, value]) => ({ label, value }));
  statsRenderDonut("stats-chart-expenses-categories", topExpenseTypes);

  const weekdayLabels = ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"];
  const weekdayCounts = new Array(7).fill(0);
  filteredTasks.forEach((t) => {
    if (Number(t.done) !== 1) return;
    const date = parseStatsDate(t.due_at || t.created_at);
    if (!date) return;
    const jsDay = date.getDay();
    const idx = (jsDay + 6) % 7;
    weekdayCounts[idx] += 1;
  });
  statsRenderBars(
    "stats-chart-tasks-weekday",
    weekdayLabels.map((label, idx) => ({ label, value: weekdayCounts[idx] })),
  );

  const trainingByBucket = Object.create(null);
  const durationByBucket = Object.create(null);
  filteredTraining.forEach((x) => {
    const date = parseStatsDate(x.date);
    if (!date) return;
    const key = statsBucketKey(date, period);
    trainingByBucket[key] = (trainingByBucket[key] || 0) + 1;
    durationByBucket[key] =
      (durationByBucket[key] || 0) + Math.round(statsNumber(x.duration_seconds) / 60);
  });
  statsRenderLineChart(
    "stats-chart-training",
    timeline.map((t) => t.label),
    [
      { name: "Сесії", color: "#c7d0db", values: timeline.map((t) => trainingByBucket[t.key] || 0) },
      { name: "Хвилини", color: "#73879f", values: timeline.map((t) => durationByBucket[t.key] || 0) },
    ],
  );

  const progression = buildTrainingProgression(training);
  statsRenderLineChart(
    "stats-chart-training-progression",
    progression.map((x) => x.label),
    [
      {
        name:
          statsState.trainingProgressScale === "year"
            ? "Накопичений прогрес за рік"
            : "Накопичений прогрес за місяць",
        color: "#6e829a",
        values: progression.map((x) => x.value),
      },
    ],
  );

  const orderStatusCounts = Object.create(null);
  filteredOrders.forEach((x) => {
    const s = String(x.status || "unknown");
    orderStatusCounts[s] = (orderStatusCounts[s] || 0) + 1;
  });
  statsRenderBars(
    "stats-chart-orders-status",
    Object.entries(orderStatusCounts).map(([label, value]) => ({ label, value })),
  );

  const projectStatusCounts = Object.create(null);
  filteredProjects.forEach((x) => {
    const s = String(x.status || "невідомо");
    projectStatusCounts[s] = (projectStatusCounts[s] || 0) + 1;
  });
  statsRenderBars(
    "stats-chart-projects-status",
    Object.entries(projectStatusCounts).map(([label, value]) => ({ label, value })),
  );

  const taskPlanMinutes = filteredTasks.reduce(
    (s, t) => s + statsNumber(t.time_limit_minutes),
    0,
  );
  const taskFactMinutes = filteredTasks.reduce(
    (s, t) => s + Math.round(statsNumber(t.timer_elapsed_seconds) / 60),
    0,
  );
  setText("stats-plan-minutes", `${formatMoney(taskPlanMinutes)} хв`);
  setText("stats-fact-minutes", `${formatMoney(taskFactMinutes)} хв`);
  const progress = document.getElementById("stats-plan-fact-progress");
  if (progress) {
    const pct = taskPlanMinutes > 0 ? Math.min(100, Math.round((taskFactMinutes / taskPlanMinutes) * 100)) : 0;
    progress.style.width = `${Math.max(2, pct)}%`;
  }

  const avgGoalProgress =
    goals.length > 0
      ? goals.reduce((s, g) => s + statsNumber(g.progress_percent), 0) / goals.length
      : 0;
  setText("stats-goals-avg-progress", `${Math.round(avgGoalProgress)}%`);
  const now = new Date();
  const riskGoals = goals
    .filter((g) => {
      const t = parseStatsDate(g.target_at);
      if (!t) return false;
      const diff = Math.floor((t.getTime() - now.getTime()) / 86400000);
      return diff >= 0 && diff <= 14 && statsNumber(g.progress_percent) < 70;
    })
    .sort((a, b) => statsNumber(a.progress_percent) - statsNumber(b.progress_percent))
    .slice(0, 5);
  statsRenderList("stats-goals-risk-list", riskGoals, (g) => {
    const date = parseStatsDate(g.target_at);
    const deadline = date
      ? date.toLocaleDateString("uk-UA", { day: "2-digit", month: "2-digit" })
      : "—";
    return `<div class="stats-list-item"><span>${escapeHtml(g.title || "Ціль")}</span><strong>${Math.round(statsNumber(g.progress_percent))}% · ${deadline}</strong></div>`;
  });

  const lowStockProducts = products
    .filter((p) => statsNumber(p.stock_quantity) <= statsNumber(p.min_stock_level || 5))
    .sort((a, b) => statsNumber(a.stock_quantity) - statsNumber(b.stock_quantity))
    .slice(0, 8);
  statsRenderList("stats-low-stock-list", lowStockProducts, (p) => {
    return `<div class="stats-list-item"><span>${escapeHtml(p.name || "Товар")}</span><strong>${statsNumber(p.stock_quantity)} шт</strong></div>`;
  });

  const productsByCategory = Object.create(null);
  products.forEach((p) => {
    const cat = String(p.category || "Інше");
    productsByCategory[cat] = (productsByCategory[cat] || 0) + 1;
  });
  const topCategories = Object.entries(productsByCategory)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 8)
    .map(([category, count]) => ({ category, count }));
  statsRenderList("stats-top-categories-list", topCategories, (item) => {
    return `<div class="stats-list-item"><span>${escapeHtml(item.category)}</span><strong>${item.count} позицій</strong></div>`;
  });

  const topYoutube = [...filteredYoutube]
    .sort((a, b) => statsNumber(b.views_count) - statsNumber(a.views_count))
    .slice(0, 8);
  statsRenderList("stats-youtube-top-list", topYoutube, (item) => {
    return `<div class="stats-list-item"><span>${escapeHtml(item.title || "Відео")}</span><strong>${formatMoney(item.views_count)} views</strong></div>`;
  });

  const youtubeByBucket = Object.create(null);
  filteredYoutube.forEach((item) => {
    const date = parseStatsDate(item.published_at);
    if (!date) return;
    const key = statsBucketKey(date, period);
    youtubeByBucket[key] = (youtubeByBucket[key] || 0) + 1;
  });
  statsRenderLineChart(
    "stats-chart-youtube-published",
    timeline.map((t) => t.label),
    [
      {
        name: "Публікації",
        color: "#6e829a",
        values: timeline.map((t) => youtubeByBucket[t.key] || 0),
      },
    ],
  );
}

// ===== СИСТЕМА ТРЕНУВАНЬ =====

// Глобальні змінні для таймера
let runTimerInterval = null;
let runTimerSeconds = 0;
let runTimerRunning = false;
let runSessionId = null;

// Поточні сесії для підходів
let currentPullupsSessionId = null;
let currentPushupsSessionId = null;

const trainingState = {
  currentWeek: 1,
  runDurationMinutes: 20,
  weekStartedAt: null,
};

const TRAINING_PROGRAM = {
  running: { base: 20, weeklyIncrement: 1 },
  pullups: { baseSets: [5, 4, 3, 2, 2], weeklyIncrement: 2 },
  pushups: { baseSets: [30, 25, 20, 15, 10], weeklyIncrement: 5 },
};

function getTrainingWeek() {
  return Math.max(1, Number(trainingState.currentWeek || 1));
}

function buildStrengthPlan(baseSets, week, increment) {
  const sets = [...baseSets];
  const steps = Math.max(0, week - 1);
  for (let i = 0; i < steps; i += 1) {
    const minVal = Math.min(...sets);
    const minIdx = sets.indexOf(minVal);
    if (minIdx >= 0) sets[minIdx] += increment;
  }
  return sets;
}

function getCurrentStrengthPlan(exerciseType) {
  const week = getTrainingWeek();
  if (exerciseType === "pullups") {
    return buildStrengthPlan(
      TRAINING_PROGRAM.pullups.baseSets,
      week,
      TRAINING_PROGRAM.pullups.weeklyIncrement,
    );
  }
  if (exerciseType === "pushups") {
    return buildStrengthPlan(
      TRAINING_PROGRAM.pushups.baseSets,
      week,
      TRAINING_PROGRAM.pushups.weeklyIncrement,
    );
  }
  return [];
}

function getPlannedRunMinutes() {
  return (
    TRAINING_PROGRAM.running.base +
    (getTrainingWeek() - 1) * TRAINING_PROGRAM.running.weeklyIncrement
  );
}

function getCurrentSessionSetCount(exerciseType) {
  return document.querySelectorAll(
    `#${exerciseType}-sets-list .training-set-item`,
  ).length;
}

function getCurrentSessionPlannedReps(exerciseType) {
  const plan = getCurrentStrengthPlan(exerciseType);
  const setIndex = getCurrentSessionSetCount(exerciseType);
  return plan[setIndex] || null;
}

function renderTrainingPlanForStrength(exerciseType) {
  const plan = getCurrentStrengthPlan(exerciseType);
  const planSetsEl = document.getElementById(`${exerciseType}-plan-sets`);
  const planNoteEl = document.getElementById(`${exerciseType}-plan-note`);
  const progressEl = document.getElementById(`${exerciseType}-plan-progress`);
  const inputEl = document.getElementById(`${exerciseType}-reps`);

  if (planSetsEl) {
    planSetsEl.innerHTML = plan
      .map((reps, idx) => `<span class="training-plan-chip">#${idx + 1}: ${reps}</span>`)
      .join("");
  }
  if (planNoteEl) {
    const weeklyInc = TRAINING_PROGRAM[exerciseType]?.weeklyIncrement || 0;
    planNoteEl.textContent = `Щотижня +${weeklyInc} до першого найменшого підходу.`;
  }
  if (progressEl) {
    const done = getCurrentSessionSetCount(exerciseType);
    progressEl.textContent = `Прогрес сесії: ${done}/5 підходів`;
  }
  if (inputEl) {
    const nextReps = getCurrentSessionPlannedReps(exerciseType);
    inputEl.placeholder = nextReps ? String(nextReps) : "План виконано";
  }
}

function renderRunningPlanCard() {
  const el = document.getElementById("running-plan-note");
  if (!el) return;
  const target = getPlannedRunMinutes();
  el.textContent = `Тиждень ${getTrainingWeek()}: ціль ${target} хв (база 20 хв, +1 хв/тиждень)`;
}

function refreshTrainingProgramUI() {
  renderRunningPlanCard();
  renderTrainingPlanForStrength("pullups");
  renderTrainingPlanForStrength("pushups");
}

function setTrainingWeekStatus(exerciseType, done, details = "") {
  const el = document.getElementById(`${exerciseType}-week-status`);
  if (!el) return;
  el.className = `training-week-status ${done ? "done" : "pending"}`;
  el.textContent = done
    ? `План тижня виконано${details ? ` · ${details}` : ""}`
    : `План тижня не виконано${details ? ` · ${details}` : ""}`;
}

function parseTrainingDateValue(value) {
  if (!value) return null;
  const d = new Date(String(value).trim().replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

function getTrainingWeekRange() {
  const start = parseTrainingDateValue(trainingState.weekStartedAt) || new Date();
  const weekStart = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);
  return { weekStart, weekEnd };
}

function isDateInCurrentTrainingWeek(value) {
  const date = parseTrainingDateValue(value);
  if (!date) return false;
  const { weekStart, weekEnd } = getTrainingWeekRange();
  return date >= weekStart && date <= weekEnd;
}

async function loadWeeklyTrainingStatus() {
  try {
    const res = await fetch("api/training.php?type=sessions&limit=200", {
      cache: "no-store",
    });
    const data = await res.json();
    if (!data.success) return;

    const sessions = (data.data || []).filter(
      (s) => Number(s.is_completed) === 1 && isDateInCurrentTrainingWeek(s.date),
    );

    const runTargetMinutes = getPlannedRunMinutes();
    const runCompleted = sessions.some(
      (s) =>
        s.exercise_type === "running" &&
        Math.round(Number(s.duration_seconds || 0) / 60) >= runTargetMinutes,
    );
    const bestRunMinutes = sessions
      .filter((s) => s.exercise_type === "running")
      .reduce((max, s) => Math.max(max, Math.round(Number(s.duration_seconds || 0) / 60)), 0);
    setTrainingWeekStatus("running", runCompleted, `${bestRunMinutes}/${runTargetMinutes} хв`);

    const pullupsPlan = getCurrentStrengthPlan("pullups");
    const pullupsTargetTotal = pullupsPlan.reduce((sum, n) => sum + n, 0);
    const pullupsCompleted = sessions.some(
      (s) =>
        s.exercise_type === "pullups" &&
        Number(s.sets_count || 0) >= 5 &&
        Number(s.total_reps || 0) >= pullupsTargetTotal,
    );
    const bestPullups = sessions
      .filter((s) => s.exercise_type === "pullups")
      .reduce((max, s) => Math.max(max, Number(s.total_reps || 0)), 0);
    setTrainingWeekStatus(
      "pullups",
      pullupsCompleted,
      `${bestPullups}/${pullupsTargetTotal} повт.`,
    );

    const pushupsPlan = getCurrentStrengthPlan("pushups");
    const pushupsTargetTotal = pushupsPlan.reduce((sum, n) => sum + n, 0);
    const pushupsCompleted = sessions.some(
      (s) =>
        s.exercise_type === "pushups" &&
        Number(s.sets_count || 0) >= 5 &&
        Number(s.total_reps || 0) >= pushupsTargetTotal,
    );
    const bestPushups = sessions
      .filter((s) => s.exercise_type === "pushups")
      .reduce((max, s) => Math.max(max, Number(s.total_reps || 0)), 0);
    setTrainingWeekStatus(
      "pushups",
      pushupsCompleted,
      `${bestPushups}/${pushupsTargetTotal} повт.`,
    );
  } catch (e) {
    console.error("Помилка завантаження статусу тижневого плану:", e);
  }
}

// Завантаження налаштувань тренувань
async function loadTrainingSettings() {
  try {
    const res = await fetch("api/training.php?type=settings");
    const data = await res.json();
    if (data.success && data.data) {
      trainingState.currentWeek = Number(data.data.current_week || 1);
      trainingState.runDurationMinutes = Number(data.data.run_duration_minutes || 20);
      trainingState.weekStartedAt = data.data.week_started_at || null;
      document.getElementById("training-current-week").textContent =
        trainingState.currentWeek;
      document.getElementById("training-run-duration").textContent =
        trainingState.runDurationMinutes + " хв";
      refreshTrainingProgramUI();
      loadWeeklyTrainingStatus();
    }
  } catch (e) {
    console.error("Помилка завантаження налаштувань тренувань:", e);
  }
}

// Завантаження сесій за сьогодні
async function loadTodaySessions(exerciseType) {
  try {
    const res = await fetch(
      `api/training.php?type=today&exercise=${exerciseType}`,
    );
    const data = await res.json();
    if (data.success) {
      const sessions = data.data || [];
      displayTodaySessions(exerciseType, sessions);
      if (exerciseType === "pullups" || exerciseType === "pushups") {
        const activeSession = sessions.find((s) => !Number(s.is_completed));
        if (exerciseType === "pullups") {
          currentPullupsSessionId = activeSession ? Number(activeSession.id) : null;
          if (currentPullupsSessionId) {
            loadCurrentSessionSets("pullups", currentPullupsSessionId);
          }
        } else {
          currentPushupsSessionId = activeSession ? Number(activeSession.id) : null;
          if (currentPushupsSessionId) {
            loadCurrentSessionSets("pushups", currentPushupsSessionId);
          }
        }
      }
    }
  } catch (e) {
    console.error("Помилка завантаження сесій:", e);
  }
}

// Відображення сесій за сьогодні
function displayTodaySessions(exerciseType, sessions) {
  const container = document.getElementById(`${exerciseType}-today-sessions`);
  if (!container) return;

  if (sessions.length === 0) {
    container.innerHTML = "";
    return;
  }

  const typeLabels = {
    running: "Біг",
    pullups: "Підтягування",
    pushups: "Віджимання",
  };

  let html = '<div class="training-today-title">Сьогодні</div>';
  sessions.forEach((session) => {
    let result = "";
    if (exerciseType === "running") {
      result = escapeHtml(session.duration_formatted || "00:00:00");
    } else {
      result = `${Number(session.sets_count || 0)} підх. / ${Number(session.total_reps || 0)} повт.`;
    }

    html += `
            <div class="training-session-card" data-session-id="${session.id}">
                <div class="training-session-info">
                    <span class="training-session-result">${result}</span>
                </div>
                <span class="training-session-time">${session.is_completed ? "✓ Завершено" : "В процесі"}</span>
            </div>
        `;
  });

  container.innerHTML = html;
}

// ===== ТАЙМЕР БІГУ =====

// Відновлення стану таймера з localStorage
function restoreRunTimerState() {
  const saved = localStorage.getItem("runTimerState");
  if (saved) {
    try {
      const state = JSON.parse(saved);
      runTimerSeconds = state.seconds || 0;
      runTimerRunning = state.running || false;
      runSessionId = state.sessionId || null;

      // Якщо таймер був запущений, обчислити пройдений час
      if (runTimerRunning && state.startTime) {
        const elapsed = Math.floor((Date.now() - state.startTime) / 1000);
        runTimerSeconds += elapsed;
      }

      updateTimerDisplay();
      updateTimerButtons();

      // Якщо таймер був запущений, продовжити
      if (runTimerRunning) {
        runTimerInterval = setInterval(timerTick, 1000);
      }
    } catch (e) {
      console.error("Помилка відновлення таймера:", e);
      clearRunTimerState();
    }
  }
}

// Збереження стану таймера
function saveRunTimerState() {
  const state = {
    seconds: runTimerSeconds,
    running: runTimerRunning,
    sessionId: runSessionId,
    startTime: runTimerRunning ? Date.now() : null,
  };
  localStorage.setItem("runTimerState", JSON.stringify(state));
}

// Очищення стану таймера
function clearRunTimerState() {
  localStorage.removeItem("runTimerState");
  runTimerSeconds = 0;
  runTimerRunning = false;
  runSessionId = null;
}

// Оновлення дисплея таймера
function updateTimerDisplay() {
  const hours = Math.floor(runTimerSeconds / 3600);
  const minutes = Math.floor((runTimerSeconds % 3600) / 60);
  const seconds = runTimerSeconds % 60;

  const display = document.getElementById("run-timer-display");
  if (display) {
    display.textContent =
      String(hours).padStart(2, "0") +
      ":" +
      String(minutes).padStart(2, "0") +
      ":" +
      String(seconds).padStart(2, "0");
  }
}

// Оновлення кнопок таймера
function updateTimerButtons() {
  const startBtn = document.getElementById("run-timer-start");
  const pauseBtn = document.getElementById("run-timer-pause");
  const resumeBtn = document.getElementById("run-timer-resume");
  const stopBtn = document.getElementById("run-timer-stop");

  if (runTimerRunning) {
    // Таймер працює
    if (startBtn) startBtn.style.display = "none";
    if (pauseBtn) pauseBtn.style.display = "flex";
    if (resumeBtn) resumeBtn.style.display = "none";
    if (stopBtn) stopBtn.style.display = "flex";
  } else if (runTimerSeconds > 0) {
    // Таймер на паузі
    if (startBtn) startBtn.style.display = "none";
    if (pauseBtn) pauseBtn.style.display = "none";
    if (resumeBtn) resumeBtn.style.display = "flex";
    if (stopBtn) stopBtn.style.display = "flex";
  } else {
    // Таймер не запущений
    if (startBtn) startBtn.style.display = "flex";
    if (pauseBtn) pauseBtn.style.display = "none";
    if (resumeBtn) resumeBtn.style.display = "none";
    if (stopBtn) stopBtn.style.display = "none";
  }
}

// Тік таймера
function timerTick() {
  runTimerSeconds++;
  updateTimerDisplay();
  // Зберігаємо стан кожні 5 секунд
  if (runTimerSeconds % 5 === 0) {
    saveRunTimerState();
  }
}

// Старт таймера
async function startRunTimer() {
  try {
    // Створити сесію
    const res = await fetch("api/training.php?type=session", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ exercise_type: "running" }),
    });
    const data = await res.json();

    if (!data.success) {
      showMessage(data.error || "Помилка створення сесії", "error");
      return;
    }

    runSessionId = data.data.id;
    runTimerSeconds = 0;
    runTimerRunning = true;

    runTimerInterval = setInterval(timerTick, 1000);

    updateTimerDisplay();
    updateTimerButtons();
    saveRunTimerState();

    showMessage("Біг розпочато!", "success");
  } catch (e) {
    console.error("Помилка старту таймера:", e);
    showMessage("Помилка старту", "error");
  }
}

// Пауза таймера
function pauseRunTimer() {
  runTimerRunning = false;
  if (runTimerInterval) {
    clearInterval(runTimerInterval);
    runTimerInterval = null;
  }
  updateTimerButtons();
  saveRunTimerState();
}

// Продовження таймера
function resumeRunTimer() {
  runTimerRunning = true;
  runTimerInterval = setInterval(timerTick, 1000);
  updateTimerButtons();
  saveRunTimerState();
}

// Зупинка таймера (завершення)
async function stopRunTimer() {
  if (runTimerInterval) {
    clearInterval(runTimerInterval);
    runTimerInterval = null;
  }

  try {
    // Оновити сесію в БД
    if (runSessionId) {
      const res = await fetch("api/training.php?type=session", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: runSessionId,
          duration_seconds: runTimerSeconds,
          is_completed: true,
        }),
      });
      const data = await res.json();

      if (data.success) {
        showMessage(
          "Тренування завершено! Час: " + formatDuration(runTimerSeconds),
          "success",
        );
      }
    }

    // Очистити таймер
    clearRunTimerState();
    updateTimerDisplay();
    updateTimerButtons();

    // Оновити список сесій
    loadTodaySessions("running");
    loadWeeklyTrainingStatus();
  } catch (e) {
    console.error("Помилка збереження сесії:", e);
    showMessage("Помилка збереження", "error");
  }
}

// Форматування тривалості
function formatDuration(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return (
    String(h).padStart(2, "0") +
    ":" +
    String(m).padStart(2, "0") +
    ":" +
    String(s).padStart(2, "0")
  );
}

// ===== ПІДХОДИ (ПІДТЯГУВАННЯ / ВІДЖИМАННЯ) =====

// Додати підхід
async function addSet(exerciseType) {
  const input = document.getElementById(`${exerciseType}-reps`);
  const reps = parseInt(input?.value || 0);
  const currentSetCount = getCurrentSessionSetCount(exerciseType);

  if (currentSetCount >= 5) {
    showMessage("У цій програмі лише 5 підходів за сесію", "error");
    return;
  }

  if (reps < 1) {
    showMessage("Введіть кількість повторів", "error");
    return;
  }

  try {
    // Отримати або створити сесію
    let sessionId =
      exerciseType === "pullups"
        ? currentPullupsSessionId
        : currentPushupsSessionId;

    if (!sessionId) {
      // Створити нову сесію
      const res = await fetch("api/training.php?type=session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ exercise_type: exerciseType }),
      });
      const data = await res.json();

      if (!data.success) {
        showMessage(data.error || "Помилка створення сесії", "error");
        return;
      }

      sessionId = data.data.id;
      if (exerciseType === "pullups") {
        currentPullupsSessionId = sessionId;
      } else {
        currentPushupsSessionId = sessionId;
      }
    }

    // Додати підхід
    const res = await fetch("api/training.php?type=set", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, repetitions: reps }),
    });
    const data = await res.json();

    if (data.success) {
      input.value = "";
      loadCurrentSessionSets(exerciseType, sessionId);
      showMessage(`Підхід додано: ${reps} повторів`, "success");
      renderTrainingPlanForStrength(exerciseType);
    } else {
      showMessage(data.error || "Помилка додавання", "error");
    }
  } catch (e) {
    console.error("Помилка додавання підходу:", e);
    showMessage("Помилка додавання підходу", "error");
  }
}

// Завантажити підходи поточної сесії
async function loadCurrentSessionSets(exerciseType, sessionId) {
  try {
    const res = await fetch(
      `api/training.php?type=sets&session_id=${sessionId}`,
    );
    const data = await res.json();

    if (data.success) {
      displayCurrentSessionSets(exerciseType, data.data || []);
    }
  } catch (e) {
    console.error("Помилка завантаження підходів:", e);
  }
}

// Відобразити підходи поточної сесії
function displayCurrentSessionSets(exerciseType, sets) {
  const container = document.getElementById(`${exerciseType}-sets-list`);
  const actionsContainer = document.getElementById(
    `${exerciseType}-session-actions`,
  );

  if (!container) return;

  if (sets.length === 0) {
    container.innerHTML =
      '<div style="color: rgba(255,255,255,0.5); font-size: 13px;">Ще немає підходів</div>';
    if (actionsContainer) actionsContainer.style.display = "none";
    return;
  }

  let html = "";
  sets.forEach((set) => {
    html += `
            <div class="training-set-item" data-set-id="${set.id}">
                <span class="training-set-number">#${set.set_number}</span>
                <span class="training-set-reps">${set.repetitions}</span>
                <button class="training-set-delete" onclick="deleteSet(${set.id}, '${exerciseType}')">×</button>
            </div>
        `;
  });

  container.innerHTML = html;
  if (actionsContainer) actionsContainer.style.display = "block";
  renderTrainingPlanForStrength(exerciseType);
}

// Видалити підхід
async function deleteSet(setId, exerciseType) {
  try {
    const res = await fetch("api/training.php?type=set", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: setId }),
    });
    const data = await res.json();

    if (data.success) {
      const sessionId =
        exerciseType === "pullups"
          ? currentPullupsSessionId
          : currentPushupsSessionId;
      if (sessionId) {
        loadCurrentSessionSets(exerciseType, sessionId);
      }
      showMessage("Підхід видалено", "success");
      renderTrainingPlanForStrength(exerciseType);
    } else {
      showMessage(data.error || "Помилка видалення", "error");
    }
  } catch (e) {
    console.error("Помилка видалення підходу:", e);
    showMessage("Помилка видалення", "error");
  }
}

// Завершити сесію
async function finishSession(exerciseType) {
  const sessionId =
    exerciseType === "pullups"
      ? currentPullupsSessionId
      : currentPushupsSessionId;

  if (!sessionId) {
    showMessage("Немає активної сесії", "error");
    return;
  }

  try {
    const res = await fetch("api/training.php?type=session", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: sessionId, is_completed: true }),
    });
    const data = await res.json();

    if (data.success) {
      // Скинути поточну сесію
      if (exerciseType === "pullups") {
        currentPullupsSessionId = null;
      } else {
        currentPushupsSessionId = null;
      }

      // Очистити список підходів
      const container = document.getElementById(`${exerciseType}-sets-list`);
      if (container) {
        container.innerHTML =
          '<div style="color: rgba(255,255,255,0.5); font-size: 13px;">Ще немає підходів</div>';
      }
      const actionsContainer = document.getElementById(
        `${exerciseType}-session-actions`,
      );
      if (actionsContainer) actionsContainer.style.display = "none";

      // Оновити список сесій за сьогодні
      loadTodaySessions(exerciseType);
      renderTrainingPlanForStrength(exerciseType);
      loadWeeklyTrainingStatus();

      showMessage("Тренування завершено!", "success");
    } else {
      showMessage(data.error || "Помилка завершення", "error");
    }
  } catch (e) {
    console.error("Помилка завершення сесії:", e);
    showMessage("Помилка завершення", "error");
  }
}

// ===== ІСТОРІЯ ТРЕНУВАНЬ =====

let currentHistoryFilter = "all";

// Завантажити історію
async function loadTrainingHistory(filter = "all") {
  try {
    let url = "api/training.php?type=sessions";
    if (filter !== "all") {
      url += `&exercise=${filter}`;
    }

    const res = await fetch(url);
    const data = await res.json();

    if (data.success) {
      displayTrainingHistory(data.data || []);
    }
  } catch (e) {
    console.error("Помилка завантаження історії:", e);
  }
}

// Відобразити історію
function displayTrainingHistory(sessions) {
  const tbody = document.getElementById("training-history-tbody");
  if (!tbody) return;

  const sortedSessions = [...sessions];
  if (currentSortField === "date") {
    sortedSessions.sort((a, b) => {
      const da = new Date(a.date || a.date_formatted || 0).getTime();
      const db = new Date(b.date || b.date_formatted || 0).getTime();
      const cmp = da - db;
      return currentSortOrder === "ASC" ? cmp : -cmp;
    });
  }

  if (sortedSessions.length === 0) {
    tbody.innerHTML =
      '<tr><td colspan="4" style="text-align: center; color: rgba(255,255,255,0.5);">Немає записів</td></tr>';
    return;
  }

  const typeLabels = {
    running: "Біг",
    pullups: "Підтягування",
    pushups: "Віджимання",
  };

  let html = "";
  sortedSessions.forEach((session) => {
    let result = "";
    if (session.exercise_type === "running") {
      result = session.duration_formatted || "00:00:00";
    } else {
      result = `${Number(session.sets_count || 0)} підходів, ${Number(session.total_reps || 0)} повторів`;
    }
    const safeDate = escapeHtml(session.date_formatted || "");
    const safeType = escapeHtml(
      typeLabels[session.exercise_type] || session.exercise_type || "",
    );
    const safeResult = escapeHtml(result);

    html += `
            <tr data-session-id="${session.id}">
                <td class="col-date">${safeDate}</td>
                <td class="col-category">${safeType}</td>
                <td class="col-name">${safeResult} ${session.is_completed ? "" : "(в процесі)"}</td>
                <td class="col-actions">
                    <button class="row-more-btn" data-id="${session.id}" data-type="training-session" data-exercise="${escapeHtml(session.exercise_type || "")}">
                        <i class="ri-more-2-fill"></i>
                    </button>
                </td>
            </tr>
        `;
  });

  tbody.innerHTML = html;
}

function clearCurrentStrengthSessionUI(exerciseType) {
  const sets = document.getElementById(`${exerciseType}-sets-list`);
  if (sets) {
    sets.innerHTML =
      '<div style="color: rgba(255,255,255,0.5); font-size: 13px;">Ще немає підходів</div>';
  }
  const actions = document.getElementById(`${exerciseType}-session-actions`);
  if (actions) actions.style.display = "none";
}

async function deleteTrainingSession(sessionId, exerciseType = "") {
  const id = Number(sessionId);
  const normalizedExercise = String(exerciseType || "").trim();
  if (!id) return;

  showConfirm("Видалити сесію тренування?", async () => {
    try {
      const res = await fetch("api/training.php?type=session", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (!data.success) {
        showMessage(data.error || "Помилка видалення", "error");
        return;
      }

      if (
        normalizedExercise === "running" &&
        Number(runSessionId || 0) === id
      ) {
        clearRunTimerState();
        updateTimerDisplay();
        updateTimerButtons();
      }

      await Promise.all([
        loadTrainingHistory(currentHistoryFilter),
        normalizedExercise ? loadTodaySessions(normalizedExercise) : Promise.resolve(),
        loadWeeklyTrainingStatus(),
      ]);

      if (normalizedExercise === "pullups" && !currentPullupsSessionId) {
        clearCurrentStrengthSessionUI("pullups");
      }
      if (normalizedExercise === "pushups" && !currentPushupsSessionId) {
        clearCurrentStrengthSessionUI("pushups");
      }

      showMessage("Сесію видалено", "success");
    } catch (e) {
      console.error("Помилка видалення сесії:", e);
      showMessage("Помилка видалення", "error");
    }
  });
}

// Фільтр історії
function filterTrainingHistory(filter) {
  currentHistoryFilter = filter;

  // Оновити активну кнопку
  document
    .querySelectorAll(".training-history-filters .filter-button")
    .forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.filter === filter);
    });

  loadTrainingHistory(filter);
}

// Ініціалізація тренувань при перемиканні підвкладки
function initTrainingSubTab(subTabId) {
  if (subTabId === "running") {
    loadTrainingSettings();
    restoreRunTimerState();
    loadTodaySessions("running");
  } else if (subTabId === "pullups") {
    loadTrainingSettings();
    loadTodaySessions("pullups");
    // Ініціалізувати список підходів
    if (currentPullupsSessionId) {
      loadCurrentSessionSets("pullups", currentPullupsSessionId);
    }
    renderTrainingPlanForStrength("pullups");
  } else if (subTabId === "pushups") {
    loadTrainingSettings();
    loadTodaySessions("pushups");
    if (currentPushupsSessionId) {
      loadCurrentSessionSets("pushups", currentPushupsSessionId);
    }
    renderTrainingPlanForStrength("pushups");
  } else if (subTabId === "training-history") {
    loadTrainingHistory(currentHistoryFilter);
  }
}

async function addNextPlannedSet(exerciseType) {
  const nextReps = getCurrentSessionPlannedReps(exerciseType);
  if (!nextReps) {
    showMessage("План на 5 підходів вже виконано", "success");
    return;
  }
  const input = document.getElementById(`${exerciseType}-reps`);
  if (input) input.value = String(nextReps);
  await addSet(exerciseType);
}

// ===== KANBAN BOARD =====
let kanbanTasks = [];

// Ініціалізація Kanban
function initKanban() {
  // Обробники для drag-and-drop
  const kanbanCards = document.querySelectorAll('.kanban-cards');

  kanbanCards.forEach(container => {
    container.addEventListener('dragover', handleDragOver);
    container.addEventListener('drop', handleDrop);
    container.addEventListener('dragenter', handleDragEnter);
    container.addEventListener('dragleave', handleDragLeave);
  });

  // Обробники для кнопок додавання карток
  document.querySelectorAll('.kanban-add-card').forEach(btn => {
    btn.addEventListener('click', function () {
      const status = this.getAttribute('data-status');
      showAddTaskPanelWithStatus(status);
    });
  });
}

// Мапінг статусів Kanban до статусів бази
const kanbanStatusMap = {
  'todo': ['Очікування', 'Нова'],
  'in-progress': ['В роботі', 'Активна'],
  'in-review': ['На перевірці', 'Ревью'],
  'done': ['Завершено', 'Виконано']
};

// Зворотній мапінг (для збереження)
const reverseStatusMap = {
  'todo': 'Очікування',
  'in-progress': 'В роботі',
  'in-review': 'На перевірці',
  'done': 'Завершено'
};

// Рендеринг Kanban-дошки
async function renderKanbanBoard() {
  try {
    const response = await fetch('api/tasks.php');
    const data = await response.json();

    if (data.success) {
      kanbanTasks = data.data || [];
      renderKanbanCards();
    } else {
      console.error('Помилка завантаження задач:', data.error);
    }
  } catch (error) {
    console.error('Помилка завантаження Kanban:', error);
  }
}

// Рендеринг карток по колонках
function renderKanbanCards() {
  // Очищуємо колонки
  document.getElementById('kanban-todo').innerHTML = '';
  document.getElementById('kanban-progress').innerHTML = '';
  document.getElementById('kanban-review').innerHTML = '';
  document.getElementById('kanban-done').innerHTML = '';

  // Лічильники
  let todoCount = 0, progressCount = 0, reviewCount = 0, doneCount = 0;

  kanbanTasks.forEach(task => {
    const column = getKanbanColumn(task.status);
    const card = createKanbanCard(task);

    if (column === 'todo') {
      document.getElementById('kanban-todo').appendChild(card);
      todoCount++;
    } else if (column === 'in-progress') {
      document.getElementById('kanban-progress').appendChild(card);
      progressCount++;
    } else if (column === 'in-review') {
      document.getElementById('kanban-review').appendChild(card);
      reviewCount++;
    } else {
      document.getElementById('kanban-done').appendChild(card);
      doneCount++;
    }
  });

  // Оновлюємо лічильники
  document.getElementById('todo-count').textContent = todoCount;
  document.getElementById('progress-count').textContent = progressCount;
  document.getElementById('review-count').textContent = reviewCount;
  document.getElementById('done-count').textContent = doneCount;
}

// Визначення колонки за статусом
function getKanbanColumn(status) {
  status = (status || '').toLowerCase();

  for (const [column, statuses] of Object.entries(kanbanStatusMap)) {
    if (statuses.some(s => status.includes(s.toLowerCase()))) {
      return column;
    }
  }

  // За замовчуванням — todo
  return 'todo';
}

// Створення картки Kanban
function createKanbanCard(task) {
  const card = document.createElement('div');
  card.className = 'kanban-card';
  card.setAttribute('draggable', 'true');
  card.dataset.id = task.id;

  // Визначаємо пріоритет
  const priority = (task.priority || 'medium').toLowerCase();
  const priorityLabel = priority === 'high' ? 'Високий' : priority === 'low' ? 'Низький' : 'Середній';

  // Теги
  const tags = task.tags ? task.tags.split(',').map(t => t.trim()).filter(t => t) : [];
  const tagsHtml = tags.slice(0, 3).map(tag =>
    `<span class="kanban-tag">${escapeHtml(tag)}</span>`
  ).join('');

  // Форматування дати
  const dueDate = task.time_limit ? formatDate(task.time_limit) : '';

  card.innerHTML = `
        <div class="kanban-card-header">
            <span class="priority-badge ${priority}">${priorityLabel}</span>
            <button class="kanban-card-menu">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="1"></circle>
                    <circle cx="12" cy="5" r="1"></circle>
                    <circle cx="12" cy="19" r="1"></circle>
                </svg>
            </button>
        </div>
        ${tagsHtml ? `<div class="kanban-card-tags">${tagsHtml}</div>` : ''}
        <div class="kanban-card-title">${escapeHtml(task.title || '')}</div>
        ${task.description ? `<div class="kanban-card-description">${escapeHtml(task.description)}</div>` : ''}
        <div class="kanban-card-footer">
            <div class="kanban-card-avatars">
                <div class="kanban-avatar">
                    <img src="src/images/profile-avatar.png" alt="avatar">
                </div>
            </div>
            <div class="kanban-card-meta">
                ${dueDate ? `
                <div class="kanban-card-date">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    ${dueDate}
                </div>` : ''}
            </div>
        </div>
    `;

  // Drag events
  card.addEventListener('dragstart', handleDragStart);
  card.addEventListener('dragend', handleDragEnd);

  // Клік для редагування
  card.addEventListener('click', function (e) {
    if (e.target.closest('.kanban-card-menu')) return;
    openTaskEditFromKanban(task.id);
  });

  return card;
}

// Format date helper
function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString('uk-UA', { day: '2-digit', month: 'short' });
}

// Escape HTML
function escapeHtml2(text) {
  if (text === null || text === undefined) return '';
  const div = document.createElement('div');
  div.textContent = String(text);
  return div.innerHTML;
}
const escapeHTML = escapeHtml;

function escapeAttr(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function sanitizeClassName2(value) {
  return String(value ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9_-]/g, "")
    .slice(0, 40) || "active";
}

// Drag & Drop handlers
let draggedCard = null;

function handleDragStart(e) {
  draggedCard = this;
  this.classList.add('dragging');
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('text/plain', this.dataset.id);
}

function handleDragEnd(e) {
  this.classList.remove('dragging');
  document.querySelectorAll('.kanban-cards').forEach(c => c.classList.remove('drag-over'));
  draggedCard = null;
}

function handleDragOver(e) {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
}

function handleDragEnter(e) {
  e.preventDefault();
  this.classList.add('drag-over');
}

function handleDragLeave(e) {
  this.classList.remove('drag-over');
}

async function handleDrop(e) {
  e.preventDefault();
  this.classList.remove('drag-over');

  if (!draggedCard) return;

  const taskId = draggedCard.dataset.id;
  const newStatus = this.getAttribute('data-status');
  const dbStatus = reverseStatusMap[newStatus] || 'Очікування';

  // Переміщуємо картку візуально
  this.appendChild(draggedCard);

  // Оновлюємо на сервері
  try {
    const response = await fetch('api/tasks.php', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(taskId), status: dbStatus })
    });

    const data = await response.json();

    if (data.success) {
      // Оновлюємо лічильники
      renderKanbanBoard();
    } else {
      showMessage(data.error || 'Помилка оновлення статусу', 'error');
      renderKanbanBoard(); // Перерендерюємо для відновлення
    }
  } catch (error) {
    console.error('Помилка оновлення:', error);
    showMessage('Помилка оновлення статусу', 'error');
    renderKanbanBoard();
  }
}

// Відкриття редагування задачі з Kanban
function openTaskEditFromKanban(taskId) {
  fetch(`api/tasks.php?id=${taskId}`)
    .then(r => r.json())
    .then(res => {
      if (res && res.success && res.data) {
        showEditTaskPanel(res.data);
      } else {
        showMessage('Помилка завантаження завдання', 'error');
      }
    })
    .catch(() => showMessage('Помилка завантаження завдання', 'error'));
}

// Показ панелі додавання завдання з вибраним статусом
function showAddTaskPanelWithStatus(status) {
  void status;
  showAddTaskPanel();
}

// ===== OVERVIEW DASHBOARD HUB ("Сьогодні") =====
let cachedUserProfile = null;

const DAILY_QUOTES = [
  { text: "Завжди здається неможливим, поки це не зроблено.", author: "Нельсон Мандела" },
  { text: "Майбутнє належить тим, хто вірить у красу своїх мрій.", author: "Елеонора Рузвельт" },
  { text: "Справа не в тому, щоб мати час, а в тому, щоб створювати його.", author: "Стів Джобс" },
  { text: "Найкращий спосіб передбачити майбутнє — це створити його.", author: "Пітер Друкер" },
  { text: "Усе в наших руках, тому їх не можна опускати.", author: "Коко Шанель" },
  { text: "Нічого не втрачено, поки не втрачено віру в себе.", author: "Григорій Сковорода" },
  { text: "Дисципліна — це міст між цілями та їх досягненням.", author: "Джим Рон" },
  { text: "Успіх — це здатність рухатися від однієї невдачі до іншої, не втрачаючи ентузіазму.", author: "Вінстон Черчилль" },
  { text: "Великі справи складаються з малих кроків, зроблених щодня.", author: "Лао-Цзи" },
  { text: "Тільки той, хто робить спроби зробити неможливе, здатний досягти більшого.", author: "Альберт Ейнштейн" },
  { text: "Лише той щасливий, хто зумів поєднати своє покликання з працею.", author: "Василь Стус" },
  { text: "Не важливо, як повільно ти рухаєшся, головне — не зупинятися.", author: "Конфуцій" },
  { text: "Наша найбільша слабкість полягає в тому, що ми здаємося. Найвідоміший шлях до успіху — спробувати ще раз.", author: "Томас Едісон" },
  { text: "Мрій так, ніби житимеш вічно. Живи так, ніби помреш сьогодні.", author: "Джеймс Дін" },
  { text: "Справжній успіх — це знайти свою справу та вкласти в неї душу.", author: "Ілон Маск" },
  { text: "Краще запалити одну маленьку свічку, ніж усе життя проклинати темряву.", author: "Конфуцій" },
  { text: "Борітеся — побороте! Вам Бог помагає!", author: "Тарас Шевченко" },
  { text: "Щоб дійти до мети, треба перш за все йти.", author: "Оноре де Бальзак" },
  { text: "Складні часи створюють сильних людей.", author: "Марк Аврелій" },
  { text: "Твоє життя вимірюється не кількістю подихів, а моментами, від яких захоплює дух.", author: "Майя Енджелоу" },
  { text: "Успіх — це сума маленьких зусиль, які повторюються день у день.", author: "Роберт Кольєр" },
  { text: "Зроби сьогодні те, що інші не хочуть, і завтра житимеш так, як інші не можуть.", author: "Джеррі Райс" },
  { text: "Навіть найдовша дорога починається з першого кроку.", author: "Сенека" },
  { text: "Хто хоче — шукає можливості, хто не хоче — шукає причини.", author: "Сократ" },
  { text: "Працюй мовчки, нехай твій успіх стане твоїм шумом.", author: "Френк Оушен" },
  { text: "Не чекайте ідеального моменту. Беріть момент і робіть його ідеальним.", author: "Генрі Форд" },
  { text: "Справжня сила проявляється у спокої та впевненості у своїх діях.", author: "Леся Українка" },
  { text: "Енергія та наполегливість долають усе.", author: "Бенджамін Франклін" },
  { text: "Сфокусуйся на процесі, і результат не змусить себе чекати.", author: "Нікола Тесла" },
  { text: "Ти спроможний на більше, ніж ти думаєш.", author: "Марк Твен" }
];

function updateDailyQuote() {
  const quoteTextEl = document.getElementById("dashboard-quote-text");
  const quoteAuthorEl = document.getElementById("dashboard-quote-author");
  if (!quoteTextEl || !quoteAuthorEl) return;

  const now = new Date();
  const startOfYear = new Date(now.getFullYear(), 0, 0);
  const diff = now - startOfYear;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);

  const quoteIndex = dayOfYear % DAILY_QUOTES.length;
  const selectedQuote = DAILY_QUOTES[quoteIndex];

  quoteTextEl.textContent = `"${selectedQuote.text}"`;
  quoteAuthorEl.textContent = `— ${selectedQuote.author}`;
}

async function updateDashboardGreeting() {
  updateDailyQuote();
  const greetingEl = document.getElementById("dashboard-greeting");
  const dateEl = document.getElementById("dashboard-date");

  if (dateEl) {
    const now = new Date();
    const days = ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"];
    const months = [
      "січня", "лютого", "березня", "квітня", "травня", "червня",
      "липня", "серпня", "вересня", "жовтня", "листопада", "грудня"
    ];
    const dayName = days[now.getDay()];
    const dayNum = now.getDate();
    const monthName = months[now.getMonth()];
    const year = now.getFullYear();
    dateEl.textContent = `${dayName}, ${dayNum} ${monthName} ${year} р.`;
  }

  if (greetingEl) {
    const hour = new Date().getHours();
    let timeGreeting = "Доброго дня";
    if (hour >= 5 && hour < 12) timeGreeting = "Доброго ранку";
    else if (hour >= 12 && hour < 18) timeGreeting = "Доброго дня";
    else if (hour >= 18 && hour < 23) timeGreeting = "Доброго вечора";
    else timeGreeting = "Доброї ночі";

    let userName = "";
    if (cachedUserProfile) {
      userName = cachedUserProfile.nickname || cachedUserProfile.username || "";
    } else {
      try {
        const res = await fetch(`api/profile.php?_=${Date.now()}`);
        const data = await res.json();
        if (data && data.success && data.data) {
          cachedUserProfile = data.data;
          userName = data.data.nickname || data.data.username || "";
        }
      } catch (_) {}
    }

    greetingEl.textContent = userName ? `${timeGreeting}, ${userName}! 👋` : `${timeGreeting}! 👋`;
  }
}

async function loadDashboard() {
  updateDashboardGreeting();
  initDashboardEvents();

  try {
    const res = await fetch("api/statistics.php", { cache: "no-store" });
    const json = await res.json();
    const data = (json && json.success && json.data) ? json.data : {};

    const tasks = Array.isArray(data.tasks) ? data.tasks : [];
    const projects = Array.isArray(data.projects) ? data.projects : [];
    const finances = data.finances || {};
    const goals = Array.isArray(data.goals) ? data.goals : [];
    const training = Array.isArray(data.training) ? data.training : [];

    // Datetime calculations
    const now = new Date();
    const nowIso = now.toISOString().slice(0, 10); // "YYYY-MM-DD"

    // 1. Tasks KPI & Today tasks
    const activeTasks = tasks.filter((t) => parseInt(t.done) === 0);
    const todayTasks = activeTasks.filter((t) => {
      if (!t.due_at) return false;
      let datePart = "";
      if (t.due_at.includes(".")) {
        const parts = t.due_at.split(" ")[0].split(".");
        if (parts.length === 3) {
          datePart = `${parts[2]}-${parts[1].padStart(2, "0")}-${parts[0].padStart(2, "0")}`;
        }
      } else {
        datePart = t.due_at.slice(0, 10);
      }
      return datePart && datePart <= nowIso;
    });

    const kpiTodayTasks = document.getElementById("dash-kpi-today-tasks");
    const kpiTotalActiveTasks = document.getElementById("dash-kpi-total-active-tasks");
    if (kpiTodayTasks) kpiTodayTasks.textContent = todayTasks.length;
    if (kpiTotalActiveTasks) kpiTotalActiveTasks.textContent = `Всього активних: ${activeTasks.length}`;

    // 2. Active Projects KPI
    const activeProjects = projects.filter(
      (p) => p.status !== "Завершено" && p.status !== "Архів"
    );
    const kpiActiveProjects = document.getElementById("dash-kpi-active-projects");
    const kpiTotalProjects = document.getElementById("dash-kpi-total-projects");
    if (kpiActiveProjects) kpiActiveProjects.textContent = activeProjects.length;
    if (kpiTotalProjects) kpiTotalProjects.textContent = `Всього проєктів: ${projects.length}`;

    // 3. Finances KPI (Current Month)
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();
    const incomes = Array.isArray(finances.incomes) ? finances.incomes : [];
    const expenses = Array.isArray(finances.expenses) ? finances.expenses : [];

    let monthIncome = 0;
    incomes.forEach((inc) => {
      if (inc.date) {
        const d = new Date(inc.date);
        if (d.getMonth() + 1 === currentMonth && d.getFullYear() === currentYear) {
          monthIncome += parseFloat(inc.amount) || 0;
        }
      }
    });

    let monthExpense = 0;
    expenses.forEach((exp) => {
      if (exp.date) {
        const d = new Date(exp.date);
        if (d.getMonth() + 1 === currentMonth && d.getFullYear() === currentYear) {
          monthExpense += parseFloat(exp.amount) || 0;
        }
      }
    });

    const monthBalance = monthIncome - monthExpense;
    const kpiFinanceBalance = document.getElementById("dash-kpi-finance-balance");
    const kpiFinanceSubtext = document.getElementById("dash-kpi-finance-subtext");
    if (kpiFinanceBalance) {
      kpiFinanceBalance.textContent = `${monthBalance >= 0 ? "+" : ""}${Math.round(monthBalance).toLocaleString("uk-UA")} ₴`;
      kpiFinanceBalance.className = `kpi-value ${monthBalance >= 0 ? "text-success" : "text-danger"}`;
    }
    if (kpiFinanceSubtext) {
      kpiFinanceSubtext.textContent = `Доходи: +${Math.round(monthIncome).toLocaleString("uk-UA")} ₴ | Витрати: -${Math.round(monthExpense).toLocaleString("uk-UA")} ₴`;
    }

    // 4. Goals KPI
    const activeGoals = goals.filter(
      (g) => g.status !== "Виконано" && g.status !== "Скасовано"
    );
    let avgProgress = 0;
    if (activeGoals.length > 0) {
      const sumProg = activeGoals.reduce(
        (acc, g) => acc + (parseFloat(g.progress_percent) || 0),
        0
      );
      avgProgress = Math.round(sumProg / activeGoals.length);
    }
    const kpiActiveGoals = document.getElementById("dash-kpi-active-goals");
    const kpiGoalsProgress = document.getElementById("dash-kpi-goals-progress");
    if (kpiActiveGoals) kpiActiveGoals.textContent = activeGoals.length;
    if (kpiGoalsProgress) kpiGoalsProgress.textContent = `Сер. прогрес: ${avgProgress}%`;

    // Render Widgets
    renderDashTodayTasks(activeTasks);
    renderDashActiveProjects(activeProjects);
    renderDashFinanceSummary(monthIncome, monthExpense, monthBalance);
    renderDashGoals(activeGoals);
    renderDashTraining(training);
  } catch (err) {
    console.error("Error loading dashboard data:", err);
    renderDashTodayTasks([]);
    renderDashActiveProjects([]);
    renderDashFinanceSummary(0, 0, 0);
    renderDashGoals([]);
    renderDashTraining([]);
  }
}

function initDashboardEvents() {
  const addTaskBtn = document.getElementById("dash-btn-add-task");
  if (addTaskBtn && !addTaskBtn.dataset.bound) {
    addTaskBtn.dataset.bound = "true";
    addTaskBtn.addEventListener("click", () => showAddTaskPanel());
  }

  const addProjectBtn = document.getElementById("dash-btn-add-project");
  if (addProjectBtn && !addProjectBtn.dataset.bound) {
    addProjectBtn.dataset.bound = "true";
    addProjectBtn.addEventListener("click", () => showAddProjectPanel());
  }

  const addExpenseBtn = document.getElementById("dash-btn-add-expense");
  if (addExpenseBtn && !addExpenseBtn.dataset.bound) {
    addExpenseBtn.dataset.bound = "true";
    addExpenseBtn.addEventListener("click", () => showAddExpensePanel());
  }

  const addGoalBtn = document.getElementById("dash-btn-add-goal");
  if (addGoalBtn && !addGoalBtn.dataset.bound) {
    addGoalBtn.dataset.bound = "true";
    addGoalBtn.addEventListener("click", () => showAddGoalDialog());
  }

  const addTrainingBtn = document.getElementById("dash-btn-add-training");
  if (addTrainingBtn && !addTrainingBtn.dataset.bound) {
    addTrainingBtn.dataset.bound = "true";
    addTrainingBtn.addEventListener("click", () => switchTab("training"));
  }

  document.querySelectorAll("[data-tab-target]").forEach((el) => {
    if (!el.dataset.bound) {
      el.dataset.bound = "true";
      el.addEventListener("click", (e) => {
        const targetTab = el.getAttribute("data-tab-target");
        if (targetTab) switchTab(targetTab);
      });
    }
  });
}

function renderDashTodayTasks(tasks) {
  const container = document.getElementById("dash-today-tasks-list");
  if (!container) return;

  if (!tasks || tasks.length === 0) {
    container.innerHTML = `
      <div class="dash-empty-state">
        <i class="ri-checkbox-circle-line"></i>
        <span>Немає активних завдань 🎉</span>
      </div>`;
    return;
  }

  const html = tasks
    .map((t) => {
      const isOverdue = t.due_at && t.due_at < new Date().toISOString().slice(0, 10);
      const hasTimer = t.timer_started_at !== null && t.timer_started_at !== undefined && t.timer_started_at !== "";
      const elapsedSeconds = Number(t.timer_elapsed_seconds || 0);
      const timeLimitMinutes = Number(t.time_limit_minutes || 0);
      const autoComplete = Boolean(t.auto_complete);

      const timerText = formatTimer(
        elapsedSeconds,
        hasTimer,
        t.id,
        t.timer_started_timestamp,
        timeLimitMinutes,
        autoComplete
      );

      let timerBtn = "";
      if (hasTimer) {
        timerBtn = `<button class="dash-timer-btn pause-btn" data-task-id="${t.id}" data-action="pause-timer" title="Призупинити таймер"><i class="ri-pause-fill"></i></button>`;
      } else {
        timerBtn = `<button class="dash-timer-btn start-btn" data-task-id="${t.id}" data-action="start-timer" title="Запустити таймер"><i class="ri-play-fill"></i></button>`;
      }

      const isAllyNote = String(t.source || "").toLowerCase() === "allynote" || (typeof t.tags === "string" && t.tags.toLowerCase().includes("allynote"));
      const allyNoteBadge = isAllyNote ? `<span class="badge-allynote" title="Синхронізовано з AllyNote"><i class="ri-booklet-line"></i> AllyNote</span>` : "";

      return `
      <div class="dash-task-item" data-task-id="${t.id}">
        <div class="dash-task-left">
          <input type="checkbox" class="dash-task-checkbox" data-task-id="${t.id}" title="Позначити виконаним">
          <span class="dash-task-title">${escapeHTML(t.title || "Завдання")} ${allyNoteBadge}</span>
        </div>
        <div class="dash-task-meta">
          ${timerText ? `<span class="dash-task-timer-badge">${timerText}</span>` : ""}
          ${timerBtn}
          ${t.category ? `<span class="dash-task-date">${escapeHTML(t.category)}</span>` : ""}
          ${t.due_at ? `<span class="dash-task-date ${isOverdue ? "overdue" : ""}">${escapeHTML(t.due_at)}</span>` : ""}
        </div>
      </div>`;
    })
    .join("");

  container.innerHTML = html;

  container.querySelectorAll(".dash-task-checkbox").forEach((cb) => {
    cb.addEventListener("change", async (e) => {
      const taskId = e.target.getAttribute("data-task-id");
      if (!taskId) return;
      try {
        const itemEl = e.target.closest(".dash-task-item");
        if (itemEl) itemEl.style.opacity = "0.5";
        await fetch("api/tasks.php", {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: taskId, done: true }),
        });
        showMessage("Завдання виконано! 🎉", "success");
        loadDashboard();
      } catch (err) {
        console.error("Error completing task from dashboard:", err);
      }
    });
  });

  container.querySelectorAll(".dash-timer-btn").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.stopPropagation();
      const taskId = btn.getAttribute("data-task-id");
      const action = btn.getAttribute("data-action");
      if (!taskId || !action) return;

      const serverAction = action === "start-timer" ? "start_timer" : "pause_timer";
      try {
        btn.disabled = true;
        await handleTimer(taskId, serverAction);
        loadDashboard();
      } catch (err) {
        console.error("Timer action error:", err);
      }
    });
  });
}

function renderDashActiveProjects(projects) {
  const container = document.getElementById("dash-active-projects-list");
  if (!container) return;

  if (!projects || projects.length === 0) {
    container.innerHTML = `
      <div class="dash-empty-state">
        <i class="ri-folder-open-line"></i>
        <span>Немає активних проєктів</span>
      </div>`;
    return;
  }

  container.innerHTML = projects
    .map(
      (p) => `
    <div class="dash-project-card">
      <div class="dash-project-name">${escapeHTML(p.name || "Без назви")}</div>
      <span class="dash-project-status">
        <i class="ri-pulse-line"></i> ${escapeHTML(p.status || "В процесі")}
      </span>
    </div>`
    )
    .join("");
}

function renderDashFinanceSummary(income, expense, balance) {
  const container = document.getElementById("dash-finances-summary");
  if (!container) return;

  container.innerHTML = `
    <div class="dash-finance-row">
      <span style="color: var(--text-muted);">Доходи цього місяця:</span>
      <strong class="text-success">+${Math.round(income).toLocaleString("uk-UA")} ₴</strong>
    </div>
    <div class="dash-finance-row">
      <span style="color: var(--text-muted);">Витрати цього місяця:</span>
      <strong class="text-danger">-${Math.round(expense).toLocaleString("uk-UA")} ₴</strong>
    </div>
    <div class="dash-finance-row" style="background: rgba(255,255,255,0.04); font-weight: 600;">
      <span style="color: var(--text-title);">Чистий залишок:</span>
      <strong class="${balance >= 0 ? "text-success" : "text-danger"}">${balance >= 0 ? "+" : ""}${Math.round(balance).toLocaleString("uk-UA")} ₴</strong>
    </div>`;
}

function renderDashGoals(goals) {
  const container = document.getElementById("dash-goals-list");
  if (!container) return;

  if (!goals || goals.length === 0) {
    container.innerHTML = `
      <div class="dash-empty-state">
        <i class="ri-focus-3-line"></i>
        <span>Немає активних цілей</span>
      </div>`;
    return;
  }

  container.innerHTML = goals
    .map((g) => {
      const pct = Math.min(100, Math.max(0, parseFloat(g.progress_percent) || 0));
      const pctColor = getGoalProgressColor(pct);
      return `
      <div class="dash-goal-item">
        <div class="dash-goal-head">
          <span class="dash-goal-title">${escapeHTML(g.title || "Ціль")}</span>
          <span class="dash-goal-percent" style="color: ${pctColor};">${pct}%</span>
        </div>
        <div class="dash-goal-track">
          <div class="dash-goal-fill" style="width: ${pct}%;"></div>
        </div>
      </div>`;
    })
    .join("");
}

function renderDashTraining(sessions) {
  const container = document.getElementById("dash-training-summary");
  if (!container) return;

  if (!sessions || sessions.length === 0) {
    container.innerHTML = `
      <div class="dash-empty-state">
        <i class="ri-run-line"></i>
        <span>Записів тренувань ще немає</span>
      </div>`;
    return;
  }

  container.innerHTML = sessions
    .map(
      (s) => `
    <div class="dash-finance-row">
      <div>
        <strong style="color: var(--text-title);">${escapeHTML(s.exercise_type || "Тренування")}</strong>
        <div style="font-size: 11px; color: var(--text-dim);">${escapeHTML(s.date || "")}</div>
      </div>
      <div style="text-align: right;">
        <span style="color: #60a5fa; font-weight: 600;">${s.total_reps || 0} повт.</span>
        <div style="font-size: 11px; color: var(--text-muted);">${s.sets_count || 0} підходів</div>
      </div>
    </div>`
    )
    .join("");
}

window.addEventListener("bb:data-mutated", () => {
  const currentTab = new URL(window.location).searchParams.get("tab") || "dashboard";
  if (currentTab === "dashboard") {
    loadDashboard();
  } else if (currentTab === "photo-reports") {
    loadPhotoReportsTab();
  }
});

/* ==========================================================================
   PHOTO REPORTS & GALLERY MODULE LOGIC
   ========================================================================== */
let currentPhotoReportType = 'week';
let cachedPhotoStats = null;
let currentGalleryFilter = 'all';

async function loadPhotoReportsTab() {
  try {
    initPhotoReportEvents();
    await refreshPhotoReportPreview();
    await loadPhotoReportsGallery();
  } catch (e) {
    console.error('Error loading photo reports tab:', e);
  }
}

function initPhotoReportEvents() {
  // Segmented control (week / month / year)
  document.querySelectorAll('#report-type-segmented .segment-btn').forEach((btn) => {
    if (!btn.dataset.bound) {
      btn.dataset.bound = 'true';
      btn.addEventListener('click', async () => {
        document.querySelectorAll('#report-type-segmented .segment-btn').forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        currentPhotoReportType = btn.getAttribute('data-report-type') || 'week';
        await refreshPhotoReportPreview();
      });
    }
  });

  // Action buttons
  const btnGenerate = document.getElementById('btn-generate-photo-report');
  if (btnGenerate && !btnGenerate.dataset.bound) {
    btnGenerate.dataset.bound = 'true';
    btnGenerate.addEventListener('click', async () => {
      cachedPhotoStats = null; // force fresh data
      await refreshPhotoReportPreview();
      showMessage('Згенеровано свіжий фотозвіт! ✨', 'success');
    });
  }

  const btnDownload = document.getElementById('btn-download-report-img');
  if (btnDownload && !btnDownload.dataset.bound) {
    btnDownload.dataset.bound = 'true';
    btnDownload.addEventListener('click', () => downloadCurrentPhotoReport());
  }

  const btnSave = document.getElementById('btn-save-report-gallery');
  if (btnSave && !btnSave.dataset.bound) {
    btnSave.dataset.bound = 'true';
    btnSave.addEventListener('click', () => saveCurrentPhotoReportToGallery());
  }

  // Gallery filter chips
  document.querySelectorAll('#gallery-filter-chips .filter-chip').forEach((chip) => {
    if (!chip.dataset.bound) {
      chip.dataset.bound = 'true';
      chip.addEventListener('click', () => {
        document.querySelectorAll('#gallery-filter-chips .filter-chip').forEach((c) => c.classList.remove('active'));
        chip.classList.add('active');
        currentGalleryFilter = chip.getAttribute('data-gallery-filter') || 'all';
        loadPhotoReportsGallery();
      });
    }
  });
}

async function fetchPhotoReportStats() {
  if (cachedPhotoStats) return cachedPhotoStats;
  try {
    const res = await fetch('api/statistics.php', { cache: 'no-store' });
    const json = await res.json();
    if (json && json.success && json.data) {
      cachedPhotoStats = json.data;
      return cachedPhotoStats;
    }
  } catch (e) {
    console.error('Error fetching stats for report:', e);
  }
  return {};
}

async function refreshPhotoReportPreview() {
  try {
    const spinner = document.getElementById('report-preview-spinner');
    if (spinner) spinner.style.opacity = '1';

    const stats = await fetchPhotoReportStats();
    const canvas = document.getElementById('photo-report-canvas');
    if (!canvas) return;

    const dataUrl = drawPhotoReportOnCanvas(canvas, currentPhotoReportType, stats, cachedUserProfile);
    const previewImg = document.getElementById('report-preview-img');
    if (previewImg) {
      previewImg.src = dataUrl;
    }

    if (spinner) {
      setTimeout(() => { spinner.style.opacity = '0'; }, 200);
    }
  } catch (e) {
    console.error('Error refreshing photo report preview:', e);
  }
}

function drawPhotoReportOnCanvas(canvas, type, stats, user) {
  const ctx = canvas.getContext('2d');
  const width = canvas.width;  // 1200
  const height = canvas.height; // 675

  // Background Gradient
  const bgGrad = ctx.createLinearGradient(0, 0, width, height);
  bgGrad.addColorStop(0, '#060a12');
  bgGrad.addColorStop(0.5, '#0f172a');
  bgGrad.addColorStop(1, '#080c16');
  ctx.fillStyle = bgGrad;
  ctx.fillRect(0, 0, width, height);

  // Background Decorative Circles & Glowing Grid
  ctx.save();
  const glowGrad1 = ctx.createRadialGradient(200, 150, 10, 200, 150, 300);
  glowGrad1.addColorStop(0, 'rgba(59, 130, 246, 0.18)');
  glowGrad1.addColorStop(1, 'rgba(59, 130, 246, 0)');
  ctx.fillStyle = glowGrad1;
  ctx.beginPath(); ctx.arc(200, 150, 300, 0, Math.PI * 2); ctx.fill();

  const glowGrad2 = ctx.createRadialGradient(1000, 500, 10, 1000, 500, 350);
  glowGrad2.addColorStop(0, 'rgba(168, 85, 247, 0.16)');
  glowGrad2.addColorStop(1, 'rgba(168, 85, 247, 0)');
  ctx.fillStyle = glowGrad2;
  ctx.beginPath(); ctx.arc(1000, 500, 350, 0, Math.PI * 2); ctx.fill();
  ctx.restore();

  // Canvas Outer Border
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.12)';
  ctx.lineWidth = 4;
  ctx.strokeRect(10, 10, width - 20, height - 20);

  // Header Section - Logo Badge
  ctx.fillStyle = '#3b82f6';
  roundRect(ctx, 50, 42, 180, 32, 6, true, false);
  ctx.font = 'bold 13px system-ui, sans-serif';
  ctx.fillStyle = '#ffffff';
  ctx.textAlign = 'center';
  ctx.fillText('SYNCFLOW', 140, 63);

  // Report Period Badge & Title
  const now = new Date();
  let titleText = 'ПІДСУМКОВИЙ ФОТОЗВІТ';
  let periodText = now.toLocaleDateString('uk-UA', { day: '2-digit', month: 'long', year: 'numeric' });

  if (type === 'week') {
    const weekNum = getWeekNumber(now);
    titleText = `ТИЖНЕВИЙ ЗВІТ (#${weekNum})`;
    periodText = `За тиждень • ${now.getFullYear()} рік`;
  } else if (type === 'month') {
    const monthName = now.toLocaleDateString('uk-UA', { month: 'long' });
    titleText = `МІСЯЧНИЙ ЗВІТ (${monthName.toUpperCase()})`;
    periodText = `${monthName} ${now.getFullYear()}`;
  } else if (type === 'year') {
    titleText = `РІЧНИЙ ПІДСУМОК ${now.getFullYear()}`;
    periodText = `Підсумки за весь ${now.getFullYear()} рік`;
  }

  ctx.textAlign = 'left';
  ctx.font = '900 26px system-ui, sans-serif';
  ctx.fillStyle = '#f8fafc';
  ctx.fillText(titleText, 250, 64);

  ctx.textAlign = 'right';
  ctx.font = '500 15px system-ui, sans-serif';
  ctx.fillStyle = '#94a3b8';
  ctx.fillText(periodText, width - 50, 63);

  // Header Separator Line
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.08)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(50, 95);
  ctx.lineTo(width - 50, 95);
  ctx.stroke();

  // Metrics Data Extraction
  const tasks = Array.isArray(stats.tasks) ? stats.tasks : [];
  const projects = Array.isArray(stats.projects) ? stats.projects : [];
  const finances = stats.finances || {};
  const goals = Array.isArray(stats.goals) ? stats.goals : [];
  const training = Array.isArray(stats.training) ? stats.training : [];

  const completedTasks = tasks.filter(t => parseInt(t.done) === 1).length;
  const activeTasks = tasks.filter(t => parseInt(t.done) === 0).length;
  const activeProjects = projects.filter(p => p.status !== 'Завершено').length;
  const activeGoals = goals.filter(g => g.status !== 'Виконано').length;
  
  let avgGoalProgress = 0;
  if (goals.length > 0) {
    const sumProg = goals.reduce((acc, g) => acc + (parseFloat(g.progress_percent) || 0), 0);
    avgGoalProgress = Math.round(sumProg / goals.length);
  }

  let totalIncome = 0;
  let totalExpense = 0;
  (finances.incomes || []).forEach(inc => { totalIncome += parseFloat(inc.amount) || 0; });
  (finances.expenses || []).forEach(exp => { totalExpense += parseFloat(exp.amount) || 0; });
  const netBalance = totalIncome - totalExpense;

  let totalReps = 0;
  let totalSets = 0;
  training.forEach(s => {
    totalReps += parseInt(s.total_reps) || 0;
    totalSets += parseInt(s.sets_count) || 0;
  });

  // Render 4 Grid Cards
  const cards = [
    {
      title: '📌 ЗАВДАННЯ ТА ФОКУС',
      color: '#3b82f6',
      val1: `${completedTasks}`, lbl1: 'Виконано',
      val2: `${activeTasks}`, lbl2: 'Активних',
      badge: `${tasks.length > 0 ? Math.round((completedTasks/tasks.length)*100) : 0}% Прогрес`
    },
    {
      title: '🚀 ПРОЄКТИ ТА ЦІЛІ',
      color: '#a855f7',
      val1: `${activeProjects}`, lbl1: 'Проєктів в роботі',
      val2: `${activeGoals}`, lbl2: 'Поточних цілей',
      badge: `${avgGoalProgress}% Сер. досягнення`
    },
    {
      title: '💰 ФІНАНСОВИЙ ПІДСУМОК',
      color: '#10b981',
      val1: `${totalIncome >= 0 ? '+' : ''}${Math.round(totalIncome).toLocaleString('uk-UA')} ₴`, lbl1: 'Доходи',
      val2: `-${Math.round(totalExpense).toLocaleString('uk-UA')} ₴`, lbl2: 'Витрати',
      badge: `Баланс: ${netBalance >= 0 ? '+' : ''}${Math.round(netBalance).toLocaleString('uk-UA')} ₴`
    },
    {
      title: '🏋️ СПОРТ ТА ЗДОРОВ\'Я',
      color: '#f59e0b',
      val1: `${training.length}`, lbl1: 'Тренувань',
      val2: `${totalReps}`, lbl2: 'Повторень',
      badge: `${totalSets} Підходів`
    }
  ];

  const colW = 530;
  const rowH = 225;
  const startX = 50;
  const startY = 115;

  cards.forEach((card, idx) => {
    const r = Math.floor(idx / 2);
    const c = idx % 2;
    const x = startX + c * (colW + 40);
    const y = startY + r * (rowH + 20);

    // Card Glass Box
    ctx.fillStyle = 'rgba(15, 23, 42, 0.6)';
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.08)';
    ctx.lineWidth = 1;
    roundRect(ctx, x, y, colW, rowH, 14, true, true);

    // Left accent bar
    ctx.fillStyle = card.color;
    roundRect(ctx, x, y, 6, rowH, { tl: 14, bl: 14, tr: 0, br: 0 }, true, false);

    // Card Title
    ctx.textAlign = 'left';
    ctx.font = 'bold 15px system-ui, sans-serif';
    ctx.fillStyle = '#e2e8f0';
    ctx.fillText(card.title, x + 24, y + 36);

    // Card Badge
    ctx.fillStyle = 'rgba(255, 255, 255, 0.06)';
    roundRect(ctx, x + colW - 170, y + 18, 150, 26, 13, true, false);
    ctx.textAlign = 'center';
    ctx.font = '600 12px system-ui, sans-serif';
    ctx.fillStyle = card.color;
    ctx.fillText(card.badge, x + colW - 95, y + 35);

    // Metric 1
    ctx.textAlign = 'left';
    ctx.font = 'bold 30px system-ui, sans-serif';
    ctx.fillStyle = '#ffffff';
    ctx.fillText(card.val1, x + 24, y + 105);
    ctx.font = '500 13px system-ui, sans-serif';
    ctx.fillStyle = '#94a3b8';
    ctx.fillText(card.lbl1, x + 24, y + 128);

    // Metric 2
    ctx.textAlign = 'left';
    ctx.font = 'bold 30px system-ui, sans-serif';
    ctx.fillStyle = '#ffffff';
    ctx.fillText(card.val2, x + 270, y + 105);
    ctx.font = '500 13px system-ui, sans-serif';
    ctx.fillStyle = '#94a3b8';
    ctx.fillText(card.lbl2, x + 270, y + 128);

    // Progress Bar
    const pbX = x + 24;
    const pbY = y + 165;
    const pbW = colW - 48;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.06)';
    roundRect(ctx, pbX, pbY, pbW, 10, 5, true, false);

    ctx.fillStyle = card.color;
    const fillPct = (idx === 0) ? (tasks.length > 0 ? (completedTasks/tasks.length) : 0) :
                    (idx === 1) ? (avgGoalProgress / 100) :
                    (idx === 2) ? (totalIncome > 0 ? Math.min(1, Math.max(0, netBalance / totalIncome)) : 0.5) : 0.8;
    roundRect(ctx, pbX, pbY, Math.max(12, pbW * fillPct), 10, 5, true, false);
  });

  // Footer Section
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.08)';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.moveTo(50, height - 55);
  ctx.lineTo(width - 50, height - 55);
  ctx.stroke();

  const userName = (user && (user.nickname || user.username)) ? (user.nickname || user.username) : 'SyncFlow User';
  ctx.textAlign = 'left';
  ctx.font = '500 13px system-ui, sans-serif';
  ctx.fillStyle = '#94a3b8';
  ctx.fillText(`👤 Користувач: ${userName}  •  Згенеровано в SyncFlow Hub`, 50, height - 24);

  ctx.textAlign = 'right';
  ctx.font = '500 12px system-ui, sans-serif';
  ctx.fillStyle = '#64748b';
  ctx.fillText(`syncflow.space`, width - 50, height - 24);

  return canvas.toDataURL('image/png');
}

function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
  let r = { tl: 0, tr: 0, br: 0, bl: 0 };
  if (typeof radius === 'number') {
    r = { tl: radius, tr: radius, br: radius, bl: radius };
  } else if (typeof radius === 'object') {
    r = Object.assign(r, radius);
  }
  ctx.beginPath();
  ctx.moveTo(x + r.tl, y);
  ctx.lineTo(x + width - r.tr, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + r.tr);
  ctx.lineTo(x + width, y + height - r.br);
  ctx.quadraticCurveTo(x + width, y + height, x + width - r.br, y + height);
  ctx.lineTo(x + r.bl, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - r.bl);
  ctx.lineTo(x, y + r.tl);
  ctx.quadraticCurveTo(x, y, x + r.tl, y);
  ctx.closePath();
  if (fill) ctx.fill();
  if (stroke) ctx.stroke();
}

function getWeekNumber(d) {
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
}

function downloadCurrentPhotoReport() {
  const previewImg = document.getElementById('report-preview-img');
  if (!previewImg || !previewImg.src) {
    showMessage('Спочатку згенеруйте фотозвіт', 'error');
    return;
  }
  const a = document.createElement('a');
  a.href = previewImg.src;
  a.download = `syncflow_report_${currentPhotoReportType}_${Date.now()}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  showMessage('Зображення фотозвіту завантажено! 📥', 'success');
}

async function saveCurrentPhotoReportToGallery() {
  const previewImg = document.getElementById('report-preview-img');
  if (!previewImg || !previewImg.src) {
    showMessage('Спочатку згенеруйте фотозвіт', 'error');
    return;
  }

  const btnSave = document.getElementById('btn-save-report-gallery');
  if (btnSave) btnSave.disabled = true;

  try {
    const periodLabelMap = {
      week: `Звіт за ${getWeekNumber(new Date())}-й тиждень ${new Date().getFullYear()} р.`,
      month: `Звіт за ${new Date().toLocaleDateString('uk-UA', { month: 'long' })} ${new Date().getFullYear()} р.`,
      year: `Підсумковий звіт за ${new Date().getFullYear()} рік`
    };

    const res = await fetch('api/photo-reports.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        report_type: currentPhotoReportType,
        title: `Фотозвіт (${currentPhotoReportType === 'week' ? 'Тижневий' : currentPhotoReportType === 'month' ? 'Місячний' : 'Річний'})`,
        period_label: periodLabelMap[currentPhotoReportType] || '',
        image_data: previewImg.src,
        stats: cachedPhotoStats
      })
    });

    const json = await res.json();
    if (json && json.success) {
      showMessage(json.message || 'Звіт збережено в галерею! 🖼️', 'success');
      await loadPhotoReportsGallery();
    } else {
      showMessage(json.message || 'Помилка збереження', 'error');
    }
  } catch (e) {
    console.error('Error saving photo report:', e);
    showMessage('Помилка мережі при збереженні', 'error');
  } finally {
    if (btnSave) btnSave.disabled = false;
  }
}

async function loadPhotoReportsGallery() {
  const container = document.getElementById('photo-reports-gallery');
  const countBadge = document.getElementById('gallery-count-badge');
  if (!container) return;

  try {
    const filterParam = currentGalleryFilter !== 'all' ? `?type=${currentGalleryFilter}` : '';
    const res = await fetch(`api/photo-reports.php${filterParam}`, { cache: 'no-store' });
    const json = await res.json();

    if (!json.success || !Array.isArray(json.data)) {
      container.innerHTML = `<div class="dash-empty-state"><i class="ri-error-warning-line"></i> Не вдалося завантажити галерею</div>`;
      return;
    }

    const reports = json.data;
    if (countBadge) countBadge.textContent = `${reports.length} збережених карт`;

    if (reports.length === 0) {
      container.innerHTML = `
        <div class="dash-empty-state" style="grid-column: 1 / -1;">
          <i class="ri-gallery-line"></i>
          <span>У галереї ще немає збережених фотозвітів.<br>Згенеруйте звіт вище та натисніть «Зберегти в галерею»!</span>
        </div>`;
      return;
    }

    const typeBadgeMap = {
      week: 'Тиждень',
      month: 'Місяць',
      year: 'Рік'
    };

    container.innerHTML = reports.map((r) => `
      <div class="gallery-card" data-report-id="${r.id}">
        <div class="gallery-card-thumb">
          <img src="${escapeAttr(r.image_url)}" alt="${escapeAttr(r.title)}" loading="lazy">
          <span class="gallery-card-badge">${escapeHtml(typeBadgeMap[r.report_type] || r.report_type)}</span>
        </div>
        <div class="gallery-card-body">
          <h4 class="gallery-card-title">${escapeHtml(r.period_label || r.title)}</h4>
          <span class="gallery-card-date"><i class="ri-time-line"></i> ${escapeHtml(r.created_at)}</span>
          <div class="gallery-card-actions">
            <a href="${escapeAttr(r.image_url)}" download="syncflow_report_${r.id}.png" class="btn btn-secondary btn-download-gallery" title="Завантажити">
              <i class="ri-download-2-line"></i> Скачати
            </a>
            <button class="btn btn-danger btn-delete-gallery" data-id="${r.id}" title="Видалити">
              <i class="ri-delete-bin-line"></i>
            </button>
          </div>
        </div>
      </div>`).join('');

    container.querySelectorAll('.btn-delete-gallery').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const id = btn.getAttribute('data-id');
        if (!id) return;
        if (!confirm('Ви дійсно бажаєте видалити цей фотозвіт з галереї?')) return;
        try {
          const res = await fetch('api/photo-reports.php', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(id) })
          });
          const json = await res.json();
          if (json.success) {
            showMessage('Звіт видалено з галереї', 'success');
            loadPhotoReportsGallery();
          } else {
            showMessage(json.message || 'Помилка видалення', 'error');
          }
        } catch (err) {
          console.error(err);
          showMessage('Помилка мережі при видаленні', 'error');
        }
      });
    });

  } catch (err) {
    console.error('Error loading gallery:', err);
    container.innerHTML = `<div class="dash-empty-state"><i class="ri-error-warning-line"></i> Помилка завантаження галереї</div>`;
  }
}

// ===== Global Table Drag & Drop Reordering =====
let globalDraggedRow = null;

function enableRowDragAndDrop(tableOrBody) {
  if (!tableOrBody) return;
  const tbody = tableOrBody.tagName === "TBODY" ? tableOrBody : tableOrBody.querySelector("tbody");
  if (!tbody) return;

  const table = tbody.closest("table");
  if (table) {
    const theadTr = table.querySelector("thead tr");
    if (theadTr && !theadTr.querySelector("th.col-drag-handle")) {
      const th = document.createElement("th");
      th.className = "col-drag-handle";
      th.innerHTML = "";
      theadTr.insertBefore(th, theadTr.firstElementChild);
    }
  }

  const rows = tbody.querySelectorAll("tr");
  rows.forEach((tr) => {
    if (tr.querySelector(".empty-table-state") || (tr.cells.length <= 1 && tr.textContent.includes("Немає"))) {
      return;
    }

    tr.setAttribute("draggable", "true");

    const handleCell = tr.querySelector(".col-drag-handle");
    const svgIcon = '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="drag-handle-svg"><circle cx="2" cy="2" r="1" fill="currentColor"/><circle cx="6" cy="2" r="1" fill="currentColor"/><circle cx="2" cy="6" r="1" fill="currentColor"/><circle cx="6" cy="6" r="1" fill="currentColor"/><circle cx="2" cy="10" r="1" fill="currentColor"/><circle cx="6" cy="10" r="1" fill="currentColor"/></svg>';
    if (handleCell) {
      handleCell.title = "Перетягнути рядок";
      handleCell.innerHTML = svgIcon;
    } else if (tr.children.length > 0) {
      const td = document.createElement("td");
      td.className = "col-drag-handle";
      td.title = "Перетягнути рядок";
      td.innerHTML = svgIcon;
      tr.insertBefore(td, tr.firstElementChild);
    }
  });
}

function initGlobalTableDragAndDrop() {
  document.addEventListener("mousedown", (e) => {
    const handle = e.target.closest(".col-drag-handle");
    if (handle) {
      const tr = handle.closest("tr");
      if (tr) tr.setAttribute("draggable", "true");
    }
  });

  document.addEventListener("dragstart", (e) => {
    const tr = e.target.closest("tbody tr");
    if (!tr || tr.querySelector(".empty-table-state") || (tr.cells.length <= 1 && tr.textContent.includes("Немає"))) {
      return;
    }
    globalDraggedRow = tr;
    tr.classList.add("table-row-dragging");
    if (e.dataTransfer) {
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/plain", "");
    }
  });

  document.addEventListener("dragover", (e) => {
    if (!globalDraggedRow) return;
    const targetRow = e.target.closest("tbody tr");
    if (!targetRow || targetRow === globalDraggedRow || targetRow.parentElement !== globalDraggedRow.parentElement) return;

    e.preventDefault();
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = "move";
    }

    const tbody = targetRow.parentElement;
    const rect = targetRow.getBoundingClientRect();
    const isBelowMiddle = (e.clientY - rect.top) / (rect.bottom - rect.top) > 0.5;

    if (isBelowMiddle) {
      if (targetRow.nextSibling !== globalDraggedRow) {
        tbody.insertBefore(globalDraggedRow, targetRow.nextSibling);
      }
    } else {
      if (targetRow !== globalDraggedRow.nextSibling) {
        tbody.insertBefore(globalDraggedRow, targetRow);
      }
    }
  });

  document.addEventListener("drop", (e) => {
    if (globalDraggedRow) {
      e.preventDefault();
      globalDraggedRow.classList.remove("table-row-dragging");
      globalDraggedRow = null;
    }
  });

  document.addEventListener("dragend", () => {
    if (globalDraggedRow) {
      globalDraggedRow.classList.remove("table-row-dragging");
      globalDraggedRow = null;
    }
    document.querySelectorAll(".table-row-dragging").forEach((r) => {
      r.classList.remove("table-row-dragging");
    });
  });

  const observer = new MutationObserver((mutations) => {
    const tbodiesToUpdate = new Set();
    mutations.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches?.("table, tbody")) {
            tbodiesToUpdate.add(node.tagName === "TABLE" ? node.querySelector("tbody") : node);
          } else if (node.matches?.("tr") && node.closest("tbody")) {
            tbodiesToUpdate.add(node.closest("tbody"));
          } else if (node.querySelectorAll) {
            node.querySelectorAll("table, tbody").forEach((t) => {
              tbodiesToUpdate.add(t.tagName === "TABLE" ? t.querySelector("tbody") : t);
            });
          }
        }
      });
    });
    tbodiesToUpdate.forEach(tbody => {
      if (tbody) enableRowDragAndDrop(tbody);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll("table, tbody").forEach((t) => enableRowDragAndDrop(t));
}



// --- Auto-generated exports for Vite modules ---
(window as any).setTaskDateInputValue = setTaskDateInputValue;
(window as any).initSorting = initSorting;
(window as any).cancelProjectPanel = cancelProjectPanel;
(window as any).parseTimeToParts = parseTimeToParts;
(window as any).updateBottomTableScrollbar = updateBottomTableScrollbar;
(window as any).attachUsersTbodyHandlers = attachUsersTbodyHandlers;
(window as any).statsNumber = statsNumber;
(window as any).getGoalProgressColor = getGoalProgressColor;
(window as any).loadYoutube = loadYoutube;
(window as any).closeAllAdaptiveSubTabMenus = closeAllAdaptiveSubTabMenus;
(window as any).formatMoney = formatMoney;
(window as any).deleteExpense = deleteExpense;
(window as any).closeTaskBulkMenus = closeTaskBulkMenus;
(window as any).renderTabAccessChecklist = renderTabAccessChecklist;
(window as any).setActiveTaskRow = setActiveTaskRow;
(window as any).renderDashTodayTasks = renderDashTodayTasks;
(window as any).parseMaskToLocalDateTime = parseMaskToLocalDateTime;
(window as any).closeDateTimePopover = closeDateTimePopover;
(window as any).activateSettingsMainPanel = activateSettingsMainPanel;
(window as any).initCustomSelects = initCustomSelects;
(window as any).loadTrainingHistory = loadTrainingHistory;
(window as any).attachBankTbodyHandlers = attachBankTbodyHandlers;
(window as any).displayUsers = displayUsers;
(window as any).switchTab = switchTab;
(window as any).statsBuildTimeline = statsBuildTimeline;
(window as any).loadProjectsHistory = loadProjectsHistory;
(window as any).deleteBank = deleteBank;
(window as any).cancelDepositGoalDialog = cancelDepositGoalDialog;
(window as any).renderRunningPlanCard = renderRunningPlanCard;
(window as any).saveRunTimerState = saveRunTimerState;
(window as any).statsRenderDonut = statsRenderDonut;
(window as any).handleDragEnter = handleDragEnter;
(window as any).renderDashTraining = renderDashTraining;
(window as any).showAddGoalDialog = showAddGoalDialog;
(window as any).saveTask = saveTask;
(window as any).updateGoal = updateGoal;
(window as any).displayTodaySessions = displayTodaySessions;
(window as any).ensureSettingsTableStructure = ensureSettingsTableStructure;
(window as any).refreshEdgeTableScrollbars = refreshEdgeTableScrollbars;
(window as any).createKanbanCard = createKanbanCard;
(window as any).updateSortIcons = updateSortIcons;
(window as any).initTaskDateTimeSplitInputs = initTaskDateTimeSplitInputs;
(window as any).clearSearch = clearSearch;
(window as any).ensurePanelEmptyState = ensurePanelEmptyState;
(window as any).loadTodaySessions = loadTodaySessions;
(window as any).restoreRunTimerState = restoreRunTimerState;
(window as any).ensureTaskColGroup = ensureTaskColGroup;
(window as any).showEgdsEditDialog = showEgdsEditDialog;
(window as any).stopTimerUpdates = stopTimerUpdates;
(window as any).displayTrainingHistory = displayTrainingHistory;
(window as any).initProjectActions = initProjectActions;
(window as any).refreshTrainingProgramUI = refreshTrainingProgramUI;
(window as any).handleDrop = handleDrop;
(window as any).showEditProjectPanel = showEditProjectPanel;
(window as any).getTrainingWeek = getTrainingWeek;
(window as any).loadStatisticsDashboard = loadStatisticsDashboard;
(window as any).loadBank = loadBank;
(window as any).updateURLWithSearch = updateURLWithSearch;
(window as any).decodeMojibakeText = decodeMojibakeText;
(window as any).parseTaskDateMask = parseTaskDateMask;
(window as any).handleDragStart = handleDragStart;
(window as any).loadDashboard = loadDashboard;
(window as any).updateSelectedCount = updateSelectedCount;
(window as any).getCurrentStrengthPlan = getCurrentStrengthPlan;
(window as any).cancelExpensePanel = cancelExpensePanel;
(window as any).runTaskBulkAction = runTaskBulkAction;
(window as any).formatTimePartsToMask = formatTimePartsToMask;
(window as any).cancelEditExpensePanel = cancelEditExpensePanel;
(window as any).showEditUserPanel = showEditUserPanel;
(window as any).displayCurrentSessionSets = displayCurrentSessionSets;
(window as any).initPrettyNumberInputs = initPrettyNumberInputs;
(window as any).syncUnifiedHeaderLayout = syncUnifiedHeaderLayout;
(window as any).ensureCurrentUser = ensureCurrentUser;
(window as any).getAdaptiveSubTabLimit = getAdaptiveSubTabLimit;
(window as any).cancelEgdsForms = cancelEgdsForms;
(window as any).formatTaskCategoryLabel = formatTaskCategoryLabel;
(window as any).refreshAdaptiveSubTabMenus = refreshAdaptiveSubTabMenus;
(window as any).attachTaskTbodyHandlers = attachTaskTbodyHandlers;
(window as any).initEdgeTableScrollbars = initEdgeTableScrollbars;
(window as any).displayExpenses = displayExpenses;
(window as any).statsRenderList = statsRenderList;
(window as any).setAutoCompleteGroupVisibility = setAutoCompleteGroupVisibility;
(window as any).loadExpenses = loadExpenses;
(window as any).performSearch = performSearch;
(window as any).saveDepositGoal = saveDepositGoal;
(window as any).switchSubTab = switchSubTab;
(window as any).bulkUpdateTasks = bulkUpdateTasks;
(window as any).initTaskBulkMenu = initTaskBulkMenu;
(window as any).initGoalsCardSelection = initGoalsCardSelection;
(window as any).closePrettyFieldSelects = closePrettyFieldSelects;
(window as any).formatDuration = formatDuration;
(window as any).loadIncomes = loadIncomes;
(window as any).computeTaskColumnWidths = computeTaskColumnWidths;
(window as any).initSmartTooltips = initSmartTooltips;
(window as any).showEditBankPanel = showEditBankPanel;
(window as any).parseAllowedTabs = parseAllowedTabs;
(window as any).isTypingContext = isTypingContext;
(window as any).clearRunTimerState = clearRunTimerState;
(window as any).deleteTrainingSession = deleteTrainingSession;
(window as any).deleteTaskById = deleteTaskById;
(window as any).updateActiveTimers = updateActiveTimers;
(window as any).showAddTaskPanel = showAddTaskPanel;
(window as any).cancelIncomePanel = cancelIncomePanel;
(window as any).initTimeLimitInputs = initTimeLimitInputs;
(window as any).getCurrentSessionPlannedReps = getCurrentSessionPlannedReps;
(window as any).setTrainingWeekStatus = setTrainingWeekStatus;
(window as any).loadGoals = loadGoals;
(window as any).invalidateStatisticsCache = invalidateStatisticsCache;
(window as any).loadPhotoReportsGallery = loadPhotoReportsGallery;
(window as any).displayEgdsOrders = displayEgdsOrders;
(window as any).formatDatePartsToMask = formatDatePartsToMask;
(window as any).showAddProjectPanel = showAddProjectPanel;
(window as any).statsRenderLineChart = statsRenderLineChart;
(window as any).cancelUserPanel = cancelUserPanel;
(window as any).roundRect = roundRect;
(window as any).finishSession = finishSession;
(window as any).measureUniversalText = measureUniversalText;
(window as any).loadUsers = loadUsers;
(window as any).closeLegacyModal = closeLegacyModal;
(window as any).formatTaskPeriodLabel = formatTaskPeriodLabel;
(window as any).getDateTimePopoverEl = getDateTimePopoverEl;
(window as any).initPrettyFieldSelects = initPrettyFieldSelects;
(window as any).applyTasksSmartSortPreset = applyTasksSmartSortPreset;
(window as any).applyUniversalTableColumnSizing = applyUniversalTableColumnSizing;
(window as any).attachIncomesTbodyHandlers = attachIncomesTbodyHandlers;
(window as any).initTaskRecurrenceEvents = initTaskRecurrenceEvents;
(window as any).renderDashActiveProjects = renderDashActiveProjects;
(window as any).displayYoutube = displayYoutube;
(window as any).renderKanbanCards = renderKanbanCards;
(window as any).ensureEdgeTableScrollbar = ensureEdgeTableScrollbar;
(window as any).loadCurrentSessionSets = loadCurrentSessionSets;
(window as any).buildTaskDueDateForPayload = buildTaskDueDateForPayload;
(window as any).closeActiveLegacyModalByContext = closeActiveLegacyModalByContext;
(window as any).cancelEditUserPanel = cancelEditUserPanel;
(window as any).renderDashFinanceSummary = renderDashFinanceSummary;
(window as any).positionDateTimePopover = positionDateTimePopover;
(window as any).initGoalsBulkSelectBtn = initGoalsBulkSelectBtn;
(window as any).openTaskEditFromKanban = openTaskEditFromKanban;
(window as any).fetchPhotoReportStats = fetchPhotoReportStats;
(window as any).initKanban = initKanban;
(window as any).updateTimerButtons = updateTimerButtons;
(window as any).refreshPhotoReportPreview = refreshPhotoReportPreview;
(window as any).saveUser = saveUser;
(window as any).resetAddUserForm = resetAddUserForm;
(window as any).cancelEditGoalDialog = cancelEditGoalDialog;
(window as any).showAddTaskPanelWithStatus = showAddTaskPanelWithStatus;
(window as any).initTaskDatePickerButtons = initTaskDatePickerButtons;
(window as any).escapeAttr = escapeAttr;
(window as any).isStatisticsTabActive = isStatisticsTabActive;
(window as any).downloadCurrentPhotoReport = downloadCurrentPhotoReport;
(window as any).updateSearchResultsCount = updateSearchResultsCount;
(window as any).applyTabAccessFromSettings = applyTabAccessFromSettings;
(window as any).openTaskForEdit = openTaskForEdit;
(window as any).buildTrainingProgression = buildTrainingProgression;
(window as any).showEditTaskPanel = showEditTaskPanel;
(window as any).renderEmptyTableState = renderEmptyTableState;
(window as any).renderDashGoals = renderDashGoals;
(window as any).getGoalMotivationText = getGoalMotivationText;
(window as any).syncWithServer = syncWithServer;
(window as any).cancelBankPanel = cancelBankPanel;
(window as any).saveSetting = saveSetting;
(window as any).filterTrainingHistory = filterTrainingHistory;
(window as any).updateTimerDisplay = updateTimerDisplay;
(window as any).showEditIncomePanel = showEditIncomePanel;
(window as any).cancelEditProjectPanel = cancelEditProjectPanel;
(window as any).loadSettings = loadSettings;
(window as any).enableRowDragAndDrop = enableRowDragAndDrop;
(window as any).clampWidth = clampWidth;
(window as any).statsSetPeriodButtons = statsSetPeriodButtons;
(window as any).formatLocalDateTimeToMask = formatLocalDateTimeToMask;
(window as any).initSearch = initSearch;
(window as any).formatTaskRepeatLabel = formatTaskRepeatLabel;
(window as any).applyTaskTableColumnSizing = applyTaskTableColumnSizing;
(window as any).deleteGoal = deleteGoal;
(window as any).escapeHtml = escapeHtml;
(window as any).clampGoalProgress = clampGoalProgress;
(window as any).initTasksSmartSortToggle = initTasksSmartSortToggle;
(window as any).displayBank = displayBank;
(window as any).initTaskKeyboardShortcuts = initTaskKeyboardShortcuts;
(window as any).renderGoalsGridCards = renderGoalsGridCards;
(window as any).updateGoalsCardSelectedCount = updateGoalsCardSelectedCount;
(window as any).formatTaskDateLabel = formatTaskDateLabel;
(window as any).initDateTimeInputs = initDateTimeInputs;
(window as any).updateProfile = updateProfile;
(window as any).renumberTableRows = renumberTableRows;
(window as any).displayGoals = displayGoals;
(window as any).initDashboardEvents = initDashboardEvents;
(window as any).initSubTabs = initSubTabs;
(window as any).getSelectedTaskIds = getSelectedTaskIds;
(window as any).saveExpense = saveExpense;
(window as any).getWeekNumber = getWeekNumber;
(window as any).statsInitControls = statsInitControls;
(window as any).syncTaskPeriodByDate = syncTaskPeriodByDate;
(window as any).measureTaskTextWidth = measureTaskTextWidth;
(window as any).displayProjects = displayProjects;
(window as any).updateUser = updateUser;
(window as any).loadEgds = loadEgds;
(window as any).getSelectedRepeatDays = getSelectedRepeatDays;
(window as any).handleDragLeave = handleDragLeave;
(window as any).updateTask = updateTask;
(window as any).showAddUserPanel = showAddUserPanel;
(window as any).statsSetTrainingProgressButtons = statsSetTrainingProgressButtons;
(window as any).getPlannedRunMinutes = getPlannedRunMinutes;
(window as any).addSet = addSet;
(window as any).loadPhotoReportsTab = loadPhotoReportsTab;
(window as any).refreshAdaptiveSubTabMenuForHeader = refreshAdaptiveSubTabMenuForHeader;
(window as any).statsRenderBars = statsRenderBars;
(window as any).openProjectEditById = openProjectEditById;
(window as any).formatTaskDateMask = formatTaskDateMask;
(window as any).cancelEditProfile = cancelEditProfile;
(window as any).updateTasksSmartSortButtonState = updateTasksSmartSortButtonState;
(window as any).pauseRunTimer = pauseRunTimer;
(window as any).saveProject = saveProject;
(window as any).loadTrainingSettings = loadTrainingSettings;
(window as any).checkAuthAndInit = checkAuthAndInit;
(window as any).parseStatsDate = parseStatsDate;
(window as any).attachExpensesTbodyHandlers = attachExpensesTbodyHandlers;
(window as any).renderDateTimePopover = renderDateTimePopover;
(window as any).timerTick = timerTick;
(window as any).initTrainingSubTab = initTrainingSubTab;
(window as any).getPreferredTaskRow = getPreferredTaskRow;
(window as any).startTimerUpdates = startTimerUpdates;
(window as any).applyDateTimePopoverValue = applyDateTimePopoverValue;
(window as any).setText = setText;
(window as any).loadTasks = loadTasks;
(window as any).buildStrengthPlan = buildStrengthPlan;
(window as any).stopRunTimer = stopRunTimer;
(window as any).updateSelectAllCheckBox = updateSelectAllCheckBox;
(window as any).initGoalsEvents = initGoalsEvents;
(window as any).collectTabAccessFromPanel = collectTabAccessFromPanel;
(window as any).showEgdsAddDialog = showEgdsAddDialog;
(window as any).renderTrainingPlanForStrength = renderTrainingPlanForStrength;
(window as any).saveCurrentPhotoReportToGallery = saveCurrentPhotoReportToGallery;
(window as any).displaySettings = displaySettings;
(window as any).getEmptyMessageByPanelId = getEmptyMessageByPanelId;
(window as any).handleDragEnd = handleDragEnd;
(window as any).statsBucketKey = statsBucketKey;
(window as any).updateEdgeTableScrollbar = updateEdgeTableScrollbar;
(window as any).isDateInStatsPeriod = isDateInStatsPeriod;
(window as any).showAddBankPanel = showAddBankPanel;
(window as any).parseTrainingDateValue = parseTrainingDateValue;
(window as any).showAddIncomePanel = showAddIncomePanel;
(window as any).cancelEditIncomePanel = cancelEditIncomePanel;
(window as any).resumeRunTimer = resumeRunTimer;
(window as any).isDateInCurrentTrainingWeek = isDateInCurrentTrainingWeek;
(window as any).normalizeTimePart = normalizeTimePart;
(window as any).showAddExpensePanel = showAddExpensePanel;
(window as any).updateDailyQuote = updateDailyQuote;
(window as any).saveEgdsOrder = saveEgdsOrder;
(window as any).renderStatisticsDashboard = renderStatisticsDashboard;
(window as any).displayIncomes = displayIncomes;
(window as any).displayTasks = displayTasks;
(window as any).ensureAdaptiveSubTabMoreWrap = ensureAdaptiveSubTabMoreWrap;
(window as any).getTodayFormattedString = getTodayFormattedString;
(window as any).initStandaloneTimer = initStandaloneTimer;
(window as any).parseTaskDueAt = parseTaskDueAt;
(window as any).switchTasksView = switchTasksView;
(window as any).fillEgdsCustomersSelect = fillEgdsCustomersSelect;
(window as any).openLegacyModal = openLegacyModal;
(window as any).renderPrettyFieldSelect = renderPrettyFieldSelect;
(window as any).resetModalFormState = resetModalFormState;
(window as any).startRunTimer = startRunTimer;
(window as any).renderGoalsTableRows = renderGoalsTableRows;
(window as any).openGoalEditById = openGoalEditById;
(window as any).showEditProfile = showEditProfile;
(window as any).handleLogout = handleLogout;
(window as any).displayEgdsProducts = displayEgdsProducts;
(window as any).saveEgdsProduct = saveEgdsProduct;
(window as any).mapRoleUA = mapRoleUA;
(window as any).initViewTabs = initViewTabs;
(window as any).statsCurrency = statsCurrency;
(window as any).setSelectedRepeatDays = setSelectedRepeatDays;
(window as any).inferPeriodFromDateValue = inferPeriodFromDateValue;
(window as any).normalizeGoalDate = normalizeGoalDate;
(window as any).updateProject = updateProject;
(window as any).updateIncome = updateIncome;
(window as any).initTaskBulkActions = initTaskBulkActions;
(window as any).handleDragOver = handleDragOver;
(window as any).addNextPlannedSet = addNextPlannedSet;
(window as any).openDateTimePopover = openDateTimePopover;
(window as any).initGlobalTableDragAndDrop = initGlobalTableDragAndDrop;
(window as any).handleTimer = handleTimer;
(window as any).cancelAddGoalDialog = cancelAddGoalDialog;
(window as any).initCheckBoxes = initCheckBoxes;
(window as any).deleteUser = deleteUser;
(window as any).drawPhotoReportOnCanvas = drawPhotoReportOnCanvas;
(window as any).loadSearchFromURL = loadSearchFromURL;
(window as any).displayTasksCalendar = displayTasksCalendar;
(window as any).saveGoal = saveGoal;
(window as any).initTabPanel = initTabPanel;
(window as any).saveBank = saveBank;
(window as any).showEditExpensePanel = showEditExpensePanel;
(window as any).getUniversalColumnBounds = getUniversalColumnBounds;
(window as any).measureCanvasRef = measureCanvasRef;
(window as any).saveIncome = saveIncome;
(window as any).cancelEditTaskPanel = cancelEditTaskPanel;
(window as any).clearCurrentStrengthSessionUI = clearCurrentStrengthSessionUI;
(window as any).cancelGoalDialogs = cancelGoalDialogs;
(window as any).initCustomModalCloseButtons = initCustomModalCloseButtons;
(window as any).refreshDateGhostHints = refreshDateGhostHints;
(window as any).markTaskAsCompleted = markTaskAsCompleted;
(window as any).initContextMenus = initContextMenus;
(window as any).updateURLWithSubTab = updateURLWithSubTab;
(window as any).formatDatePartsToDateMask = formatDatePartsToDateMask;
(window as any).renderGoalsCurrentView = renderGoalsCurrentView;
(window as any).loadProfile = loadProfile;
(window as any).parseMaskToDateParts = parseMaskToDateParts;
(window as any).initSidebar = initSidebar;
(window as any).cancelEditBankPanel = cancelEditBankPanel;
(window as any).initYoutubeControls = initYoutubeControls;
(window as any).deleteSet = deleteSet;
(window as any).formatTimer = formatTimer;
(window as any).computeUniversalColumnWidths = computeUniversalColumnWidths;
(window as any).updateBank = updateBank;
(window as any).loadProjects = loadProjects;
(window as any).initPhotoReportEvents = initPhotoReportEvents;
(window as any).resetCheckboxStates = resetCheckboxStates;
(window as any).loadWeeklyTrainingStatus = loadWeeklyTrainingStatus;
(window as any).updateURL = updateURL;
(window as any).displayProjectsHistory = displayProjectsHistory;
(window as any).sanitizeClassName = sanitizeClassName;
(window as any).getActiveTasksPanel = getActiveTasksPanel;
(window as any).renderKanbanBoard = renderKanbanBoard;
(window as any).cancelTaskPanel = cancelTaskPanel;
(window as any).updateDashboardGreeting = updateDashboardGreeting;
(window as any).getGoalCategoryTheme = getGoalCategoryTheme;
(window as any).getCurrentSessionSetCount = getCurrentSessionSetCount;
(window as any).showConfirm = showConfirm;
(window as any).refreshPrettyFieldSelects = refreshPrettyFieldSelects;
(window as any).deleteIncome = deleteIncome;
(window as any).formatDate = formatDate;
(window as any).initAdaptiveSubTabMenus = initAdaptiveSubTabMenus;
(window as any).getKanbanColumn = getKanbanColumn;
(window as any).ensureUniversalColGroup = ensureUniversalColGroup;
(window as any).openDepositGoalModal = openDepositGoalModal;
(window as any).getTrainingWeekRange = getTrainingWeekRange;
(window as any).deleteProject = deleteProject;
(window as any).initUniversalDataTableLayout = initUniversalDataTableLayout;
(window as any).deleteEgdsItem = deleteEgdsItem;
(window as any).updateExpense = updateExpense;
try { (window as any).runTimerSeconds = runTimerSeconds; } catch(e) {}
try { (window as any).YOUTUBE_DEFAULT_CHANNEL_URL = YOUTUBE_DEFAULT_CHANNEL_URL; } catch(e) {}
try { (window as any).universalTableMeasureCanvas = universalTableMeasureCanvas; } catch(e) {}
try { (window as any).runTimerRunning = runTimerRunning; } catch(e) {}
try { (window as any).kanbanTasks = kanbanTasks; } catch(e) {}
try { (window as any).runSessionId = runSessionId; } catch(e) {}
try { (window as any).isLoading = isLoading; } catch(e) {}
try { (window as any).TRAINING_PROGRAM = TRAINING_PROGRAM; } catch(e) {}
try { (window as any).standaloneTimerInterval = standaloneTimerInterval; } catch(e) {}
try { (window as any).standaloneCountdownTargetSeconds = standaloneCountdownTargetSeconds; } catch(e) {}
try { (window as any).standaloneLaps = standaloneLaps; } catch(e) {}
try { (window as any).standaloneTimerRunning = standaloneTimerRunning; } catch(e) {}
try { (window as any).currentGalleryFilter = currentGalleryFilter; } catch(e) {}
try { (window as any).activeTimers = activeTimers; } catch(e) {}
try { (window as any).universalTableResizeBound = universalTableResizeBound; } catch(e) {}
try { (window as any).tasksSmartSortEnabled = tasksSmartSortEnabled; } catch(e) {}
try { (window as any).cachedPhotoStats = cachedPhotoStats; } catch(e) {}
try { (window as any).globalDraggedRow = globalDraggedRow; } catch(e) {}
try { (window as any).escapeHTML = escapeHTML; } catch(e) {}
try { (window as any).currentPhotoReportType = currentPhotoReportType; } catch(e) {}
try { (window as any).cachedGoalsData = cachedGoalsData; } catch(e) {}
try { (window as any).taskMeasureCanvas = taskMeasureCanvas; } catch(e) {}
try { (window as any).DAILY_QUOTES = DAILY_QUOTES; } catch(e) {}
try { (window as any).reverseStatusMap = reverseStatusMap; } catch(e) {}
try { (window as any).youtubeControlsInitialized = youtubeControlsInitialized; } catch(e) {}
try { (window as any).standaloneTimerSeconds = standaloneTimerSeconds; } catch(e) {}
try { (window as any).TASK_COLUMN_MAX_WIDTHS = TASK_COLUMN_MAX_WIDTHS; } catch(e) {}
try { (window as any).dateTimePopoverState = dateTimePopoverState; } catch(e) {}
try { (window as any).TASK_COLUMN_DEFAULT_WIDTHS = TASK_COLUMN_DEFAULT_WIDTHS; } catch(e) {}
try { (window as any).timerUpdateInterval = timerUpdateInterval; } catch(e) {}
try { (window as any).statsState = statsState; } catch(e) {}
try { (window as any).runTimerInterval = runTimerInterval; } catch(e) {}
try { (window as any).DTP_MONTHS = DTP_MONTHS; } catch(e) {}
try { (window as any).universalTableDiscoveryObserverBound = universalTableDiscoveryObserverBound; } catch(e) {}
try { (window as any).timerSyncInterval = timerSyncInterval; } catch(e) {}
try { (window as any).cachedUserProfile = cachedUserProfile; } catch(e) {}
try { (window as any).standaloneTimerMode = standaloneTimerMode; } catch(e) {}
try { (window as any).TASK_COLUMN_MIN_WIDTHS = TASK_COLUMN_MIN_WIDTHS; } catch(e) {}
try { (window as any).currentHistoryFilter = currentHistoryFilter; } catch(e) {}
try { (window as any).DTP_WEEKDAYS = DTP_WEEKDAYS; } catch(e) {}
try { (window as any).currentSearchQuery = currentSearchQuery; } catch(e) {}
try { (window as any).searchListenerInit = searchListenerInit; } catch(e) {}
try { (window as any).dataTbody = dataTbody; } catch(e) {}
try { (window as any).currentSortOrder = currentSortOrder; } catch(e) {}
try { (window as any).kanbanStatusMap = kanbanStatusMap; } catch(e) {}
try { (window as any).lastActiveTaskId = lastActiveTaskId; } catch(e) {}
try { (window as any).trainingState = trainingState; } catch(e) {}
try { (window as any).EDGE_TABLE_SCROLL_SELECTOR = EDGE_TABLE_SCROLL_SELECTOR; } catch(e) {}
try { (window as any).currentPullupsSessionId = currentPullupsSessionId; } catch(e) {}
try { (window as any).currentGoalsView = currentGoalsView; } catch(e) {}
try { (window as any).draggedCard = draggedCard; } catch(e) {}
try { (window as any).currentPushupsSessionId = currentPushupsSessionId; } catch(e) {}
try { (window as any).currentSortField = currentSortField; } catch(e) {}
